export enum Language {
  ENGLISH = "en",
  SPANISH = "es",
  PORTUGUESE = "pt",
}

interface Dictionary {
  [key: string]: {
    [key in Language]: string;
  };
}

export const dictionary: Dictionary = {
  // LANDING PAGE
  "fluxi-is-free": {
    [Language.ENGLISH]: "Fluxi is 100% free",
    [Language.SPANISH]: "Fluxi es 100% gratis",
    [Language.PORTUGUESE]: "Fluxi é 100% gratuito",
  },
  "add-your-product-with-ia": {
    [Language.ENGLISH]:
      "Add your product, and Fluxi creates your sales funnel in seconds",
    [Language.SPANISH]:
      "Agrega tu producto, y Fluxi crea tu embudo de ventas en segundos",
    [Language.PORTUGUESE]:
      "Adicione seu produto, e o Fluxi cria seu funil de vendas em segundos",
  },
  "fluxi-complementary-offers": {
    [Language.ENGLISH]:
      "Fluxi´s AI finds complementary offers that maximize your average sales ticket with automatic upsells, downsells, and bump offers.",
    [Language.SPANISH]:
      "Fluxi en segundos, diseña y optimiza embudos de venta de altísima conversión, creando  ofertas complementarias",
    [Language.PORTUGUESE]:
      "A IA do Fluxi encontra ofertas complementares que maximizam seu ticket médio com upsells, downsells e bump offers automáticos.",
  },
  "register-now": {
    [Language.ENGLISH]: "Register now!",
    [Language.SPANISH]: "Regístrate ahora",
    [Language.PORTUGUESE]: "Registre-se agora!",
  },
  "try-now": {
    [Language.ENGLISH]: "Try now!",
    [Language.SPANISH]: "Prueba ahora",
    [Language.PORTUGUESE]: "Experimente agora!",
  },
  "sign-up-now": {
    [Language.ENGLISH]: "Sign up now!",
    [Language.SPANISH]: "¡Regístrate ahora!",
    [Language.PORTUGUESE]: "Cadastre-se agora!",
  },
  "continuous-optimization": {
    [Language.ENGLISH]:
      "Continuous optimization based on your buyers real behavior.",
    [Language.SPANISH]:
      "Fluxi crea copys persuasivos basados en investigación en tiempo real del cliente de tu producto.",
    [Language.PORTUGUESE]:
      "Otimização contínua baseada no comportamento real dos seus compradores.",
  },
  "fluxi-soon": {
    [Language.ENGLISH]:
      "Fluxi is coming soon. Join our waitlist and get priority access before anyone else.",
    [Language.SPANISH]:
      "Fluxi llegará pronto. Únete a nuestra lista de espera y obtén acceso prioritario antes que nadie.",
    [Language.PORTUGUESE]:
      "Fluxi está chegando. Junte-se à nossa lista de espera e tenha acesso prioritário antes de todos.",
  },
  "self-optimizing": {
    [Language.ENGLISH]: "Self-optimizing pages with AI",
    [Language.SPANISH]: "Páginas autooptimizadas con IA",
    [Language.PORTUGUESE]: "Páginas auto-otimizadas com IA",
  },
  "works-item-1": {
    [Language.ENGLISH]: "Works with any product you want to boost sales for",
    [Language.SPANISH]:
      "Funciona con cualquier producto que quieras aumentar las ventas",
    [Language.PORTUGUESE]:
      "Funciona com qualquer produto que você queira aumentar as vendas",
  },
  "works-item-2": {
    [Language.ENGLISH]:
      "Smart and effective upsells, downsells, and bump offers for each product",
    [Language.SPANISH]:
      "Upsells, downsells y ofertas de aumento inteligentes y efectivas para cada producto",
    [Language.PORTUGUESE]:
      "Upsells, downsells e bump offers inteligentes e eficazes para cada produto",
  },
  "works-item-3": {
    [Language.ENGLISH]: "Create and edit over 30 AI-optimized sales funnels",
    [Language.SPANISH]:
      "Crea y edita más de 30 embudos de ventas optimizados con IA",
    [Language.PORTUGUESE]:
      "Crie e edite mais de 30 funis de vendas otimizados com IA",
  },
  "works-item-4": {
    [Language.ENGLISH]: "Personalized AI digital gifts, free for each funnel",
    [Language.SPANISH]:
      "Gastos digitales personalizados con IA, gratis para cada embudo",
    [Language.PORTUGUESE]:
      "Brindes digitais personalizados com IA, grátis para cada funil",
  },
  "want-your-products": {
    [Language.ENGLISH]: "Want your products to sell like magic?",
    [Language.SPANISH]:
      "¿Quieres que tus productos se vendan como por arte de magia?",
    [Language.PORTUGUESE]: "Quer que seus produtos vendam como mágica?",
  },
  "fluxi-is-perfect": {
    [Language.ENGLISH]: "Fluxi is perfect for you",
    [Language.SPANISH]: "Fluxi es perfecto para ti",
    [Language.PORTUGUESE]: "Fluxi é perfeito para você",
  },
  "for-entrepreneurs": {
    [Language.ENGLISH]: "For entrepreneurs chasing",
    [Language.SPANISH]: "Para emprendedores que persiguen",
    [Language.PORTUGUESE]: "Para empreendedores que buscam",
  },
  "remarkable-sales-conversion": {
    [Language.ENGLISH]: "remarkable sales conversion results",
    [Language.SPANISH]: "resultados de conversión de ventas notables",
    [Language.PORTUGUESE]: "resultados notáveis de conversão de vendas",
  },
  "with-the-power": {
    [Language.ENGLISH]: "with the power of AI",
    [Language.SPANISH]: "con el poder de IA",
    [Language.PORTUGUESE]: "com o poder da IA",
  },
  "we-turn-your-wishes": {
    [Language.ENGLISH]: "We turn your wishes into sales",
    [Language.SPANISH]: "Convertimos tus deseos en ventas",
    [Language.PORTUGUESE]: "Transformamos seus desejos em vendas",
  },
  "start-boosting-your-sales": {
    [Language.ENGLISH]: "Start boosting your sales significantly with Fluxi",
    [Language.SPANISH]:
      "Comienza a aumentar tus ventas significativamente con Fluxi",
    [Language.PORTUGUESE]:
      "Comece a aumentar suas vendas significativamente com o Fluxi",
  },
  faqs: {
    [Language.ENGLISH]: "FAQs",
    [Language.SPANISH]: "Preguntas frecuentes",
    [Language.PORTUGUESE]: "Perguntas frequentes",
  },
  "question-1": {
    [Language.ENGLISH]: "How does Fluxi work?",
    [Language.SPANISH]: "¿Cómo funciona Fluxi?",
    [Language.PORTUGUESE]: "Como o Fluxi funciona?",
  },
  "answer-1": {
    [Language.ENGLISH]:
      "Fluxi uses artificial intelligence to create highly effective sales funnels in seconds. Simply add your product, and Fluxi automatically generates upsells, downsells, and bump offers optimized to maximize your revenue, with no technical expertise required.",
    [Language.SPANISH]:
      "Fluxi utiliza inteligencia artificial para crear embudos de ventas altamente efectivos en segundos. Simplemente agrega tu producto, y Fluxi automáticamente genera upsells, downsells y ofertas de aumento optimizadas para maximizar tus ingresos, sin necesidad de experiencia técnica.",
    [Language.PORTUGUESE]:
      "O Fluxi usa inteligência artificial para criar funis de vendas altamente eficazes em segundos. Basta adicionar seu produto, e o Fluxi gera automaticamente upsells, downsells e bump offers otimizados para maximizar sua receita, sem necessidade de experiência técnica.",
  },
  "question-2": {
    [Language.ENGLISH]: "Do I need any experience to use Fluxi?",
    [Language.SPANISH]: "¿Necesito experiencia para usar Fluxi?",
    [Language.PORTUGUESE]: "Preciso de experiência para usar o Fluxi?",
  },
  "answer-2": {
    [Language.ENGLISH]:
      "No, Fluxi is designed to be easy to use. You don't need technical experience or sales knowledge. The platform automatically creates funnels tailored to your product, helping you boost sales without hassle.",
    [Language.SPANISH]:
      "No, Fluxi está diseñado para ser fácil de usar. No necesitas experiencia técnica o conocimientos de ventas. La plataforma automáticamente crea embudos adaptados a tu producto, ayudándote a aumentar las ventas sin complicaciones.",
    [Language.PORTUGUESE]:
      "Não, o Fluxi foi projetado para ser fácil de usar. Você não precisa de experiência técnica ou conhecimento em vendas. A plataforma cria automaticamente funis adaptados ao seu produto, ajudando você a aumentar as vendas sem complicações.",
  },
  "question-3": {
    [Language.ENGLISH]:
      "How long does it take to set up a sales funnel in Fluxi?",
    [Language.SPANISH]:
      "¿Cuánto tiempo toma configurar un embudo de ventas en Fluxi?",
    [Language.PORTUGUESE]:
      "Quanto tempo leva para configurar um funil de vendas no Fluxi?",
  },
  "answer-3": {
    [Language.ENGLISH]:
      "Setting up a sales funnel with Fluxi is instant. Just input your product information, and the AI will generate an optimized funnel in seconds, ready to start increasing your revenue.",
    [Language.SPANISH]:
      "Configurar un embudo de ventas con Fluxi es instantáneo. Simplemente ingresa la información de tu producto, y la IA generará un embudo optimizado en segundos, listo para comenzar a aumentar tus ingresos.",
    [Language.PORTUGUESE]:
      "Configurar um funil de vendas com o Fluxi é instantâneo. Basta inserir as informações do seu produto, e a IA gerará um funil otimizado em segundos, pronto para começar a aumentar sua receita.",
  },
  "question-4": {
    [Language.ENGLISH]:
      "Does Fluxi keep optimizing my funnel after it's set up?",
    [Language.SPANISH]:
      "¿Fluxi sigue optimizando mi embudo después de configurarlo?",
    [Language.PORTUGUESE]:
      "O Fluxi continua otimizando meu funil depois de configurado?",
  },
  "answer-4": {
    [Language.ENGLISH]:
      "Yes, Fluxi not only creates your funnel but also continuously optimizes it based on performance data. The AI adjusts offers, content, and structure to continually improve conversion rates and maximize your profits.",
    [Language.SPANISH]:
      "Sí, Fluxi no solo crea tu embudo sino que también lo optimiza continuamente basado en datos de rendimiento. La IA ajusta ofertas, contenido y estructura para mejorar continuamente las tasas de conversión y maximizar tus ganancias.",
    [Language.PORTUGUESE]:
      "Sim, o Fluxi não apenas cria seu funil, mas também o otimiza continuamente com base em dados de desempenho. A IA ajusta ofertas, conteúdo e estrutura para melhorar continuamente as taxas de conversão e maximizar seus lucros.",
  },
  "its-like-having": {
    [Language.ENGLISH]:
      "It's like having an expert sales optimization team working 24/7",
    [Language.SPANISH]:
      "Es como tener un equipo de optimización de ventas experto trabajando 24/7",
    [Language.PORTUGUESE]:
      "É como ter uma equipe especialista em otimização de vendas trabalhando 24/7",
  },
  "try-fluxi-for-free": {
    [Language.ENGLISH]: "Try Fluxi for free!",
    [Language.SPANISH]: "Prueba Fluxi gratis!",
    [Language.PORTUGUESE]: "Experimente o Fluxi grátis!",
  },
  "sales-like-magic": {
    [Language.ENGLISH]: "Sales like magic",
    [Language.SPANISH]: "Ventas como por arte de magia",
    [Language.PORTUGUESE]: "Vendas como mágica",
  },
  "start-for-free-now": {
    [Language.ENGLISH]: "Start for free now!",
    [Language.SPANISH]: "Comienza gratis ahora!",
    [Language.PORTUGUESE]: "Comece grátis agora!",
  },
  "made-with-passion-by-fluxi": {
    [Language.ENGLISH]: "Made with passion by Fluxi",
    [Language.SPANISH]: "Hecho con pasión por Fluxi",
    [Language.PORTUGUESE]: "Feito com paixão pelo Fluxi",
  },
  copyright: {
    [Language.ENGLISH]: "Copyright © 2025. All rights reserved.",
    [Language.SPANISH]:
      "Derechos de autor © 2025. Todos los derechos reservados.",
    [Language.PORTUGUESE]:
      "Direitos autorais © 2025. Todos os direitos reservados.",
  },
  // HOME PAGE
  "greeting-morning": {
    [Language.ENGLISH]: "Good morning",
    [Language.SPANISH]: "Buenos días",
    [Language.PORTUGUESE]: "Bom dia",
  },
  "greeting-afternoon": {
    [Language.ENGLISH]: "Good afternoon",
    [Language.SPANISH]: "Buenas tardes",
    [Language.PORTUGUESE]: "Boa tarde",
  },
  "greeting-night": {
    [Language.ENGLISH]: "Good night",
    [Language.SPANISH]: "Buenas noches",
    [Language.PORTUGUESE]: "Boa noite",
  },
  "question-home": {
    [Language.ENGLISH]: "What do you want to do today?",
    [Language.SPANISH]: "¿Qué quieres hacer hoy?",
    [Language.PORTUGUESE]: "O que você quer fazer hoje?",
  },
  "updates": {
    [Language.ENGLISH]: "UPDATES",
    [Language.SPANISH]: "ACTUALIZACIONES",
    [Language.PORTUGUESE]: "ATUALIZAÇÕES",
  },
  "new-singular": {
    [Language.ENGLISH]: "new",
    [Language.SPANISH]: "nueva",
    [Language.PORTUGUESE]: "nova",
  },
  "new-plural": {
    [Language.ENGLISH]: "new",
    [Language.SPANISH]: "nuevas",
    [Language.PORTUGUESE]: "novas",
  },
  "create-new-funnel": {
    [Language.ENGLISH]: "Create a new funnel",
    [Language.SPANISH]: "Crear un nuevo embudo",
    [Language.PORTUGUESE]: "Criar um novo funil",
  },
  "see-my-sales": {
    [Language.ENGLISH]: "See my sales",
    [Language.SPANISH]: "Ver mis ventas",
    [Language.PORTUGUESE]: "Ver minhas vendas",
  },
  "see-my-funnels": {
    [Language.ENGLISH]: "See my funnels",
    [Language.SPANISH]: "Ver mis embudos",
    [Language.PORTUGUESE]: "Ver meus funis",
  },
  "see-my-ads": {
    [Language.ENGLISH]: "See my ads",
    [Language.SPANISH]: "Ver mis anuncios",
    [Language.PORTUGUESE]: "Ver meus anúncios",
  },
  "error-uploading-images-too-long": {
    [Language.ENGLISH]: "Error uploading images, the maximum size is 5MB",
    [Language.SPANISH]: "Error al subir imagenes, el tamaño maximo es de 5MB",
    [Language.PORTUGUESE]: "Erro ao subir imagens, o tamanho máximo é de 5MB",
  },
  "error-processing-images": {
    [Language.ENGLISH]: "Error processing images",
    [Language.SPANISH]: "Error al procesar las imágenes",
    [Language.PORTUGUESE]: "Erro ao processar imagens",
  },
  "success-uploading-images": {
    [Language.ENGLISH]: "Images uploaded successfully",
    [Language.SPANISH]: "Imágenes subidas exitosamente",
    [Language.PORTUGUESE]: "Imagens subidas com sucesso",
  },
  "success-uploading-images-failed": {
    [Language.ENGLISH]: "Images uploaded successfully. Failed {failedCount} images.",
    [Language.SPANISH]: "Imágenes subidas exitosamente. Fallaron {failedCount} imágenes.",
    [Language.PORTUGUESE]: "Imagens subidas com sucesso. Falharam {failedCount} imagens.",
  },

  "integration-activated": {
    [Language.ENGLISH]: "Integration activated",
    [Language.SPANISH]: "Integración activada",
    [Language.PORTUGUESE]: "Integração ativada",
  },
  "integration-deactivated": {
    [Language.ENGLISH]: "Integration deactivated",
    [Language.SPANISH]: "Integración desactivada",
    [Language.PORTUGUESE]: "Integração desativada",
  },
  // SIDEBAR
  home: {
    [Language.ENGLISH]: "Home",
    [Language.SPANISH]: "Inicio",
    [Language.PORTUGUESE]: "Início",
  },
  orders: {
    [Language.ENGLISH]: "Orders",
    [Language.SPANISH]: "Ordenes",
    [Language.PORTUGUESE]: "Pedidos",
  },
  products: {
    [Language.ENGLISH]: "Products",
    [Language.SPANISH]: "Productos",
    [Language.PORTUGUESE]: "Produtos",
  },
  ads: {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  hyphens: {
    [Language.ENGLISH]: "Scripts",
    [Language.SPANISH]: "Guiones",
    [Language.PORTUGUESE]: "Hífenes",
  },
  funnels: {
    [Language.ENGLISH]: "Funnels",
    [Language.SPANISH]: "Embudos",
    [Language.PORTUGUESE]: "Funis",
  },
  "ab-testing": {
    [Language.ENGLISH]: "A/B Testing",
    [Language.SPANISH]: "A/B Testing",
    [Language.PORTUGUESE]: "A/B Testing",
  },
  settings: {
    [Language.ENGLISH]: "Settings",
    [Language.SPANISH]: "Configuración",
    [Language.PORTUGUESE]: "Configurações",
  },

  training: {
    [Language.ENGLISH]: "Training",
    [Language.SPANISH]: "Entrenamiento",
    [Language.PORTUGUESE]: "Treinamento",
  },

  "come-ready": {
    [Language.ENGLISH]:
      "Com'n you are ready to get rich, do your first funnel now!",
    [Language.SPANISH]:
      "Vamos, listo para ganar dinero, crea tu primer embudo ahora!",
    [Language.PORTUGUESE]:
      "Vamos, você está pronto para ficar rico, crie seu primeiro funil agora!",
  },

  // ORDERS PAGE
  "undo-changes": {
    [Language.ENGLISH]: "Undo changes",
    [Language.SPANISH]: "Deshacer cambios",
    [Language.PORTUGUESE]: "Desfazer alterações",
  },
  "save-changes": {
    [Language.ENGLISH]: "Save changes",
    [Language.SPANISH]: "Guardar cambios",
    [Language.PORTUGUESE]: "Salvar alterações",
  },
  "filter-by-date": {
    [Language.ENGLISH]: "Filter by date",
    [Language.SPANISH]: "Filtrar por fecha",
    [Language.PORTUGUESE]: "Filtrar por data",
  },
  "relative-dates": {
    [Language.ENGLISH]: "Relative dates",
    [Language.SPANISH]: "Fechas relativas",
    [Language.PORTUGUESE]: "Datas relativas",
  },
  "specific-dates": {
    [Language.ENGLISH]: "Specific dates",
    [Language.SPANISH]: "Fechas específicas",
    [Language.PORTUGUESE]: "Datas específicas",
  },
  today: {
    [Language.ENGLISH]: "Today",
    [Language.SPANISH]: "Hoy",
    [Language.PORTUGUESE]: "Hoje",
  },
  yesterday: {
    [Language.ENGLISH]: "Yesterday",
    [Language.SPANISH]: "Ayer",
    [Language.PORTUGUESE]: "Ontem",
  },
  "this-month": {
    [Language.ENGLISH]: "This month",
    [Language.SPANISH]: "Este mes",
    [Language.PORTUGUESE]: "Este mês",
  },
  "last-month": {
    [Language.ENGLISH]: "Last month",
    [Language.SPANISH]: "Mes pasado",
    [Language.PORTUGUESE]: "Mês passado",
  },
  "start-date": {
    [Language.ENGLISH]: "Start date",
    [Language.SPANISH]: "Fecha inicial",
    [Language.PORTUGUESE]: "Data inicial",
  },
  "end-date": {
    [Language.ENGLISH]: "End date",
    [Language.SPANISH]: "Fecha final",
    [Language.PORTUGUESE]: "Data final",
  },
  "apply-filter": {
    [Language.ENGLISH]: "Apply filter",
    [Language.SPANISH]: "Aplicar filtro",
    [Language.PORTUGUESE]: "Aplicar filtro",
  },
  "no-orders-found": {
    [Language.ENGLISH]: "No orders found",
    [Language.SPANISH]: "No se encontraron órdenes",
    [Language.PORTUGUESE]: "Nenhuma ordem encontrada",
  },
  "try-different-filters": {
    [Language.ENGLISH]: "Try different filters or date range",
    [Language.SPANISH]: "Intenta con diferentes filtros o rango de fechas",
    [Language.PORTUGUESE]: "Tente diferentes filtros ou intervalo de datas",
  },
  "search-product": {
    [Language.ENGLISH]: "Search product...",
    [Language.SPANISH]: "Buscar producto...",
    [Language.PORTUGUESE]: "Buscar produto...",
  },
  "sales-orders": {
    [Language.ENGLISH]: "Sales orders",
    [Language.SPANISH]: "Ordenes",
    [Language.PORTUGUESE]: "Pedidos",
  },
  // FILTERS
  all: {
    [Language.ENGLISH]: "All",
    [Language.SPANISH]: "Todos",
    [Language.PORTUGUESE]: "Todos",
  },
  unfulfilled: {
    [Language.ENGLISH]: "Unfulfilled",
    [Language.SPANISH]: "No entregados",
    [Language.PORTUGUESE]: "Não entregues",
  },
  fulfilled: {
    [Language.ENGLISH]: "Fulfilled",
    [Language.SPANISH]: "Entregados",
    [Language.PORTUGUESE]: "Entregues",
  },
  pending: {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendientes",
    [Language.PORTUGUESE]: "Pendentes",
  },
  paid: {
    [Language.ENGLISH]: "Paid",
    [Language.SPANISH]: "Pagados",
    [Language.PORTUGUESE]: "Pagados",
  },
  unpaid: {
    [Language.ENGLISH]: "Unpaid",
    [Language.SPANISH]: "No pagados",
    [Language.PORTUGUESE]: "Não pagados",
  },
  // SALES STATS
  "total-sales": {
    [Language.ENGLISH]: "Total sales",
    [Language.SPANISH]: "Total de ventas",
    [Language.PORTUGUESE]: "Total de vendas",
  },
  "products-sold": {
    [Language.ENGLISH]: "Products sold",
    [Language.SPANISH]: "Productos vendidos",
    [Language.PORTUGUESE]: "Produtos vendidos",
  },
  buyers: {
    [Language.ENGLISH]: "Buyers",
    [Language.SPANISH]: "Compradores",
    [Language.PORTUGUESE]: "Compradores",
  },
  // SALES TABLE
  downloading: {
    [Language.ENGLISH]: "Downloading...",
    [Language.SPANISH]: "Descargando...",
    [Language.PORTUGUESE]: "Baixando...",
  },
  "download-orders": {
    [Language.ENGLISH]: "Download orders",
    [Language.SPANISH]: "Descargar ordenes",
    [Language.PORTUGUESE]: "Baixar pedidos",
  },
  "download-visible-orders": {
    [Language.ENGLISH]: "Download visible orders",
    [Language.SPANISH]: "Descargar ordenes visibles",
    [Language.PORTUGUESE]: "Baixar pedidos visíveis",
  },
  "download-all-orders": {
    [Language.ENGLISH]: "Download all orders",
    [Language.SPANISH]: "Descargar todas las ordenes",
    [Language.PORTUGUESE]: "Baixar todos os pedidos",
  },
  date: {
    [Language.ENGLISH]: "Date",
    [Language.SPANISH]: "Fecha",
    [Language.PORTUGUESE]: "Data",
  },
  "date-and-time": {
    [Language.ENGLISH]: "Date and time",
    [Language.SPANISH]: "Fecha y hora",
    [Language.PORTUGUESE]: "Data e hora",
  },
  "order-number": {
    [Language.ENGLISH]: "Order number",
    [Language.SPANISH]: "Número de orden",
    [Language.PORTUGUESE]: "Número de pedido",
  },
  customer: {
    [Language.ENGLISH]: "Customer",
    [Language.SPANISH]: "Cliente",
    [Language.PORTUGUESE]: "Cliente",
  },
  total: {
    [Language.ENGLISH]: "Total",
    [Language.SPANISH]: "Total",
    [Language.PORTUGUESE]: "Total",
  },
  channel: {
    [Language.ENGLISH]: "Channel",
    [Language.SPANISH]: "Canal",
    [Language.PORTUGUESE]: "Canal",
  },
  payment: {
    [Language.ENGLISH]: "Payment",
    [Language.SPANISH]: "Pago",
    [Language.PORTUGUESE]: "Pagamento",
  },
  "payment-method": {
    [Language.ENGLISH]: "Payment method",
    [Language.SPANISH]: "Método de pago",
    [Language.PORTUGUESE]: "Método de pagamento",
  },
  status: {
    [Language.ENGLISH]: "Status",
    [Language.SPANISH]: "Estado",
    [Language.PORTUGUESE]: "Estado",
  },
  "payment-status": {
    [Language.ENGLISH]: "Payment status",
    [Language.SPANISH]: "Estado de pago",
    [Language.PORTUGUESE]: "Estado de pagamento",
  },
  fulfillment: {
    [Language.ENGLISH]: "Fulfillment",
    [Language.SPANISH]: "Envío",
    [Language.PORTUGUESE]: "Envio",
  },
  "fulfillment-status": {
    [Language.ENGLISH]: "Fulfillment status",
    [Language.SPANISH]: "Estado de envío",
    [Language.PORTUGUESE]: "Estado de envio",
  },
  items: {
    [Language.ENGLISH]: "Items",
    [Language.SPANISH]: "Unidades",
    [Language.PORTUGUESE]: "Unidades",
  },
  actions: {
    [Language.ENGLISH]: "Actions",
    [Language.SPANISH]: "Acciones",
    [Language.PORTUGUESE]: "Ações",
  },
  "paid-state": {
    [Language.ENGLISH]: "Paid",
    [Language.SPANISH]: "Pagado",
    [Language.PORTUGUESE]: "Pago",
  },
  "pending-state": {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendiente",
    [Language.PORTUGUESE]: "Pendente",
  },
  "unpaid-state": {
    [Language.ENGLISH]: "Unpaid",
    [Language.SPANISH]: "No pagado",
    [Language.PORTUGUESE]: "Não pago",
  },
  "fulfilled-state": {
    [Language.ENGLISH]: "Fulfilled",
    [Language.SPANISH]: "Entregado",
    [Language.PORTUGUESE]: "Entregado",
  },
  "unfulfilled-state": {
    [Language.ENGLISH]: "Unfulfilled",
    [Language.SPANISH]: "No entregado",
    [Language.PORTUGUESE]: "Não entregado",
  },
  view: {
    [Language.ENGLISH]: "View",
    [Language.SPANISH]: "Ver",
    [Language.PORTUGUESE]: "Ver",
  },
  "view-details": {
    [Language.ENGLISH]: "View Details",
    [Language.SPANISH]: "Ver Detalles",
    [Language.PORTUGUESE]: "Ver Detalhes",
  },
  "confirmation": {
    [Language.ENGLISH]: "Confirmation",
    [Language.SPANISH]: "Confirmación",
    [Language.PORTUGUESE]: "Confirmação",
  },
  "no-confirmation": {
    [Language.ENGLISH]: "No confirmation",
    [Language.SPANISH]: "Sin confirmación",
    [Language.PORTUGUESE]: "Sem confirmação",
  },
  "ws-confirmed": {
    [Language.ENGLISH]: "Confirmed",
    [Language.SPANISH]: "Confirmados",
    [Language.PORTUGUESE]: "Confirmados",
  },
  "ws-not-confirmed": {
    [Language.ENGLISH]: "Not confirmed",
    [Language.SPANISH]: "No confirmados",
    [Language.PORTUGUESE]: "Não confirmados",
  },
  "ws-awaiting": {
    [Language.ENGLISH]: "Awaiting",
    [Language.SPANISH]: "Esperando",
    [Language.PORTUGUESE]: "Aguardando",
  },
  "ws-none": {
    [Language.ENGLISH]: "No confirmation",
    [Language.SPANISH]: "Sin confirmación",
    [Language.PORTUGUESE]: "Sem confirmação",
  },
  "edit-address": {
    [Language.ENGLISH]: "Edit address",
    [Language.SPANISH]: "Editar dirección",
    [Language.PORTUGUESE]: "Editar endereço",
  },
  "address-detail": {
    [Language.ENGLISH]: "Address detail",
    [Language.SPANISH]: "Detalle de dirección",
    [Language.PORTUGUESE]: "Detalhe do endereço",
  },
  city: {
    [Language.ENGLISH]: "City",
    [Language.SPANISH]: "Ciudad",
    [Language.PORTUGUESE]: "Cidade",
  },
  department: {
    [Language.ENGLISH]: "Department",
    [Language.SPANISH]: "Departamento",
    [Language.PORTUGUESE]: "Departamento",
  },
  neighborhood: {
    [Language.ENGLISH]: "Neighborhood",
    [Language.SPANISH]: "Barrio",
    [Language.PORTUGUESE]: "Bairro",
  },
  "last-name": {
    [Language.ENGLISH]: "Last name",
    [Language.SPANISH]: "Apellido",
    [Language.PORTUGUESE]: "Sobrenome",
  },
  "save": {
    [Language.ENGLISH]: "Save",
    [Language.SPANISH]: "Guardar",
    [Language.PORTUGUESE]: "Salvar",
  },
  "address-updated": {
    [Language.ENGLISH]: "Address updated successfully",
    [Language.SPANISH]: "Dirección actualizada correctamente",
    [Language.PORTUGUESE]: "Endereço atualizado com sucesso",
  },
  "ai-active-warning": {
    [Language.ENGLISH]: "This conversation is being handled by AI. To edit manually, disable the AI from the chat.",
    [Language.SPANISH]: "Esta conversación la está gestionando la IA. Para editar manualmente, desactiva la IA desde el chat.",
    [Language.PORTUGUESE]: "Esta conversa está sendo gerenciada pela IA. Para editar manualmente, desative a IA no chat.",
  },
  "kanban": {
    [Language.ENGLISH]: "Kanban",
    [Language.SPANISH]: "Kanban",
    [Language.PORTUGUESE]: "Kanban",
  },
  "kanban-title-global": {
    [Language.ENGLISH]: "Confirmation Kanban",
    [Language.SPANISH]: "Kanban de Confirmaciones",
    [Language.PORTUGUESE]: "Kanban de Confirmações",
  },
  "kanban-subtitle-global": {
    [Language.ENGLISH]: "Drag orders to change their status",
    [Language.SPANISH]: "Arrastra los pedidos para cambiar su estado",
    [Language.PORTUGUESE]: "Arraste os pedidos para mudar seu status",
  },
  "order-confirmed-success": {
    [Language.ENGLISH]: "Order confirmed successfully",
    [Language.SPANISH]: "Pedido confirmado correctamente",
    [Language.PORTUGUESE]: "Pedido confirmado com sucesso",
  },
  "order-canceled-success": {
    [Language.ENGLISH]: "Order canceled successfully",
    [Language.SPANISH]: "Pedido cancelado correctamente",
    [Language.PORTUGUESE]: "Pedido cancelado com sucesso",
  },

  // ORDER DETAILS PAGE
  "order-details": {
    [Language.ENGLISH]: "Order details",
    [Language.SPANISH]: "Detalles de la orden",
    [Language.PORTUGUESE]: "Detalhes da ordem",
  },
  priority: {
    [Language.ENGLISH]: "Priority",
    [Language.SPANISH]: "Prioridad",
    [Language.PORTUGUESE]: "Prioridade",
  },
  "fulfill-item": {
    [Language.ENGLISH]: "Mark as delivered",
    [Language.SPANISH]: "Marcar como entregado",
    [Language.PORTUGUESE]: "Marcar como entregado",
  },
  "unfulfill-item": {
    [Language.ENGLISH]: "Mark as not delivered",
    [Language.SPANISH]: "Marcar como no entregado",
    [Language.PORTUGUESE]: "Marcar como não entregado",
  },
  "first-time-customer": {
    [Language.ENGLISH]: "First time customer",
    [Language.SPANISH]: "Primer pedido",
    [Language.PORTUGUESE]: "Primeiro pedido",
  },
  "customer-details": {
    [Language.ENGLISH]: "Customer details",
    [Language.SPANISH]: "Detalles del cliente",
    [Language.PORTUGUESE]: "Detalhes do cliente",
  },
  "payment-details": {
    [Language.ENGLISH]: "Payment details",
    [Language.SPANISH]: "Detalles de pago",
    [Language.PORTUGUESE]: "Detalhes de pagamento",
  },
  subtotal: {
    [Language.ENGLISH]: "Subtotal",
    [Language.SPANISH]: "Subtotal",
    [Language.PORTUGUESE]: "Subtotal",
  },
  "paid-on": {
    [Language.ENGLISH]: "Paid on",
    [Language.SPANISH]: "Pagado el",
    [Language.PORTUGUESE]: "Pago em",
  },
  "paid-with": {
    [Language.ENGLISH]: "Paid with",
    [Language.SPANISH]: "Pagado con",
    [Language.PORTUGUESE]: "Pago com",
  },
  "additional-offer": {
    [Language.ENGLISH]: "Additional offer",
    [Language.SPANISH]: "Oferta adicional",
    [Language.PORTUGUESE]: "Oferta adicional",
  },
  "benefit-purchase": {
    [Language.ENGLISH]: "Benefit purchase",
    [Language.SPANISH]: "Compra de beneficio",
    [Language.PORTUGUESE]: "Compra de benefício",
  },
  free: {
    [Language.ENGLISH]: "Free",
    [Language.SPANISH]: "Gratis",
    [Language.PORTUGUESE]: "Grátis",
  },
  "shipping-address": {
    [Language.ENGLISH]: "Shipping address",
    [Language.SPANISH]: "Dirección de envío",
    [Language.PORTUGUESE]: "Endereço de envio",
  },

  // PRODUCTS PAGE
  product: {
    [Language.ENGLISH]: "Product",
    [Language.SPANISH]: "Producto",
    [Language.PORTUGUESE]: "Produto",
  },
  price: {
    [Language.ENGLISH]: "Price",
    [Language.SPANISH]: "Precio",
    [Language.PORTUGUESE]: "Preço",
  },
  "last-updated": {
    [Language.ENGLISH]: "Last updated",
    [Language.SPANISH]: "Última actualización",
    [Language.PORTUGUESE]: "Última atualização",
  },
  "optional": {
    [Language.ENGLISH]: "OPTIONAL",
    [Language.SPANISH]: "OPCIONAL",
    [Language.PORTUGUESE]: "OPCIONAL",
  },
  colors: {
    [Language.ENGLISH]: "Colors",
    [Language.SPANISH]: "Colores",
    [Language.PORTUGUESE]: "Cores",
  },
  "upload-your-own-template": {
    [Language.ENGLISH]: "Upload your own template",
    [Language.SPANISH]: "Subir tu propio template",
    [Language.PORTUGUESE]: "Subir seu próprio template",
  },

  // ADS PAGE
  "ai-will-create-for-you": {
    [Language.ENGLISH]: "AI will create for you",
    [Language.SPANISH]: "La IA creará para ti",
    [Language.PORTUGUESE]: "A IA criará para você",
  },
  "automatically-optimized": {
    [Language.ENGLISH]: "Automatically optimized",
    [Language.SPANISH]: "Automáticamente optimizado",
    [Language.PORTUGUESE]: "Automaticamente otimizado",
  },
  "unique-ad-image-creatives": {
    [Language.ENGLISH]: "Unique ad creatives (images)",
    [Language.SPANISH]: "Creativos (imágenes) únicos de anuncios",
    [Language.PORTUGUESE]: "Criativos (imagens) únicos de anúncios",
  },
  "ready-for-your-campaigns": {
    [Language.ENGLISH]: "Ready for your campaigns",
    [Language.SPANISH]: "Listos para tus campañas",
    [Language.PORTUGUESE]: "Prontos para suas campanhas",
  },
  "customize-creatives": {
    [Language.ENGLISH]: "Customize creatives",
    [Language.SPANISH]: "Personalizar creativos",
    [Language.PORTUGUESE]: "Personalizar criativos",
  },
  "optional-describe-style": {
    [Language.ENGLISH]: "Optional · Describe the desired style",
    [Language.SPANISH]: "Opcional · Describe el estilo deseado",
    [Language.PORTUGUESE]: "Opcional · Descreva o estilo desejado",
  },
  "generate-ads": {
    [Language.ENGLISH]: "Generate ads",
    [Language.SPANISH]: "Generar Anuncios",
    [Language.PORTUGUESE]: "Gerar anúncios",
  },
  "ads-created": {
    [Language.ENGLISH]: "ads created",
    [Language.SPANISH]: "anuncios creados",
    [Language.PORTUGUESE]: "anúncios criados",
  },
  "images": {
    [Language.ENGLISH]: "Images",
    [Language.SPANISH]: "Imágenes",
    [Language.PORTUGUESE]: "Imagens",
  },
  "videos": {
    [Language.ENGLISH]: "Videos",
    [Language.SPANISH]: "Videos",
    [Language.PORTUGUESE]: "Vídeos",
  },
  "please-fill-all-the-fields": {
    [Language.ENGLISH]: "Please fill all the fields",
    [Language.SPANISH]: "Por favor, completa todos los campos",
    [Language.PORTUGUESE]: "Por favor, complete todos os campos",
  },
  "problems-with-the-creation-of-pages-and-images":{
    [Language.ENGLISH]: "We are currently experiencing problems with the creation of pages and images, we will soon re-enable this option. Thank you for your patience",
    [Language.SPANISH]: "En este momento estamos presentando problemas con la creación de páginas e imagenes, pronto volveremos a habilitar esta opción. Gracias por tu paciencia",
    [Language.PORTUGUESE]: "En este momento estamos presentando problemas com a criação de páginas e imagens, em breve voltaremos a habilitar esta opção. Obrigado pela sua paciência",

  },
  "failed-to-generate-narrative": {
    [Language.ENGLISH]: "Failed to generate narrative",
    [Language.SPANISH]: "Error al generar la narrativa",
    [Language.PORTUGUESE]: "Erro ao gerar a narrativa",
  },
  "narrative-generated-successfully": {
    [Language.ENGLISH]: "Narrative generated successfully",
    [Language.SPANISH]: "Narrativa generada correctamente",
    [Language.PORTUGUESE]: "Narrativa gerada com sucesso",
  },
  "your-ads": {
    [Language.ENGLISH]: "Your ads",
    [Language.SPANISH]: "Tus anuncios",
    [Language.PORTUGUESE]: "Seus anúncios",
  },
  "your-generated-narratives-will-appear-here": {
    [Language.ENGLISH]: "Your generated narratives will appear here.",
    [Language.SPANISH]: "Tus narrativas generadas aparecerán aquí.",
    [Language.PORTUGUESE]: "Suas narrativas geradas aparecerão aqui.",
  },
  "start-filling-the-form-on-the-right": {
    [Language.ENGLISH]: "Start filling the form on the right.",
    [Language.SPANISH]: "Comienza llenando el formulario de la derecha.",
    [Language.PORTUGUESE]: "Comece a preencher o formulário à direita.",
  },
  "no-narratives-yet": {
    [Language.ENGLISH]: "No narratives yet",
    [Language.SPANISH]: "No hay narrativas aún",
    [Language.PORTUGUESE]: "Nenhuma narrativa ainda",
  },
  "no-narratives-found-for-this-filter": {
    [Language.ENGLISH]: "No narratives found for this filter.",
    [Language.SPANISH]: "No se encontraron narrativas para este filtro.",
    [Language.PORTUGUESE]: "Nenhuma narrativa encontrada para este filtro.",
  },
  "create-your-scripts": {
    [Language.ENGLISH]: "Create your scripts",
    [Language.SPANISH]: "Crear tus guiones",
    [Language.PORTUGUESE]: "Criar seus guias",
  },
  "product-name": {
    [Language.ENGLISH]: "Product name",
    [Language.SPANISH]: "Nombre del producto",
    [Language.PORTUGUESE]: "Nome do produto",
  },
  "product-description": {
    [Language.ENGLISH]: "Product description",
    [Language.SPANISH]: "Descripción del producto",
    [Language.PORTUGUESE]: "Descrição do produto",
  },
  "confirm-your-main-product": {
    [Language.ENGLISH]: "Confirm your Main Product",
    [Language.SPANISH]: "Confirma tu Producto Principal",
    [Language.PORTUGUESE]: "Confirme seu Produto Principal",
  },
  "edit-data-if-needed": {
    [Language.ENGLISH]: "Edit the data if needed before continuing.",
    [Language.SPANISH]: "Edita los datos si es necesario antes de continuar.",
    [Language.PORTUGUESE]: "Edite os dados se necessário antes de continuar.",
  },
  "confirm-data": {
    [Language.ENGLISH]: "Confirm data",
    [Language.SPANISH]: "Confirmar datos",
    [Language.PORTUGUESE]: "Confirmar dados",
  },
  "checking-product-images": {
    [Language.ENGLISH]: "We are checking the product images. Try again in a moment.",
    [Language.SPANISH]: "Estamos verificando las imágenes. Intenta de nuevo en un momento.",
    [Language.PORTUGUESE]: "Estamos verificando as imagens. Tente novamente em um momento.",
  },
  "inaccessible-product-images": {
    [Language.ENGLISH]: "Some images cannot be loaded. Remove them or upload another image.",
    [Language.SPANISH]: "Hay imágenes que no se pueden cargar. Elimínalas o sube otra imagen.",
    [Language.PORTUGUESE]: "Algumas imagens não podem ser carregadas. Remova-as ou envie outra imagem.",
  },
  "product-image-load-failed": {
    [Language.ENGLISH]: "This image could not be loaded.",
    [Language.SPANISH]: "No se pudo cargar esta imagen.",
    [Language.PORTUGUESE]: "Não foi possível carregar esta imagem.",
  },
  "remove-inaccessible-product-images": {
    [Language.ENGLISH]: "Remove the images that do not load or upload a new one to continue.",
    [Language.SPANISH]: "Elimina las imágenes que no cargan o sube una nueva para continuar.",
    [Language.PORTUGUESE]: "Remova as imagens que não carregam ou envie uma nova para continuar.",
  },
  "confirm-order-bump": {
    [Language.ENGLISH]: "Confirm your Order Bump",
    [Language.SPANISH]: "Confirma tu Order Bump",
    [Language.PORTUGUESE]: "Confirme seu Order Bump",
  },
  "confirm-upsell": {
    [Language.ENGLISH]: "Confirm your Upsell",
    [Language.SPANISH]: "Confirma tu Upsell",
    [Language.PORTUGUESE]: "Confirme seu Upsell",
  },
  "sale-angle": {
    [Language.ENGLISH]: "Sale angle",
    [Language.SPANISH]: "Ángulo de venta",
    [Language.PORTUGUESE]: "Ângulo de venda",
  },
  "product-name-placeholder": {
    [Language.ENGLISH]: "Product name",
    [Language.SPANISH]: "Nombre del producto",
    [Language.PORTUGUESE]: "Nome do produto",
  },
  "product-description-placeholder": {
    [Language.ENGLISH]: "Product description",
    [Language.SPANISH]: "Descripción del producto",
    [Language.PORTUGUESE]: "Descrição do produto",
  },
  "sale-angle-placeholder": {
    [Language.ENGLISH]: "Sale angle",
    [Language.SPANISH]: "Ángulo de venta",
    [Language.PORTUGUESE]: "Ângulo de venda",
  },
  "podcast-style": {
    [Language.ENGLISH]: "Podcast style",
    [Language.SPANISH]: "Estilo podcast",
    [Language.PORTUGUESE]: "Estilo podcast",
  },
  "comedy-style": {
    [Language.ENGLISH]: "Comedy style",
    [Language.SPANISH]: "Estilo comedia",
    [Language.PORTUGUESE]: "Estilo comedia",
  },
  "tutorial-style": {
    [Language.ENGLISH]: "Tutorial style",
    [Language.SPANISH]: "Estilo tutorial",
    [Language.PORTUGUESE]: "Estilo tutorial",
  },
  "testimonial-style": {
    [Language.ENGLISH]: "Testimonial style",
    [Language.SPANISH]: "Estilo testimonial",
    [Language.PORTUGUESE]: "Estilo testimonial",
  },
  "generate-scripts": {
    [Language.ENGLISH]: "Generate scripts",
    [Language.SPANISH]: "Generar guiones",
    [Language.PORTUGUESE]: "Gerar guias",
  },
  "generating-your-scripts": {
    [Language.ENGLISH]: "Generating your scripts",
    [Language.SPANISH]: "Generando tus guiones",
    [Language.PORTUGUESE]: "Gerando seus guias",
  },
  "this-might-take-a-few-moments": {
    [Language.ENGLISH]: "This might take a few moments...",
    [Language.SPANISH]: "Esto puede tomar unos minutos...",
    [Language.PORTUGUESE]: "Isso pode levar alguns momentos...",
  },
  "create-ad": {
    [Language.ENGLISH]: "Create ad",
    [Language.SPANISH]: "Crear anuncio",
    [Language.PORTUGUESE]: "Criar anúncio",
  },
  style: {
    [Language.ENGLISH]: "Style",
    [Language.SPANISH]: "Estilo",
    [Language.PORTUGUESE]: "Estilo",
  },
  "controversial-expert-style": {
    [Language.ENGLISH]: "Controversial expert",
    [Language.SPANISH]: "Experto polémico",
    [Language.PORTUGUESE]: "Experto polêmico",
  },
  "dark-conspiracy-style": {
    [Language.ENGLISH]: "Dark conspiracy",
    [Language.SPANISH]: "Conspiración oscura",
    [Language.PORTUGUESE]: "Conspirância escura",
  },
  "honest-review-style": {
    [Language.ENGLISH]: "Honest review",
    [Language.SPANISH]: "Reseña honesta",
    [Language.PORTUGUESE]: "Resenha honesta",
  },

  // FUNNELS PAGE
  "my-funnels": {
    [Language.ENGLISH]: "My funnels",
    [Language.SPANISH]: "Mis embudos",
    [Language.PORTUGUESE]: "Meus embudos",
  },
  "manage-your-sales-funnels": {
    [Language.ENGLISH]: "Manage your sales funnels",
    [Language.SPANISH]: "Gestiona tus embudos de ventas",
    [Language.PORTUGUESE]: "Gerencia seus embudos de vendas",
  },
  "create-funnel": {
    [Language.ENGLISH]: "Create funnel",
    [Language.SPANISH]: "Crear embudo",
    [Language.PORTUGUESE]: "Criar embudo",
  },
  "create-home": {
    [Language.ENGLISH]: "Create home",
    [Language.SPANISH]: "Crear tienda",
    [Language.PORTUGUESE]: "Criar loja",
  },
  "connected-funnels": {
    [Language.ENGLISH]: "Connected funnels",
    [Language.SPANISH]: "Embudos conectados",
    [Language.PORTUGUESE]: "Embudos conectados",
  },
  "are-you-sure-you-want-to-delete-this-funnel": {
    [Language.ENGLISH]: "Are you sure you want to delete this funnel?",
    [Language.SPANISH]: "¿Estás seguro de querer eliminar este embudo?",
    [Language.PORTUGUESE]: "Tem certeza que deseja deletar este embudo?",
  },
  "this-action-cannot-be-undone": {
    [Language.ENGLISH]: "This action cannot be undone.",
    [Language.SPANISH]: "Esta acción no puede ser deshecha.",
    [Language.PORTUGUESE]: "Esta ação não pode ser desfeita.",
  },
  delete: {
    [Language.ENGLISH]: "Delete",
    [Language.SPANISH]: "Eliminar",
    [Language.PORTUGUESE]: "Deletar",
  },
  active: {
    [Language.ENGLISH]: "Active",
    [Language.SPANISH]: "Activo",
    [Language.PORTUGUESE]: "Ativo",
  },
  draft: {
    [Language.ENGLISH]: "Draft",
    [Language.SPANISH]: "Borrador",
    [Language.PORTUGUESE]: "Rascunho",
  },
  processing: {
    [Language.ENGLISH]: "Processing",
    [Language.SPANISH]: "Procesando",
    [Language.PORTUGUESE]: "Processando",
  },
  "funnel-created": {
    [Language.ENGLISH]: "Funnel created",
    [Language.SPANISH]: "Embudo creado",
    [Language.PORTUGUESE]: "Embudo criado",
  },
  edit: {
    [Language.ENGLISH]: "Edit",
    [Language.SPANISH]: "Editar",
    [Language.PORTUGUESE]: "Editar",
  },
  stats: {
    [Language.ENGLISH]: "Stats",
    [Language.SPANISH]: "Estadísticas",
    [Language.PORTUGUESE]: "Métricas",
  },
  metrics: {
    [Language.ENGLISH]: "Metrics",
    [Language.SPANISH]: "Métricas",
    [Language.PORTUGUESE]: "Métricas",
  },
  "ai-auto-optimization": {
    [Language.ENGLISH]: "AI Auto-Optimization",
    [Language.SPANISH]: "Optimización automática de IA",
    [Language.PORTUGUESE]: "Otimização automática de IA",
  },
  duplicate: {
    [Language.ENGLISH]: "Duplicate",
    [Language.SPANISH]: "Duplicar",
    [Language.PORTUGUESE]: "Duplicar",
  },
  "product-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the product has a name, price, description, and images.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el producto tenga un nombre, precio, descripción y imágenes.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o produto tenha um nome, preço, descrição e imagens.",
  },
  "product-information-incomplete-title": {
    [Language.ENGLISH]: "Product Information Incomplete",
    [Language.SPANISH]: "Información del producto incompleta",
    [Language.PORTUGUESE]: "Informações do produto incompletas",
  },
  "describe-your-custom-sales-angle": {
    [Language.ENGLISH]: "Describe your custom sales angle",
    [Language.SPANISH]: "Describe tu ángulo de venta personalizado",
    [Language.PORTUGUESE]: "Descreva seu ângulo de venda personalizado",
  },
  "describe-your-custom-sales-angle-placeholder": {
    [Language.ENGLISH]:
      "Describe how you want to position your product to potential customers...",
    [Language.SPANISH]:
      "Describe cómo quieres posicionar tu producto a potenciales clientes...",
    [Language.PORTUGUESE]:
      "Descreva como você deseja posicionar seu produto para potenciais clientes...",
  },
  "describe-your-custom-sales-angle-footer": {
    [Language.ENGLISH]:
      "Be specific about the unique selling proposition and the emotional appeal you want to create.",
    [Language.SPANISH]:
      "Sé específico sobre la propuesta de valor única y el atractivo emocional que quieres crear.",
    [Language.PORTUGUESE]:
      "Seja específico sobre a proposta de valor única e o apelo emocional que você deseja criar.",
  },
  "magic-title-step-3": {
    [Language.ENGLISH]: "Magic happens here!",
    [Language.SPANISH]: "¡Magia sucede aquí!",
    [Language.PORTUGUESE]: "A magia acontece aqui!",
  },
  "magic-description-step-3": {
    [Language.ENGLISH]:
      "Product bundles are key to increasing your average order value and making more money",
    [Language.SPANISH]:
      "Los paquetes de productos son clave para aumentar tu valor promedio de pedido y ganar más dinero",
    [Language.PORTUGUESE]:
      "Os pacotes de produtos são chave para aumentar seu valor médio de pedido e ganhar mais dinheiro",
  },
  "order-bump-description": {
    [Language.ENGLISH]:
      "Add a small complementary item that customers can add with a single click",
    [Language.SPANISH]:
      "Agrega un pequeño artículo complementario que los clientes pueden agregar con un solo clic",
    [Language.PORTUGUESE]:
      "Adicione um pequeno item complementar que os clientes podem adicionar com um único clique",
  },
  "upsell-title": {
    [Language.ENGLISH]: "UpSell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  "upsell-description": {
    [Language.ENGLISH]:
      "Offer complementary products at special prices to increase the value of the purchase",
    [Language.SPANISH]:
      "Oferta productos complementarios a precios especiales para aumentar el valor de la compra",
    [Language.PORTUGUESE]:
      "Ofereça produtos complementares a preços especiais para aumentar o valor da compra",
  },
  "complementary-products": {
    [Language.ENGLISH]: "Complementary products",
    [Language.SPANISH]: "Productos complementarios",
    [Language.PORTUGUESE]: "Produtos complementares",
  },

  // ONBOARDING PAGE
  "magical-funnel-creation": {
    [Language.ENGLISH]: "Magical funnel creation",
    [Language.SPANISH]: "Creación de embudo mágica",
    [Language.PORTUGUESE]: "Criação de funil mágico",
  },
  "product-details": {
    [Language.ENGLISH]: "Product details",
    [Language.SPANISH]: "Detalles del producto",
    [Language.PORTUGUESE]: "Detalhes do produto",
  },
  "marketing-angle": {
    [Language.ENGLISH]: "Marketing angle",
    [Language.SPANISH]: "Ángulo de marketing",
    [Language.PORTUGUESE]: "Ângulo de marketing",
  },
  "upsell-options": {
    [Language.ENGLISH]: "Upsell options",
    [Language.SPANISH]: "Opciones de upsell",
    [Language.PORTUGUESE]: "Opções de upsell",
  },
  "brand-style": {
    [Language.ENGLISH]: "Brand & style",
    [Language.SPANISH]: "Marca y estilo",
    [Language.PORTUGUESE]: "Marca e estilo",
  },
  "select-a-product-for-your-sales-funnel": {
    [Language.ENGLISH]: "Select a product for your sales funnel",
    [Language.SPANISH]: "Selecciona un producto para tu embudo de ventas",
    [Language.PORTUGUESE]: "Selecione um produto para seu funil de vendas",
  },
  "import-from-link": {
    [Language.ENGLISH]: "Import from link",
    [Language.SPANISH]: "Importar desde link",
    [Language.PORTUGUESE]: "Importar desde link",
  },
  "enter-manually": {
    [Language.ENGLISH]: "Enter manually",
    [Language.SPANISH]: "Ingresar manualmente",
    [Language.PORTUGUESE]: "Entrar manualmente",
  },
  "your-products": {
    [Language.ENGLISH]: "Your products",
    [Language.SPANISH]: "Tus productos",
    [Language.PORTUGUESE]: "Seus produtos",
  },
  "choose-different-method": {
    [Language.ENGLISH]: "Choose different method",
    [Language.SPANISH]: "Elegir un método diferente",
    [Language.PORTUGUESE]: "Escolher um método diferente",
  },
  "import-product-from-link": {
    [Language.ENGLISH]: "Import product from link",
    [Language.SPANISH]: "Importar producto desde link",
    [Language.PORTUGUESE]: "Importar produto desde link",
  },
  "searching-your-product": {
    [Language.ENGLISH]: "Searching your product...",
    [Language.SPANISH]: "Buscando tu producto...",
    [Language.PORTUGUESE]: "Buscando seu produto...",
  },
  "paste-product-url-placeholder": {
    [Language.ENGLISH]: "Paste product URL",
    [Language.SPANISH]: "Pega la URL del producto",
    [Language.PORTUGUESE]: "Cole a URL do produto",
  },
  "product-information": {
    [Language.ENGLISH]: "Product information",
    [Language.SPANISH]: "Información del producto",
    [Language.PORTUGUESE]: "Informações do produto",
  },
  "upload-image": {
    [Language.ENGLISH]: "Upload Image",
    [Language.SPANISH]: "Subir Imagen",
    [Language.PORTUGUESE]: "Subir Imagem",
  },
  "upload-images": {
    [Language.ENGLISH]: "Upload Images",
    [Language.SPANISH]: "Subir Imágenes",
    [Language.PORTUGUESE]: "Subir Imagens",
  },
  "accepted-formats": {
    [Language.ENGLISH]: "Accepted formats: JPG, PNG, WEBP and JPEG",
    [Language.SPANISH]: "Formatos aceptados: JPG, PNG, WEBP y JPEG",
    [Language.PORTUGUESE]: "Formatos aceitos: JPG, PNG, WEBP e JPEG",
  },
  "drag-and-drop-your-images-here-or-click-to-select": {
    [Language.ENGLISH]: "Drag and drop your images here or click to select",
    [Language.SPANISH]:
      "Arrastra y suelta tus imágenes aquí o haz clic para seleccionar",
    [Language.PORTUGUESE]:
      "Arraste e solte suas imagens aqui ou clique para selecionar",
  },
  "add-more-images": {
    [Language.ENGLISH]: "Add more images",
    [Language.SPANISH]: "Agregar más imágenes",
    [Language.PORTUGUESE]: "Adicionar mais imagens",
  },
  "product-details-placeholder": {
    [Language.ENGLISH]: "Product details",
    [Language.SPANISH]: "Detalles del producto",
    [Language.PORTUGUESE]: "Detalhes do produto",
  },
  "product-name-placeholder-manual-entry": {
    [Language.ENGLISH]: "Example: Adidas predator",
    [Language.SPANISH]: "Ejemplo: Adidas predator",
    [Language.PORTUGUESE]: "Exemplo: Adidas predator",
  },
  "product-details-placeholder-manual-entry": {
    [Language.ENGLISH]:
      "Describe the main features and benefits of your product...",
    [Language.SPANISH]:
      "Describe las principales características y beneficios de tu producto...",
    [Language.PORTUGUESE]:
      "Descreva as principais características e benefícios de seu produto...",
  },
  "search-previous-products-placeholder": {
    [Language.ENGLISH]: "Search previous products",
    [Language.SPANISH]: "Buscar productos anteriores",
    [Language.PORTUGUESE]: "Buscar produtos anteriores",
  },
  next: {
    [Language.ENGLISH]: "Next",
    [Language.SPANISH]: "Siguiente",
    [Language.PORTUGUESE]: "Próximo",
  },
  previous: {
    [Language.ENGLISH]: "Previous",
    [Language.SPANISH]: "Anterior",
    [Language.PORTUGUESE]: "Anterior",
  },
  "loading-personalized-sales-angles": {
    [Language.ENGLISH]: "Searching reviews of similar products...",
    [Language.SPANISH]: "Buscando reseñas de productos similares...",
    [Language.PORTUGUESE]: "Buscando avaliações de produtos similares...",
  },
  "funnel-research-error-title": {
    [Language.ENGLISH]: "We couldn't complete the research",
    [Language.SPANISH]: "No pudimos realizar la investigación",
    [Language.PORTUGUESE]: "Não conseguimos concluir a pesquisa",
  },
  "funnel-research-error-description": {
    [Language.ENGLISH]: "The product analysis took longer than expected. Please try again in a few minutes.",
    [Language.SPANISH]: "El análisis del producto tomó más de lo esperado. Inténtalo nuevamente en unos minutos.",
    [Language.PORTUGUESE]: "A análise do produto demorou mais do que o esperado. Tente novamente em alguns minutos.",
  },
  "sales-angles-error-title": {
    [Language.ENGLISH]: "We could not generate the sales angles",
    [Language.SPANISH]: "No pudimos generar los ángulos",
    [Language.PORTUGUESE]: "Não conseguimos gerar os ângulos",
  },
  "sales-angles-error-message": {
    [Language.ENGLISH]: "We could not generate quality sales angles. Retry to keep the funnel strategy grounded in the product.",
    [Language.SPANISH]: "No pudimos generar ángulos de venta de calidad. Reintenta para mantener la estrategia del embudo bien aterrizada al producto.",
    [Language.PORTUGUESE]: "Não conseguimos gerar ângulos de venda de qualidade. Tente novamente para manter a estratégia do funil alinhada ao produto.",
  },
  recommended: {
    [Language.ENGLISH]: "Recommended",
    [Language.SPANISH]: "Recomendado",
    [Language.PORTUGUESE]: "Recomendado",
  },
  "choose-1-to-6-sales-angles-for-your-funnels": {
    [Language.ENGLISH]: "Choose 1 to 6 sales angles for your funnels",
    [Language.SPANISH]: "Elige 1 a 6 ángulos de venta para tus embudos",
    [Language.PORTUGUESE]: "Escolha 1 a 6 ângulos de venda para seus embudos",
  },
  "free-shipping": {
    [Language.ENGLISH]: "Free shipping",
    [Language.SPANISH]: "Envío gratis",
    [Language.PORTUGUESE]: "Frete grátis",
  },
  "30-days-warranty": {
    [Language.ENGLISH]: "30 days warranty",
    [Language.SPANISH]: "30 días de garantía",
    [Language.PORTUGUESE]: "30 dias de garantia",
  },
  "90-days-warranty": {
    [Language.ENGLISH]: "90 days warranty",
    [Language.SPANISH]: "90 días de garantía",
    [Language.PORTUGUESE]: "90 dias de garantia",
  },
  "custom-warranty": {
    [Language.ENGLISH]: "Custom warranty",
    [Language.SPANISH]: "Garantía personalizada",
    [Language.PORTUGUESE]: "Garantia personalizada",
  },
  "no-products-found": {
    [Language.ENGLISH]: "No products found",
    [Language.SPANISH]: "No se encontraron productos",
    [Language.PORTUGUESE]: "Nenhum produto encontrado",
  },
  "loading-products": {
    [Language.ENGLISH]: "Loading products...",
    [Language.SPANISH]: "Cargando productos...",
    [Language.PORTUGUESE]: "Carregando produtos...",
  },
  "import-order bump-from-link": {
    [Language.ENGLISH]: "Import order bump from link",
    [Language.SPANISH]: "Importar oferta de aumento desde link",
    [Language.PORTUGUESE]: "Importar oferta de aumento desde link",
  },
  "import-upsell-from-link": {
    [Language.ENGLISH]: "Import upsell from link",
    [Language.SPANISH]: "Importar upsell desde link",
    [Language.PORTUGUESE]: "Importar upsell desde link",
  },
  "product-image-automatically-imported": {
    [Language.ENGLISH]:
      "The product image will be automatically imported from the marketplace.",
    [Language.SPANISH]:
      "La imagen del producto se importará automáticamente desde el marketplace.",
    [Language.PORTUGUESE]:
      "A imagem do produto será importada automaticamente do marketplace.",
  },
  "upload-an-image-of-your-product": {
    [Language.ENGLISH]: "Upload an image of your product",
    [Language.SPANISH]: "Subir una imagen de tu producto",
    [Language.PORTUGUESE]: "Subir uma imagem do seu produto",
  },
  "upload-product-image": {
    [Language.ENGLISH]: "Upload product image",
    [Language.SPANISH]: "Subir imagen del producto",
    [Language.PORTUGUESE]: "Subir imagem do produto",
  },
  description: {
    [Language.ENGLISH]: "Description",
    [Language.SPANISH]: "Descripción",
    [Language.PORTUGUESE]: "Descrição",
  },
  "enter-product-name-placeholder": {
    [Language.ENGLISH]: "Enter product name",
    [Language.SPANISH]: "Ingresar nombre del producto",
    [Language.PORTUGUESE]: "Digite o nome do produto",
  },
  "enter-price-placeholder": {
    [Language.ENGLISH]: "Enter price",
    [Language.SPANISH]: "Ingresar precio",
    [Language.PORTUGUESE]: "Digite o preço",
  },
  "main-product-price-incomplete-title": {
    [Language.ENGLISH]: "Main Product Price Incomplete",
    [Language.SPANISH]: "Precio del producto principal incompleto",
    [Language.PORTUGUESE]: "Preço do produto principal incompleto",
  },
  "order-bump-product-price-incomplete-title": {
    [Language.ENGLISH]: "Order Bump Product Price Incomplete",
    [Language.SPANISH]: "Precio del order bump incompleto",
    [Language.PORTUGUESE]: "Preço do order bump incompleto",
  },
  "upsell-product-price-incomplete-title": {
    [Language.ENGLISH]: "Upsell Product Price Incomplete",
    [Language.SPANISH]: "Precio del upsell incompleto",
    [Language.PORTUGUESE]: "Preço do upsell incompleto",
  },
  "price-required": {
    [Language.ENGLISH]: "Price required",
    [Language.SPANISH]: "Precio requerido",
    [Language.PORTUGUESE]: "Preço requerido",
  },
  "enter-description-placeholder": {
    [Language.ENGLISH]: "Enter description",
    [Language.SPANISH]: "Ingresar descripción",
    [Language.PORTUGUESE]: "Digite a descrição",
  },
  "product-information-incomplete-message": {
    [Language.ENGLISH]:
      "Please make sure the product has a name, price, description, and images.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el producto tenga un nombre, precio, descripción y imágenes.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o produto tenha um nome, preço, descrição e imagens.",
  },
  "one-last-thing-tell-us-about-your-brand": {
    [Language.ENGLISH]: "One last thing! Tell us about your brand",
    [Language.SPANISH]: "¡Una última cosa! Cuéntanos sobre tu marca",
    [Language.PORTUGUESE]: "Uma última coisa! Conte-nos sobre sua marca",
  },
  "generating-suggestions-with-ai": {
    [Language.ENGLISH]: "Generating suggestions with AI ...",
    [Language.SPANISH]: "Generando sugerencias con IA ...",
    [Language.PORTUGUESE]: "Gerando sugestões com IA ...",
  },
  "sync-error-title": {
    [Language.ENGLISH]: "Sync error",
    [Language.SPANISH]: "Error de sincronización",
    [Language.PORTUGUESE]: "Erro de sincronização",
  },
  "sync-error-description": {
    [Language.ENGLISH]: "Error connecting to the inventory API",
    [Language.SPANISH]: "Error al conectar con el API de inventario",
    [Language.PORTUGUESE]: "Erro ao conectar com o API de inventário",
  },
  "sync-error-dropi-title": {
    [Language.ENGLISH]: "Error syncing order with Dropi",
    [Language.SPANISH]: "Error al sincronizar orden con Dropi",
    [Language.PORTUGUESE]: "Erro ao sincronizar pedido com Dropi",
  },
  "sync-error-shopify-title": {
    [Language.ENGLISH]: "Error syncing order with Shopify",
    [Language.SPANISH]: "Error al sincronizar orden con Shopify",
    [Language.PORTUGUESE]: "Erro ao sincronizar pedido com Shopify",
  },
  "sync-error-both-title": {
    [Language.ENGLISH]: "Error syncing order with Shopify and Dropi",
    [Language.SPANISH]: "Error al sincronizar orden con Shopify y Dropi",
    [Language.PORTUGUESE]: "Erro ao sincronizar pedido com Shopify e Dropi",
  },
  generating: {
    [Language.ENGLISH]: "Generating...",
    [Language.SPANISH]: "Generando...",
    [Language.PORTUGUESE]: "Gerando...",
  },
  generate: {
    [Language.ENGLISH]: "Generate",
    [Language.SPANISH]: "Generar",
    [Language.PORTUGUESE]: "Gerar",
  },
  "brand-name": {
    [Language.ENGLISH]: "Brand name",
    [Language.SPANISH]: "Nombre de la marca",
    [Language.PORTUGUESE]: "Nome da marca",
  },
  "enter-your-brand-name-placeholder": {
    [Language.ENGLISH]: "Enter your brand name",
    [Language.SPANISH]: "Ingresar nombre de la marca",
    [Language.PORTUGUESE]: "Digite o nome da marca",
  },
  "price-configuration": {
    [Language.ENGLISH]: "Price configuration (In dollars USA)",
    [Language.SPANISH]: "Configuración de precios (En pesos colombianos)",
    [Language.PORTUGUESE]: "Configuração de preços (Em reais brasileiros)",
  },
  "no-products-configured": {
    [Language.ENGLISH]: "No products configured.",
    [Language.SPANISH]: "No hay productos configurados.",
    [Language.PORTUGUESE]: "Nenhum produto configurado.",
  },
  "product-with-variants-message": {
    [Language.ENGLISH]:
      "This product will be created with variations based on the Dropi page and will be reflected in the created funnel",
    [Language.SPANISH]:
      "Este producto se creará con variaciones basadas en la página de Dropi y quedará reflejado en el embudo creado",
    [Language.PORTUGUESE]:
      "Este produto será criado com variações baseadas na página do Dropi e refletirá no funil criado",
  },
  "main-product": {
    [Language.ENGLISH]: "Main product",
    [Language.SPANISH]: "Producto principal",
    [Language.PORTUGUESE]: "Produto principal",
  },
  "order-bump": {
    [Language.ENGLISH]: "Order bump",
    [Language.SPANISH]: "Order bump",
    [Language.PORTUGUESE]: "Order bump",
  },
  "money-back-guarantee": {
    [Language.ENGLISH]: "Money-Back Guarantee",
    [Language.SPANISH]: "Garantía de devolución de dinero",
    [Language.PORTUGUESE]: "Garantia de devolução de dinheiro",
  },
  days: {
    [Language.ENGLISH]: "Days",
    [Language.SPANISH]: "Días",
    [Language.PORTUGUESE]: "Dias",
  },
  "free-shipfping": {
    [Language.ENGLISH]: "Free shipping",
    [Language.SPANISH]: "Envío gratis",
    [Language.PORTUGUESE]: "Frete grátis",
  },
  "please-select-a-minimum-of-1-marketing-angle": {
    [Language.ENGLISH]: "Please select a minimum of 1 marketing angle.",
    [Language.SPANISH]:
      "Por favor, selecciona un mínimo de 1 ángulo de marketing.",
    [Language.PORTUGUESE]:
      "Por favor, selecione um mínimo de 1 ângulo de marketing.",
  },
  "marketing-angle-required": {
    [Language.ENGLISH]: "Marketing angle required",
    [Language.SPANISH]: "Ángulo de marketing requerido",
    [Language.PORTUGUESE]: "Ângulo de marketing requerido",
  },
  "select-funnels-homes": {
    [Language.ENGLISH]: "Select funnels for your home",
    [Language.SPANISH]: "Selecciona los embudos para tu tienda",
    [Language.PORTUGUESE]: "Selecione os funis para sua loja",
  },
  "search-funnels": {
    [Language.ENGLISH]: "Search and select funnels...",
    [Language.SPANISH]: "Buscar y seleccionar embudos...",
    [Language.PORTUGUESE]: "Pesquisar e selecionar funis...",
  },
  "no-funnels-found": {
    [Language.ENGLISH]: "No funnels found",
    [Language.SPANISH]: "No se encontraron embudos",
    [Language.PORTUGUESE]: "Nenhum funil encontrado",
  },
  "no-funnels-available": {
    [Language.ENGLISH]: "No more funnels available",
    [Language.SPANISH]: "No hay más embudos disponibles",
    [Language.PORTUGUESE]: "Nenhum funil disponível",
  },
  "funnels-selected-home-label": {
    [Language.ENGLISH]: "Here you will see the funnels you select",
    [Language.SPANISH]: "Acá aparecerán los embudos que selecciones",
    [Language.PORTUGUESE]: "Aqui você verá os funis que selecionar",
  },
  "group-funnels-and-create-homes": {
    [Language.ENGLISH]: "Group funnels and create your store in seconds",
    [Language.SPANISH]: "Agrupa embudos y crea tu tienda en segundos",
    [Language.PORTUGUESE]: "Agrupa funis e cria sua loja em segundos",
  },
  "brand-configuration": {
    [Language.ENGLISH]: "Brand configuration",
    [Language.SPANISH]: "Configuración de marca",
    [Language.PORTUGUESE]: "Configuração de marca",
  },
  "brand-context": {
    [Language.ENGLISH]: "Brand context",
    [Language.SPANISH]: "Contexto de marca",
    [Language.PORTUGUESE]: "Contexto de marca",
  },
  "brand-context-description": {
    [Language.ENGLISH]: "What is your mission and what makes your brand unique",
    [Language.SPANISH]: "Cuál es tu misión y qué hace única a tu marca",
    [Language.PORTUGUESE]: "Qual é sua missão e o que torna sua marca única",
  },
  "enter-brand-name": {
    [Language.ENGLISH]: "Enter your brand name",
    [Language.SPANISH]: "Ingresa el nombre de tu marca",
    [Language.PORTUGUESE]: "Digite o nome da marca",
  },
  "describe-brand": {
    [Language.ENGLISH]: "Describe your brand: mission, values, target audience and what makes it unique",
    [Language.SPANISH]: "Describe tu marca: misión, valores, público objetivo y qué la hace única",
    [Language.PORTUGUESE]: "Descreva sua marca: missão, valores, público alvo e o que a torna única",
  },
  "regenerate-with-ia": {
    [Language.ENGLISH]: "Regenerate with IA",
    [Language.SPANISH]: "Regenerar con IA",
    [Language.PORTUGUESE]: "Regenerar com IA",
  },
  "create-store": {
    [Language.ENGLISH]: "Create store",
    [Language.SPANISH]: "Crear tienda",
    [Language.PORTUGUESE]: "Criar loja",
  },
  // SETTINGS PAGE
  "payment-methods": {
    [Language.ENGLISH]: "Payment methods",
    [Language.SPANISH]: "Métodos de pago",
    [Language.PORTUGUESE]: "Métodos de pagamento",
  },
  "customer-support": {
    [Language.ENGLISH]: "Customer support",
    [Language.SPANISH]: "Soporte al cliente",
    [Language.PORTUGUESE]: "Suporte ao cliente",
  },
  logout: {
    [Language.ENGLISH]: "Logout",
    [Language.SPANISH]: "Cerrar sesión",
    [Language.PORTUGUESE]: "Sair",
  },
  "payment-methods-description": {
    [Language.ENGLISH]: "Manage your payment methods",
    [Language.SPANISH]: "Gestiona tus métodos de pago",
    [Language.PORTUGUESE]: "Gerencie seus métodos de pagamento",
  },

  // Funnel Statistics
  "funnel-statistics": {
    [Language.ENGLISH]: "Funnel statistics",
    [Language.SPANISH]: "Estadísticas del embudo",
    [Language.PORTUGUESE]: "Estatísticas do funil",
  },
  "total-revenue": {
    [Language.ENGLISH]: "Total Revenue",
    [Language.SPANISH]: "Ingresos totales",
    [Language.PORTUGUESE]: "Receita total",
  },
  "average-ticket": {
    [Language.ENGLISH]: "Average Ticket",
    [Language.SPANISH]: "Ticket promedio",
    [Language.PORTUGUESE]: "Ticket médio",
  },
  "funnel-products": {
    [Language.ENGLISH]: "Funnel Products",
    [Language.SPANISH]: "Productos del embudo",
    [Language.PORTUGUESE]: "Produtos do funil",
  },
  "no-sales-yet": {
    [Language.ENGLISH]: "There are no sales yet",
    [Language.SPANISH]: "No hay ventas aún",
    [Language.PORTUGUESE]: "Ainda não há vendas",
  },
  "sales-without-product-navigation": {
    [Language.ENGLISH]: "Sales are registered for this funnel. Product navigation detail is not available yet.",
    [Language.SPANISH]: "Este embudo ya tiene ventas. El detalle de navegación por producto aún no está disponible.",
    [Language.PORTUGUESE]: "Este funil já tem vendas. O detalhe de navegação por produto ainda não está disponível.",
  },
  "total-visits": {
    [Language.ENGLISH]: "Total Visits",
    [Language.SPANISH]: "Visitas totales",
    [Language.PORTUGUESE]: "Visitas totais",
  },
  "units-sold": {
    [Language.ENGLISH]: "Units sold",
    [Language.SPANISH]: "Unidades vendidas",
    [Language.PORTUGUESE]: "Unidades vendidas",
  },
  revenue: {
    [Language.ENGLISH]: "Revenue",
    [Language.SPANISH]: "Ingresos",
    [Language.PORTUGUESE]: "Receita",
  },
  visits: {
    [Language.ENGLISH]: "Visits",
    [Language.SPANISH]: "Visitas",
    [Language.PORTUGUESE]: "Visitas",
  },
  conversion: {
    [Language.ENGLISH]: "Conversion",
    [Language.SPANISH]: "Conversión",
    [Language.PORTUGUESE]: "Conversão",
  },

  // times
  "all-dates": {
    [Language.ENGLISH]: "All Dates",
    [Language.SPANISH]: "Todas las fechas",
    [Language.PORTUGUESE]: "Todas as datas",
  },
  "last-7-days": {
    [Language.ENGLISH]: "Last 7 Days",
    [Language.SPANISH]: "Últimos 7 días",
    [Language.PORTUGUESE]: "Últimos 7 dias",
  },
  "last-30-days": {
    [Language.ENGLISH]: "Last 30 Days",
    [Language.SPANISH]: "Últimos 30 días",
    [Language.PORTUGUESE]: "Últimos 30 dias",
  },
  "last-90-days": {
    [Language.ENGLISH]: "Last 90 Days",
    [Language.SPANISH]: "Últimos 90 días",
    [Language.PORTUGUESE]: "Últimos 90 dias",
  },
  "custom-range": {
    [Language.ENGLISH]: "Custom Range",
    [Language.SPANISH]: "Rango personalizado",
    [Language.PORTUGUESE]: "Intervalo personalizado",
  },

  // buttons
  "change-currency": {
    [Language.ENGLISH]: "Change currency",
    [Language.SPANISH]: "Cambiar moneda",
    [Language.PORTUGUESE]: "Mudar moeda",
  },
  // payment methods
  inactive: {
    [Language.ENGLISH]: "Inactive",
    [Language.SPANISH]: "Inactivo",
    [Language.PORTUGUESE]: "Inativo",
  },
  on: {
    [Language.ENGLISH]: "On",
    [Language.SPANISH]: "Encendido",
    [Language.PORTUGUESE]: "Ligado",
  },
  off: {
    [Language.ENGLISH]: "Off",
    [Language.SPANISH]: "Apagado",
    [Language.PORTUGUESE]: "Desligado",
  },
  update: {
    [Language.ENGLISH]: "Update",
    [Language.SPANISH]: "Actualizar",
    [Language.PORTUGUESE]: "Atualizar",
  },
  connect: {
    [Language.ENGLISH]: "Connect",
    [Language.SPANISH]: "Conectar",
    [Language.PORTUGUESE]: "Conectar",
  },

  // COMING SOON PAGE
  "you-must-use-a-computer-to-access-the-application": {
    [Language.ENGLISH]: "You must use a computer to access the application",
    [Language.SPANISH]: "Debes utilizar un computador para acceder a la aplicación",
    [Language.PORTUGUESE]: "Você deve usar um computador para acessar a aplicação",
  },
  "more-information": {
    [Language.ENGLISH]: "More information",
    [Language.SPANISH]: "Más información",
    [Language.PORTUGUESE]: "Mais informações",
  },
  "why-use-fluxi-from-a-computer": {
    [Language.ENGLISH]: "Why use Fluxi from a computer?",
    [Language.SPANISH]: "¿Por qué usar Fluxi desde una computadora?",
    [Language.PORTUGUESE]: "Por que usar o Fluxi de um computador?",
  },
  "creating-stores-and-professional-pages-requires-space": {
    [Language.ENGLISH]: "Creating stores and professional pages requires space. In Fluxi you have access to powerful tools: visual customizer, order manager, script creator, integrations with shipping platforms and much more.",
    [Language.SPANISH]: "Crear tiendas y páginas profesionales requiere espacio. En Fluxi tienes acceso a herramientas potentes: personalizador visual, gestor de órdenes, creador de guiones, integraciones con plataformas de envío y mucho más.",
    [Language.PORTUGUESE]: "Criar lojas e páginas profissionais requer espaço. No Fluxi você tem acesso a ferramentas poderosas: personalizador visual, gerenciador de pedidos, criador de guias, integrações com plataformas de envio e muito mais.",
  },
  "all-these-tools-work-better-on-a-large-screen": {
    [Language.ENGLISH]: "All these tools work better on a large screen, where you can see each detail and work comfortably. That's why Fluxi is designed for computer, not for mobile.",
    [Language.SPANISH]: "Todas estas herramientas funcionan mejor en pantalla grande, donde puedes ver cada detalle y trabajar con comodidad. Por eso Fluxi está diseñado para computadora, no para móvil.",
    [Language.PORTUGUESE]: "Todas essas ferramentas funcionam melhor em uma tela grande, onde você pode ver cada detalhe e trabalhar confortavelmente. É por isso que o Fluxi é projetado para computador, não para celular.",
  },
  // CURRENCY
  "currency-cop": {
    [Language.ENGLISH]: "COP",
    [Language.SPANISH]: "COP",
    [Language.PORTUGUESE]: "COP",
  },
  "currency-usd": {
    [Language.ENGLISH]: "USD",
    [Language.SPANISH]: "USD",
    [Language.PORTUGUESE]: "USD",
  },
  "upsell-offer": {
    [Language.ENGLISH]: "Upsell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  "create-funnels": {
    [Language.ENGLISH]: "Create funnels",
    [Language.SPANISH]: "Crear embudos",
    [Language.PORTUGUESE]: "Criar funis",
  },

  // Funnels Card
  "funnel-creation": {
    [Language.ENGLISH]: "Funnel Creation",
    [Language.SPANISH]: "Creación de embudo",
    [Language.PORTUGUESE]: "Criação de funil",
  },
  "researching-target-audience": {
    [Language.ENGLISH]: "Researching Target Audience",
    [Language.SPANISH]: "Investigación de público objetivo",
    [Language.PORTUGUESE]: "Pesquisa de público alvo",
  },
  "uncovering-unique-insights": {
    [Language.ENGLISH]: "Uncovering Unique Insights",
    [Language.SPANISH]: "Descubriendo insights únicos",
    [Language.PORTUGUESE]: "Descobrindo insights únicos",
  },
  "identifying-pain-points": {
    [Language.ENGLISH]: "Identifying Pain Points",
    [Language.SPANISH]: "Identificando puntos de dolor",
    [Language.PORTUGUESE]: "Identificando pontos de dor",
  },
  "writing-persuasive-copy": {
    [Language.ENGLISH]: "Writing Persuasive Copy",
    [Language.SPANISH]: "Escribiendo copy persuasivo",
    [Language.PORTUGUESE]: "Escrevendo copy persuasivo",
  },
  "creating-high-quality-images": {
    [Language.ENGLISH]: "Creating High-Quality Images",
    [Language.SPANISH]: "Creando imágenes de alta calidad",
    [Language.PORTUGUESE]: "Criando imagens de alta qualidade",
  },
  "optimizing-results": {
    [Language.ENGLISH]: "Optimizing Results",
    [Language.SPANISH]: "Optimizando resultados",
    [Language.PORTUGUESE]: "Otimizando resultados",
  },
  "refining-the-details": {
    [Language.ENGLISH]: "Refining the Details",
    [Language.SPANISH]: "Refinando los detalles",
    [Language.PORTUGUESE]: "Refinando os detalhes",
  },
  "manage-membership": {
    [Language.ENGLISH]: "Manage membership",
    [Language.SPANISH]: "Gestionar membresía",
    [Language.PORTUGUESE]: "Gerenciar membros",
  },
  "go-out": {
    [Language.ENGLISH]: "Log out",
    [Language.SPANISH]: "Salir",
    [Language.PORTUGUESE]: "Sair",
  },
  membership: {
    [Language.ENGLISH]: "Membership",
    [Language.SPANISH]: "Membresia",
    [Language.PORTUGUESE]: "Membros",
  },
  credit: {
    [Language.ENGLISH]: "credit",
    [Language.SPANISH]: "crédito",
    [Language.PORTUGUESE]: "crédito",
  },
  credits: {
    [Language.ENGLISH]: "Credits",
    [Language.SPANISH]: "Créditos",
    [Language.PORTUGUESE]: "Créditos",
  },
  "select-3-images": {
    [Language.ENGLISH]: "Select at least 1 image to continue",
    [Language.SPANISH]: "Selecciona al menos 1 imagen para continuar",
    [Language.PORTUGUESE]: "Selecione pelo menos 1 imagem para continuar",
  },
  "max-selection-reached": {
    [Language.ENGLISH]: "You've reached the maximum of 20 templates. Generate these before requesting more.",
    [Language.SPANISH]: "Has alcanzado el máximo de 20 plantillas. Genera estas antes de solicitar más.",
    [Language.PORTUGUESE]: "Você atingiu o máximo de 20 modelos. Gere estes antes de solicitar mais.",
  },
  "total-cost": {
    [Language.ENGLISH]: "Total cost",
    [Language.SPANISH]: "Costo total",
    [Language.PORTUGUESE]: "Custo total",
  },
  available: {
    [Language.ENGLISH]: "available",
    [Language.SPANISH]: "disponibles",
    [Language.PORTUGUESE]: "disponíveis",
  },
  "credits-usage": {
    [Language.ENGLISH]: "Credits usage",
    [Language.SPANISH]: "Uso de créditos",
    [Language.PORTUGUESE]: "Uso de créditos",
  },
  "credits-used": {
    [Language.ENGLISH]: "Credits used",
    [Language.SPANISH]: "Créditos usados",
    [Language.PORTUGUESE]: "Créditos usados",
  },
  "credits-remaining": {
    [Language.ENGLISH]: "Credits remaining",
    [Language.SPANISH]: "Créditos restantes",
    [Language.PORTUGUESE]: "Créditos restantes",
  },
  "plan-total": {
    [Language.ENGLISH]: "Plan total",
    [Language.SPANISH]: "Total del plan",
    [Language.PORTUGUESE]: "Total do plano",
  },
  "payment-history": {
    [Language.ENGLISH]: "Payment history",
    [Language.SPANISH]: "Historial de pagos",
    [Language.PORTUGUESE]: "Histórico de pagamentos",
  },
  "activation-date": {
    [Language.ENGLISH]: "Activation date",
    [Language.SPANISH]: "Fecha de activación",
    [Language.PORTUGUESE]: "Data de ativação",
  },
  "upcoming-renovation": {
    [Language.ENGLISH]: "Upcoming renewal",
    [Language.SPANISH]: "Próxima renovación",
    [Language.PORTUGUESE]: "Renovação próxima",
  },
  succeeded: {
    [Language.ENGLISH]: "Succeeded",
    [Language.SPANISH]: "Completado",
    [Language.PORTUGUESE]: "Completado",
  },
  failed: {
    [Language.ENGLISH]: "Failed",
    [Language.SPANISH]: "Fallido",
    [Language.PORTUGUESE]: "Falhou",
  },
  "try-again": {
    [Language.ENGLISH]: "Try again",
    [Language.SPANISH]: "Volver a intentar",
    [Language.PORTUGUESE]: "Tentar novamente",
  },
  sorry: {
    [Language.ENGLISH]: "Sorry",
    [Language.SPANISH]: "Lo sentimos",
    [Language.PORTUGUESE]: "Desculpe",
  },
  "error-update-plan": {
    [Language.ENGLISH]: "An error occurred with the update of your plan",
    [Language.SPANISH]: "Ha ocurrido un error con la actualización de tu plan",
    [Language.PORTUGUESE]: "Ocorreu um erro com a atualização do seu plano",
  },
  congratulations: {
    [Language.ENGLISH]: "Congratulations!",
    [Language.SPANISH]: "¡Felicitaciones!",
    [Language.PORTUGUESE]: "Parabéns!",
  },
  "plan-updated": {
    [Language.ENGLISH]: "Your plan has been updated successfully",
    [Language.SPANISH]: "Tu plan ha sido actualizado correctamente",
    [Language.PORTUGUESE]: "Seu plan foi atualizado com sucesso",
  },
  "no-products-found-onboarding": {
    [Language.ENGLISH]: "No products found",
    [Language.SPANISH]: "No se encontraron productos",
    [Language.PORTUGUESE]: "Nenhum produto encontrado",
  },
  "upload-images-description-onboarding-product-manual": {
    [Language.ENGLISH]: "Upload images where your product is clearly visible",
    [Language.SPANISH]: "Sube imágenes donde tu producto se vea claramente",
    [Language.PORTUGUESE]:
      "Carregue imagens onde seu produto seja claramente visível",
  },
  "upload-image-description-onboarding-product-manual": {
    [Language.ENGLISH]:
      "Upload a image where your product is clearly visible, this image will be used to create all the content of your page",
    [Language.SPANISH]:
      "Carga una imagen que muestre de forma clara tu producto, esta imagen se usará para que nuestra inteligencia artificial cree todo el contenido de tu página",
    [Language.PORTUGUESE]:
      "Carregue uma imagem que mostre claramente seu produto, esta imagem será usada para que nossa inteligência artificial crie todo o conteúdo da sua página",
  },
  "upload-images-description-upload-onboarding-product-manual": {
    [Language.ENGLISH]:
      "Upload images that show your product clearly and how it is used, these images will be used to create all the content of your page",
    [Language.SPANISH]:
      "Carga imagenes que muestren de forma clara tu producto y como se utiliza, estas imagenes se usarán para que nuestra inteligencia artificial cree todo el contenido de tu página",
    [Language.PORTUGUESE]:
      "Carregue imagens que mostrem claramente seu produto e como é usado, estas imagens serão usadas para que nossa inteligência artificial crie todo o conteúdo da sua página",
  },
  "order-bump-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the order bump has a name, description, and image.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el order bump tenga un nombre, descripción y imagen.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o order bump tenha um nome, descrição e imagem.",
  },
  "order-bump-information-incomplete-title": {
    [Language.ENGLISH]: "Order Bump Information Incomplete",
    [Language.SPANISH]: "Información de order bump incompleta",
    [Language.PORTUGUESE]: "Informações do order bump incompleto",
  },
  "upsell-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the upsell has a name, description, and image.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el upsell tenga un nombre, descripción y imagen.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o upsell tenha um nome, descrição e imagem.",
  },
  "upsell-information-incomplete-title": {
    [Language.ENGLISH]: "Upsell Information Incomplete",
    [Language.SPANISH]: "Información de upsell incompleta",
    [Language.PORTUGUESE]: "Informações do upsell incompleto",
  },
  BUMP_OFFER: {
    [Language.ENGLISH]: "Order Bump",
    [Language.SPANISH]: "Order Bump",
    [Language.PORTUGUESE]: "Order Bump",
  },
  PRINCIPAL: {
    [Language.ENGLISH]: "Main Product",
    [Language.SPANISH]: "Producto principal",
    [Language.PORTUGUESE]: "Produto principal",
  },
  UNKNOWN: {
    [Language.ENGLISH]: "Unknown",
    [Language.SPANISH]: "Desconocido",
    [Language.PORTUGUESE]: "Desconhecido",
  },
  UP_SELL: {
    [Language.ENGLISH]: "Upsell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  integrations: {
    [Language.ENGLISH]: "Integrations",
    [Language.SPANISH]: "Integraciones",
    [Language.PORTUGUESE]: "Integrações",
  },
  cancel: {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "integration-added": {
    [Language.ENGLISH]: "Integration added",
    [Language.SPANISH]: "Integración agregada",
    [Language.PORTUGUESE]: "Integração adicionada",
  },
  "integration-success-title": {
    [Language.ENGLISH]: "Successful Integration!",
    [Language.SPANISH]: "Integración Exitosa!",
    [Language.PORTUGUESE]: "Integração Bem-sucedida!",
  },
  "integration-success-description": {
    [Language.ENGLISH]: "has been linked successfully. From now on, all your inventory and orders will be synced in real time with",
    [Language.SPANISH]: "se ha vinculado correctamente. A partir de ahora, todo tu inventario y órdenes se sincronizarán en tiempo real con",
    [Language.PORTUGUESE]: "foi vinculado corretamente. A partir de agora, todo o seu inventário e pedidos serão sincronizados em tempo real com",
  },
  continue: {
    [Language.ENGLISH]: "Continue",
    [Language.SPANISH]: "Continuar",
    [Language.PORTUGUESE]: "Continuar",
  },
  "integration-error": {
    [Language.ENGLISH]: "Integration error",
    [Language.SPANISH]: "Error de integración",
    [Language.PORTUGUESE]: "Erro de integração",
  },
  "integration-canceled": {
    [Language.ENGLISH]: "Integration canceled",
    [Language.SPANISH]: "Integración cancelada",
    [Language.PORTUGUESE]: "Integração cancelada",
  },
  DROPI_TOKEN_INVALID: {
    [Language.ENGLISH]: "Dropi rejected the connection. Check the token, environment, and backend IP allowlist.",
    [Language.SPANISH]: "Dropi rechazó la conexión. Revisa el token, el ambiente y la IP habilitada del backend.",
    [Language.PORTUGUESE]: "A Dropi rejeitou a conexão. Verifique o token, o ambiente e o IP autorizado do backend.",
  },
  "product-cloned-successfully": {
    [Language.ENGLISH]: "Product cloned successfully",
    [Language.SPANISH]: "Producto duplicado correctamente",
    [Language.PORTUGUESE]: "Produto duplicado com sucesso",
  },
  invalid_token: {
    [Language.ENGLISH]: "The credentials you entered are not valid. Please check them in your Mercado Pago account and try again.",
    [Language.SPANISH]: "Las credenciales ingresadas no son válidas. Revisalas en tu cuenta de Mercado Pago e intentá de nuevo.",
    [Language.PORTUGUESE]: "As credenciais inseridas não são válidas. Verifique-as na sua conta do Mercado Pago e tente novamente.",
  },
  funnel: {
    [Language.ENGLISH]: "Funnel",
    [Language.SPANISH]: "Embudo",
    [Language.PORTUGUESE]: "Funil",
  },
  created: {
    [Language.ENGLISH]: "Created",
    [Language.SPANISH]: "Creado",
    [Language.PORTUGUESE]: "Criado",
  },
  "integration-dropi": {
    [Language.ENGLISH]: "Integration Dropi",
    [Language.SPANISH]: "Integración Dropi",
    [Language.PORTUGUESE]: "Integração Dropi",
  },
  "integration-dropi-description-success": {
    [Language.ENGLISH]: "Order synchronized correctly",
    [Language.SPANISH]: "Orden sincronizada correctamente",
    [Language.PORTUGUESE]: "Ordem sincronizada corretamente",
  },
  "integration-dropi-description-error": {
    [Language.ENGLISH]: "Order synchronization failed",
    [Language.SPANISH]: "Fallo en la sincronización, orden NO sincronizada",
    [Language.PORTUGUESE]: "Falha na sincronização, ordem não sincronizada",
  },
  "integration-dropi-description-pending": {
    [Language.ENGLISH]: "Order is pending synchronization with Dropi",
    [Language.SPANISH]: "Orden pendiente de sincronización con Dropi",
    [Language.PORTUGUESE]: "Pedido pendente de sincronização com Dropi",
  },
  "integration-dropi-button-text": {
    [Language.ENGLISH]: "View order in Dropi",
    [Language.SPANISH]: "Ver orden en Dropi",
    [Language.PORTUGUESE]: "Ver ordem em Dropi",
  },
  "integration-dropi-sync-order-button": {
    [Language.ENGLISH]: "Sync order",
    [Language.SPANISH]: "Sincronizar orden",
    [Language.PORTUGUESE]: "Sincronizar pedido",
  },
  "integration-dropi-retry-with-address": {
    [Language.ENGLISH]: "Edit and sync",
    [Language.SPANISH]: "Editar y sincronizar",
    [Language.PORTUGUESE]: "Editar e sincronizar",
  },
  "dropi-retry-modal-title": {
    [Language.ENGLISH]: "Edit shipping and sync",
    [Language.SPANISH]: "Editar envío y sincronizar",
    [Language.PORTUGUESE]: "Editar envio e sincronizar",
  },
  "dropi-retry-success": {
    [Language.ENGLISH]: "Order sent to Dropi again",
    [Language.SPANISH]: "Orden enviada nuevamente a Dropi",
    [Language.PORTUGUESE]: "Pedido enviado novamente ao Dropi",
  },
  "dropi-pending-sync-retry-label": {
    [Language.ENGLISH]: "Retry Dropi sync",
    [Language.SPANISH]: "Reintentar sincronización con Dropi",
    [Language.PORTUGUESE]: "Tentar sincronização com Dropi novamente",
  },
  "dropi-pending-sync-title": {
    [Language.ENGLISH]: "Order pending in Dropi",
    [Language.SPANISH]: "Orden pendiente en Dropi",
    [Language.PORTUGUESE]: "Pedido pendente no Dropi",
  },
  "dropi-pending-sync-description": {
    [Language.ENGLISH]: "Click to retry Dropi synchronization without editing the order data.",
    [Language.SPANISH]: "Haz click para reintentar la sincronización con Dropi sin editar los datos.",
    [Language.PORTUGUESE]: "Clique para tentar a sincronização com Dropi novamente sem editar os dados.",
  },
  "dropi-pending-sync-retry-error": {
    [Language.ENGLISH]: "Dropi retry failed. Try again.",
    [Language.SPANISH]: "No se pudo reintentar la orden en Dropi. Inténtalo de nuevo.",
    [Language.PORTUGUESE]: "Não foi possível tentar o pedido no Dropi novamente. Tente de novo.",
  },
  "reintegrate-dropi": {
    [Language.ENGLISH]: "Reintegrate with Dropi",
    [Language.SPANISH]: "Reintegrar a Dropi",
    [Language.PORTUGUESE]: "Reintegrar ao Dropi",
  },
  "funnels-label": {
    [Language.ENGLISH]: "Funnels",
    [Language.SPANISH]: "Embudos",
    [Language.PORTUGUESE]: "Funis",
  },
  "homes-label": {
    [Language.ENGLISH]: "Stores",
    [Language.SPANISH]: "Tiendas",
    [Language.PORTUGUESE]: "Lojas",
  },
  "error-select-funnel": {
    [Language.ENGLISH]: "Please select at least one funnel",
    [Language.SPANISH]: "Por favor, selecciona al menos un embudo",
    [Language.PORTUGUESE]: "Por favor, selecione pelo menos um funil",
  },
  "success-create-home": {
    [Language.ENGLISH]: "Home created successfully",
    [Language.SPANISH]: "Tienda creada correctamente",
    [Language.PORTUGUESE]: "Loja criada com sucesso",
  },
  "error-create-home": {
    [Language.ENGLISH]: "An error occurred with the creation of your home",
    [Language.SPANISH]: "Ha ocurrido un error con la creación de tu tienda",
    [Language.PORTUGUESE]: "Ocorreu um erro com a criação da sua loja",
  },
  "error-brand-data": {
    [Language.ENGLISH]: "Please fill brand name and context",
    [Language.SPANISH]:
      "Por favor, completa el nombre de la marca y el contexto",
    [Language.PORTUGUESE]: "Por favor, complete o nome da marca e o contexto",
  },
  "products-page-description": {
    [Language.ENGLISH]: "Manage all your products",
    [Language.SPANISH]: "Gestiona todos los productos de tu cuenta",
    [Language.PORTUGUESE]: "Gerencie todos os produtos da sua conta",
  },
  "cancel-changes": {
    [Language.ENGLISH]: "Cancel changes",
    [Language.SPANISH]: "Cancelar cambios",
    [Language.PORTUGUESE]: "Cancelar alterações",
  },
  "error-updating-products": {
    [Language.ENGLISH]: "Error updating products. Please try again.",
    [Language.SPANISH]:
      "Error al actualizar los productos. Por favor, intenta nuevamente.",
    [Language.PORTUGUESE]:
      "Erro ao atualizar os produtos. Por favor, tente novamente.",
  },
  "products-updated-successfully": {
    [Language.ENGLISH]: "products updated successfully",
    [Language.SPANISH]: "productos actualizados correctamente",
    [Language.PORTUGUESE]: "produtos atualizados com sucesso",
  },
  "create-new-home": {
    [Language.ENGLISH]: "Create new home",
    [Language.SPANISH]: "Crear nueva tienda",
    [Language.PORTUGUESE]: "Criar nova loja",
  },
  "each-angle-selected-1-credit": {
    [Language.ENGLISH]: "Each funnel selected = 85 credits",
    [Language.SPANISH]: "Cada embudo seleccionado = 85 créditos",
    [Language.PORTUGUESE]: "Cada funil selecionado = 85 créditos",
  },
  "1-credit": {
    [Language.ENGLISH]: "85 credits",
    [Language.SPANISH]: "85 créditos",
    [Language.PORTUGUESE]: "85 créditos",
  },
  "generating-video": {
    [Language.ENGLISH]: "Generating video",
    [Language.SPANISH]: "Generando video",
    [Language.PORTUGUESE]: "Gerando vídeo",
  },
  "error-ad-creation": {
    [Language.ENGLISH]: "An error occurred with the creation of the ad",
    [Language.SPANISH]: "Ha ocurrido un error con la creación de la publicidad",
    [Language.PORTUGUESE]: "Ocorreu um erro com a criação da publicidade",
  },
  "no-video-found": {
    [Language.ENGLISH]: "No video found",
    [Language.SPANISH]: "No se encontró video",
    [Language.PORTUGUESE]: "Nenhum vídeo encontrado",
  },
  INITIALIZING: {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendiente",
    [Language.PORTUGUESE]: "Pendente",
  },
  IN_PROGRESS: {
    [Language.ENGLISH]: "In progress",
    [Language.SPANISH]: "En progreso",
    [Language.PORTUGUESE]: "Em progresso",
  },
  FINISHED: {
    [Language.ENGLISH]: "Done",
    [Language.SPANISH]: "Completado",
    [Language.PORTUGUESE]: "Completado",
  },
  ERROR: {
    [Language.ENGLISH]: "Failed",
    [Language.SPANISH]: "Fallido",
    [Language.PORTUGUESE]: "Falhou",
  },
  "link-copied": {
    [Language.ENGLISH]: "Link copied",
    [Language.SPANISH]: "Link copiado",
    [Language.PORTUGUESE]: "Link copiado",
  },
  "change-plan": {
    [Language.ENGLISH]: "Change plan",
    [Language.SPANISH]: "Cambiar plan",
    [Language.PORTUGUESE]: "Alterar plano",
  },
  "product-images": {
    [Language.ENGLISH]: "Product images",
    [Language.SPANISH]: "Imágenes del producto",
    [Language.PORTUGUESE]: "Imagens do produto",
  },
  "remove-image": {
    [Language.ENGLISH]: "Remove image",
    [Language.SPANISH]: "Eliminar imagen",
    [Language.PORTUGUESE]: "Remover imagem",
  },
  "max-images-reached": {
    [Language.ENGLISH]: "Max images reached",
    [Language.SPANISH]: "Límite alcanzado",
    [Language.PORTUGUESE]: "Limite alcançado",
  },
  "max-file-size-per-image": {
    [Language.ENGLISH]: "Max file size per image is 5MB",
    [Language.SPANISH]: "El límite de tamaño por imagen es de 5MB",
    [Language.PORTUGUESE]: "O limite de tamanho por imagem é de 5MB",
  },
  "uploading-images": {
    [Language.ENGLISH]: "Uploading images...",
    [Language.SPANISH]: "Subiendo imágenes...",
    [Language.PORTUGUESE]: "Carregando imagens...",
  },
  progress: {
    [Language.ENGLISH]: "Progress",
    [Language.SPANISH]: "Progreso",
    [Language.PORTUGUESE]: "Progresso",
  },
  "uploading-image": {
    [Language.ENGLISH]: "Uploading image...",
    [Language.SPANISH]: "Subiendo imagen...",
    [Language.PORTUGUESE]: "Carregando imagem...",
  },
  male: {
    [Language.ENGLISH]: "Male",
    [Language.SPANISH]: "Masculino",
    [Language.PORTUGUESE]: "Masculino",
  },
  female: {
    [Language.ENGLISH]: "Female",
    [Language.SPANISH]: "Femenino",
    [Language.PORTUGUESE]: "Feminino",
  },
  "order-deleted": {
    [Language.ENGLISH]: "Order deleted",
    [Language.SPANISH]: "Orden eliminada",
    [Language.PORTUGUESE]: "Ordem deletada",
  },
  "error-deleting-order": {
    [Language.ENGLISH]: "Error deleting order",
    [Language.SPANISH]: "Error al eliminar la orden",
    [Language.PORTUGUESE]: "Erro ao deletar a ordem",
  },
  "are-you-sure-you-want-to-delete-this-order": {
    [Language.ENGLISH]: "Are you sure you want to delete this order?",
    [Language.SPANISH]: "¿Estás seguro de que deseas eliminar esta orden?",
    [Language.PORTUGUESE]: "Tem certeza que deseja deletar esta ordem?",
  },
  "this-order-is-integrated-with-dropi": {
    [Language.ENGLISH]:
      "This order is integrated with Dropi. If you delete it in Fluxi, you must delete it manually in Dropi to avoid differences between systems.",
    [Language.SPANISH]:
      "Esta orden está integrada con Dropi. Si la eliminas en Fluxi, deberás eliminarla también manualmente en Dropi para evitar diferencias entre sistemas.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Dropi. Se você deletar em Fluxi, deve deletar manualmente em Dropi para evitar diferenças entre sistemas.",
  },
  "this-order-is-integrated-with-shopify": {
    [Language.ENGLISH]:
      "This order is integrated with Shopify. If you delete it in Fluxi, you must delete it manually in Shopify to avoid differences between systems.",
    [Language.SPANISH]:
      "Esta orden está integrada con Shopify. Si la eliminas en Fluxi, deberás eliminarla también manualmente en Shopify para evitar diferencias entre sistemas.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Shopify. Se você deletar em Fluxi, deve deletar manualmente em Shopify para evitar diferenças entre sistemas.",
  },
  "this-order-is-integrated-with-dropi-and-shopify": {
    [Language.ENGLISH]:
      "This order is integrated with Dropi and Shopify. If you delete it in Fluxi, you must delete it manually in both systems to avoid differences.",
    [Language.SPANISH]:
      "Esta orden está integrada con Dropi y Shopify. Si la eliminas en Fluxi, deberás eliminarla también manualmente en ambos sistemas para evitar diferencias.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Dropi e Shopify. Se você deletar em Fluxi, deve deletar manualmente em ambos sistemas para evitar diferenças.",
  },
  "error-getting-order-details": {
    [Language.ENGLISH]: "Error getting order details",
    [Language.SPANISH]: "Error al obtener los detalles de la orden",
    [Language.PORTUGUESE]: "Erro ao obter os detalhes da ordem",
  },
  "custom-angle": {
    [Language.ENGLISH]: "Custom Angle",
    [Language.SPANISH]: "Ángulo personalizado",
    [Language.PORTUGUESE]: "Ângulo personalizado",
  },
  "create-your-own-approach": {
    [Language.ENGLISH]: "Create your own approach.",
    [Language.SPANISH]: "Crea tu propio enfoque.",
    [Language.PORTUGUESE]: "Crie seu próprio enfoque.",
  },
  "visits-unique": {
    [Language.ENGLISH]: "Unique visits",
    [Language.SPANISH]: "Visitas únicas",
    [Language.PORTUGUESE]: "Visitas únicas",
  },
  "login-with-google": {
    [Language.ENGLISH]: "Login with Google",
    [Language.SPANISH]: "Iniciar sesión con Google",
    [Language.PORTUGUESE]: "Iniciar sessão com Google",
  },
  loading: {
    [Language.ENGLISH]: "Loading...",
    [Language.SPANISH]: "Cargando...",
    [Language.PORTUGUESE]: "Carregando...",
  },
  "load-more": {
    [Language.ENGLISH]: "Load more",
    [Language.SPANISH]: "Cargar más",
    [Language.PORTUGUESE]: "Carregar mais",
  },
  "or-sign-in-with": {
    [Language.ENGLISH]: "Or sign in with",
    [Language.SPANISH]: "O iniciar sesión con",
    [Language.PORTUGUESE]: "O iniciar sessão com",
  },
  "additional-information": {
    [Language.ENGLISH]: "Additional information",
    [Language.SPANISH]: "Información adicional",
    [Language.PORTUGUESE]: "Informação adicional",
  },
  "integration-shopify": {
    [Language.ENGLISH]: "Integration Shopify",
    [Language.SPANISH]: "Integración Shopify",
    [Language.PORTUGUESE]: "Integração Shopify",
  },
  "integration-shopify-description-success": {
    [Language.ENGLISH]: "Order synchronized correctly",
    [Language.SPANISH]: "Orden sincronizada correctamente",
    [Language.PORTUGUESE]: "Ordem sincronizada corretamente",
  },
  "integration-shopify-description-error": {
    [Language.ENGLISH]: "Order synchronization failed",
    [Language.SPANISH]: "Fallo en la sincronización, orden NO sincronizada",
    [Language.PORTUGUESE]: "Falha na sincronização, ordem não sincronizada",
  },
  "fluxi-support": {
    [Language.ENGLISH]: "Camila - Cancellation Agent",
    [Language.SPANISH]: "Camila - Agente de cancelación",
    [Language.PORTUGUESE]: "Camila - Agente de cancelamento",
  },
  "we-are-here-to-help-you": {
    [Language.ENGLISH]: "I'm here to help you",
    [Language.SPANISH]: "Estoy aquí para ayudarte",
    [Language.PORTUGUESE]: "Estou aqui para ajudar você",
  },
  "write-your-message": {
    [Language.ENGLISH]: "Write your message...",
    [Language.SPANISH]: "Escribe tu mensaje...",
    [Language.PORTUGUESE]: "Escreva sua mensagem...",
  },
  "buy-credits": {
    [Language.ENGLISH]: "Buy credits",
    [Language.SPANISH]: "Comprar créditos",
    [Language.PORTUGUESE]: "Comprar créditos",
  },
  "insufficient-credits": {
    [Language.ENGLISH]: "Insufficient credits",
    [Language.SPANISH]: "Créditos insuficientes",
    [Language.PORTUGUESE]: "Créditos insuficientes",
  },
  "insufficient-credits-description": {
    [Language.ENGLISH]: "You need {required} credits but only have {available}. Please purchase more credits to continue.",
    [Language.SPANISH]: "Necesitas {required} créditos pero solo tienes {available}. Compra más créditos para continuar.",
    [Language.PORTUGUESE]: "Você precisa de {required} créditos mas só tem {available}. Compre mais créditos para continuar.",
  },
  "waiting-for-payment": {
    [Language.ENGLISH]: "Waiting for payment...",
    [Language.SPANISH]: "Esperando el pago...",
    [Language.PORTUGUESE]: "Aguardando pagamento...",
  },
  "payment-opened-in-new-tab": {
    [Language.ENGLISH]: "Payment page opened in a new tab. Complete your purchase and return here.",
    [Language.SPANISH]: "Se abrió la página de pago en una nueva pestaña. Completa tu compra y regresa aquí.",
    [Language.PORTUGUESE]: "A página de pagamento foi aberta em uma nova aba. Complete sua compra e volte aqui.",
  },
  "verify-payment": {
    [Language.ENGLISH]: "Verify payment",
    [Language.SPANISH]: "Verificar pago",
    [Language.PORTUGUESE]: "Verificar pagamento",
  },
  "credits-updated": {
    [Language.ENGLISH]: "Credits updated!",
    [Language.SPANISH]: "¡Créditos actualizados!",
    [Language.PORTUGUESE]: "Créditos atualizados!",
  },
  "checking-credits": {
    [Language.ENGLISH]: "Checking credits...",
    [Language.SPANISH]: "Verificando créditos...",
    [Language.PORTUGUESE]: "Verificando créditos...",
  },
  "remember-use-credits": {
    [Language.ENGLISH]: "Remember to use your credits.",
    [Language.SPANISH]: "Recuerda usar tus créditos.",
    [Language.PORTUGUESE]: "Lembre-se de usar seus créditos.",
  },
  "product-not-found": {
    [Language.ENGLISH]:
      "Product not found, please try again with a different product or enter manually",
    [Language.SPANISH]:
      "No pudimos extraer la información del producto con el link suministrado, por favor intenta con un link diferente o ingresa la infomación manualmente",
    [Language.PORTUGUESE]:
      "Não conseguimos extrair a informação do produto com o link fornecido, por favor tente com um link diferente ou insira a informação manualmente",
  },
  "no-images-found": {
    [Language.ENGLISH]: "No images found",
    [Language.SPANISH]: "No se encontraron imágenes",
    [Language.PORTUGUESE]: "Nenhuma imagem encontrada",
  },
  "product-not-found-title": {
    [Language.ENGLISH]: "Product not found",
    [Language.SPANISH]: "Producto no encontrado",
    [Language.PORTUGUESE]: "Produto não encontrado",
  },
  "no-images-found-title": {
    [Language.ENGLISH]: "No images found",
    [Language.SPANISH]: "No se encontraron imágenes",
    [Language.PORTUGUESE]: "Nenhuma imagem encontrada",
  },
  english: {
    [Language.ENGLISH]: "English",
    [Language.SPANISH]: "Ingles",
    [Language.PORTUGUESE]: "Inglês",
  },
  spanish: {
    [Language.ENGLISH]: "Spanish",
    [Language.SPANISH]: "Español",
    [Language.PORTUGUESE]: "Espanhol",
  },
  portuguese: {
    [Language.ENGLISH]: "Portuguese",
    [Language.SPANISH]: "Portugués",
    [Language.PORTUGUESE]: "Português",
  },
  "what-country-do-you-want-to": {
    [Language.ENGLISH]: "What country do you want to",
    [Language.SPANISH]: "¿En qué país quieres",
    [Language.PORTUGUESE]: "Em que país você quer",
  },
  "sell-with-fluxi": {
    [Language.ENGLISH]: "sell with Fluxi?",
    [Language.SPANISH]: "vender con Fluxi?",
    [Language.PORTUGUESE]: "vender com Fluxi?",
  },
  "welcome-to": {
    [Language.ENGLISH]: "Welcome to",
    [Language.SPANISH]: "Bienvenid@ a",
    [Language.PORTUGUESE]: "Bem-vindo(a) ao",
  },
  fluxi: {
    [Language.ENGLISH]: "Fluxi",
    [Language.SPANISH]: "Fluxi",
    [Language.PORTUGUESE]: "Fluxi",
  },
  "configure-your-account-in-a-few-moments": {
    [Language.ENGLISH]: "Configure your account in a few moments",
    [Language.SPANISH]: "Configura tu cuenta en solo unos momentos",
    [Language.PORTUGUESE]: "Configure sua conta em alguns momentos",
  },
  "select-your-country": {
    [Language.ENGLISH]: "Select your country...",
    [Language.SPANISH]: "Selecciona tu país...",
    [Language.PORTUGUESE]: "Selecione seu país...",
  },
  argentina: {
    [Language.ENGLISH]: "Argentina",
    [Language.SPANISH]: "Argentina",
    [Language.PORTUGUESE]: "Argentina",
  },
  bolivia: {
    [Language.ENGLISH]: "Bolivia",
    [Language.SPANISH]: "Bolivia",
    [Language.PORTUGUESE]: "Bolivia",
  },
  brazil: {
    [Language.ENGLISH]: "Brazil",
    [Language.SPANISH]: "Brasil",
    [Language.PORTUGUESE]: "Brasil",
  },
  chile: {
    [Language.ENGLISH]: "Chile",
    [Language.SPANISH]: "Chile",
    [Language.PORTUGUESE]: "Chile",
  },
  colombia: {
    [Language.ENGLISH]: "Colombia",
    [Language.SPANISH]: "Colombia",
    [Language.PORTUGUESE]: "Colombia",
  },
  "costa-rica": {
    [Language.ENGLISH]: "Costa Rica",
    [Language.SPANISH]: "Costa Rica",
    [Language.PORTUGUESE]: "Costa Rica",
  },
  cuba: {
    [Language.ENGLISH]: "Cuba",
    [Language.SPANISH]: "Cuba",
    [Language.PORTUGUESE]: "Cuba",
  },
  "dominican-republic": {
    [Language.ENGLISH]: "Dominican Republic",
    [Language.SPANISH]: "República Dominicana",
    [Language.PORTUGUESE]: "República Dominicana",
  },
  ecuador: {
    [Language.ENGLISH]: "Ecuador",
    [Language.SPANISH]: "Ecuador",
    [Language.PORTUGUESE]: "Ecuador",
  },
  "el-salvador": {
    [Language.ENGLISH]: "El Salvador",
    [Language.SPANISH]: "El Salvador",
    [Language.PORTUGUESE]: "El Salvador",
  },
  guatemala: {
    [Language.ENGLISH]: "Guatemala",
    [Language.SPANISH]: "Guatemala",
    [Language.PORTUGUESE]: "Guatemala",
  },
  honduras: {
    [Language.ENGLISH]: "Honduras",
    [Language.SPANISH]: "Honduras",
    [Language.PORTUGUESE]: "Honduras",
  },
  mexico: {
    [Language.ENGLISH]: "Mexico",
    [Language.SPANISH]: "México",
    [Language.PORTUGUESE]: "México",
  },
  nicaragua: {
    [Language.ENGLISH]: "Nicaragua",
    [Language.SPANISH]: "Nicaragua",
    [Language.PORTUGUESE]: "Nicaragua",
  },
  panama: {
    [Language.ENGLISH]: "Panama",
    [Language.SPANISH]: "Panamá",
    [Language.PORTUGUESE]: "Panamá",
  },
  paraguay: {
    [Language.ENGLISH]: "Paraguay",
    [Language.SPANISH]: "Paraguay",
    [Language.PORTUGUESE]: "Paraguay",
  },
  peru: {
    [Language.ENGLISH]: "Peru",
    [Language.SPANISH]: "Perú",
    [Language.PORTUGUESE]: "Perú",
  },
  "puerto-rico": {
    [Language.ENGLISH]: "Puerto Rico",
    [Language.SPANISH]: "Puerto Rico",
    [Language.PORTUGUESE]: "Puerto Rico",
  },
  spain: {
    [Language.ENGLISH]: "Spain",
    [Language.SPANISH]: "España",
    [Language.PORTUGUESE]: "Espanha",
  },
  "united-states": {
    [Language.ENGLISH]: "United States",
    [Language.SPANISH]: "Estados Unidos",
    [Language.PORTUGUESE]: "Estados Unidos",
  },
  uruguay: {
    [Language.ENGLISH]: "Uruguay",
    [Language.SPANISH]: "Uruguay",
    [Language.PORTUGUESE]: "Uruguai",
  },
  venezuela: {
    [Language.ENGLISH]: "Venezuela",
    [Language.SPANISH]: "Venezuela",
    [Language.PORTUGUESE]: "Venezuela",
  },
  "the-currency-is-linked-to-your-country": {
    [Language.ENGLISH]: "The currency is linked to your country",
    [Language.SPANISH]: "La moneda está vinculada a tu país",
    [Language.PORTUGUESE]: "A moeda está vinculada ao seu país",
  },
  "you-can-change-the-language-if-you-need": {
    [Language.ENGLISH]: "You can change the language if you need",
    [Language.SPANISH]: "Puedes cambiar el idioma si lo necesitas",
    [Language.PORTUGUESE]: "Você pode mudar o idioma se precisar",
  },
  "complete-configuration": {
    [Language.ENGLISH]: "Complete configuration",
    [Language.SPANISH]: "Completar configuración",
    [Language.PORTUGUESE]: "Completar configuração",
  },
  "these-settings-cannot-be-changed-later": {
    [Language.ENGLISH]: "These settings cannot be changed later",
    [Language.SPANISH]: "Estas configuraciones no se podrán cambiar después",
    [Language.PORTUGUESE]:
      "Estas configurações não podem ser alteradas mais tarde",
  },
  currency: {
    [Language.ENGLISH]: "Currency",
    [Language.SPANISH]: "Moneda",
    [Language.PORTUGUESE]: "Moeda",
  },
  "linked-to-the-country": {
    [Language.ENGLISH]: "Linked to the country",
    [Language.SPANISH]: "Vinculada al país",
    [Language.PORTUGUESE]: "Vinculada ao país",
  },
  language: {
    [Language.ENGLISH]: "Language",
    [Language.SPANISH]: "Idioma",
    [Language.PORTUGUESE]: "Idioma",
  },
  "colombian-peso": {
    [Language.ENGLISH]: "Colombian Peso",
    [Language.SPANISH]: "Peso Colombiano",
    [Language.PORTUGUESE]: "Peso Colombiano",
  },
  dollar: {
    [Language.ENGLISH]: "Dollar",
    [Language.SPANISH]: "Dólar",
    [Language.PORTUGUESE]: "Dólar",
  },
  "local-currency": {
    [Language.ENGLISH]: "Local Currency",
    [Language.SPANISH]: "Moneda local",
    [Language.PORTUGUESE]: "Moeda local",
  },
  "argentine-peso": {
    [Language.ENGLISH]: "Argentine Peso",
    [Language.SPANISH]: "Peso Argentino",
    [Language.PORTUGUESE]: "Peso Argentino",
  },
  "boliviano": {
    [Language.ENGLISH]: "Boliviano",
    [Language.SPANISH]: "Boliviano",
    [Language.PORTUGUESE]: "Boliviano",
  },
  "brazilian-real": {
    [Language.ENGLISH]: "Brazilian Real",
    [Language.SPANISH]: "Real Brasileño",
    [Language.PORTUGUESE]: "Real Brasileiro",
  },
  "canadian-dollar": {
    [Language.ENGLISH]: "Canadian Dollar",
    [Language.SPANISH]: "Dólar Canadiense",
    [Language.PORTUGUESE]: "Dólar Canadense",
  },
  "chilean-peso": {
    [Language.ENGLISH]: "Chilean Peso",
    [Language.SPANISH]: "Peso Chileno",
    [Language.PORTUGUESE]: "Peso Chileno",
  },
  "mexican-peso": {
    [Language.ENGLISH]: "Mexican Peso",
    [Language.SPANISH]: "Peso Mexicano",
    [Language.PORTUGUESE]: "Peso Mexicano",
  },
  "paraguayan-guarani": {
    [Language.ENGLISH]: "Guaraní",
    [Language.SPANISH]: "Guaraní",
    [Language.PORTUGUESE]: "Guarani",
  },
  "peruvian-sol": {
    [Language.ENGLISH]: "Sol",
    [Language.SPANISH]: "Soles",
    [Language.PORTUGUESE]: "Sol",
  },
  "uruguayan-peso": {
    [Language.ENGLISH]: "Uruguayan Peso",
    [Language.SPANISH]: "Peso Uruguayo",
    [Language.PORTUGUESE]: "Peso Uruguaio",
  },
  "venezuelan-bolivar": {
    [Language.ENGLISH]: "Bolívar",
    [Language.SPANISH]: "Bolívar",
    [Language.PORTUGUESE]: "Bolívar",
  },
  "guatemalan-quetzal": {
    [Language.ENGLISH]: "Quetzal",
    [Language.SPANISH]: "Quetzal",
    [Language.PORTUGUESE]: "Quetzal",
  },
  "what-country-do-you-want-to-sell-with-fluxi": {
    [Language.ENGLISH]: "What country do you want to sell with Fluxi?",
    [Language.SPANISH]: "¿En qué país quieres vender con Fluxi?",
    [Language.PORTUGUESE]: "Em que país você quer vender com Fluxi?",
  },
  "configuration-completed-successfully": {
    [Language.ENGLISH]: "Configuration completed successfully",
    [Language.SPANISH]: "Configuración completada correctamente",
    [Language.PORTUGUESE]: "Configuração completada com sucesso",
  },
  "error-completing-configuration": {
    [Language.ENGLISH]: "Error completing configuration",
    [Language.SPANISH]: "Error al completar la configuración",
    [Language.PORTUGUESE]: "Erro ao completar a configuração",
  },
  "delete-order": {
    [Language.ENGLISH]: "Delete order",
    [Language.SPANISH]: "Eliminar orden",
    [Language.PORTUGUESE]: "Deletar pedido",
  },
  "filter-by-product": {
    [Language.ENGLISH]: "Filter by product",
    [Language.SPANISH]: "Filtrar por producto",
    [Language.PORTUGUESE]: "Filtrar por produto",
  },
  "filter-by-sale-angle": {
    [Language.ENGLISH]: "Filter by sale angle",
    [Language.SPANISH]: "Filtrar por ángulo de venta",
    [Language.PORTUGUESE]: "Filtrar por ângulo de venda",
  },
  "public-token": {
    [Language.ENGLISH]: "Public token",
    [Language.SPANISH]: "Token público",
    [Language.PORTUGUESE]: "Token público",
  },
  "private-token": {
    [Language.ENGLISH]: "Private token",
    [Language.SPANISH]: "Token privado",
    [Language.PORTUGUESE]: "Token privado",
  },
  "enter-your-public-token": {
    [Language.ENGLISH]: "Enter your public token",
    [Language.SPANISH]: "Ingresa tu token público",
    [Language.PORTUGUESE]: "Insira seu token público",
  },
  "enter-your-private-token": {
    [Language.ENGLISH]: "Enter your private token",
    [Language.SPANISH]: "Ingresa tu token privado",
    [Language.PORTUGUESE]: "Insira seu token privado",
  },
  "test-tokens-not-allowed-in-production": {
    [Language.ENGLISH]: "You are using test credentials from Mercado Pago. To accept real payments, go to your Mercado Pago account and generate production credentials.",
    [Language.SPANISH]: "Estás usando credenciales de prueba de Mercado Pago. Para aceptar pagos reales, ingresá a tu cuenta de Mercado Pago y generá las credenciales de producción.",
    [Language.PORTUGUESE]: "Você está usando credenciais de teste do Mercado Pago. Para aceitar pagamentos reais, acesse sua conta do Mercado Pago e gere as credenciais de produção.",
  },
  "add-integration-token": {
    [Language.ENGLISH]: "Add integration token",
    [Language.SPANISH]: "Agregar token de integración",
    [Language.PORTUGUESE]: "Adicionar token de integração",
  },
  "dropi-token": {
    [Language.ENGLISH]: "Dropi token",
    [Language.SPANISH]: "Token de Dropi",
    [Language.PORTUGUESE]: "Token de Dropi",
  },
  "example-dropi-token": {
    [Language.ENGLISH]: "Ex: sk_live_1234abc...",
    [Language.SPANISH]: "Ej: sk_live_1234abc...",
    [Language.PORTUGUESE]: "Ej: sk_live_1234abc...",
  },
  "mercadopago-connect-title": {
    [Language.ENGLISH]: "Connect your Mercado Pago account",
    [Language.SPANISH]: "Conecta tu cuenta Mercado Pago",
    [Language.PORTUGUESE]: "Conecte sua conta Mercado Pago",
  },
  "mercadopago-connect-description": {
    [Language.ENGLISH]: "By connecting your account, you will be able to process payments securely and automatically. This integration links Fluxi transactions directly with your account.",
    [Language.SPANISH]: "Al conectar tu cuenta, podrás procesar pagos de manera segura y automática. Esta integración vincula las transacciones de Fluxi directamente con tu cuenta.",
    [Language.PORTUGUESE]: "Ao conectar sua conta, você poderá processar pagamentos de forma segura e automática. Esta integração vincula as transações do Fluxi diretamente com sua conta.",
  },
  "mercadopago-feature-secure": {
    [Language.ENGLISH]: "Secure payment processing",
    [Language.SPANISH]: "Procesamiento de pagos seguro",
    [Language.PORTUGUESE]: "Processamento de pagamentos seguro",
  },
  "mercadopago-feature-sync": {
    [Language.ENGLISH]: "Automatic transaction reconciliation",
    [Language.SPANISH]: "Conciliación automática de transacciones",
    [Language.PORTUGUESE]: "Conciliação automática de transações",
  },
  "mercadopago-feature-finance": {
    [Language.ENGLISH]: "Centralized financial management",
    [Language.SPANISH]: "Gestión financiera centralizada",
    [Language.PORTUGUESE]: "Gestão financeira centralizada",
  },
  "mercadopago-video-tutorial": {
    [Language.ENGLISH]: "Don't know how to connect Mercado Pago?",
    [Language.SPANISH]: "¿No sabes cómo conectar Mercado Pago?",
    [Language.PORTUGUESE]: "Não sabe como conectar o Mercado Pago?",
  },
  "invalid-mercadopago-token-format": {
    [Language.ENGLISH]: "The tokens entered do not appear to be valid Mercado Pago credentials. They should start with APP_USR-.",
    [Language.SPANISH]: "Los tokens ingresados no parecen ser credenciales válidas de Mercado Pago. Deben comenzar con APP_USR-.",
    [Language.PORTUGUESE]: "Os tokens inseridos não parecem ser credenciais válidas do Mercado Pago. Devem começar com APP_USR-.",
  },
  "mercadopago-credentials-hint": {
    [Language.ENGLISH]: "Credentials from the Mercado Pago Developer Panel.",
    [Language.SPANISH]: "Credenciales en el Panel de Desarrollador de Mercado Pago.",
    [Language.PORTUGUESE]: "Credenciais no Painel de Desenvolvedor do Mercado Pago.",
  },
  connecting: {
    [Language.ENGLISH]: "Connecting...",
    [Language.SPANISH]: "Conectando...",
    [Language.PORTUGUESE]: "Conectando...",
  },
  "dropi-connect-title": {
    [Language.ENGLISH]: "Connect your Dropi account",
    [Language.SPANISH]: "Conecta tu cuenta Dropi",
    [Language.PORTUGUESE]: "Conecte sua conta Dropi",
  },
  "dropi-connect-description": {
    [Language.ENGLISH]: "Sync your dropshipping products and orders directly with Fluxi. This integration allows you to automate order management with Dropi suppliers.",
    [Language.SPANISH]: "Sincroniza tus productos y órdenes de dropshipping directamente con Fluxi. Esta integración te permite automatizar la gestión de pedidos con proveedores de Dropi.",
    [Language.PORTUGUESE]: "Sincronize seus produtos e pedidos de dropshipping diretamente com o Fluxi. Esta integração permite automatizar a gestão de pedidos com fornecedores do Dropi.",
  },
  "dropi-feature-sync": {
    [Language.ENGLISH]: "Supplier inventory synchronization",
    [Language.SPANISH]: "Sincronización de inventario de proveedores",
    [Language.PORTUGUESE]: "Sincronização de inventário de fornecedores",
  },
  "dropi-feature-orders": {
    [Language.ENGLISH]: "Purchase order automation",
    [Language.SPANISH]: "Automatización de órdenes de compra",
    [Language.PORTUGUESE]: "Automação de ordens de compra",
  },
  "dropi-feature-tracking": {
    [Language.ENGLISH]: "Real-time shipment tracking",
    [Language.SPANISH]: "Trazabilidad de envíos en tiempo real",
    [Language.PORTUGUESE]: "Rastreabilidade de envios em tempo real",
  },
  "dropi-video-tutorial": {
    [Language.ENGLISH]: "Don't know how to connect Dropi?",
    [Language.SPANISH]: "¿No sabes cómo conectar Dropi?",
    [Language.PORTUGUESE]: "Não sabe como conectar o Dropi?",
  },
  "see-here": {
    [Language.ENGLISH]: "See here",
    [Language.SPANISH]: "Ver aquí",
    [Language.PORTUGUESE]: "Veja aqui",
  },
  "watch-video-tutorial": {
    [Language.ENGLISH]: "Watch video tutorial",
    [Language.SPANISH]: "Ver video tutorial",
    [Language.PORTUGUESE]: "Assistir tutorial em vídeo",
  },
  "dropi-credentials-hint": {
    [Language.ENGLISH]: "Find this token in the API settings of your Dropi account.",
    [Language.SPANISH]: "Encuentra este token en la configuración de API de tu cuenta Dropi.",
    [Language.PORTUGUESE]: "Encontre este token nas configurações de API da sua conta Dropi.",
  },
  questions: {
    [Language.ENGLISH]: "Questions?",
    [Language.SPANISH]: "¿Preguntas?",
    [Language.PORTUGUESE]: "Perguntas?",
  },
  "select-credits": {
    [Language.ENGLISH]: "Select the number of credits you want to buy",
    [Language.SPANISH]: "Selecciona la cantidad de créditos que deseas comprar",
    [Language.PORTUGUESE]:
      "Selecione a quantidade de créditos que deseja comprar",
  },
  "credits-quantity": {
    [Language.ENGLISH]: "Credits quantity",
    [Language.SPANISH]: "Cantidad de créditos",
    [Language.PORTUGUESE]: "Quantidade de créditos",
  },
  "error-creating-purchase-link": {
    [Language.ENGLISH]: "Error creating purchase link",
    [Language.SPANISH]: "Error al crear el enlace de compra",
    [Language.PORTUGUESE]: "Erro ao criar o link de compra",
  },
  "pay-now": {
    [Language.ENGLISH]: "Pay now",
    [Language.SPANISH]: "Pagar ahora",
    [Language.PORTUGUESE]: "Pagar agora",
  },
  "payment-successful": {
    [Language.ENGLISH]: "Payment successful",
    [Language.SPANISH]: "Pago exitoso",
    [Language.PORTUGUESE]: "Pagamento realizado com sucesso",
  },
  "payment-failed": {
    [Language.ENGLISH]: "Payment failed",
    [Language.SPANISH]: "Pago fallido",
    [Language.PORTUGUESE]: "Pagamento falhou",
  },
  "purchase-cancelled": {
    [Language.ENGLISH]: "Purchase cancelled",
    [Language.SPANISH]: "Compra cancelada",
    [Language.PORTUGUESE]: "Compra cancelada",
  },
  "purchase-cancelled-description": {
    [Language.ENGLISH]:
      "The purchase could not be completed. No charges were made.",
    [Language.SPANISH]:
      "No se pudo completar la compra. No se ha realizado ningún cargo.",
    [Language.PORTUGUESE]:
      "A compra não pôde ser concluída. Nenhum cargo foi realizado.",
  },
  "payment-failed-description": {
    [Language.ENGLISH]: "We're sorry, we had problems with your card",
    [Language.SPANISH]:
      "Lamentamos lo ocurrido, hemos tenido problemas con tu tarjeta",
    [Language.PORTUGUESE]:
      "Lamentamos o ocorrido, tivemos problemas com sua cartão",
  },
  "payment-successful-description": {
    [Language.ENGLISH]:
      "Great! You have subscribed to [Plan name], you can now enjoy all its benefits",
    [Language.SPANISH]:
      "¡Genial! Te has suscrito al [Nombre del Plan], ya puedes disfrutar de todos sus beneficios",
    [Language.PORTUGUESE]:
      "Ótimo! Você se inscreveu no [Nome do Plano], agora você pode aproveitar todos os seus benefícios",
  },
  "credits-purchased-description": {
    [Language.ENGLISH]:
      "¡Genial! Has adquirido [Cantidad] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [fecha de vencimiento] para no dejarlos vencer.",
    [Language.SPANISH]:
      "¡Genial! Has adquirido [Cantidad] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [fecha de vencimiento] para no dejarlos vencer.",
    [Language.PORTUGUESE]:
      "Ótimo! Você adquiriu [Quantidade] créditos, agora você pode aproveitar seus novos créditos, lembre-se de usarlos antes de [data de vencimento] para não deixá-los vencer.",
  },
  retry: {
    [Language.ENGLISH]: "Retry",
    [Language.SPANISH]: "Volver a intentar",
    [Language.PORTUGUESE]: "Tentar novamente",
  },
  "credits-purchased": {
    [Language.ENGLISH]: "Credits purchased",
    [Language.SPANISH]: "Créditos comprados",
    [Language.PORTUGUESE]: "Créditos comprados",
  },
  "enter-your-email": {
    [Language.ENGLISH]: "Enter your email",
    [Language.SPANISH]: "Ingresa tu correo",
    [Language.PORTUGUESE]: "Insira seu email",
  },
  "email-required": {
    [Language.ENGLISH]: "Email is required",
    [Language.SPANISH]: "El correo electrónico es requerido",
    [Language.PORTUGUESE]: "O email é obrigatório",
  },
  "email-invalid": {
    [Language.ENGLISH]: "Please enter a valid email",
    [Language.SPANISH]: "Por favor ingresa un correo electrónico válido",
    [Language.PORTUGUESE]: "Por favor, insira um email válido",
  },
  "send-code": {
    [Language.ENGLISH]: "Send code",
    [Language.SPANISH]: "Enviar código",
    [Language.PORTUGUESE]: "Enviar código",
  },
  "sending-code": {
    [Language.ENGLISH]: "Sending code...",
    [Language.SPANISH]: "Enviando código...",
    [Language.PORTUGUESE]: "Enviando código...",
  },
  "create-account-title": {
    [Language.ENGLISH]: "Create account",
    [Language.SPANISH]: "Crear cuenta",
    [Language.PORTUGUESE]: "Criar conta",
  },
  "create-account-banner": {
    [Language.ENGLISH]:
      "We couldn't find an account with the email [email]. Complete your details to create your account.",
    [Language.SPANISH]:
      "No encontramos una cuenta con el correo [email]. Completa tus datos para crear tu cuenta.",
    [Language.PORTUGUESE]:
      "Não encontramos uma conta com o email [email]. Complete seus dados para criar sua conta.",
  },
  "missing-user-detail-banner": {
    [Language.ENGLISH]: "Your account already exists but we need to complete some additional details",
    [Language.SPANISH]: "Tu cuenta ya existe pero necesitamos que completes algunos datos adicionales",
    [Language.PORTUGUESE]: "Sua conta já existe, mas precisamos completar alguns dados adicionais.",
  },
  "switch-guest-welcome-banner": {
    [Language.ENGLISH]: "Welcome to Fluxi! Enter your details below to create your account.",
    [Language.SPANISH]: "¡Bienvenido a Fluxi! Ingresa tus datos a continuación para crear tu cuenta.",
    [Language.PORTUGUESE]: "Bem-vindo ao Fluxi! Insira seus dados abaixo para criar sua conta.",
  },
  name: {
    [Language.ENGLISH]: "Name",
    [Language.SPANISH]: "Nombre",
    [Language.PORTUGUESE]: "Nome",
  },
  "full-name-placeholder": {
    [Language.ENGLISH]: "Full name",
    [Language.SPANISH]: "Nombre Completo",
    [Language.PORTUGUESE]: "Nome completo",
  },
  "email-label": {
    [Language.ENGLISH]: "Email",
    [Language.SPANISH]: "Correo electrónico",
    [Language.PORTUGUESE]: "Email",
  },
  "phone-label": {
    [Language.ENGLISH]: "Phone",
    [Language.SPANISH]: "Celular",
    [Language.PORTUGUESE]: "Celular",
  },
  "phone-placeholder": {
    [Language.ENGLISH]: "+57 300...",
    [Language.SPANISH]: "+57 300...",
    [Language.PORTUGUESE]: "+57 300...",
  },
  "name-required": {
    [Language.ENGLISH]: "Name is required",
    [Language.SPANISH]: "El nombre es requerido",
    [Language.PORTUGUESE]: "O nome é obrigatório",
  },
  "phone-required": {
    [Language.ENGLISH]: "Phone is required",
    [Language.SPANISH]: "El celular es requerido",
    [Language.PORTUGUESE]: "O celular é obrigatório",
  },
  "enter-code-title": {
    [Language.ENGLISH]: "Enter the code",
    [Language.SPANISH]: "Ingresa el código",
    [Language.PORTUGUESE]: "Insira o código",
  },
  "we-sent-code-to": {
    [Language.ENGLISH]: "We sent a 6-digit code to",
    [Language.SPANISH]: "Hemos enviado un código de 6 dígitos a",
    [Language.PORTUGUESE]: "Enviamos um código de 6 dígitos para",
  },
  "enter-verification-code-label": {
    [Language.ENGLISH]: "Enter the verification code",
    [Language.SPANISH]: "Ingresa el código de verificación",
    [Language.PORTUGUESE]: "Insira o código de verificação",
  },
  "verifying-code": {
    [Language.ENGLISH]: "Verifying code...",
    [Language.SPANISH]: "Verificando código...",
    [Language.PORTUGUESE]: "Verificando código...",
  },
  "resend-code": {
    [Language.ENGLISH]: "Resend code",
    [Language.SPANISH]: "Reenviar código",
    [Language.PORTUGUESE]: "Reenviar código",
  },
  "resend-code-in": {
    [Language.ENGLISH]: "Resend code in [seconds]s",
    [Language.SPANISH]: "Reenviar código en [seconds]s",
    [Language.PORTUGUESE]: "Reenviar código em [seconds]s",
  },
  "change-email": {
    [Language.ENGLISH]: "Change email",
    [Language.SPANISH]: "Cambiar correo electrónico",
    [Language.PORTUGUESE]: "Alterar email",
  },
  "code-verified-success": {
    [Language.ENGLISH]: "Code verified successfully",
    [Language.SPANISH]: "Código verificado correctamente",
    [Language.PORTUGUESE]: "Código verificado com sucesso",
  },
  "verification-success-title": {
    [Language.ENGLISH]: "Verification successful!",
    [Language.SPANISH]: "¡Verificación Exitosa!",
    [Language.PORTUGUESE]: "Verificação bem-sucedida!",
  },
  "verification-success-description": {
    [Language.ENGLISH]: "Your email has been verified successfully",
    [Language.SPANISH]: "Tu correo electrónico ha sido verificado correctamente",
    [Language.PORTUGUESE]: "Seu email foi verificado com sucesso",
  },
  "verified-successfully": {
    [Language.ENGLISH]: "Verified successfully",
    [Language.SPANISH]: "Verificado exitosamente",
    [Language.PORTUGUESE]: "Verificado com sucesso",
  },
  "invalid-code": {
    [Language.ENGLISH]: "Invalid code. Please try again.",
    [Language.SPANISH]: "Código inválido. Por favor intenta de nuevo.",
    [Language.PORTUGUESE]: "Código inválido. Por favor tente novamente.",
  },
  "ai": {
    [Language.ENGLISH]: "AI",
    [Language.SPANISH]: "IA",
    [Language.PORTUGUESE]: "IA",
  },
  "magic-art": {
    [Language.ENGLISH]: "magic",
    [Language.SPANISH]: "arte de magia",
    [Language.PORTUGUESE]: "arte de mágica",
  },
  "sales-by-": {
    [Language.ENGLISH]: "Sales like",
    [Language.SPANISH]: "Ventas como por",
    [Language.PORTUGUESE]: "Vendas como por",
  },
  used: {
    [Language.ENGLISH]: "Used",
    [Language.SPANISH]: "Usados",
    [Language.PORTUGUESE]: "Usados",
  },
  remaining: {
    [Language.ENGLISH]: "Remaining",
    [Language.SPANISH]: "Restantes",
    [Language.PORTUGUESE]: "Restantes",
  },
  // PAYMENT RESULT PAGE
  "subscription-success-description": {
    [Language.ENGLISH]:
      "Great! You have subscribed to [plan_name], you can now enjoy all its benefits",
    [Language.SPANISH]:
      "¡Genial! Te has suscrito al [plan_name], ya puedes disfrutar de todos sus beneficios",
    [Language.PORTUGUESE]:
      "Ótimo! Você se inscreveu no [plan_name], agora pode aproveitar todos os benefícios",
  },
  "credits-purchased-title": {
    [Language.ENGLISH]: "Credits purchased!",
    [Language.SPANISH]: "¡Créditos comprados!",
    [Language.PORTUGUESE]: "Créditos comprados!",
  },
  "credits-success-description": {
    [Language.ENGLISH]:
      "Great! You have acquired [credits_amount] credits, you can now enjoy your new credits, remember to use them before [expiration_date] so they don't expire.",
    [Language.SPANISH]:
      "¡Genial! Has adquirido [credits_amount] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [expiration_date] para no dejarlos vencer.",
    [Language.PORTUGUESE]:
      "Ótimo! Você adquiriu [credits_amount] créditos, agora pode aproveitar seus novos créditos, lembre-se de usá-los antes de [expiration_date] para não expirarem.",
  },
  "credits-cancel-description": {
    [Language.ENGLISH]:
      "The purchase of [credits_amount] credits could not be completed. No charges have been made.",
    [Language.SPANISH]:
      "No se pudo completar la compra de [credits_amount] créditos. No se ha realizado ningún cargo.",
    [Language.PORTUGUESE]:
      "A compra de [credits_amount] créditos não pôde ser concluída. Nenhuma cobrança foi realizada.",
  },
  back: {
    [Language.ENGLISH]: "Back",
    [Language.SPANISH]: "Atrás",
    [Language.PORTUGUESE]: "Voltar",
  },
  cost: {
    [Language.ENGLISH]: "Cost",
    [Language.SPANISH]: "Costo",
    [Language.PORTUGUESE]: "Custo",
  },
  "no-valid-files-to-upload": {
    [Language.ENGLISH]: "No valid files to upload",
    [Language.SPANISH]: "No hay archivos válidos para subir",
    [Language.PORTUGUESE]: "Nenhum arquivo válido para upload",
  },
  "upload-photo": {
    [Language.ENGLISH]: "Upload photo",
    [Language.SPANISH]: "Subir foto",
    [Language.PORTUGUESE]: "Enviar foto",
  },
  "select-a-product-to-create-ads": {
    [Language.ENGLISH]: "Select a product to create ads",
    [Language.SPANISH]: "Selecciona un producto para crear anuncios",
    [Language.PORTUGUESE]: "Selecione um produto para criar anúncios",
  },
  "create-new-ad-with-ai": {
    [Language.ENGLISH]: "Create Image with AI",
    [Language.SPANISH]: "Crear Imagen con IA",
    [Language.PORTUGUESE]: "Criar Imagem com IA",
  },
  "creative": {
    [Language.ENGLISH]: "Creative",
    [Language.SPANISH]: "Creativo",
    [Language.PORTUGUESE]: "Creativo",
  },
  "creatives": {
    [Language.ENGLISH]: "creatives",
    [Language.SPANISH]: "creativos",
    [Language.PORTUGUESE]: "creativos",
  },
  "this-funnel-has-no-creatives": {
    [Language.ENGLISH]: "This funnel has no creatives",
    [Language.SPANISH]: "Este embudo no tiene creativos",
    [Language.PORTUGUESE]: "Este embudo não tem creativos",
  },
  "when-you-generate-creatives-they-will-appear-here": {
    [Language.ENGLISH]: "When you generate creatives, they will appear here",
    [Language.SPANISH]: "Cuando generes creativos, aparecerán aquí",
    [Language.PORTUGUESE]: "Quando você gerar creativos, eles aparecerão aqui",
  },
  "missing-query-param": {
    [Language.ENGLISH]: "Missing query param",
    [Language.SPANISH]: "Falta el query param",
    [Language.PORTUGUESE]: "Falta o query param",
  },
  "select-a-funnel": {
    [Language.ENGLISH]: "Select a funnel",
    [Language.SPANISH]: "Selecciona un embudo",
    [Language.PORTUGUESE]: "Selecione um embudo",
  },
  "choose-the-funnel-associated-with-the-new-ad": {
    [Language.ENGLISH]: "Choose the funnel associated with the new ad",
    [Language.SPANISH]: "Elige el embudo al que irá asociado el nuevo anuncio",
    [Language.PORTUGUESE]: "Selecione o embudo associado ao novo anúncio",
  },
  "what-type-of-ad-do-you-want-to-create": {
    [Language.ENGLISH]: "What type of ad do you want to create?",
    [Language.SPANISH]: "¿Qué tipo de anuncio quieres crear?",
    [Language.PORTUGUESE]: "Qual tipo de anúncio você deseja criar?",
  },
  "select-the-format-that-best-suits-your-campaign": {
    [Language.ENGLISH]: "Select the format that best suits your campaign",
    [Language.SPANISH]: "Selecciona el formato que mejor se adapte a tu campaña",
    [Language.PORTUGUESE]: "Selecione o formato que melhor se adapta à sua campanha",
  },
  "image-ad": {
    [Language.ENGLISH]: "Image Ad",
    [Language.SPANISH]: "Imagen Ad",
    [Language.PORTUGUESE]: "Anúncio de imagem",
  },
  "create-image-ads-with-ai-for-your-campaigns": {
    [Language.ENGLISH]: "Create image ads with AI for your campaigns",
    [Language.SPANISH]: "Crea imágenes publicitarias con IA para tus campañas",
    [Language.PORTUGUESE]: "Crie anúncios de imagem com IA para suas campanhas",
  },
  "video-ad": {
    [Language.ENGLISH]: "Video Ad",
    [Language.SPANISH]: "Video Ad",
    [Language.PORTUGUESE]: "Anúncio de vídeo",
  },
  "ad-studio": {
    [Language.ENGLISH]: "Ad Studio Image",
    [Language.SPANISH]: "Ad Studio Imagen",
    [Language.PORTUGUESE]: "Ad Studio Imagem",
  },
  "ad-studio-video": {
    [Language.ENGLISH]: "Ad Studio Video",
    [Language.SPANISH]: "Ad Studio Video",
    [Language.PORTUGUESE]: "Ad Studio Vídeo",
  },
  "configuration": {
    [Language.ENGLISH]: "Settings",
    [Language.SPANISH]: "Configuración",
    [Language.PORTUGUESE]: "Configuração",
  },
  "format": {
    [Language.ENGLISH]: "Format",
    [Language.SPANISH]: "Formato",
    [Language.PORTUGUESE]: "Formato",
  },
  "instructions": {
    [Language.ENGLISH]: "Instructions",
    [Language.SPANISH]: "Instrucciones",
    [Language.PORTUGUESE]: "Instruções",
  },
  "generate-1-image": {
    [Language.ENGLISH]: "Generate 1 image",
    [Language.SPANISH]: "Generar 1 imagen",
    [Language.PORTUGUESE]: "Gerar 1 imagem",
  },
  "all-products": {
    [Language.ENGLISH]: "All products",
    [Language.SPANISH]: "Todos los productos",
    [Language.PORTUGUESE]: "Todos os produtos",
  },
  "no-products-available": {
    [Language.ENGLISH]: "No products available",
    [Language.SPANISH]: "No hay productos disponibles",
    [Language.PORTUGUESE]: "Nenhum produto disponível",
  },
  "select-a-product": {
    [Language.ENGLISH]: "Select a product",
    [Language.SPANISH]: "Selecciona un producto",
    [Language.PORTUGUESE]: "Selecione um produto",
  },
  "select-the-product-for-which-you-want-to-create-the-ad": {
    [Language.ENGLISH]: "Select the product for which you want to create the ad",
    [Language.SPANISH]: "Selecciona el producto para el cual quieres crear el anuncio",
    [Language.PORTUGUESE]: "Selecione o produto para o qual você deseja criar o anúncio",
  },
  "remember-not-to-leave-the-page-so-you-dont-lose-the-progress-of-your-ad": {
    [Language.ENGLISH]: "Remember not to leave the page, so you don't lose the progress of your ad",
    [Language.SPANISH]: "Recuerda no salir de la página, así no perderás el progreso de tu anuncio",
    [Language.PORTUGUESE]: "Lembre-se de não sair da página, para não perder o progresso do seu anúncio",
  },
  "generating-ads": {
    [Language.ENGLISH]: "Generating ads",
    [Language.SPANISH]: "Generando anuncios",
    [Language.PORTUGUESE]: "Gerando anúncios",
  },
  "this-could-take-a-few-minutes": {
    [Language.ENGLISH]: "This could take a few minutes",
    [Language.SPANISH]: "Esto podría tomar unos minutos",
    [Language.PORTUGUESE]: "Isso pode levar alguns minutos",
  },
  "we-are-generating-your-ads": {
    [Language.ENGLISH]: "We are generating your ads",
    [Language.SPANISH]: "Estamos generando tus anuncios",
    [Language.PORTUGUESE]: "Estamos gerando seus anúncios",
  },
  "generating-your-ads": {
    [Language.ENGLISH]: "Generating your ads",
    [Language.SPANISH]: "Generando tus anuncios",
    [Language.PORTUGUESE]: "Gerando seus anúncios",
  },
  "click-on-a-style-to-add-it": {
    [Language.ENGLISH]: "Click on a style to add it",
    [Language.SPANISH]: "Haz clic en un estilo para agregarlo",
    [Language.PORTUGUESE]: "Clique em um estilo para adicioná-lo",
  },
  "viral": {
    [Language.ENGLISH]: "Viral",
    [Language.SPANISH]: "Viral",
    [Language.PORTUGUESE]: "Viral",
  },
  "offer": {
    [Language.ENGLISH]: "Offer",
    [Language.SPANISH]: "Oferta",
    [Language.PORTUGUESE]: "Oferta",
  },
  "testimonials": {
    [Language.ENGLISH]: "Testimonials",
    [Language.SPANISH]: "Testimonios",
    [Language.PORTUGUESE]: "Testimonios",
  },
  "no-creatives-available": {
    [Language.ENGLISH]: "No creatives available",
    [Language.SPANISH]: "Aún no tienes creativos disponibles.",
    [Language.PORTUGUESE]: "Nenhum creativo disponível.",
  },
  "create-a-creative-first": {
    [Language.ENGLISH]: "Create a creative first and then come back here.",
    [Language.SPANISH]: "Crea un creativo primero y luego vuelve aquí.",
    [Language.PORTUGUESE]: "Crie um creativo primeiro e depois volte aqui.",
  },
  "download": {
    [Language.ENGLISH]: "Download",
    [Language.SPANISH]: "Descargar",
    [Language.PORTUGUESE]: "Baixar",
  },
  "custom-reference": {
    [Language.ENGLISH]: "Custom reference",
    [Language.SPANISH]: "Referencia personalizada",
    [Language.PORTUGUESE]: "Referência personalizada",
  },
  "custom-reference-description": {
    [Language.ENGLISH]: "Upload a reference image to use as a custom style",
    [Language.SPANISH]: "Carga una imagen de referencia para usar como estilo personalizado",
    [Language.PORTUGUESE]: "Carregue uma imagem de referência para usar como estilo personalizado",
  },
  "see-my-hyphens": {
    [Language.ENGLISH]: "See my hyphens",
    [Language.SPANISH]: "Ver mis guiones",
    [Language.PORTUGUESE]: "Ver meus guias",
  },
  "verde": {
    [Language.ENGLISH]: "Green",
    [Language.SPANISH]: "Verde",
    [Language.PORTUGUESE]: "Verde",
  },
  "coral": {
    [Language.ENGLISH]: "Coral",
    [Language.SPANISH]: "Coral",
    [Language.PORTUGUESE]: "Coral",
  },
  "oro": {
    [Language.ENGLISH]: "Gold",
    [Language.SPANISH]: "Oro",
    [Language.PORTUGUESE]: "Oro",
  },
  "mono": {
    [Language.ENGLISH]: "Mono",
    [Language.SPANISH]: "Mono",
    [Language.PORTUGUESE]: "Mono",
  },
  "violeta": {
    [Language.ENGLISH]: "Violet",
    [Language.SPANISH]: "Violeta",
    [Language.PORTUGUESE]: "Violeta",
  },
  "no-name": {
    [Language.ENGLISH]: "No name",
    [Language.SPANISH]: "Sin nombre",
    [Language.PORTUGUESE]: "Sem nome",
  },
  "carousels": {
    [Language.ENGLISH]: "Carousels",
    [Language.SPANISH]: "Carruseles",
    [Language.PORTUGUESE]: "Carrosséis",
  },
  "custom": {
    [Language.ENGLISH]: "Custom",
    [Language.SPANISH]: "Personalizado",
    [Language.PORTUGUESE]: "Personalizado",
  },
  "your-styles": {
    [Language.ENGLISH]: "Your styles",
    [Language.SPANISH]: "Tus estilos",
    [Language.PORTUGUESE]: "Seus estilos",
  },
  "styles": {
    [Language.ENGLISH]: "styles",
    [Language.SPANISH]: "estilos",
    [Language.PORTUGUESE]: "estilos",
  },
  "no-styles-found": {
    [Language.ENGLISH]: "No styles found in this category",
    [Language.SPANISH]: "No hay estilos en esta categoría",
    [Language.PORTUGUESE]: "Nenhum estilo nesta categoria",
  },
  "select-styles-from-the-gallery": {
    [Language.ENGLISH]: "Select styles from the gallery",
    [Language.SPANISH]: "Selecciona estilos de la galería",
    [Language.PORTUGUESE]: "Selecione estilos da galeria",
  },
  "example-style-aggressive-close-up-of-the-product": {
    [Language.ENGLISH]: "Example: aggressive style, close-up of the product...",
    [Language.SPANISH]: "Ejemplo: estilo agresivo, close-up del producto...",
    [Language.PORTUGUESE]: "Exemplo: estilo agressivo, close-up do produto...",
  },
  "coming-soon": {
    [Language.ENGLISH]: "Coming soon",
    [Language.SPANISH]: "Próximamente",
    [Language.PORTUGUESE]: "Em breve",
  },
  "video-ads-with-ai-avatars-and-cloned-voices": {
    [Language.ENGLISH]: "Video ads with AI avatars and cloned voices",
    [Language.SPANISH]: "Videos publicitarios con avatares IA y voces clonadas",
    [Language.PORTUGUESE]: "Vídeos publicitários com avatares IA e vozes clonadas",
  },
  "create-image-ad-with-ai": {
    [Language.ENGLISH]: "Create image ad with AI",
    [Language.SPANISH]: "Crear imagen ad con IA",
    [Language.PORTUGUESE]: "Criar anúncio de imagem com IA",
  },
  "configure-the-product-details-to-generate-your-ad": {
    [Language.ENGLISH]: "Configure the product details to generate your ad",
    [Language.SPANISH]: "Configura los detalles del producto para generar tu anuncio",
    [Language.PORTUGUESE]: "Configure os detalhes do produto para gerar seu anúncio",
  },
  "these-data-come-from-your-funnel": {
    [Language.ENGLISH]: "These data come from your funnel. You can edit them if you want.",
    [Language.SPANISH]: "Estos datos vienen de tu embudo. Puedes editarlos si lo deseas.",
    [Language.PORTUGUESE]: "Estes dados vêm do seu embudo. Você pode editá-los se quiser.",
  },
  "uploading...": {
    [Language.ENGLISH]: "Uploading...",
    [Language.SPANISH]: "Subiendo...",
    [Language.PORTUGUESE]: "Enviando...",
  },
  "change-image": {
    [Language.ENGLISH]: "Change image",
    [Language.SPANISH]: "Cambiar imagen",
    [Language.PORTUGUESE]: "Alterar imagem",
  },
  "tell-us-how-you-want-your-ad-to-look": {
    [Language.ENGLISH]: "Tell us how you want your ad to look",
    [Language.SPANISH]: "Cuéntanos cómo quieres que se vea tu anuncio: estilo visual, colores, elementos, escenario, etc.",
    [Language.PORTUGUESE]: "Conte-nos como você quer que seu anúncio pareça: estilo visual, cores, elementos, cenário, etc.",
  },
  "example-prompt-create-image-ad-with-ai": {
    [Language.ENGLISH]: "Ex: I want a minimalist ad with a blue gradient background, the product centered with a soft glow, and text highlighting the main benefits...",
    [Language.SPANISH]: "Ej: Quiero un anuncio minimalista con fondo degradado azul, el producto centrado con un brillo suave, y texto que destaque los beneficios principales...",
    [Language.PORTUGUESE]: "Ex: Quero um anúncio minimalista com fundo degradado azul, o produto centralizado com um brilho suave, e texto que destaque os benefícios principais...",
  },
  "this-field-is-required-to-generate-your-ad": {
    [Language.ENGLISH]: "This field is required to generate your ad",
    [Language.SPANISH]: "Este campo es obligatorio para generar tu anuncio",
    [Language.PORTUGUESE]: "Este campo é obrigatório para gerar seu anúncio",
  },
  "generate-ad": {
    [Language.ENGLISH]: "Generate ad",
    [Language.SPANISH]: "Generar anuncio",
    [Language.PORTUGUESE]: "Gerar anúncio",
  },
  "product-image": {
    [Language.ENGLISH]: "Product image",
    [Language.SPANISH]: "Imagen del producto",
    [Language.PORTUGUESE]: "Imagem do produto",
  },
  "jpg-png-webp": {
    [Language.ENGLISH]: "JPG, PNG or WebP",
    [Language.SPANISH]: "JPG, PNG o WebP",
    [Language.PORTUGUESE]: "JPG, PNG ou WebP",
  },
  "describe-your-ideal-ad": {
    [Language.ENGLISH]: "Describe your ideal ad",
    [Language.SPANISH]: "Describe tu anuncio ideal",
    [Language.PORTUGUESE]: "Descreva seu anúncio ideal",
  },
  "required": {
    [Language.ENGLISH]: "Required",
    [Language.SPANISH]: "Requerido",
    [Language.PORTUGUESE]: "Requerido",
  },
  link: {
    [Language.ENGLISH]: "Link",
    [Language.SPANISH]: "Link",
    [Language.PORTUGUESE]: "Link",
  },
  "increase-your-revenue-with-complementary-products": {
    [Language.ENGLISH]: "Increase your revenue with complementary products",
    [Language.SPANISH]: "Aumenta tu facturación con productos complementarios",
    [Language.PORTUGUESE]: "Aumente sua receita com produtos complementares",
  },
  "add-order-bump": {
    [Language.ENGLISH]: "Add order bump",
    [Language.SPANISH]: "Agregar order bump",
    [Language.PORTUGUESE]: "Adicionar order bump",
  },
  "what-is-an-order-bump": {
    [Language.ENGLISH]: "What is an order bump?",
    [Language.SPANISH]: "¿Qué es un order bump?",
    [Language.PORTUGUESE]: "O que é um order bump?",
  },
  "add-upsell": {
    [Language.ENGLISH]: "Add upsell",
    [Language.SPANISH]: "Agregar upsell",
    [Language.PORTUGUESE]: "Adicionar upsell",
  },
  "what-is-an-upsell": {
    [Language.ENGLISH]: "What is an upsell?",
    [Language.SPANISH]: "¿Qué es un upsell?",
    [Language.PORTUGUESE]: "O que é um upsell?",
  },
  "only-a-few-steps-left": {
    [Language.ENGLISH]: "Only a few steps left",
    [Language.SPANISH]: "Falta muy poco",
    [Language.PORTUGUESE]: "Falta pouco",
  },
  "generate-with-ai": {
    [Language.ENGLISH]: "Generate with AI",
    [Language.SPANISH]: "Generar con IA",
    [Language.PORTUGUESE]: "Gerar com IA",
  },
  warranty: {
    [Language.ENGLISH]: "Warranty",
    [Language.SPANISH]: "Garantía",
    [Language.PORTUGUESE]: "Garantia",
  },
  "warranty-tooltip": {
    [Language.ENGLISH]: "This will be announced on your sales page (e.g., '30-day return guarantee'). It increases trust by reducing the perceived risk of buying.",
    [Language.SPANISH]: "Esto se anunciará en tu página de ventas (ej. 'Garantía de devolución de 30 días'). Aumenta la confianza al reducir el riesgo percibido al comprar.",
    [Language.PORTUGUESE]: "Isso será anunciado na sua página de vendas (ex. 'Garantia de devolução de 30 dias'). Aumenta a confiança reduzindo o risco percebido ao comprar.",
  },
  "add-context-suggestion": {
    [Language.ENGLISH]: "Add communication suggestions (Optional)",
    [Language.SPANISH]: "Agregar sugerencias de comunicación (Opcional)",
    [Language.PORTUGUESE]: "Adicionar sugestões de comunicação (Opcional)",
  },
  "context-suggestion-label": {
    [Language.ENGLISH]: "Extra context for the AI",
    [Language.SPANISH]: "Contexto extra para la IA",
    [Language.PORTUGUESE]: "Contexto extra para a IA",
  },
  "context-suggestion-placeholder": {
    [Language.ENGLISH]: "E.g.: more direct tone, avoid medical claims.",
    [Language.SPANISH]: "Ej.: tono más directo, evitar claims médicos.",
    [Language.PORTUGUESE]: "Ex.: tom mais direto, evitar claims médicos.",
  },
  "context-suggestion-helper": {
    [Language.ENGLISH]: "This text will be used as extra context in every generation (HTML and images).",
    [Language.SPANISH]: "Este texto se usará como contexto adicional en cada generación (HTML e imágenes).",
    [Language.PORTUGUESE]: "Este texto será usado como contexto adicional em cada geração (HTML e imagens).",
  },
  "close-context": {
    [Language.ENGLISH]: "Close",
    [Language.SPANISH]: "Cerrar",
    [Language.PORTUGUESE]: "Fechar",
  },
  "load-a-product-to-create-your-page": {
    [Language.ENGLISH]: "Load a product to ",
    [Language.SPANISH]: "Carga un producto para ",
    [Language.PORTUGUESE]: "Carregue um produto para ",
  },
  "create-your-page": {
    [Language.ENGLISH]: "create your funnel",
    [Language.SPANISH]: "crear tu embudo",
    [Language.PORTUGUESE]: "criar seu funil",
  },
  "no-previous-products-available": {
    [Language.ENGLISH]: "No previous products available",
    [Language.SPANISH]: "No hay productos previos disponibles",
    [Language.PORTUGUESE]: "Nenhum produto anterior disponível",
  },
  "select-one-or-more-sales-angles": {
    [Language.ENGLISH]: "Select one or more sales angles",
    [Language.SPANISH]: "Selecciona uno o varios ángulos de venta",
    [Language.PORTUGUESE]: "Selecione um ou mais ângulos de venda",
  },
  "we-will-create-a-page-with-each-selected-sales-angle": {
    [Language.ENGLISH]: "We will create a page with each selected sales angle",
    [Language.SPANISH]: "Crearemos una página con cada ángulo seleccionado",
    [Language.PORTUGUESE]: "Criaremos uma página com cada ângulo selecionado",
  },
  "enter-custom-sales-angle": {
    [Language.ENGLISH]: "Enter custom sales angle",
    [Language.SPANISH]: "Ingresar ángulo personalizado",
    [Language.PORTUGUESE]: "Inserir ângulo personalizado",
  },
  "custom-sections-only": {
    [Language.ENGLISH]: "Custom sections only",
    [Language.SPANISH]: "Solo secciones personalizadas",
    [Language.PORTUGUESE]: "Apenas seções personalizadas",
  },
  "custom-sections-only-description": {
    [Language.ENGLISH]: "Create funnel with custom sections only",
    [Language.SPANISH]: "Crear embudo solo con secciones personalizadas",
    [Language.PORTUGUESE]: "Criar funil apenas com seções personalizadas",
  },
  "create-page": {
    [Language.ENGLISH]: "Create page",
    [Language.SPANISH]: "Crear página",
    [Language.PORTUGUESE]: "Criar página",
  },
  "how-many-funnels": {
    [Language.ENGLISH]: "How many funnels do you want to create?",
    [Language.SPANISH]: "¿Cuántos embudos quieres crear?",
    [Language.PORTUGUESE]: "Quantos funis você quer criar?",
  },
  "funnel-count-tip": {
    [Language.ENGLISH]: "Sellers who create 3 or more funnels are 47% more likely to find their winning angle.",
    [Language.SPANISH]: "Los vendedores que crean 3 o más embudos tienen un 47% más de probabilidad de encontrar su ángulo ganador.",
    [Language.PORTUGUESE]: "Vendedores que criam 3 ou mais funis têm 47% mais chance de encontrar seu ângulo vencedor.",
  },
  "personalize-funnels": {
    [Language.ENGLISH]: "Personalize your funnels",
    [Language.SPANISH]: "Personaliza tus embudos",
    [Language.PORTUGUESE]: "Personalize seus funis",
  },
  "personalize-funnels-description": {
    [Language.ENGLISH]: "Select a funnel to edit its design, structure, and angle",
    [Language.SPANISH]: "Selecciona un embudo para editar su diseño, estructura y ángulo",
    [Language.PORTUGUESE]: "Selecione um funil para editar seu design, estrutura e ângulo",
  },
  "design-tab": {
    [Language.ENGLISH]: "Design",
    [Language.SPANISH]: "Diseño",
    [Language.PORTUGUESE]: "Design",
  },
  "structure-tab": {
    [Language.ENGLISH]: "Structure",
    [Language.SPANISH]: "Estructura",
    [Language.PORTUGUESE]: "Estrutura",
  },
  "angle-tab": {
    [Language.ENGLISH]: "Angle",
    [Language.SPANISH]: "Ángulo",
    [Language.PORTUGUESE]: "Ângulo",
  },
  "ads-tab": {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  "select-ad-templates": {
    [Language.ENGLISH]: "AD TEMPLATES",
    [Language.SPANISH]: "PLANTILLAS DE ANUNCIOS",
    [Language.PORTUGUESE]: "MODELOS DE ANÚNCIOS",
  },
  "n-ads-selected": {
    [Language.ENGLISH]: "{n} template(s) selected",
    [Language.SPANISH]: "{n} plantilla(s) seleccionada(s)",
    [Language.PORTUGUESE]: "{n} modelo(s) selecionado(s)",
  },
  "max-ad-templates-reached": {
    [Language.ENGLISH]: "Maximum of {n} templates per funnel reached",
    [Language.SPANISH]: "Llegaste al máximo de {n} plantillas por embudo",
    [Language.PORTUGUESE]: "Máximo de {n} modelos por funil atingido",
  },
  "ads-count-label": {
    [Language.ENGLISH]: "ads",
    [Language.SPANISH]: "anuncios",
    [Language.PORTUGUESE]: "anúncios",
  },
  "video-studio": {
    [Language.ENGLISH]: "Videos",
    [Language.SPANISH]: "Videos",
    [Language.PORTUGUESE]: "Videos",
  },
  "estimated-cost": {
    [Language.ENGLISH]: "Estimated cost",
    [Language.SPANISH]: "Costo estimado",
    [Language.PORTUGUESE]: "Custo estimado",
  },
  "template-design": {
    [Language.ENGLISH]: "TEMPLATE / DESIGN",
    [Language.SPANISH]: "PLANTILLA / DISEÑO",
    [Language.PORTUGUESE]: "MODELO / DESIGN",
  },
  "funnel-structure": {
    [Language.ENGLISH]: "FUNNEL STRUCTURE",
    [Language.SPANISH]: "ESTRUCTURA DEL EMBUDO",
    [Language.PORTUGUESE]: "ESTRUTURA DO FUNIL",
  },
  "select-angles-for-funnel": {
    [Language.ENGLISH]: "SALES ANGLES",
    [Language.SPANISH]: "ÁNGULOS DE VENTA",
    [Language.PORTUGUESE]: "ÂNGULOS DE VENDA",
  },
  "sections": {
    [Language.ENGLISH]: "sections",
    [Language.SPANISH]: "secciones",
    [Language.PORTUGUESE]: "seções",
  },
  "all-ready-to-create": {
    [Language.ENGLISH]: "All ready to create",
    [Language.SPANISH]: "Todo listo para crear",
    [Language.PORTUGUESE]: "Tudo pronto para criar",
  },
  "review-summary": {
    [Language.ENGLISH]: "Review the summary of what Fluxi will generate for you",
    [Language.SPANISH]: "Revisa el resumen de lo que Fluxi generará para ti",
    [Language.PORTUGUESE]: "Revise o resumo do que Fluxi irá gerar para você",
  },
  "active-sections": {
    [Language.ENGLISH]: "Active sections",
    [Language.SPANISH]: "Secciones activas",
    [Language.PORTUGUESE]: "Seções ativas",
  },
  "breakdown-by-funnel": {
    [Language.ENGLISH]: "BREAKDOWN BY FUNNEL",
    [Language.SPANISH]: "DESGLOSE POR EMBUDO",
    [Language.PORTUGUESE]: "DETALHAMENTO POR FUNIL",
  },
  "generate-all": {
    [Language.ENGLISH]: "Generate all",
    [Language.SPANISH]: "Generar todo",
    [Language.PORTUGUESE]: "Gerar tudo",
  },
  "add-funnel": {
    [Language.ENGLISH]: "Add funnel",
    [Language.SPANISH]: "Agregar embudo",
    [Language.PORTUGUESE]: "Adicionar funil",
  },
  "please-select-design-for-all-funnels": {
    [Language.ENGLISH]: "Please select a design for all funnels",
    [Language.SPANISH]: "Por favor selecciona un diseño para todos los embudos",
    [Language.PORTUGUESE]: "Por favor selecione um design para todos os funis",
  },
  "design-required": {
    [Language.ENGLISH]: "Design required",
    [Language.SPANISH]: "Diseño requerido",
    [Language.PORTUGUESE]: "Design necessário",
  },

  "survey-title": {
    [Language.ENGLISH]: "Answer a few questions to personalize your account",
    [Language.SPANISH]: "Responde unas preguntas para personalizar tu cuenta",
    [Language.PORTUGUESE]:
      "Responda algumas perguntas para personalizar sua conta",
  },
  "start-survey": {
    [Language.ENGLISH]: "Start survey",
    [Language.SPANISH]: "Comenzar",
    [Language.PORTUGUESE]: "Iniciar",
  },
  "write-your-answer-here": {
    [Language.ENGLISH]: "Write your answer here",
    [Language.SPANISH]: "Escribe tu respuesta aquí",
    [Language.PORTUGUESE]: "Escreva sua resposta aqui",
  },
  "go-to-account": {
    [Language.ENGLISH]: "Go to my account",
    [Language.SPANISH]: "Ir a mi cuenta",
    [Language.PORTUGUESE]: "Ir para minha conta",
  },
  "all-set": {
    [Language.ENGLISH]: "All set",
    [Language.SPANISH]: "Todo listo",
    [Language.PORTUGUESE]: "Tudo pronto",
  },
  "whatsapp-community-message": {
    [Language.ENGLISH]: "Don't miss our exclusive events and the latest Fluxi updates!\n\nJoin the WhatsApp community now.",
    [Language.SPANISH]: "¡No te pierdas de nuestros eventos exclusivos y de las actualizaciones de Fluxi!\n\nIngresa ahora a la comunidad de Whatsapp",
    [Language.PORTUGUESE]: "Não perca nossos eventos exclusivos e as atualizações do Fluxi!\n\nEntre agora na comunidade do WhatsApp.",
  },
  "whatsapp-community-join": {
    [Language.ENGLISH]: "Join the Fluxi community",
    [Language.SPANISH]: "Unirme a la comunidad de Fluxi",
    [Language.PORTUGUESE]: "Entrar na comunidade do Fluxi",
  },
  "whatsapp-community-already-member": {
    [Language.ENGLISH]: "I'm already part of the Fluxi community",
    [Language.SPANISH]: "Ya hago parte de la comunidad de Fluxi",
    [Language.PORTUGUESE]: "Já faço parte da comunidade do Fluxi",
  },
  "Nombres y apellidos": {
    [Language.ENGLISH]: "First and last name",
    [Language.SPANISH]: "Nombres y apellidos",
    [Language.PORTUGUESE]: "Nome e sobrenome",
  },
  "Ingresa tu nombre completo": {
    [Language.ENGLISH]: "Enter your full name",
    [Language.SPANISH]: "Ingresa tu nombre completo",
    [Language.PORTUGUESE]: "Digite seu nome completo",
  },










  // SURVEY TRANSLATIONS
  "¿Cual es tu numero de celular?": {
    [Language.ENGLISH]: "What is your phone number?",
    [Language.SPANISH]: "¿Cuál es tu número de teléfono?",
    [Language.PORTUGUESE]: "Qual é seu número de telefone?",
  },

  "Asegurate de agregar el prefijo de tu pais (ejemplo: +57 3xxxxxx)": {
    [Language.ENGLISH]:
      "Make sure to add the prefix of your country (example: +57 3xxxxxx)",
    [Language.SPANISH]:
      "Asegúrate de agregar el prefijo de tu país (ejemplo: +57 3xxxxxx)",
    [Language.PORTUGUESE]:
      "Certifique-se de adicionar o prefixo do seu país (exemplo: +57 3xxxxxx)",
  },

  "¿Ya has tenido ventas online?": {
    [Language.ENGLISH]: "Have you had online sales before?",
    [Language.SPANISH]: "¿Ya has tenido ventas online?",
    [Language.PORTUGUESE]: "Você já teve vendas online?",
  },

  "¿Por qué medios has vendido?": {
    [Language.ENGLISH]: "Which channels have you sold through?",
    [Language.SPANISH]: "¿Por qué medios has vendido?",
    [Language.PORTUGUESE]: "Por quais canais você vendeu?",
  },

  "Puedes seleccionar varios": {
    [Language.ENGLISH]: "You can select multiple options",
    [Language.SPANISH]: "Puedes seleccionar varios",
    [Language.PORTUGUESE]: "Você pode selecionar várias opções",
  },

  "¿Vendes en tienda física?": {
    [Language.ENGLISH]: "Do you sell in a physical store?",
    [Language.SPANISH]: "¿Vendes en tienda física?",
    [Language.PORTUGUESE]: "Você vende em loja física?",
  },

  "¿Cuánto vendes al mes?": {
    [Language.ENGLISH]: "How much do you sell per month?",
    [Language.SPANISH]: "¿Cuánto vendes al mes?",
    [Language.PORTUGUESE]: "Quanto você vende por mês?",
  },

  "Aproximadamente, en pesos colombianos": {
    [Language.ENGLISH]: "Approximately, in Colombian pesos",
    [Language.SPANISH]: "Aproximadamente, en pesos colombianos",
    [Language.PORTUGUESE]: "Aproximadamente, em pesos colombianos",
  },

  "¿Cuántos productos has vendido?": {
    [Language.ENGLISH]: "How many products have you sold?",
    [Language.SPANISH]: "¿Cuántos productos has vendido?",
    [Language.PORTUGUESE]: "Quantos produtos você vendeu?",
  },

  "Productos diferentes que ofreces": {
    [Language.ENGLISH]: "Different products you offer",
    [Language.SPANISH]: "Productos diferentes que ofreces",
    [Language.PORTUGUESE]: "Produtos diferentes que você oferece",
  },

  "¿Qué productos vendes?": {
    [Language.ENGLISH]: "What products do you sell?",
    [Language.SPANISH]: "¿Qué productos vendes?",
    [Language.PORTUGUESE]: "Quais produtos você vende?",
  },

  "Cuales productos ofreces": {
    [Language.ENGLISH]: "Which products you offer",
    [Language.SPANISH]: "Cuales productos ofreces",
    [Language.PORTUGUESE]: "Quais produtos você oferece",
  },

  "¿Qué crees que te ha hecho falta?": {
    [Language.ENGLISH]: "What do you think you’ve been missing?",
    [Language.SPANISH]: "¿Qué crees que te ha hecho falta?",
    [Language.PORTUGUESE]: "O que você acha que está faltando?",
  },

  "Para empezar a vender online": {
    [Language.ENGLISH]: "To start selling online",
    [Language.SPANISH]: "Para empezar a vender online",
    [Language.PORTUGUESE]: "Para começar a vender online",
  },

  "¿Por qué decidiste comprar Fluxi?": {
    [Language.ENGLISH]: "Why did you decide to buy Fluxi?",
    [Language.SPANISH]: "¿Por qué decidiste comprar Fluxi?",
    [Language.PORTUGUESE]: "Por que você decidiu comprar o Fluxi?",
  },

  "Cuéntanos qué te motivó a elegir nuestra plataforma": {
    [Language.ENGLISH]: "Tell us what motivated you to choose our platform",
    [Language.SPANISH]: "Cuéntanos qué te motivó a elegir nuestra plataforma",
    [Language.PORTUGUESE]:
      "Conte-nos o que motivou você a escolher nossa plataforma",
  },

  "Todo listo": {
    [Language.ENGLISH]: "All set",
    [Language.SPANISH]: "Todo listo",
    [Language.PORTUGUESE]: "Tudo pronto",
  },
  Sí: {
    [Language.ENGLISH]: "Yes",
    [Language.SPANISH]: "Sí",
    [Language.PORTUGUESE]: "Sim",
  },

  No: {
    [Language.ENGLISH]: "No",
    [Language.SPANISH]: "No",
    [Language.PORTUGUESE]: "Não",
  },

  Whatsapp: {
    [Language.ENGLISH]: "Whatsapp",
    [Language.SPANISH]: "Whatsapp",
    [Language.PORTUGUESE]: "Whatsapp",
  },

  "Página web": {
    [Language.ENGLISH]: "Website",
    [Language.SPANISH]: "Página web",
    [Language.PORTUGUESE]: "Site",
  },

  "Tienda física": {
    [Language.ENGLISH]: "Physical store",
    [Language.SPANISH]: "Tienda física",
    [Language.PORTUGUESE]: "Loja física",
  },

  "1": {
    [Language.ENGLISH]: "1",
    [Language.SPANISH]: "1",
    [Language.PORTUGUESE]: "1",
  },

  "10": {
    [Language.ENGLISH]: "10",
    [Language.SPANISH]: "10",
    [Language.PORTUGUESE]: "10",
  },

  "50": {
    [Language.ENGLISH]: "50",
    [Language.SPANISH]: "50",
    [Language.PORTUGUESE]: "50",
  },

  "100": {
    [Language.ENGLISH]: "100",
    [Language.SPANISH]: "100",
    [Language.PORTUGUESE]: "100",
  },

  "Mejor producto": {
    [Language.ENGLISH]: "Better product",
    [Language.SPANISH]: "Mejor producto",
    [Language.PORTUGUESE]: "Produto melhor",
  },

  "Mejor precio": {
    [Language.ENGLISH]: "Better price",
    [Language.SPANISH]: "Mejor precio",
    [Language.PORTUGUESE]: "Preço melhor",
  },

  "Mejor contenido en redes sociales": {
    [Language.ENGLISH]: "Better social media content",
    [Language.SPANISH]: "Mejor contenido en redes sociales",
    [Language.PORTUGUESE]: "Melhor conteúdo nas redes sociais",
  },

  "Mejor página web": {
    [Language.ENGLISH]: "Better website",
    [Language.SPANISH]: "Mejor página web",
    [Language.PORTUGUESE]: "Site melhor",
  },

  "No sé": {
    [Language.ENGLISH]: "I don't know",
    [Language.SPANISH]: "No sé",
    [Language.PORTUGUESE]: "Não sei",
  },

  "$1 millón": {
    [Language.ENGLISH]: "$1 million COP",
    [Language.SPANISH]: "$1 millón",
    [Language.PORTUGUESE]: "1 milhão COP",
  },

  "$10 millones": {
    [Language.ENGLISH]: "$10 million COP",
    [Language.SPANISH]: "$10 millones",
    [Language.PORTUGUESE]: "10 milhões COP",
  },

  "$50 millones": {
    [Language.ENGLISH]: "$50 million COP",
    [Language.SPANISH]: "$50 millones",
    [Language.PORTUGUESE]: "50 milhões COP",
  },

  "$100 millones": {
    [Language.ENGLISH]: "$100 million COP",
    [Language.SPANISH]: "$100 millones",
    [Language.PORTUGUESE]: "100 milhões COP",
  },

  "$500 millones": {
    [Language.ENGLISH]: "$500 million COP",
    [Language.SPANISH]: "$500 millones",
    [Language.PORTUGUESE]: "500 milhões COP",
  },

  "$1 millón-USD": {
    [Language.ENGLISH]: "$1,000 USD",
    [Language.SPANISH]: "$1,000 USD",
    [Language.PORTUGUESE]: "$1,000 USD",
  },

  "$10 millones-USD": {
    [Language.ENGLISH]: "$5,000 USD",
    [Language.SPANISH]: "$5,000 USD",
    [Language.PORTUGUESE]: "$5,000 USD",
  },

  "$50 millones-USD": {
    [Language.ENGLISH]: "$10,000 USD",
    [Language.SPANISH]: "$10,000 USD",
    [Language.PORTUGUESE]: "$10,000 USD",
  },

  "$100 millones-USD": {
    [Language.ENGLISH]: "$50,000 USD",
    [Language.SPANISH]: "$50,000 USD",
    [Language.PORTUGUESE]: "$50,000 USD",
  },

  "$500 millones-USD": {
    [Language.ENGLISH]: "$100,000 USD",
    [Language.SPANISH]: "$100,000 USD",
    [Language.PORTUGUESE]: "$100,000 USD",
  },

  "describe-your-custom-sales-angle-placeholder-manual-entry": {
    [Language.ENGLISH]: "Describe your custom sales angle...",
    [Language.SPANISH]: "Escribe tu angulo de venta...",
    [Language.PORTUGUESE]: "Descreva seu ângulo de venda personalizado...",
  },
  "add": {
    [Language.ENGLISH]: "Add",
    [Language.SPANISH]: "Agregar",
    [Language.PORTUGUESE]: "Adicionar",
  },
  "counter-delivery": {
    [Language.ENGLISH]: "Cash on payment",
    [Language.SPANISH]: "Contra entrega",
    [Language.PORTUGUESE]: "Entrega contra",
  },
  "you-must-spend-these-credits-before": {
    [Language.ENGLISH]: "You must spend these credits before",
    [Language.SPANISH]: "Debes gastar estos créditos antes del",
    [Language.PORTUGUESE]: "Você deve gastar esses créditos antes do",
  },
  "when-your-credits-will-be-renewed": {
    [Language.ENGLISH]: "when your credits will be renewed",
    [Language.SPANISH]: "cuando se te renovarán los créditos",
    [Language.PORTUGUESE]: "quando seus créditos serão renovados",
  },
  "Plan Lite": {
    [Language.ENGLISH]: "Lite Plan",
    [Language.SPANISH]: "Plan Lite",
    [Language.PORTUGUESE]: "Plano Lite",
  },
  "Plan Básico": {
    [Language.ENGLISH]: "Basic Plan",
    [Language.SPANISH]: "Plan Básico",
    [Language.PORTUGUESE]: "Plano Básico",
  },
  "Plan Medio": {
    [Language.ENGLISH]: "Medium Plan",
    [Language.SPANISH]: "Plan Medio",
    [Language.PORTUGUESE]: "Plano Médio",
  },
  "Plan Avanzado": {
    [Language.ENGLISH]: "Advanced Plan",
    [Language.SPANISH]: "Plan Avanzado",
    [Language.PORTUGUESE]: "Plano Avançado",
  },
  "Plan Master": {
    [Language.ENGLISH]: "Master Plan",
    [Language.SPANISH]: "Plan Master",
    [Language.PORTUGUESE]: "Plano Master",
  },
  "Suscripción Mensual Lite": {
    [Language.ENGLISH]: "Monthly Lite Plan",
    [Language.SPANISH]: "Suscripción Mensual Lite",
    [Language.PORTUGUESE]: "Plano Mensal Lite",
  },
  "canada": {
    [Language.ENGLISH]: "Canada",
    [Language.SPANISH]: "Canada",
    [Language.PORTUGUESE]: "Canadá",
  },
  "hello": {
    [Language.ENGLISH]: "Hello!",
    [Language.SPANISH]: "¡Hola!",
    [Language.PORTUGUESE]: "¡Olá!",
  },
  "help-me-create-your-first-page": {
    [Language.ENGLISH]: "I'll help you create your first page",
    [Language.SPANISH]: "Te ayudaré a crear tu primera página",
    [Language.PORTUGUESE]: "Vou ajudar você a criar sua primeira página",
  },
  "do-you-prefer-to-see-the-training-first": {
    [Language.ENGLISH]: "Do you prefer to see the training first?",
    [Language.SPANISH]: "¿Prefieres ver el entrenamiento primero?",
    [Language.PORTUGUESE]: "Prefere ver o treinamento primeiro?",
  },
  "go-to-training": {
    [Language.ENGLISH]: "Go to training",
    [Language.SPANISH]: "Ir al entrenamiento",
    [Language.PORTUGUESE]: "Ir para o treinamento",
  },
  "let's-start": {
    [Language.ENGLISH]: "Let's start",
    [Language.SPANISH]: "Empecemos",
    [Language.PORTUGUESE]: "Vamos começar",
  },

  // TUTORIAL CREATE SALES PAGE
  "Crear página de ventas": {
    [Language.ENGLISH]: "Create sales page",
    [Language.SPANISH]: "Crear página de ventas",
    [Language.PORTUGUESE]: "Criar página de vendas",
  },
  "Inicia dándole clic al botón para empezar a crear tu primera página de ventas de manera guiada.": {
    [Language.ENGLISH]: "Start by clicking the button to start creating your first sales page guided.",
    [Language.SPANISH]: "Inicia dándole clic al botón para empezar a crear tu primera página de ventas de manera guiada.",
    [Language.PORTUGUESE]: "Inicie clicando no botão para começar a criar sua primeira página de vendas guiada.",
  },
  "Elige cómo empezar": {
    [Language.ENGLISH]: "Choose how to start",
    [Language.SPANISH]: "Elige cómo empezar",
    [Language.PORTUGUESE]: "Escolha como começar",
  },
  "Tendrás 3 opciones diferentes para cargar tu producto ganador.": {
    [Language.ENGLISH]: "You will have 3 different options to load your winning product.",
    [Language.SPANISH]: "Tendrás 3 opciones diferentes para cargar tu producto ganador.",
    [Language.PORTUGUESE]: "Você terá 3 opções diferentes para carregar seu produto vencedor.",
  },
  "Order Bump": {
    [Language.ENGLISH]: "Order Bump",
    [Language.SPANISH]: "Order Bump",
    [Language.PORTUGUESE]: "Order Bump",
  },
  "Es una oferta rápida en el checkout. Perfecto para artículos pequeños o complementarios.": {
    [Language.ENGLISH]: "It is a quick offer at checkout. Perfect for small or complementary items.",
    [Language.SPANISH]: "Es una oferta rápida en el checkout. Perfecto para artículos pequeños o complementarios.",
    [Language.PORTUGUESE]: "É uma oferta rápida no checkout. Perfeito para itens pequenos ou complementares.",
  },
  "Upsell": {
    [Language.ENGLISH]: "Upsell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  "Ofrece un producto adicional, o un descuento atractivo, aumenta el ticket de venta.": {
    [Language.ENGLISH]: "Offer an additional product, or an attractive discount, increase the sales ticket.",
    [Language.SPANISH]: "Ofrece un producto adicional, o un descuento atractivo, aumenta el ticket de venta.",
    [Language.PORTUGUESE]: "Ofereça um produto adicional, ou um desconto atraente, aumente o ticket de venda.",
  },
  "Ángulos de venta": {
    [Language.ENGLISH]: "Sales angles",
    [Language.SPANISH]: "Ángulos de venta",
    [Language.PORTUGUESE]: "Ângulos de venda",
  },
  "Selecciona el enfoque de marketing ideal para vender tu producto. Identificamos los dolores mas importantes de tu usuario final, para generar el contenido persuasivo de toda tu pagina de ventas y maximizar tus conversiones.": {
    [Language.ENGLISH]: "Select the ideal marketing focus to sell your product. We identify the most important pains of your final user, to generate the persuasive content of your entire sales page and maximize your conversions.",
    [Language.SPANISH]: "Selecciona el enfoque de marketing ideal para vender tu producto. Identificamos los dolores mas importantes de tu usuario final, para generar el contenido persuasivo de toda tu pagina de ventas y maximizar tus conversiones.",
    [Language.PORTUGUESE]: "Selecione o foco de marketing ideal para vender seu produto. Identificamos os dolores mais importantes do seu usuário final, para gerar o conteúdo persuasivo de toda sua página de vendas e maximizar suas conversões.",
  },
  "¡Listo!, estamos creando tu página de ventas": {
    [Language.ENGLISH]: "Ready, we are creating your sales page",
    [Language.SPANISH]: "¡Listo!, estamos creando tu página de ventas",
    [Language.PORTUGUESE]: "Pronto, estamos criando sua página de vendas",
  },
  "¡Estará lista en algunos minutos! Mientras esperas, puedes seguir explorando Fluxi.": {
    [Language.ENGLISH]: "It will be ready in a few minutes! While you wait, you can continue exploring Fluxi.",
    [Language.SPANISH]: "¡Estará lista en algunos minutos! Mientras esperas, puedes seguir explorando Fluxi.",
    [Language.PORTUGUESE]: "Pronto, estará pronta em alguns minutos! Enquanto espera, você pode continuar explorando o Fluxi.",
  },
  "finalize": {
    [Language.ENGLISH]: "Finalize",
    [Language.SPANISH]: "Finalizar",
    [Language.PORTUGUESE]: "Finalizar",
  },
  "understood": {
    [Language.ENGLISH]: "Understood",
    [Language.SPANISH]: "Entendido",
    [Language.PORTUGUESE]: "Entendido",
  },
  "upgrade-plan": {
    [Language.ENGLISH]: "I want to upgrade my plan",
    [Language.SPANISH]: "Quiero mejorar mi plan",
    [Language.PORTUGUESE]: "Quero melhorar meu plano",
  },
  "your-subscription-has-been-canceled": {
    [Language.ENGLISH]: "Your subscription has been canceled",
    [Language.SPANISH]: "Tu suscripción ha sido cancelada",
    [Language.PORTUGUESE]: "Sua assinatura foi cancelada",
  },
  "cancel-success-description": {
    [Language.ENGLISH]: "Your plan has been canceled. You can continue using Fluxi until the end of your billing period.",
    [Language.SPANISH]: "Tu plan ha sido cancelado. Podrás seguir usando Fluxi hasta el final de tu período de facturación.",
    [Language.PORTUGUESE]: "Seu plano foi cancelado. Você poderá continuar usando o Fluxi até o final do seu período de faturamento.",
  },
  "your-access-will-end-on": {
    [Language.ENGLISH]: "Your access will end on",
    [Language.SPANISH]: "Tu acceso terminará el",
    [Language.PORTUGUESE]: "Seu acesso terminará em",
  },
  "after-this-date-you-will-lose-access-to-fluxi": {
    [Language.ENGLISH]: "After this date you will lose access to Fluxi",
    [Language.SPANISH]: "Después de esta fecha perderás el acceso a Fluxi",
    [Language.PORTUGUESE]: "Depois desta data, você perderá o acesso ao Fluxi",
  },
  "special-price": {
    [Language.ENGLISH]: "Special Price",
    [Language.SPANISH]: "Precio Especial",
    [Language.PORTUGUESE]: "Preço Especial",
  },
  "to-compensate-the-remaining-days-of-your-previous-plan-we-give-you-a-50-discount-in-the-first-month": {
    [Language.ENGLISH]: "To compensate the remaining days of your previous plan, we give you a 50% discount in the first month",
    [Language.SPANISH]: "Para compensar los días restantes de tu plan anterior, te damos el 50% de descuento en el primer mes",
    [Language.PORTUGUESE]: "Para compensar os dias restantes do seu plano anterior, damos um desconto de 50% no primeiro mês",
  },
  "to-compensate-the-remaining-days-of-your-previous-plan-we-give-you-a-100-discount-in-the-first-month": {
    [Language.ENGLISH]: "To compensate the remaining days of your previous plan, we give you a 100% discount in the first month",
    [Language.SPANISH]: "Para compensar los días restantes de tu plan anterior, te damos el 100% de descuento en el primer mes",
    [Language.PORTUGUESE]: "Para compensar os dias restantes do seu plano anterior, damos um desconto de 100% no primeiro mês",
  },
  "plan-lite-first-month": {
    [Language.ENGLISH]: "Plan Lite - $9.99 first month",
    [Language.SPANISH]: "Plan Lite - $9.99 primer mes",
    [Language.PORTUGUESE]: "Plano Lite - $9.99 primeiro mês",
  },
  "then-19-per-month": {
    [Language.ENGLISH]: "Then $19/month",
    [Language.SPANISH]: "Luego $19/mes",
    [Language.PORTUGUESE]: "Depois $19/mês",
  },
  "before-you-leave-we-offer-you-a-lite-plan-for-only": {
    [Language.ENGLISH]: "Get your Lite Plan for only ",
    [Language.SPANISH]: "Obtén tu Plan Lite por tan solo ",
    [Language.PORTUGUESE]: "Obtenha seu Plano Lite por apenas ",
  },
  "keep-all-your-created-pages-active": {
    [Language.ENGLISH]: "Keep all your created pages active",
    [Language.SPANISH]: "Mantén todas tus páginas creadas activas",
    [Language.PORTUGUESE]: "Mantenha todas as suas páginas criadas ativas",
  },
  "no-additional-credits-next-month": {
    [Language.ENGLISH]: "No additional credits next month",
    [Language.SPANISH]: "Sin créditos adicionales el próximo mes",
    [Language.PORTUGUESE]: "Sem créditos adicionais no próximo mês",
  },
  "access-to-the-platform": {
    [Language.ENGLISH]: "Access to the platform",
    [Language.SPANISH]: "Acceso a la plataforma",
    [Language.PORTUGUESE]: "Acesso à plataforma",
  },
  "you-can-buy-credits-or-upgrade-your-plan-when-you-want": {
    [Language.ENGLISH]: "You can buy credits or upgrade your plan when you want",
    [Language.SPANISH]: "Puedes comprar créditos o hacer upgrade a tu plan cuando quieras",
    [Language.PORTUGUESE]: "Você pode comprar créditos ou fazer upgrade do seu plano quando quiser",
  },
  "yes-i-want-the-lite-plan": {
    [Language.ENGLISH]: "Yes, I want the Lite plan",
    [Language.SPANISH]: "¡Sí! Quiero el Plan Lite",
    [Language.PORTUGUESE]: "Sim, quero o Plano Lite",
  },
  "no-thanks-i-want-to-cancel-my-access-to-fluxi": {
    [Language.ENGLISH]: "No thanks",
    [Language.SPANISH]: "No gracias",
    [Language.PORTUGUESE]: "Não, obrigado",
  },
  "error-canceling-subscription": {
    [Language.ENGLISH]: "Error canceling subscription",
    [Language.SPANISH]: "Error al cancelar la suscripción",
    [Language.PORTUGUESE]: "Erro ao cancelar a assinatura",
  },
  "the-feedback-must-have-at-least": {
    [Language.ENGLISH]: "The feedback must have at least",
    [Language.SPANISH]: "El feedback debe tener al menos",
    [Language.PORTUGUESE]: "O feedback deve ter pelo menos",
  },
  "please-tell-us-the-real-reason-for-your-cancellation": {
    [Language.ENGLISH]: "Please tell us the real reason for your cancellation. Be honest, we help you improve.",
    [Language.SPANISH]: "Por favor cuéntanos la razón real por la que deseas cancelar. Sé honesto, nos ayudas a mejorar.",
    [Language.PORTUGUESE]: "Por favor, conte-nos a razão real pela qual deseja cancelar. Seja honesto, nos ajuda a melhorar.",
  },
  "write-here-your-answer": {
    [Language.ENGLISH]: "Write here your answer...",
    [Language.SPANISH]: "Escribe aquí tu respuesta...",
    [Language.PORTUGUESE]: "Escreva aqui sua resposta...",
  },
  "minimum-characters": {
    [Language.ENGLISH]: "minimum characters",
    [Language.SPANISH]: "caracteres mínimos",
    [Language.PORTUGUESE]: "caracteres mínimos",
  },
  "tell-me-what-problems-are-you-finding-with-fluxi": {
    [Language.ENGLISH]: "Tell me what problems are you finding with Fluxi that are not allowing you to fully enjoy your membership?",
    [Language.SPANISH]: "Cuéntame, ¿qué problemas estás encontrando con Fluxi que no te permiten aprovechar tu membresía completamente?",
    [Language.PORTUGUESE]: "Conte-me, quais problemas está encontrando com o Fluxi que não lhe permitem aproveitar sua assinatura completamente?",
  },
  "hello-my-name-is-camila": {
    [Language.ENGLISH]: "Hello, my name is Camila, and I'm here to help you with your cancellation request.",
    [Language.SPANISH]: "Hola, mi nombre es Camila y estoy aquí para ayudarte con tu solicitud de cancelación.",
    [Language.PORTUGUESE]: "Olá, meu nome é Camila e estou aqui para ajudá-lo com sua solicitação de cancelamento.",
  },
  "downsell-closing-message": {
    [Language.ENGLISH]: "I'll leave you with the information about the Lite Plan so you can proceed to confirm it.",
    [Language.SPANISH]: "Te dejo la información sobre el Plan Lite para que puedas proceder a confirmarlo.",
    [Language.PORTUGUESE]: "Vou deixar as informações sobre o Plano Lite para que você possa prosseguir e confirmá-lo.",
  },
  "recovered-closing-message": {
    [Language.ENGLISH]: "Glad I could help! I'll close this chat now. Remember, you can always reactivate whenever you want.",
    [Language.SPANISH]: "¡Me alegra haber podido ayudarte! Cerraré este chat ahora. Recuerda que siempre puedes reactivar cuando quieras.",
    [Language.PORTUGUESE]: "Fico feliz em ter ajudado! Vou fechar este chat agora. Lembre-se de que você sempre pode reativar quando quiser.",
  },
  "are-you-sure-you-want-to-leave": {
    [Language.ENGLISH]: "Are you sure you want to leave?",
    [Language.SPANISH]: "¿Seguro que quieres irte?",
    [Language.PORTUGUESE]: "Tem certeza que deseja sair?",
  },
  "before-you-lose-access-to-your-funnels-and-metrics-is-there-anything-we-can-resolve-together": {
    [Language.ENGLISH]: "Before you lose access to your funnels and metrics, is there anything we can resolve together?",
    [Language.SPANISH]: "Antes de que pierdas el acceso a tus embudos y métricas, ¿hay algo que podamos resolver juntos?",
    [Language.PORTUGUESE]: "Antes de perder o acesso a seus funnels e métricas, há algo que podemos resolver juntos?",
  },
  "i-prefer-to-talk-to-support": {
    [Language.ENGLISH]: "I prefer to talk to support",
    [Language.SPANISH]: "Prefiero hablar con soporte",
    [Language.PORTUGUESE]: "Prefiro falar com suporte",
  },
  "yes-i-want-to-cancel-my-subscription": {
    [Language.ENGLISH]: "Yes, I want to cancel my subscription",
    [Language.SPANISH]: "Sí, quiero cancelar mi suscripción",
    [Language.PORTUGUESE]: "Sim, quero cancelar minha assinatura",
  },
  "what-would-you-like-to-do-with-your-current-plan": {
    [Language.ENGLISH]: "What would you like to do with your current plan?",
    [Language.SPANISH]: "¿Qué te gustaría hacer con tu plan actual?",
    [Language.PORTUGUESE]: "O que você gostaria de fazer com seu plano atual?",
  },
  "improve-my-plan": {
    [Language.ENGLISH]: "Improve my plan",
    [Language.SPANISH]: "Mejorar mi plan",
    [Language.PORTUGUESE]: "Melhorar meu plano",
  },
  "cancel-my-plan": {
    [Language.ENGLISH]: "Cancel my plan",
    [Language.SPANISH]: "Cancelar mi plan",
    [Language.PORTUGUESE]: "Cancelar meu plano",
  },
  "wait-we-have-a-special-offer": {
    [Language.ENGLISH]: "Lite Plan",
    [Language.SPANISH]: "Plan Lite",
    [Language.PORTUGUESE]: "Plano Lite",
  },
  "19-per-month": {
    [Language.ENGLISH]: "Plan Lite - $19/month",
    [Language.SPANISH]: "Plan Lite - $19/mes",
    [Language.PORTUGUESE]: "Plano Lite - $19/mês",
  },
  "downgrade-lite-success": {
    [Language.ENGLISH]: "Downgrade to Lite plan successful",
    [Language.SPANISH]: "Downgrade to Lite plan successful",
    [Language.PORTUGUESE]: "Downgrade to Lite plan successful",
  },
  "downgrade-lite-error": {
    [Language.ENGLISH]: "Error downgrading to Lite plan",
    [Language.SPANISH]: "Error downgrading to Lite plan",
    [Language.PORTUGUESE]: "Error downgrading to Lite plan",
  },
  "$19/mes": {
    [Language.ENGLISH]: "$19/month",
    [Language.SPANISH]: "$19/mes",
    [Language.PORTUGUESE]: "$19/mês",
  },
  "free-first-month": {
    [Language.ENGLISH]: "Plan Lite - Free! first month",
    [Language.SPANISH]: "Plan Lite - ¡Grátis! primer mes",
    [Language.PORTUGUESE]: "Plano Lite - ¡Grátis! primeiro mês",
  },
  "ab-testing-description": {
    [Language.ENGLISH]: "Manage and analyze your price experiments",
    [Language.SPANISH]: "Gestiona y analiza tus experimentos de precios",
    [Language.PORTUGUESE]: "Gerencie e analise seus experimentos de preços",
  },
  "create-ab-test": {
    [Language.ENGLISH]: "Create A/B Test",
    [Language.SPANISH]: "Crear A/B Test",
    [Language.PORTUGUESE]: "Criar Teste A/B",
  },
  "error-loading-experiments": {
    [Language.ENGLISH]: "Error loading experiments",
    [Language.SPANISH]: "Error al cargar los experimentos",
    [Language.PORTUGUESE]: "Erro ao carregar os experimentos",
  },
  "test-updated-successfully": {
    [Language.ENGLISH]: "Test updated successfully",
    [Language.SPANISH]: "Test actualizado correctamente",
    [Language.PORTUGUESE]: "Teste atualizado com sucesso",
  },
  "error-updating-test": {
    [Language.ENGLISH]: "Error updating test",
    [Language.SPANISH]: "Error al actualizar el test",
    [Language.PORTUGUESE]: "Erro ao atualizar o teste",
  },
  "test": {
    [Language.ENGLISH]: "Test",
    [Language.SPANISH]: "Test",
    [Language.PORTUGUESE]: "Teste",
  },
  "variants": {
    [Language.ENGLISH]: "Variants",
    [Language.SPANISH]: "Variantes",
    [Language.PORTUGUESE]: "Variantes",
  },
  "conversions": {
    [Language.ENGLISH]: "Conversions",
    [Language.SPANISH]: "Conversiones",
    [Language.PORTUGUESE]: "Conversões",
  },
  "conversion-rate": {
    [Language.ENGLISH]: "Conversion Rate",
    [Language.SPANISH]: "Tasa de conversión",
    [Language.PORTUGUESE]: "Taxa de conversão",
  },
  "pause": {
    [Language.ENGLISH]: "Pause",
    [Language.SPANISH]: "Pausar",
    [Language.PORTUGUESE]: "Pausar",
  },
  "activate": {
    [Language.ENGLISH]: "Activate",
    [Language.SPANISH]: "Activar",
    [Language.PORTUGUESE]: "Activar",
  },
  "id": {
    [Language.ENGLISH]: "ID",
    [Language.SPANISH]: "ID",
    [Language.PORTUGUESE]: "ID",
  },
  "base-price": {
    [Language.ENGLISH]: "Base price",
    [Language.SPANISH]: "Precio base",
    [Language.PORTUGUESE]: "Preço base",
  },
  "paused": {
    [Language.ENGLISH]: "Paused",
    [Language.SPANISH]: "Pausado",
    [Language.PORTUGUESE]: "Pausado",
  },
  "current-price": {
    [Language.ENGLISH]: "Current price",
    [Language.SPANISH]: "Precio actual",
    [Language.PORTUGUESE]: "Preço atual",
  },
  "change": {
    [Language.ENGLISH]: "Change",
    [Language.SPANISH]: "Cambiar",
    [Language.PORTUGUESE]: "Alterar",
  },
  "test-name": {
    [Language.ENGLISH]: "Test name",
    [Language.SPANISH]: "Nombre del test",
    [Language.PORTUGUESE]: "Nome do teste",
  },
  "test-name-placeholder": {
    [Language.ENGLISH]: "Enter a name for the test",
    [Language.SPANISH]: "Ingresa un nombre para el test",
    [Language.PORTUGUESE]: "Digite um nome para o teste",
  },
  "price-variants": {
    [Language.ENGLISH]: "Price variants",
    [Language.SPANISH]: "Variantes de precio",
    [Language.PORTUGUESE]: "Variantes de preço",
  },
  "add-variant": {
    [Language.ENGLISH]: "Add variant",
    [Language.SPANISH]: "Agregar variante",
    [Language.PORTUGUESE]: "Adicionar variante",
  },
  "variant": {
    [Language.ENGLISH]: "Variant",
    [Language.SPANISH]: "Variante",
    [Language.PORTUGUESE]: "Variante",
  },
  "select-product": {
    [Language.ENGLISH]: "Select product",
    [Language.SPANISH]: "Seleccionar producto",
    [Language.PORTUGUESE]: "Selecionar produto",
  },
  "select-product-description": {
    [Language.ENGLISH]: "Select the product for which you want to create a price A/B test",
    [Language.SPANISH]: "Selecciona el producto para el cual deseas crear un test A/B de precios",
    [Language.PORTUGUESE]: "Selecione o produto para o qual você deseja criar um teste A/B de preços",
  },
  "configure-prices": {
    [Language.ENGLISH]: "Configure prices",
    [Language.SPANISH]: "Configurar precios",
    [Language.PORTUGUESE]: "Configurar preços",
  },
  "step-1": {
    [Language.ENGLISH]: "Step 1",
    [Language.SPANISH]: "Paso 1",
    [Language.PORTUGUESE]: "Passo 1",
  },
  "step-2": {
    [Language.ENGLISH]: "Step 2",
    [Language.SPANISH]: "Paso 2",
    [Language.PORTUGUESE]: "Passo 2",
  },
  "test-created-successfully": {
    [Language.ENGLISH]: "Test created successfully",
    [Language.SPANISH]: "Test creado correctamente",
    [Language.PORTUGUESE]: "Teste criado com sucesso",
  },
  "error-creating-test": {
    [Language.ENGLISH]: "Error creating test",
    [Language.SPANISH]: "Error al crear el test",
    [Language.PORTUGUESE]: "Erro ao criar o teste",
  },
  "information": {
    [Language.ENGLISH]: "Information",
    [Language.SPANISH]: "Información",
    [Language.PORTUGUESE]: "Informação",
  },
  "visitors-will-be-automatically-divided-between-variants": {
    [Language.ENGLISH]: "Visitors will be automatically divided between variants",
    [Language.SPANISH]: "Los visitantes se dividirán automáticamente entre las variantes",
    [Language.PORTUGUESE]: "Os visitantes serão automaticamente divididos entre as variantes",
  },
  "each-variant-will-display-a-different-price": {
    [Language.ENGLISH]: "Each variant will display a different price",
    [Language.SPANISH]: "Cada variante mostrará un precio diferente",
    [Language.PORTUGUESE]: "Cada variante exibirá um preço diferente",
  },
  "conversions-and-metrics-will-be-recorded-for-each-price": {
    [Language.ENGLISH]: "Conversions and metrics will be recorded for each price",
    [Language.SPANISH]: "Se registrarán las conversiones y métricas de cada precio",
    [Language.PORTUGUESE]: "As conversões e métricas serão registradas para cada preço",
  },
  "you-can-pause-or-end-the-test-at-any-time": {
    [Language.ENGLISH]: "You can pause or end the test at any time",
    [Language.SPANISH]: "Puedes pausar o finalizar el test en cualquier momento",
    [Language.PORTUGUESE]: "Você pode pausar ou finalizar o teste em qualquer momento",
  },
  "winner": {
    [Language.ENGLISH]: "Winner",
    [Language.SPANISH]: "Ganador",
    [Language.PORTUGUESE]: "Vencedor",
  },
  "variant-comparison": {
    [Language.ENGLISH]: "Variant comparison",
    [Language.SPANISH]: "Comparación de variantes",
    [Language.PORTUGUESE]: "Comparação de variantes",
  },
  "traffic": {
    [Language.ENGLISH]: "Traffic",
    [Language.SPANISH]: "Tráfico",
    [Language.PORTUGUESE]: "Tráfego",
  },
  "error-loading-experiment": {
    [Language.ENGLISH]: "Error loading experiment",
    [Language.SPANISH]: "Error al cargar el experimento",
    [Language.PORTUGUESE]: "Erro ao carregar o experimento",
  },
  "experiment": {
    [Language.ENGLISH]: "Experiment",
    [Language.SPANISH]: "Experimento",
    [Language.PORTUGUESE]: "Experimento",
  },
  "funnel-id": {
    [Language.ENGLISH]: "Funnel ID",
    [Language.SPANISH]: "ID de embudo",
    [Language.PORTUGUESE]: "ID do funil",
  },
  "error-upserting-experiments": {
    [Language.ENGLISH]: "Error upserting experiments",
    [Language.SPANISH]: "Error al upsertar los experimentos",
    [Language.PORTUGUESE]: "Erro ao upsertar os experimentos",
  },
  "only-one-active-ab-test-per-funnel": {
    [Language.ENGLISH]: "Only one active A/B test per funnel",
    [Language.SPANISH]: "Solo se puede tener un A/B Testing activo por embudo",
    [Language.PORTUGUESE]: "Sólo pode haver um Teste A/B ativo por funil",
  },
  "yes-create-ab-test": {
    [Language.ENGLISH]: "Yes, create A/B Test",
    [Language.SPANISH]: "Sí, crear A/B Test",
    [Language.PORTUGUESE]: "Sim, criar Teste A/B",
  },
  "creating": {
    [Language.ENGLISH]: "Creating...",
    [Language.SPANISH]: "Creando...",
    [Language.PORTUGUESE]: "Criando...",
  },
  "active-ab-tests": {
    [Language.ENGLISH]: "Active A/B Tests",
    [Language.SPANISH]: "A/B Tests activos",
    [Language.PORTUGUESE]: "Testes A/B ativos",
  },
  "will-be-automatically-paused": {
    [Language.ENGLISH]: "will be automatically paused",
    [Language.SPANISH]: "serán pausados automáticamente",
    [Language.PORTUGUESE]: "serão pausados automaticamente",
  },
  "automatically-paused": {
    [Language.ENGLISH]: "automatically paused",
    [Language.SPANISH]: "pausados automáticamente",
    [Language.PORTUGUESE]: "pausados automaticamente",
  },
  "disabled": {
    [Language.ENGLISH]: "disabled",
    [Language.SPANISH]: "deshabilitados",
    [Language.PORTUGUESE]: "desabilitados",
  },
  "if-there-are-other": {
    [Language.ENGLISH]: "If there are other",
    [Language.SPANISH]: "Si existen otros",
    [Language.PORTUGUESE]: "Se houver outros",
  },
  "you-are-about-to-create-an": {
    [Language.ENGLISH]: "You are about to create an",
    [Language.SPANISH]: "Estás a punto de crear un",
    [Language.PORTUGUESE]: "Você está prestes a criar um",
  },
  "for-this-funnel": {
    [Language.ENGLISH]: "for this funnel",
    [Language.SPANISH]: "para este embudo",
    [Language.PORTUGUESE]: "para este funil",
  },
  "all-discounted-prices": {
    [Language.ENGLISH]: "All discounted prices",
    [Language.SPANISH]: "Todos los precios con descuento",
    [Language.PORTUGUESE]: "Todos os preços com desconto",
  },
  "discounted-prices": {
    [Language.ENGLISH]: "discounted prices",
    [Language.SPANISH]: "precios con descuento",
    [Language.PORTUGUESE]: "preços com desconto",
  },
  "will-be-disabled": {
    [Language.ENGLISH]: "will",
    [Language.SPANISH]: "serán",
    [Language.PORTUGUESE]: "serão",
  },
  "all-discounted-prices-will-be-disabled": {
    [Language.ENGLISH]: "All discounted prices by unit that you have in this funnel will be disabled",
    [Language.SPANISH]: "Todos los precios con descuento por unidades que tengas en este embudo serán deshabilitados",
    [Language.PORTUGUESE]: "Todos os preços com desconto por unidade que você tenha neste funil serão desabilitados",
  },
  "percentage-error": {
    [Language.ENGLISH]: "The percentages must sum 100%",
    [Language.SPANISH]: "Los porcentajes deben sumar 100%",
    [Language.PORTUGUESE]: "Os porcentagens devem somar 100%",
  },
  "no-ab-tests-found": {
    [Language.ENGLISH]: "No A/B tests found",
    [Language.SPANISH]: "No se encontraron tests A/B",
    [Language.PORTUGUESE]: "Nenhum teste A/B encontrado",
  },
  "choose-your-plan": {
    [Language.ENGLISH]: "Choose your plan",
    [Language.SPANISH]: "Elige tu plan",
    [Language.PORTUGUESE]: "Escolha seu plano",
  },
  "most-popular": {
    [Language.ENGLISH]: "Most popular",
    [Language.SPANISH]: "Más popular",
    [Language.PORTUGUESE]: "Mais popular",
  },
  "per-month": {
    [Language.ENGLISH]: "per month",
    [Language.SPANISH]: "por mes",
    [Language.PORTUGUESE]: "por mês",
  },
  "everything-included": {
    [Language.ENGLISH]: "Everything included",
    [Language.SPANISH]: "Todo incluido",
    [Language.PORTUGUESE]: "Tudo incluído",
  },
  "start-now": {
    [Language.ENGLISH]: "Start now",
    [Language.SPANISH]: "Comenzar ahora",
    [Language.PORTUGUESE]: "Começar agora",
  },
  "verification-success": {
    [Language.ENGLISH]: "Verification successful",
    [Language.SPANISH]: "Verificación exitosa",
    [Language.PORTUGUESE]: "Verificação bem-sucedida",
  },
  "enter-code": {
    [Language.ENGLISH]: "Enter code",
    [Language.SPANISH]: "Ingresa el código",
    [Language.PORTUGUESE]: "Insira o código",
  },
  "we-have-sent-a-6-digit-code-to": {
    [Language.ENGLISH]: "We have sent a 6 digit code to",
    [Language.SPANISH]: "Hemos enviado un código de 6 dígitos a",
    [Language.PORTUGUESE]: "Enviamos um código de 6 dígitos para",
  },
  "enter-verification-code": {
    [Language.ENGLISH]: "Enter verification code",
    [Language.SPANISH]: "Ingresa el código de verificación",
    [Language.PORTUGUESE]: "Insira o código de verificação",
  },
  "code-sent-successfully": {
    [Language.ENGLISH]: "Code sent successfully",
    [Language.SPANISH]: "Código enviado correctamente",
    [Language.PORTUGUESE]: "Código enviado com sucesso",
  },

  // ─── ADS CREATIVES ────────────────────────────────────────
  "error-generating": {
    [Language.ENGLISH]: "Error generating",
    [Language.SPANISH]: "Error al generar",
    [Language.PORTUGUESE]: "Erro ao gerar",
  },
  "try-again-later": {
    [Language.ENGLISH]: "Try again later",
    [Language.SPANISH]: "Intenta de nuevo más tarde",
    [Language.PORTUGUESE]: "Tente novamente mais tarde",
  },
  "done": {
    [Language.ENGLISH]: "Done",
    [Language.SPANISH]: "Listo",
    [Language.PORTUGUESE]: "Pronto",
  },
  "new": {
    [Language.ENGLISH]: "New",
    [Language.SPANISH]: "Nuevo",
    [Language.PORTUGUESE]: "Novo",
  },
  "generating-ad": {
    [Language.ENGLISH]: "Generating ad",
    [Language.SPANISH]: "Generando anuncio",
    [Language.PORTUGUESE]: "Gerando anúncio",
  },
  "this-may-take-a-moment": {
    [Language.ENGLISH]: "This may take a moment...",
    [Language.SPANISH]: "Esto puede tardar unos momentos...",
    [Language.PORTUGUESE]: "Isso pode levar alguns momentos...",
  },
  "video-generating-wait": {
    [Language.ENGLISH]: "This takes a few minutes",
    [Language.SPANISH]: "Esto toma unos minutos",
    [Language.PORTUGUESE]: "Isso leva alguns minutos",
  },
  "video-generating-please-wait": {
    [Language.ENGLISH]: "Please wait a moment",
    [Language.SPANISH]: "Por favor espera un momento",
    [Language.PORTUGUESE]: "Por favor aguarde um momento",
  },
  "no-videos-yet": {
    [Language.ENGLISH]: "This product has no videos yet.",
    [Language.SPANISH]: "Este producto aún no tiene videos.",
    [Language.PORTUGUESE]: "Este produto ainda não tem vídeos.",
  },
  "generate-videos-here": {
    [Language.ENGLISH]: "When you generate videos, they will appear here.",
    [Language.SPANISH]: "Cuando generes videos, aparecerán aquí.",
    [Language.PORTUGUESE]: "Quando você gerar vídeos, eles aparecerão aqui.",
  },
  "create-video-with-ai": {
    [Language.ENGLISH]: "Create Video with AI",
    [Language.SPANISH]: "Crear Video con IA",
    [Language.PORTUGUESE]: "Criar Vídeo com IA",
  },
  "tab-images": {
    [Language.ENGLISH]: "Images",
    [Language.SPANISH]: "Imágenes",
    [Language.PORTUGUESE]: "Imagens",
  },
  "tab-scripts": {
    [Language.ENGLISH]: "Scripts",
    [Language.SPANISH]: "Guiones",
    [Language.PORTUGUESE]: "Roteiros",
  },
  "tab-videos": {
    [Language.ENGLISH]: "Videos",
    [Language.SPANISH]: "Videos",
    [Language.PORTUGUESE]: "Vídeos",
  },
  "view-creative": {
    [Language.ENGLISH]: "View creative",
    [Language.SPANISH]: "Ver creativo",
    [Language.PORTUGUESE]: "Ver criativo",
  },
  "download-creative": {
    [Language.ENGLISH]: "Download creative",
    [Language.SPANISH]: "Descargar creativo",
    [Language.PORTUGUESE]: "Baixar criativo",
  },

  // ─── EDIT PANEL ────────────────────────────────────────────
  "what-do-you-want-to-change": {
    [Language.ENGLISH]: "What do you want to change?",
    [Language.SPANISH]: "¿Qué quieres cambiar?",
    [Language.PORTUGUESE]: "O que você quer mudar?",
  },
  "describe-what-to-change": {
    [Language.ENGLISH]: "Describe what you want to change...",
    [Language.SPANISH]: "Describe qué quieres cambiar...",
    [Language.PORTUGUESE]: "Descreva o que você quer mudar...",
  },
  "change-text": {
    [Language.ENGLISH]: "Change text",
    [Language.SPANISH]: "Cambiar texto",
    [Language.PORTUGUESE]: "Mudar texto",
  },
  "change-text-to": {
    [Language.ENGLISH]: "Change the text to ",
    [Language.SPANISH]: "Cambiar el texto por ",
    [Language.PORTUGUESE]: "Mudar o texto para ",
  },
  "change-price": {
    [Language.ENGLISH]: "Change price",
    [Language.SPANISH]: "Cambiar precio",
    [Language.PORTUGUESE]: "Mudar preço",
  },
  "change-price-to": {
    [Language.ENGLISH]: "Change the price to $",
    [Language.SPANISH]: "Cambiar el precio por $",
    [Language.PORTUGUESE]: "Mudar o preço para $",
  },
  "add-price": {
    [Language.ENGLISH]: "Add price",
    [Language.SPANISH]: "Agregar precio",
    [Language.PORTUGUESE]: "Adicionar preço",
  },
  "add-price-to": {
    [Language.ENGLISH]: "Add the price $",
    [Language.SPANISH]: "Agregar el precio $",
    [Language.PORTUGUESE]: "Adicionar o preço $",
  },
  "add-free-shipping-text": {
    [Language.ENGLISH]: "Add a text that says FREE SHIPPING",
    [Language.SPANISH]: "Agregar un texto que diga ENVÍO GRATIS",
    [Language.PORTUGUESE]: "Adicionar um texto que diga FRETE GRÁTIS",
  },
  "darker-background": {
    [Language.ENGLISH]: "Darker background",
    [Language.SPANISH]: "Fondo más oscuro",
    [Language.PORTUGUESE]: "Fundo mais escuro",
  },
  "make-background-darker": {
    [Language.ENGLISH]: "Make the background darker",
    [Language.SPANISH]: "Hacer el fondo más oscuro",
    [Language.PORTUGUESE]: "Deixar o fundo mais escuro",
  },
  "editing": {
    [Language.ENGLISH]: "Editing...",
    [Language.SPANISH]: "Editando...",
    [Language.PORTUGUESE]: "Editando...",
  },
  "editing-image-progress": {
    [Language.ENGLISH]: "Editing image...",
    [Language.SPANISH]: "Editando imagen...",
    [Language.PORTUGUESE]: "Editando imagem...",
  },

  // ─── AD STUDIO SIDEBAR ────────────────────────────────────
  // Phase 2 V9 (Apr 19 2026 late night) — placeholders rewritten. Old ones
  // were all "add/change price" variants and didn't guide users toward the
  // things the image generator actually reacts to: headline copy, highlight
  // element, mood, angle, overlay text, promotional hooks. Added a helper
  // line under the label (instructions-helper) explaining what this box
  // does so users know whether to bother filling it in.
  "instructions-helper": {
    [Language.ENGLISH]: "Use this to guide the image: headline, benefit to highlight, mood, offer, or detail to show. Leave blank and we pick for you.",
    [Language.SPANISH]: "Usa esto para guiar la imagen: titular, beneficio a resaltar, clima, oferta o detalle a mostrar. Si lo dejas vacío, decidimos nosotros.",
    [Language.PORTUGUESE]: "Use para guiar a imagem: título, benefício a destacar, clima, oferta ou detalhe a mostrar. Se deixar vazio, decidimos por você.",
  },
  "instruction-placeholder-1": {
    [Language.ENGLISH]: "E.g.: Headline 'Sleep like a baby', highlight the cooling fabric, calm nighttime mood",
    [Language.SPANISH]: "Ej: Titular 'Dormí como un bebé', resaltar la tela refrescante, clima nocturno calmo",
    [Language.PORTUGUESE]: "Ex: Título 'Durma como um bebê', destacar o tecido refrescante, clima noturno calmo",
  },
  "instruction-placeholder-2": {
    [Language.ENGLISH]: "E.g.: Show the product in-use by a woman 25-35, add '2x1 today' offer badge, vibrant energetic tone",
    [Language.SPANISH]: "Ej: Mostrar el producto en uso por una mujer de 25-35, agregar sello 'Hoy 2x1', tono vibrante y enérgico",
    [Language.PORTUGUESE]: "Ex: Mostrar o produto em uso por uma mulher de 25-35, adicionar selo 'Hoje 2x1', tom vibrante e enérgico",
  },
  "instruction-placeholder-3": {
    [Language.ENGLISH]: "E.g.: Big text 'FREE SHIPPING', bold modern typography, product centered on a clean pastel background",
    [Language.SPANISH]: "Ej: Texto grande 'ENVÍO GRATIS', tipografía bold moderna, producto centrado sobre fondo pastel limpio",
    [Language.PORTUGUESE]: "Ex: Texto grande 'FRETE GRÁTIS', tipografia bold moderna, produto centralizado em fundo pastel limpo",
  },
  "instruction-placeholder-4": {
    [Language.ENGLISH]: "E.g.: Comparison before/after, include 50% OFF sticker, show the ingredient close-up, minimalist look",
    [Language.SPANISH]: "Ej: Comparativa antes/después, incluir sticker 50% OFF, mostrar el ingrediente en primer plano, look minimalista",
    [Language.PORTUGUESE]: "Ex: Comparação antes/depois, incluir adesivo 50% OFF, mostrar o ingrediente em primeiro plano, visual minimalista",
  },
  "your-images": {
    [Language.ENGLISH]: "Your Images",
    [Language.SPANISH]: "Tus Imágenes",
    [Language.PORTUGUESE]: "Suas Imagens",
  },
  "configure-each-image-before-generating": {
    [Language.ENGLISH]: "Configure each image before generating",
    [Language.SPANISH]: "Configura cada imagen antes de generar",
    [Language.PORTUGUESE]: "Configure cada imagem antes de gerar",
  },
  "auto": {
    [Language.ENGLISH]: "Auto",
    [Language.SPANISH]: "Auto",
    [Language.PORTUGUESE]: "Auto",
  },
  "primary": {
    [Language.ENGLISH]: "Primary",
    [Language.SPANISH]: "Primario",
    [Language.PORTUGUESE]: "Primário",
  },
  "background": {
    [Language.ENGLISH]: "Background",
    [Language.SPANISH]: "Fondo",
    [Language.PORTUGUESE]: "Fundo",
  },
  "generate-images": {
    [Language.ENGLISH]: "Generate Images",
    [Language.SPANISH]: "Generar Imágenes",
    [Language.PORTUGUESE]: "Gerar Imagens",
  },
  "select-n-styles": {
    [Language.ENGLISH]: "Select {n} styles",
    [Language.SPANISH]: "Selecciona {n} estilos",
    [Language.PORTUGUESE]: "Selecione {n} estilos",
  },

  // ─── AD STUDIO GALLERY ────────────────────────────────────
  "templates-selected-ready": {
    [Language.ENGLISH]: "Templates selected! You can now generate your ads",
    [Language.SPANISH]: "¡Plantillas seleccionadas! Ya puedes generar tus anuncios",
    [Language.PORTUGUESE]: "Templates selecionados! Agora você pode gerar seus anúncios",
  },
  "select-n-templates-to-continue": {
    [Language.ENGLISH]: "Select {n} templates to continue",
    [Language.SPANISH]: "Selecciona {n} plantillas para continuar",
    [Language.PORTUGUESE]: "Selecione {n} templates para continuar",
  },
  "select-n-more-templates": {
    [Language.ENGLISH]: "Select {n} more template(s) to continue",
    [Language.SPANISH]: "Selecciona {n} plantilla(s) más para continuar",
    [Language.PORTUGUESE]: "Selecione mais {n} template(s) para continuar",
  },
  "max-templates-reached": {
    [Language.ENGLISH]: "You reached the maximum of {n} templates per generation",
    [Language.SPANISH]: "Llegaste al máximo de {n} plantillas por generación",
    [Language.PORTUGUESE]: "Você atingiu o máximo de {n} templates por geração",
  },
  "n-templates-selected": {
    [Language.ENGLISH]: "{n} template(s) selected",
    [Language.SPANISH]: "{n} plantilla(s) seleccionada(s)",
    [Language.PORTUGUESE]: "{n} template(s) selecionado(s)",
  },
  "templates-selected": {
    [Language.ENGLISH]: "Templates selected!",
    [Language.SPANISH]: "¡Plantillas seleccionadas!",
    [Language.PORTUGUESE]: "Templates selecionados!",
  },
  "remove": {
    [Language.ENGLISH]: "Remove",
    [Language.SPANISH]: "Quitar",
    [Language.PORTUGUESE]: "Remover",
  },
  "caption": {
    [Language.ENGLISH]: "Caption",
    [Language.SPANISH]: "Descripción",
    [Language.PORTUGUESE]: "Legenda",
  },
  "step2-no-product-error": {
    [Language.ENGLISH]: "Error: step=2 but no product selected",
    [Language.SPANISH]: "Error: step=2 pero no hay producto seleccionado",
    [Language.PORTUGUESE]: "Erro: step=2 mas nenhum produto selecionado",
  },
  "custom-reference-style-description": {
    [Language.ENGLISH]: "Upload any ad you like and the AI replicates it with your product maintaining the same visual style",
    [Language.SPANISH]: "Sube cualquier anuncio que te guste y la IA lo replica con tu producto manteniendo el mismo estilo visual",
    [Language.PORTUGUESE]: "Envie qualquer anúncio que você goste e a IA o replica com seu produto mantendo o mesmo estilo visual",
  },
  "close": {
    [Language.ENGLISH]: "Close",
    [Language.SPANISH]: "Cerrar",
    [Language.PORTUGUESE]: "Fechar",
  },

  // ─── CUSTOM REFERENCE CARD ─────────────────────────────────
  "only-jpg-png-webp-allowed": {
    [Language.ENGLISH]: "Only JPG, PNG or WEBP files are allowed",
    [Language.SPANISH]: "Solo se permiten archivos JPG, PNG o WEBP",
    [Language.PORTUGUESE]: "Apenas arquivos JPG, PNG ou WEBP são permitidos",
  },
  "file-max-5mb": {
    [Language.ENGLISH]: "File cannot exceed 5MB",
    [Language.SPANISH]: "El archivo no puede superar 5MB",
    [Language.PORTUGUESE]: "O arquivo não pode exceder 5MB",
  },
  "your-style-your-product": {
    [Language.ENGLISH]: "Your style, your product",
    [Language.SPANISH]: "Tu estilo, tu producto",
    [Language.PORTUGUESE]: "Seu estilo, seu produto",
  },
  "ref": {
    [Language.ENGLISH]: "Ref.",
    [Language.SPANISH]: "Ref.",
    [Language.PORTUGUESE]: "Ref.",
  },
  "your-ad": {
    [Language.ENGLISH]: "Your ad",
    [Language.SPANISH]: "Tu ad",
    [Language.PORTUGUESE]: "Seu ad",
  },
  "upload-an-ad-you-like": {
    [Language.ENGLISH]: "Upload an ad you like",
    [Language.SPANISH]: "Sube un anuncio que te guste",
    [Language.PORTUGUESE]: "Envie um anúncio que você goste",
  },
  "ai-replicates-style-with-product": {
    [Language.ENGLISH]: "AI replicates its style with your product",
    [Language.SPANISH]: "La IA replica su estilo con tu producto",
    [Language.PORTUGUESE]: "A IA replica o estilo com seu produto",
  },
  "view-preview": {
    [Language.ENGLISH]: "View preview",
    [Language.SPANISH]: "Ver preview",
    [Language.PORTUGUESE]: "Ver preview",
  },
  "personalized": {
    [Language.ENGLISH]: "Custom",
    [Language.SPANISH]: "Personalizada",
    [Language.PORTUGUESE]: "Personalizada",
  },

  // ─── STORE / GENERATION ────────────────────────────────────
  "timeout-error": {
    [Language.ENGLISH]: "Timeout reached",
    [Language.SPANISH]: "Tiempo de espera agotado",
    [Language.PORTUGUESE]: "Tempo de espera esgotado",
  },
  "error-starting-generation": {
    [Language.ENGLISH]: "Error starting generation. Try again.",
    [Language.SPANISH]: "Error al iniciar la generación. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Erro ao iniciar a geração. Tente novamente.",
  },
  "image-uploaded-successfully": {
    [Language.ENGLISH]: "Image uploaded successfully",
    [Language.SPANISH]: "Imagen subida correctamente",
    [Language.PORTUGUESE]: "Imagem enviada com sucesso",
  },
  "error-uploading-image": {
    [Language.ENGLISH]: "Error uploading image. Try again.",
    [Language.SPANISH]: "Error al subir la imagen. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Erro ao enviar a imagem. Tente novamente.",
  },
  "could-not-load-reference-image": {
    [Language.ENGLISH]: "Could not load reference image. Upload it manually.",
    [Language.SPANISH]: "No se pudo cargar la imagen de referencia. Súbela manualmente.",
    [Language.PORTUGUESE]: "Não foi possível carregar a imagem de referência. Envie manualmente.",
  },
  "image-edited-and-saved": {
    [Language.ENGLISH]: "Image edited and saved",
    [Language.SPANISH]: "Imagen editada y guardada",
    [Language.PORTUGUESE]: "Imagem editada e salva",
  },
  "image-edited-not-saved": {
    [Language.ENGLISH]: "Image edited (could not save permanently)",
    [Language.SPANISH]: "Imagen editada (no se pudo guardar permanentemente)",
    [Language.PORTUGUESE]: "Imagem editada (não foi possível salvar permanentemente)",
  },
  "error-editing-try-again": {
    [Language.ENGLISH]: "Error editing. Try again.",
    [Language.SPANISH]: "Error al editar. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Erro ao editar. Tente novamente.",
  },
  "no-results-for": {
    [Language.ENGLISH]: "No results for",
    [Language.SPANISH]: "Sin resultados para",
    [Language.PORTUGUESE]: "Sem resultados para",
  },
  "error-creating-product": {
    [Language.ENGLISH]: "Error creating product. Try again.",
    [Language.SPANISH]: "Error al crear el producto. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Erro ao criar o produto. Tente novamente.",
  },
  "no-image-url-received": {
    [Language.ENGLISH]: "No image URL received",
    [Language.SPANISH]: "No se recibió URL de la imagen",
    [Language.PORTUGUESE]: "URL da imagem não recebida",
  },
  "no-product-id-received": {
    [Language.ENGLISH]: "No product ID received",
    [Language.SPANISH]: "No se recibió el ID del producto",
    [Language.PORTUGUESE]: "ID do produto não recebido",
  },
  "all-fields-required": {
    [Language.ENGLISH]: "All fields are required",
    [Language.SPANISH]: "Todos los campos son requeridos",
    [Language.PORTUGUESE]: "Todos os campos são obrigatórios",
  },
  "create-new-product": {
    [Language.ENGLISH]: "Create new product",
    [Language.SPANISH]: "Crear producto nuevo",
    [Language.PORTUGUESE]: "Criar novo produto",
  },
  "add-your-product-to-create-ads": {
    [Language.ENGLISH]: "Add your product to create ads",
    [Language.SPANISH]: "Agrega tu producto para crear anuncios",
    [Language.PORTUGUESE]: "Adicione seu produto para criar anúncios",
  },
  "describe-your-product": {
    [Language.ENGLISH]: "Describe your product, key benefits, target audience...",
    [Language.SPANISH]: "Describe tu producto, beneficios clave, público objetivo...",
    [Language.PORTUGUESE]: "Descreva seu produto, benefícios-chave, público-alvo...",
  },
  "uploading": {
    [Language.ENGLISH]: "Uploading...",
    [Language.SPANISH]: "Subiendo...",
    [Language.PORTUGUESE]: "Enviando...",
  },
  "create-and-continue": {
    [Language.ENGLISH]: "Create and continue",
    [Language.SPANISH]: "Crear y continuar",
    [Language.PORTUGUESE]: "Criar e continuar",
  },
  "no-results": {
    [Language.ENGLISH]: "No results for",
    [Language.SPANISH]: "Sin resultados para",
    [Language.PORTUGUESE]: "Sem resultados para",
  },
  "copied": {
    [Language.ENGLISH]: "Copied",
    [Language.SPANISH]: "Copiado",
    [Language.PORTUGUESE]: "Copiado",
  },
  "copy": {
    [Language.ENGLISH]: "Copy",
    [Language.SPANISH]: "Copiar",
    [Language.PORTUGUESE]: "Copiar",
  },
  "of": {
    [Language.ENGLISH]: "of",
    [Language.SPANISH]: "de",
    [Language.PORTUGUESE]: "de",
  },
  "could-not-save": {
    [Language.ENGLISH]: "Could not save",
    [Language.SPANISH]: "No se pudo guardar",
    [Language.PORTUGUESE]: "Não foi possível salvar",
  },
  "unknown-error": {
    [Language.ENGLISH]: "Unknown error",
    [Language.SPANISH]: "Error desconocido",
    [Language.PORTUGUESE]: "Erro desconhecido",
  },

  // ─── ADS SPY ─────────────────────────────────────────────
  "ads-spy": {
    [Language.ENGLISH]: "Ads Spy",
    [Language.SPANISH]: "Espía de Anuncios",
    [Language.PORTUGUESE]: "Espião de Anúncios",
  },
  "spy-brands": {
    [Language.ENGLISH]: "Brands",
    [Language.SPANISH]: "Marcas",
    [Language.PORTUGUESE]: "Marcas",
  },
  "spy-ads": {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  "spy-bookmarks": {
    [Language.ENGLISH]: "Bookmarks",
    [Language.SPANISH]: "Favoritos",
    [Language.PORTUGUESE]: "Favoritos",
  },
  "add-brand": {
    [Language.ENGLISH]: "Add Brand",
    [Language.SPANISH]: "Añadir Marca",
    [Language.PORTUGUESE]: "Adicionar Marca",
  },
  "analyzing": {
    [Language.ENGLISH]: "Analyzing...",
    [Language.SPANISH]: "Analizando...",
    [Language.PORTUGUESE]: "Analisando...",
  },
  "analyze-all": {
    [Language.ENGLISH]: "Analyze All",
    [Language.SPANISH]: "Analizar Todos",
    [Language.PORTUGUESE]: "Analisar Todos",
  },
  "analyze-ads-with-ai-tooltip": {
    [Language.ENGLISH]: "Analyze ads with AI to enable smart filters",
    [Language.SPANISH]: "Analiza anuncios con IA para habilitar filtros inteligentes",
    [Language.PORTUGUESE]: "Analise anúncios com IA para habilitar filtros inteligentes",
  },
  "search-new-ads": {
    [Language.ENGLISH]: "Search New Ads",
    [Language.SPANISH]: "Buscar Nuevos Anuncios",
    [Language.PORTUGUESE]: "Buscar Novos Anúncios",
  },
  "analyzing-n-ads": {
    [Language.ENGLISH]: "Analyzing {n} ads...",
    [Language.SPANISH]: "Analizando {n} anuncios...",
    [Language.PORTUGUESE]: "Analisando {n} anúncios...",
  },
  "completed": {
    [Language.ENGLISH]: "Completed",
    [Language.SPANISH]: "Completado",
    [Language.PORTUGUESE]: "Concluído",
  },
  "analyze-ads-with-ai": {
    [Language.ENGLISH]: "Analyze ads with AI",
    [Language.SPANISH]: "Analizar anuncios con IA",
    [Language.PORTUGUESE]: "Analisar anúncios com IA",
  },
  "will-analyze-n-ads": {
    [Language.ENGLISH]: "{n} ads will be analyzed that have not been processed yet.",
    [Language.SPANISH]: "Se analizarán {n} anuncios que aún no han sido procesados.",
    [Language.PORTUGUESE]: "{n} anúncios serão analisados que ainda não foram processados.",
  },
  "ai-will-classify-ads": {
    [Language.ENGLISH]: "AI will classify each ad by asset type, visual format, messaging, hook, and offer. This will enable smart filters.",
    [Language.SPANISH]: "La IA clasificará cada anuncio por tipo de recurso, formato visual, mensajería, gancho y oferta. Esto habilitará los filtros inteligentes.",
    [Language.PORTUGUESE]: "A IA classificará cada anúncio por tipo de recurso, formato visual, mensagem, gancho e oferta. Isso habilitará os filtros inteligentes.",
  },
  "no-pending-ads": {
    [Language.ENGLISH]: "No pending ads",
    [Language.SPANISH]: "No hay anuncios pendientes",
    [Language.PORTUGUESE]: "Não há anúncios pendentes",
  },
  "analyze-n-ads": {
    [Language.ENGLISH]: "Analyze {n} ads",
    [Language.SPANISH]: "Analizar {n} anuncios",
    [Language.PORTUGUESE]: "Analisar {n} anúncios",
  },
  "add-a-brand-to-start": {
    [Language.ENGLISH]: "Add a brand to get started",
    [Language.SPANISH]: "Agrega una marca para empezar",
    [Language.PORTUGUESE]: "Adicione uma marca para começar",
  },
  "to-spy-ads-add-brand": {
    [Language.ENGLISH]: "To spy on ads, you first need to add at least one competitor brand.",
    [Language.SPANISH]: "Para espiar anuncios, primero necesitas agregar al menos una marca de la competencia.",
    [Language.PORTUGUESE]: "Para espiar anúncios, primeiro você precisa adicionar pelo menos uma marca concorrente.",
  },
  "add-brand-lowercase": {
    [Language.ENGLISH]: "Add brand",
    [Language.SPANISH]: "Añadir marca",
    [Language.PORTUGUESE]: "Adicionar marca",
  },
  "no-ads-yet": {
    [Language.ENGLISH]: "No ads yet",
    [Language.SPANISH]: "No hay anuncios todavía",
    [Language.PORTUGUESE]: "Nenhum anúncio ainda",
  },
  "scrape-brands-to-see-ads": {
    [Language.ENGLISH]: "Scrape your brands to see their ads",
    [Language.SPANISH]: "Haz scraping de tus marcas para ver sus anuncios",
    [Language.PORTUGUESE]: "Faça scraping das suas marcas para ver seus anúncios",
  },
  "no-more-ads": {
    [Language.ENGLISH]: "No more ads",
    [Language.SPANISH]: "No hay más anuncios",
    [Language.PORTUGUESE]: "Não há mais anúncios",
  },
  "searching-ads-for": {
    [Language.ENGLISH]: "Searching ads for {name}...",
    [Language.SPANISH]: "Buscando anuncios de {name}...",
    [Language.PORTUGUESE]: "Buscando anúncios de {name}...",
  },
  "brand-scrape-result": {
    [Language.ENGLISH]: "{name}: {inserted} new, {duplicates} duplicates",
    [Language.SPANISH]: "{name}: {inserted} nuevos, {duplicates} duplicados",
    [Language.PORTUGUESE]: "{name}: {inserted} novos, {duplicates} duplicados",
  },
  "error-searching-ads-for": {
    [Language.ENGLISH]: "Error searching ads for {name}",
    [Language.SPANISH]: "Error buscando anuncios de {name}",
    [Language.PORTUGUESE]: "Erro ao buscar anúncios de {name}",
  },
  "confirm-delete-brand": {
    [Language.ENGLISH]: "Delete \"{name}\" and all its unsaved ads?",
    [Language.SPANISH]: "Eliminar \"{name}\" y todos sus anuncios no guardados?",
    [Language.PORTUGUESE]: "Excluir \"{name}\" e todos os anúncios não salvos?",
  },
  "brand-deleted": {
    [Language.ENGLISH]: "Brand deleted",
    [Language.SPANISH]: "Marca eliminada",
    [Language.PORTUGUESE]: "Marca excluída",
  },
  "error-deleting-brand": {
    [Language.ENGLISH]: "Error deleting brand",
    [Language.SPANISH]: "Error eliminando marca",
    [Language.PORTUGUESE]: "Erro ao excluir marca",
  },
  "no-brands-yet": {
    [Language.ENGLISH]: "You don't have brands yet",
    [Language.SPANISH]: "Aún no tienes marcas",
    [Language.PORTUGUESE]: "Você ainda não tem marcas",
  },
  "add-first-competitor": {
    [Language.ENGLISH]: "Add your first competitor to start spying on their ads",
    [Language.SPANISH]: "Añade tu primer competidor para empezar a espiar sus anuncios",
    [Language.PORTUGUESE]: "Adicione seu primeiro concorrente para começar a espiar seus anúncios",
  },
  "brand-table-brand": {
    [Language.ENGLISH]: "Brand",
    [Language.SPANISH]: "Marca",
    [Language.PORTUGUESE]: "Marca",
  },
  "brand-table-ads": {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  "brand-table-bookmarks": {
    [Language.ENGLISH]: "Bookmarks",
    [Language.SPANISH]: "Favoritos",
    [Language.PORTUGUESE]: "Favoritos",
  },
  "brand-table-activity": {
    [Language.ENGLISH]: "Activity",
    [Language.SPANISH]: "Actividad",
    [Language.PORTUGUESE]: "Atividade",
  },
  "brand-table-actions": {
    [Language.ENGLISH]: "Actions",
    [Language.SPANISH]: "Acciones",
    [Language.PORTUGUESE]: "Ações",
  },
  "no-activity": {
    [Language.ENGLISH]: "No activity",
    [Language.SPANISH]: "Sin actividad",
    [Language.PORTUGUESE]: "Sem atividade",
  },
  "search-ads": {
    [Language.ENGLISH]: "Search ads",
    [Language.SPANISH]: "Buscar anuncios",
    [Language.PORTUGUESE]: "Buscar anúncios",
  },
  "view-ads": {
    [Language.ENGLISH]: "View ads",
    [Language.SPANISH]: "Ver anuncios",
    [Language.PORTUGUESE]: "Ver anúncios",
  },
  "search-new": {
    [Language.ENGLISH]: "Search new",
    [Language.SPANISH]: "Buscar nuevos",
    [Language.PORTUGUESE]: "Buscar novos",
  },
  "brand-updated": {
    [Language.ENGLISH]: "Brand updated",
    [Language.SPANISH]: "Marca actualizada",
    [Language.PORTUGUESE]: "Marca atualizada",
  },
  "brand-added": {
    [Language.ENGLISH]: "Brand added",
    [Language.SPANISH]: "Marca añadida",
    [Language.PORTUGUESE]: "Marca adicionada",
  },
  "error-saving-brand": {
    [Language.ENGLISH]: "Error saving brand",
    [Language.SPANISH]: "Error guardando marca",
    [Language.PORTUGUESE]: "Erro ao salvar marca",
  },
  "edit-brand": {
    [Language.ENGLISH]: "Edit Brand",
    [Language.SPANISH]: "Editar Marca",
    [Language.PORTUGUESE]: "Editar Marca",
  },
  "brand-name-label": {
    [Language.ENGLISH]: "Brand name",
    [Language.SPANISH]: "Nombre de la marca",
    [Language.PORTUGUESE]: "Nome da marca",
  },
  "brand-name-placeholder": {
    [Language.ENGLISH]: "E.g.: Nike, AG1, Dr. Squatch...",
    [Language.SPANISH]: "Ej: Nike, AG1, Dr. Squatch...",
    [Language.PORTUGUESE]: "Ex: Nike, AG1, Dr. Squatch...",
  },
  "meta-ad-library-url": {
    [Language.ENGLISH]: "Meta Ad Library URL",
    [Language.SPANISH]: "URL de Meta Ad Library",
    [Language.PORTUGUESE]: "URL do Meta Ad Library",
  },
  "paste-ad-library-url": {
    [Language.ENGLISH]: "Paste the Ad Library URL here...",
    [Language.SPANISH]: "Pega aquí la URL de la Ad Library...",
    [Language.PORTUGUESE]: "Cole aqui a URL do Ad Library...",
  },
  "go-to-ad-library-hint": {
    [Language.ENGLISH]: "Go to facebook.com/ads/library, search the brand and copy that URL",
    [Language.SPANISH]: "Ve a facebook.com/ads/library, busca la marca y copia esa URL",
    [Language.PORTUGUESE]: "Acesse facebook.com/ads/library, busque a marca e copie a URL",
  },
  "category": {
    [Language.ENGLISH]: "Category",
    [Language.SPANISH]: "Categoría",
    [Language.PORTUGUESE]: "Categoria",
  },
  "no-active-brands": {
    [Language.ENGLISH]: "No active brands",
    [Language.SPANISH]: "No hay marcas activas",
    [Language.PORTUGUESE]: "Não há marcas ativas",
  },
  "bulk-search": {
    [Language.ENGLISH]: "Bulk Search",
    [Language.SPANISH]: "Búsqueda Masiva",
    [Language.PORTUGUESE]: "Busca em Massa",
  },
  "will-search-new-ads-in-n-brands": {
    [Language.ENGLISH]: "New ads will be searched in {n} active brand(s).",
    [Language.SPANISH]: "Se buscarán anuncios nuevos en {n} marca(s) activa(s).",
    [Language.PORTUGUESE]: "Novos anúncios serão buscados em {n} marca(s) ativa(s).",
  },
  "system-will-check-ad-library": {
    [Language.ENGLISH]: "The system will check each brand's ad library and add those not yet in your collection.",
    [Language.SPANISH]: "El sistema revisará la biblioteca de anuncios de cada marca y agregará los que aún no estén en tu colección.",
    [Language.PORTUGUESE]: "O sistema revisará a biblioteca de anúncios de cada marca e adicionará os que ainda não estão na sua coleção.",
  },
  "search-in-n-brands": {
    [Language.ENGLISH]: "Search in {n} brand(s)",
    [Language.SPANISH]: "Buscar en {n} marca(s)",
    [Language.PORTUGUESE]: "Buscar em {n} marca(s)",
  },
  "search-completed": {
    [Language.ENGLISH]: "Search completed",
    [Language.SPANISH]: "Búsqueda completada",
    [Language.PORTUGUESE]: "Busca concluída",
  },
  "searching-ads": {
    [Language.ENGLISH]: "Searching ads...",
    [Language.SPANISH]: "Buscando anuncios...",
    [Language.PORTUGUESE]: "Buscando anúncios...",
  },
  "n-of-n-brands": {
    [Language.ENGLISH]: "{current} of {total} brands",
    [Language.SPANISH]: "{current} de {total} marcas",
    [Language.PORTUGUESE]: "{current} de {total} marcas",
  },
  "searching-in": {
    [Language.ENGLISH]: "Searching in:",
    [Language.SPANISH]: "Buscando en:",
    [Language.PORTUGUESE]: "Buscando em:",
  },
  "n-new-ads-from-n-brands": {
    [Language.ENGLISH]: "{ads} new ads from {brands} brands",
    [Language.SPANISH]: "{ads} anuncios nuevos de {brands} marcas",
    [Language.PORTUGUESE]: "{ads} novos anúncios de {brands} marcas",
  },
  "n-new": {
    [Language.ENGLISH]: "+{n} new",
    [Language.SPANISH]: "+{n} nuevos",
    [Language.PORTUGUESE]: "+{n} novos",
  },
  "error": {
    [Language.ENGLISH]: "Error",
    [Language.SPANISH]: "Error",
    [Language.PORTUGUESE]: "Erro",
  },
  "search-n-new-ads-n-errors": {
    [Language.ENGLISH]: "Search: {new} new ads, {errors} with error",
    [Language.SPANISH]: "Búsqueda: {new} anuncios nuevos, {errors} con error",
    [Language.PORTUGUESE]: "Busca: {new} novos anúncios, {errors} com erro",
  },
  "search-completed-n-new": {
    [Language.ENGLISH]: "Search completed: {n} new ads",
    [Language.SPANISH]: "Búsqueda completada: {n} anuncios nuevos",
    [Language.PORTUGUESE]: "Busca concluída: {n} novos anúncios",
  },
  "all-brands": {
    [Language.ENGLISH]: "All brands ({n})",
    [Language.SPANISH]: "Todas las marcas ({n})",
    [Language.PORTUGUESE]: "Todas as marcas ({n})",
  },
  "all-types": {
    [Language.ENGLISH]: "All types",
    [Language.SPANISH]: "Todo tipo",
    [Language.PORTUGUESE]: "Todos os tipos",
  },
  "image": {
    [Language.ENGLISH]: "Image",
    [Language.SPANISH]: "Imagen",
    [Language.PORTUGUESE]: "Imagem",
  },
  "all-statuses": {
    [Language.ENGLISH]: "All statuses",
    [Language.SPANISH]: "Todos los estados",
    [Language.PORTUGUESE]: "Todos os status",
  },
  "active-status": {
    [Language.ENGLISH]: "Active",
    [Language.SPANISH]: "Activos",
    [Language.PORTUGUESE]: "Ativos",
  },
  "expired-status": {
    [Language.ENGLISH]: "Expired",
    [Language.SPANISH]: "Expirados",
    [Language.PORTUGUESE]: "Expirados",
  },
  "best-ranked": {
    [Language.ENGLISH]: "Best ranked",
    [Language.SPANISH]: "Mejor clasificados",
    [Language.PORTUGUESE]: "Melhor classificados",
  },
  "most-recent": {
    [Language.ENGLISH]: "Most recent",
    [Language.SPANISH]: "Más recientes",
    [Language.PORTUGUESE]: "Mais recentes",
  },
  "oldest": {
    [Language.ENGLISH]: "Oldest",
    [Language.SPANISH]: "Más antiguos",
    [Language.PORTUGUESE]: "Mais antigos",
  },
  "ai-filters": {
    [Language.ENGLISH]: "AI Filters",
    [Language.SPANISH]: "Filtros IA",
    [Language.PORTUGUESE]: "Filtros IA",
  },
  "clear": {
    [Language.ENGLISH]: "Clear",
    [Language.SPANISH]: "Limpiar",
    [Language.PORTUGUESE]: "Limpar",
  },
  "asset-type": {
    [Language.ENGLISH]: "Asset type",
    [Language.SPANISH]: "Tipo de recurso",
    [Language.PORTUGUESE]: "Tipo de recurso",
  },
  "visual-format": {
    [Language.ENGLISH]: "Visual format",
    [Language.SPANISH]: "Formato visual",
    [Language.PORTUGUESE]: "Formato visual",
  },
  "messaging-angle": {
    [Language.ENGLISH]: "Messaging",
    [Language.SPANISH]: "Mensajería",
    [Language.PORTUGUESE]: "Mensagem",
  },
  "hook-tactic": {
    [Language.ENGLISH]: "Hook",
    [Language.SPANISH]: "Gancho",
    [Language.PORTUGUESE]: "Gancho",
  },
  "offer-type": {
    [Language.ENGLISH]: "Offer",
    [Language.SPANISH]: "Oferta",
    [Language.PORTUGUESE]: "Oferta",
  },
  "no-bookmarks-yet": {
    [Language.ENGLISH]: "No bookmarks yet",
    [Language.SPANISH]: "No hay favoritos todavía",
    [Language.PORTUGUESE]: "Nenhum favorito ainda",
  },
  "click-star-to-save": {
    [Language.ENGLISH]: "Click the star on any ad to save it",
    [Language.SPANISH]: "Haz clic en la estrella de cualquier anuncio para guardarlo",
    [Language.PORTUGUESE]: "Clique na estrela de qualquer anúncio para salvá-lo",
  },
  "no-media": {
    [Language.ENGLISH]: "No media",
    [Language.SPANISH]: "Sin media",
    [Language.PORTUGUESE]: "Sem mídia",
  },
  "ad-expired": {
    [Language.ENGLISH]: "Ad expired",
    [Language.SPANISH]: "Anuncio expirado",
    [Language.PORTUGUESE]: "Anúncio expirado",
  },
  "create-similar": {
    [Language.ENGLISH]: "Create similar",
    [Language.SPANISH]: "Crear similar",
    [Language.PORTUGUESE]: "Criar similar",
  },
  "no-text": {
    [Language.ENGLISH]: "No text",
    [Language.SPANISH]: "Sin texto",
    [Language.PORTUGUESE]: "Sem texto",
  },
  "error-loading-details": {
    [Language.ENGLISH]: "Error loading details",
    [Language.SPANISH]: "Error cargando detalles",
    [Language.PORTUGUESE]: "Erro ao carregar detalhes",
  },
  "no-media-available": {
    [Language.ENGLISH]: "No media available",
    [Language.SPANISH]: "Sin media disponible",
    [Language.PORTUGUESE]: "Sem mídia disponível",
  },
  "no-headline": {
    [Language.ENGLISH]: "No headline",
    [Language.SPANISH]: "Sin titular",
    [Language.PORTUGUESE]: "Sem título",
  },
  "text": {
    [Language.ENGLISH]: "Text",
    [Language.SPANISH]: "Texto",
    [Language.PORTUGUESE]: "Texto",
  },
  "call-to-action": {
    [Language.ENGLISH]: "Call to action",
    [Language.SPANISH]: "Llamada a acción",
    [Language.PORTUGUESE]: "Chamada para ação",
  },
  "type": {
    [Language.ENGLISH]: "Type",
    [Language.SPANISH]: "Tipo",
    [Language.PORTUGUESE]: "Tipo",
  },
  "position": {
    [Language.ENGLISH]: "Position",
    [Language.SPANISH]: "Posición",
    [Language.PORTUGUESE]: "Posição",
  },
  "start": {
    [Language.ENGLISH]: "Start",
    [Language.SPANISH]: "Inicio",
    [Language.PORTUGUESE]: "Início",
  },
  "view-landing-page": {
    [Language.ENGLISH]: "View landing page",
    [Language.SPANISH]: "Ver landing page",
    [Language.PORTUGUESE]: "Ver landing page",
  },
  "view-all-brand-ads": {
    [Language.ENGLISH]: "View all ads from {name}",
    [Language.SPANISH]: "Ver todos los anuncios de {name}",
    [Language.PORTUGUESE]: "Ver todos os anúncios de {name}",
  },
  "view-individual-ad": {
    [Language.ENGLISH]: "View individual ad",
    [Language.SPANISH]: "Ver anuncio individual",
    [Language.PORTUGUESE]: "Ver anúncio individual",
  },
  "analyze-with-ai": {
    [Language.ENGLISH]: "Analyze with AI",
    [Language.SPANISH]: "Analizar con IA",
    [Language.PORTUGUESE]: "Analisar com IA",
  },
  "ai-analysis": {
    [Language.ENGLISH]: "AI Analysis",
    [Language.SPANISH]: "Análisis IA",
    [Language.PORTUGUESE]: "Análise IA",
  },
  "summary": {
    [Language.ENGLISH]: "Summary",
    [Language.SPANISH]: "Resumen",
    [Language.PORTUGUESE]: "Resumo",
  },
  "suggested-improvements": {
    [Language.ENGLISH]: "Suggested improvements",
    [Language.SPANISH]: "Mejoras sugeridas",
    [Language.PORTUGUESE]: "Melhorias sugeridas",
  },

  // LANDING OFFER PAGE
  "offer-enter-email-title": {
    [Language.ENGLISH]: "Enter the email you'll use to create your Fluxi account",
    [Language.SPANISH]: "Ingresa el correo con el que crearás tu cuenta de Fluxi",
    [Language.PORTUGUESE]: "Insira o e-mail com o qual você criará sua conta Fluxi",
  },
  "offer-email-label": {
    [Language.ENGLISH]: "EMAIL ADDRESS",
    [Language.SPANISH]: "CORREO ELECTRÓNICO",
    [Language.PORTUGUESE]: "ENDEREÇO DE E-MAIL",
  },
  "offer-email-placeholder": {
    [Language.ENGLISH]: "you@email.com",
    [Language.SPANISH]: "tu@correo.com",
    [Language.PORTUGUESE]: "seu@email.com",
  },
  "offer-email-warning": {
    [Language.ENGLISH]: "All your invoices, access credentials, purchase confirmations and other Fluxi communications will be sent to this email.",
    [Language.SPANISH]: "A este correo llegarán todas tus facturas, accesos, confirmaciones de compra y demás comunicaciones de Fluxi.",
    [Language.PORTUGUESE]: "Todas as suas faturas, acessos, confirmações de compra e demais comunicações do Fluxi serão enviadas para este e-mail.",
  },
  "offer-email-warning-bold": {
    [Language.ENGLISH]: "Make sure to enter the correct email, as it cannot be changed in the future.",
    [Language.SPANISH]: "Asegúrate de ingresar el correo correcto, ya que no podrá ser modificado en el futuro.",
    [Language.PORTUGUESE]: "Certifique-se de inserir o e-mail correto, pois não poderá ser alterado no futuro.",
  },
  "offer-continue": {
    [Language.ENGLISH]: "Continue",
    [Language.SPANISH]: "Continuar",
    [Language.PORTUGUESE]: "Continuar",
  },
  "offer-processing": {
    [Language.ENGLISH]: "Processing...",
    [Language.SPANISH]: "Procesando...",
    [Language.PORTUGUESE]: "Processando...",
  },
  "offer-error-generic": {
    [Language.ENGLISH]: "An error occurred. Please try again.",
    [Language.SPANISH]: "Ocurrió un error. Por favor intenta de nuevo.",
    [Language.PORTUGUESE]: "Ocorreu um erro. Por favor, tente novamente.",
  },
  "offer-all-rights-reserved": {
    [Language.ENGLISH]: "Fluxi. All rights reserved.",
    [Language.SPANISH]: "Fluxi. Todos los derechos reservados.",
    [Language.PORTUGUESE]: "Fluxi. Todos os direitos reservados.",
  },

  // ABANDONED CARTS
  "orders-tab": {
    [Language.ENGLISH]: "Orders",
    [Language.SPANISH]: "Órdenes",
    [Language.PORTUGUESE]: "Pedidos",
  },
  "abandoned-carts-tab": {
    [Language.ENGLISH]: "Abandoned Carts",
    [Language.SPANISH]: "Carritos Abandonados",
    [Language.PORTUGUESE]: "Carrinhos Abandonados",
  },
  "last-activity": {
    [Language.ENGLISH]: "Last activity",
    [Language.SPANISH]: "Última actividad",
    [Language.PORTUGUESE]: "Última atividade",
  },
  "last-stage-reached": {
    [Language.ENGLISH]: "Last stage",
    [Language.SPANISH]: "Última etapa",
    [Language.PORTUGUESE]: "Última etapa",
  },
  "no-abandoned-carts": {
    [Language.ENGLISH]: "No abandoned carts for this period",
    [Language.SPANISH]: "No hay carritos abandonados en este período",
    [Language.PORTUGUESE]: "Sem carrinhos abandonados neste período",
  },
  "customer-name": {
    [Language.ENGLISH]: "Customer name",
    [Language.SPANISH]: "Nombre cliente",
    [Language.PORTUGUESE]: "Nome do cliente",
  },
  "abandoned-carts-description": {
    [Language.ENGLISH]: "Customers who started a purchase but didn't complete it.",
    [Language.SPANISH]: "Clientes que iniciaron una compra pero no la completaron.",
    [Language.PORTUGUESE]: "Clientes que iniciaram uma compra mas não a concluíram.",
  },
  "abandoned-carts-search-placeholder": {
    [Language.ENGLISH]: "Search name, email or phone",
    [Language.SPANISH]: "Buscar nombre, email o celular",
    [Language.PORTUGUESE]: "Buscar nome, email ou celular",
  },
  "abandoned-carts-all-funnels": {
    [Language.ENGLISH]: "All funnels",
    [Language.SPANISH]: "Todos los embudos",
    [Language.PORTUGUESE]: "Todos os funis",
  },
  "abandoned-carts-all-stages": {
    [Language.ENGLISH]: "All stages",
    [Language.SPANISH]: "Todas las etapas",
    [Language.PORTUGUESE]: "Todas as etapas",
  },
  "recover-cart-button": {
    [Language.ENGLISH]: "Recover purchase",
    [Language.SPANISH]: "Recuperar compra",
    [Language.PORTUGUESE]: "Recuperar compra",
  },
  "recover-cart-sending": {
    [Language.ENGLISH]: "Sending...",
    [Language.SPANISH]: "Enviando...",
    [Language.PORTUGUESE]: "Enviando...",
  },
  "recover-cart-success": {
    [Language.ENGLISH]: "Recovery message sent on WhatsApp",
    [Language.SPANISH]: "Mensaje de recuperación enviado por WhatsApp",
    [Language.PORTUGUESE]: "Mensagem de recuperação enviada pelo WhatsApp",
  },
  "recover-cart-sent-badge": {
    [Language.ENGLISH]: "Sent",
    [Language.SPANISH]: "Enviado",
    [Language.PORTUGUESE]: "Enviado",
  },
  "recover-cart-error": {
    [Language.ENGLISH]: "Could not send recovery message",
    [Language.SPANISH]: "No se pudo enviar el mensaje de recuperación",
    [Language.PORTUGUESE]: "Não foi possível enviar a mensagem de recuperação",
  },
  "recover-cart-no-template": {
    [Language.ENGLISH]: "No cart recovery template assigned. Configure it in WhatsApp → Templates.",
    [Language.SPANISH]: "No hay plantilla de recuperación asignada. Configúrala en WhatsApp → Plantillas.",
    [Language.PORTUGUESE]: "Sem modelo de recuperação atribuído. Configure em WhatsApp → Modelos.",
  },
  "recover-cart-token-expired": {
    [Language.ENGLISH]: "WhatsApp token expired. Reconnect the account in Settings → WhatsApp → Manage API.",
    [Language.SPANISH]: "El token de WhatsApp expiró. Reconecta la cuenta en Configuración → WhatsApp → Gestionar API.",
    [Language.PORTUGUESE]: "O token do WhatsApp expirou. Reconecte a conta em Configurações → WhatsApp → Gerenciar API.",
  },
  "recover-cart-outside-window": {
    [Language.ENGLISH]: "More than 24h passed since the customer's last message. Only approved templates can be sent.",
    [Language.SPANISH]: "Pasaron más de 24h del último mensaje del cliente. Solo se pueden enviar plantillas aprobadas.",
    [Language.PORTUGUESE]: "Passaram mais de 24h desde a última mensagem do cliente. Apenas modelos aprovados podem ser enviados.",
  },
  "ws-templates-default-cart-recovery": {
    [Language.ENGLISH]: "Cart recovery (abandoned carts)",
    [Language.SPANISH]: "Recuperación de carrito (carritos abandonados)",
    [Language.PORTUGUESE]: "Recuperação de carrinho (carrinhos abandonados)",
  },

  // FUNNEL EVENTS CHART
  "statistics-tab": {
    [Language.ENGLISH]: "Statistics",
    [Language.SPANISH]: "Estadísticas",
    [Language.PORTUGUESE]: "Estatísticas",
  },
  "chart-tab": {
    [Language.ENGLISH]: "Chart",
    [Language.SPANISH]: "Gráfico",
    [Language.PORTUGUESE]: "Gráfico",
  },
  "conversion-funnel": {
    [Language.ENGLISH]: "Conversion Funnel",
    [Language.SPANISH]: "Embudo de conversión",
    [Language.PORTUGUESE]: "Funil de conversão",
  },
  "abandoned-stage-checkoutForm": {
    [Language.ENGLISH]: "Checkout form",
    [Language.SPANISH]: "Formulario checkout",
    [Language.PORTUGUESE]: "Formulário de checkout",
  },
  "abandoned-stage-paymentModal": {
    [Language.ENGLISH]: "Payment modal",
    [Language.SPANISH]: "Modal de pago",
    [Language.PORTUGUESE]: "Modal de pagamento",
  },
  "funnel-stage-pageview": {
    [Language.ENGLISH]: "Page View",
    [Language.SPANISH]: "Vista de página",
    [Language.PORTUGUESE]: "Visualização de página",
  },
  "funnel-stage-viewContent": {
    [Language.ENGLISH]: "View Content",
    [Language.SPANISH]: "Vista de contenido",
    [Language.PORTUGUESE]: "Visualização de conteúdo",
  },
  "funnel-stage-addToCart": {
    [Language.ENGLISH]: "Add to Cart",
    [Language.SPANISH]: "Agregar al carrito",
    [Language.PORTUGUESE]: "Adicionar ao carrinho",
  },
  "funnel-stage-initiateCheckout": {
    [Language.ENGLISH]: "Initiate Checkout",
    [Language.SPANISH]: "Iniciar checkout",
    [Language.PORTUGUESE]: "Iniciar checkout",
  },
  "funnel-stage-addCheckoutInfo": {
    [Language.ENGLISH]: "Add Checkout Info",
    [Language.SPANISH]: "Información de envío",
    [Language.PORTUGUESE]: "Informações de envio",
  },
  "funnel-stage-addPaymentInfo": {
    [Language.ENGLISH]: "Add Payment Info",
    [Language.SPANISH]: "Información de pago",
    [Language.PORTUGUESE]: "Informações de pagamento",
  },
  "funnel-stage-purchase": {
    [Language.ENGLISH]: "Purchase",
    [Language.SPANISH]: "Compra",
    [Language.PORTUGUESE]: "Compra",
  },
  "funnel-drop-off": {
    [Language.ENGLISH]: "drop-off",
    [Language.SPANISH]: "abandono",
    [Language.PORTUGUESE]: "abandono",
  },
  "no-funnel-data": {
    [Language.ENGLISH]: "No funnel data yet for this period",
    [Language.SPANISH]: "Sin datos de embudo para este período",
    [Language.PORTUGUESE]: "Sem dados de funil para este período",
  },

  // ---- CHAT / WHATSAPP CONFIRMATION ----
  "chat": {
    [Language.ENGLISH]: "Chat",
    [Language.SPANISH]: "Chat",
    [Language.PORTUGUESE]: "Chat",
  },
  "chatbot": {
    [Language.ENGLISH]: "Chatbot",
    [Language.SPANISH]: "Chatbot",
    [Language.PORTUGUESE]: "Chatbot",
  },
  "chat-setup-title": {
    [Language.ENGLISH]: "Set up your WhatsApp Business",
    [Language.SPANISH]: "Configura tu WhatsApp Business",
    [Language.PORTUGUESE]: "Configure seu WhatsApp Business",
  },
  "chat-setup-subtitle": {
    [Language.ENGLISH]: "To automatically confirm orders, connect your WhatsApp Business account",
    [Language.SPANISH]: "Para confirmar pedidos automáticamente, conecta tu cuenta de WhatsApp Business",
    [Language.PORTUGUESE]: "Para confirmar pedidos automaticamente, conecte sua conta do WhatsApp Business",
  },
  "chat-setup-cta": {
    [Language.ENGLISH]: "Set up now",
    [Language.SPANISH]: "Configurar ahora",
    [Language.PORTUGUESE]: "Configurar agora",
  },
  "chat-inbox-title": {
    [Language.ENGLISH]: "Chats",
    [Language.SPANISH]: "Chats",
    [Language.PORTUGUESE]: "Chats",
  },
  "chat-filter-all": {
    [Language.ENGLISH]: "All",
    [Language.SPANISH]: "Todos",
    [Language.PORTUGUESE]: "Todos",
  },
  "chat-filter-pending": {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendientes",
    [Language.PORTUGUESE]: "Pendentes",
  },
  "chat-filter-confirmed": {
    [Language.ENGLISH]: "Confirmed",
    [Language.SPANISH]: "Confirmados",
    [Language.PORTUGUESE]: "Confirmados",
  },
  "chat-filter-rejected": {
    [Language.ENGLISH]: "Rejected",
    [Language.SPANISH]: "Rechazados",
    [Language.PORTUGUESE]: "Rejeitados",
  },
  "chat-active-count": {
    [Language.ENGLISH]: "active",
    [Language.SPANISH]: "activos",
    [Language.PORTUGUESE]: "ativos",
  },
  "chat-no-conversations": {
    [Language.ENGLISH]: "No conversations yet",
    [Language.SPANISH]: "Aún no hay conversaciones",
    [Language.PORTUGUESE]: "Nenhuma conversa ainda",
  },
  "chat-select-conversation": {
    [Language.ENGLISH]: "Select a conversation to view messages",
    [Language.SPANISH]: "Selecciona una conversación para ver los mensajes",
    [Language.PORTUGUESE]: "Selecione uma conversa para ver as mensagens",
  },
  "chat-order": {
    [Language.ENGLISH]: "Order",
    [Language.SPANISH]: "Pedido",
    [Language.PORTUGUESE]: "Pedido",
  },
  "chat-search-placeholder": {
    [Language.ENGLISH]: "Search conversations...",
    [Language.SPANISH]: "Buscar conversaciones...",
    [Language.PORTUGUESE]: "Buscar conversas...",
  },
  "chat-ai-footer": {
    [Language.ENGLISH]: "Responses are automatically managed by the AI agent",
    [Language.SPANISH]: "Las respuestas son gestionadas automáticamente por el agente de IA",
    [Language.PORTUGUESE]: "As respostas são gerenciadas automaticamente pelo agente de IA",
  },
  "whatsapp-connect-title": {
    [Language.ENGLISH]: "Connect WhatsApp Business",
    [Language.SPANISH]: "Conectar WhatsApp Business",
    [Language.PORTUGUESE]: "Conectar WhatsApp Business",
  },
  "whatsapp-connect-description": {
    [Language.ENGLISH]: "Connect your WhatsApp Business account to start receiving order confirmations via WhatsApp.",
    [Language.SPANISH]: "Conecta tu cuenta de WhatsApp Business para empezar a recibir confirmaciones de pedidos por WhatsApp.",
    [Language.PORTUGUESE]: "Conecte sua conta do WhatsApp Business para começar a receber confirmações de pedidos pelo WhatsApp.",
  },
  "whatsapp-connect-button": {
    [Language.ENGLISH]: "Connect with WhatsApp",
    [Language.SPANISH]: "Conectar con WhatsApp",
    [Language.PORTUGUESE]: "Conectar com WhatsApp",
  },
  "whatsapp-feature-confirmations": {
    [Language.ENGLISH]: "Automatic order confirmations via WhatsApp",
    [Language.SPANISH]: "Confirmaciones automáticas de pedidos por WhatsApp",
    [Language.PORTUGUESE]: "Confirmações automáticas de pedidos pelo WhatsApp",
  },
  "whatsapp-feature-messages": {
    [Language.ENGLISH]: "Personalized messages to your customers",
    [Language.SPANISH]: "Mensajes personalizados a tus clientes",
    [Language.PORTUGUESE]: "Mensagens personalizadas para seus clientes",
  },
  "whatsapp-feature-tracking": {
    [Language.ENGLISH]: "Real-time delivery tracking notifications",
    [Language.SPANISH]: "Notificaciones de seguimiento de envíos en tiempo real",
    [Language.PORTUGUESE]: "Notificações de rastreamento de envios em tempo real",
  },
  "whatsapp-phone-number-id": {
    [Language.ENGLISH]: "Phone Number ID",
    [Language.SPANISH]: "Phone Number ID",
    [Language.PORTUGUESE]: "Phone Number ID",
  },
  "whatsapp-waba-id": {
    [Language.ENGLISH]: "WABA ID",
    [Language.SPANISH]: "WABA ID",
    [Language.PORTUGUESE]: "WABA ID",
  },
  "whatsapp-access-token": {
    [Language.ENGLISH]: "Access Token",
    [Language.SPANISH]: "Access Token",
    [Language.PORTUGUESE]: "Access Token",
  },
  "whatsapp-app-secret": {
    [Language.ENGLISH]: "App Secret (optional)",
    [Language.SPANISH]: "App Secret (opcional)",
    [Language.PORTUGUESE]: "App Secret (opcional)",
  },
  "whatsapp-verify-token": {
    [Language.ENGLISH]: "Verify Token",
    [Language.SPANISH]: "Verify Token",
    [Language.PORTUGUESE]: "Verify Token",
  },
  "whatsapp-display-name": {
    [Language.ENGLISH]: "Display Name (optional)",
    [Language.SPANISH]: "Nombre visible (opcional)",
    [Language.PORTUGUESE]: "Nome visível (opcional)",
  },
  "select-design-template": {
    [Language.ENGLISH]: "Select a template for the product page",
    [Language.SPANISH]: "Selecciona una plantilla para la página de producto",
    [Language.PORTUGUESE]: "Selecione um modelo para a página do produto",
  },
  "select-sales-angle": {
    [Language.ENGLISH]: "Select a sales angle",
    [Language.SPANISH]: "Selecciona un ángulo de venta",
    [Language.PORTUGUESE]: "Selecione um ângulo de venda",
  },
  "select-ad-templates-title": {
    [Language.ENGLISH]: "Select up to 20 ad templates for this funnel",
    [Language.SPANISH]: "Selecciona hasta 20 plantillas de anuncios para este embudo",
    [Language.PORTUGUESE]: "Selecione até 20 modelos de anúncios para este funil",
  },
  "ad-templates-subtitle": {
    [Language.ENGLISH]: "For each selected template, we will create an ad for your product.",
    [Language.SPANISH]: "A partir de cada plantilla seleccionada crearemos un anuncio para tu producto.",
    [Language.PORTUGUESE]: "Para cada modelo selecionado, criaremos um anúncio para seu produto.",
  },
  "next-funnel": {
    [Language.ENGLISH]: "Next funnel",
    [Language.SPANISH]: "Siguiente embudo",
    [Language.PORTUGUESE]: "Próximo funil",
  },
  "n-selected": {
    [Language.ENGLISH]: "{n} selected",
    [Language.SPANISH]: "{n} seleccionados",
    [Language.PORTUGUESE]: "{n} selecionados",
  },
  "edit-angle": {
    [Language.ENGLISH]: "Edit",
    [Language.SPANISH]: "Editar",
    [Language.PORTUGUESE]: "Editar",
  },
  "funnel-label": {
    [Language.ENGLISH]: "Funnel",
    [Language.SPANISH]: "Embudo",
    [Language.PORTUGUESE]: "Funil",
  },
  "custom-angle-name-placeholder": {
    [Language.ENGLISH]: "Angle name",
    [Language.SPANISH]: "Nombre del ángulo",
    [Language.PORTUGUESE]: "Nome do ângulo",
  },
  "custom-angle-desc-placeholder": {
    [Language.ENGLISH]: "Describe your sales approach...",
    [Language.SPANISH]: "Describe tu enfoque de venta...",
    [Language.PORTUGUESE]: "Descreva sua abordagem de vendas...",
  },

  // ─── VIDEO STUDIO ───
  "video-tab-all": {
    [Language.ENGLISH]: "All",
    [Language.SPANISH]: "Todos",
    [Language.PORTUGUESE]: "Todos",
  },
  "video-tab-medical": {
    [Language.ENGLISH]: "3D Animated",
    [Language.SPANISH]: "Animado 3D",
    [Language.PORTUGUESE]: "Animado 3D",
  },
  "video-tab-ugc": {
    [Language.ENGLISH]: "UGC",
    [Language.SPANISH]: "UGC",
    [Language.PORTUGUESE]: "UGC",
  },
  "video-tab-demo": {
    [Language.ENGLISH]: "Demo",
    [Language.SPANISH]: "Demo",
    [Language.PORTUGUESE]: "Demo",
  },
  "video-style-selected": {
    [Language.ENGLISH]: "style selected",
    [Language.SPANISH]: "estilo seleccionado",
    [Language.PORTUGUESE]: "estilo selecionado",
  },
  "video-estimated-time": {
    [Language.ENGLISH]: "Creation time:",
    [Language.SPANISH]: "Tiempo de creación:",
    [Language.PORTUGUESE]: "Tempo de criação:",
  },
  "video-required": {
    [Language.ENGLISH]: "required",
    [Language.SPANISH]: "obligatorio",
    [Language.PORTUGUESE]: "obrigatório",
  },
  "video-optional": {
    [Language.ENGLISH]: "optional",
    [Language.SPANISH]: "opcional",
    [Language.PORTUGUESE]: "opcional",
  },
  "video-recommended": {
    [Language.ENGLISH]: "recommended",
    [Language.SPANISH]: "recomendado",
    [Language.PORTUGUESE]: "recomendado",
  },
  "video-problem-hint": {
    [Language.ENGLISH]: "What problem does this product solve?",
    [Language.SPANISH]: "¿Qué problema resuelve este producto?",
    [Language.PORTUGUESE]: "Qual problema este produto resolve?",
  },
  "video-problem-hint-placeholder": {
    [Language.ENGLISH]: "E.g.: wrinkles and dry skin, dirty teeth, back pain...",
    [Language.SPANISH]: "Ej: arrugas y piel reseca, dientes sucios, dolor de espalda...",
    [Language.PORTUGUESE]: "Ex: rugas e pele seca, dentes sujos, dor nas costas...",
  },
  "video-select-tone": {
    [Language.ENGLISH]: "Select a tone",
    [Language.SPANISH]: "Selecciona un tono",
    [Language.PORTUGUESE]: "Selecione um tom",
  },
  "tone-educational": {
    [Language.ENGLISH]: "Educational",
    [Language.SPANISH]: "Educativo",
    [Language.PORTUGUESE]: "Educativo",
  },
  "tone-dramatic": {
    [Language.ENGLISH]: "Dramatic",
    [Language.SPANISH]: "Dramático",
    [Language.PORTUGUESE]: "Dramático",
  },
  "tone-humorous": {
    [Language.ENGLISH]: "Humorous",
    [Language.SPANISH]: "Humorístico",
    [Language.PORTUGUESE]: "Humorístico",
  },
  "tone-urgent": {
    [Language.ENGLISH]: "Urgent",
    [Language.SPANISH]: "Urgente",
    [Language.PORTUGUESE]: "Urgente",
  },
  "video-empty-title": {
    [Language.ENGLISH]: "You don't have any generated videos yet",
    [Language.SPANISH]: "Aún no tienes videos generados",
    [Language.PORTUGUESE]: "Você ainda não tem vídeos gerados",
  },
  "video-empty-subtitle": {
    [Language.ENGLISH]: "Create your first AI-powered advertising video",
    [Language.SPANISH]: "Crea tu primer video publicitario con IA",
    [Language.PORTUGUESE]: "Crie seu primeiro vídeo publicitário com IA",
  },
  "video-no-styles-found": {
    [Language.ENGLISH]: "No styles found",
    [Language.SPANISH]: "No se encontraron estilos",
    [Language.PORTUGUESE]: "Nenhum estilo encontrado",
  },
  "video-type-sassy-object-name": {
    [Language.ENGLISH]: "Product with Life",
    [Language.SPANISH]: "Producto con Vida",
    [Language.PORTUGUESE]: "Produto com Vida",
  },
  "video-type-sassy-object-desc": {
    [Language.ENGLISH]: "Your product comes alive with its own personality and talks directly to the customer",
    [Language.SPANISH]: "Tu producto cobra vida con personalidad propia y le habla directo al cliente",
    [Language.PORTUGUESE]: "Seu produto ganha vida com personalidade própria e fala diretamente ao cliente",
  },
  "video-type-animated-problem-name": {
    [Language.ENGLISH]: "Animated Problem",
    [Language.SPANISH]: "Problema Animado",
    [Language.PORTUGUESE]: "Problema Animado",
  },
  "video-type-animated-problem-desc": {
    [Language.ENGLISH]: "The problem your product solves becomes visible and comes alive to explain itself",
    [Language.SPANISH]: "El problema que tu producto resuelve se hace visible y cobra vida para explicarse",
    [Language.PORTUGUESE]: "O problema que seu produto resolve se torna visível e ganha vida para se explicar",
  },
  "video-type-label": {
    [Language.ENGLISH]: "Video Type",
    [Language.SPANISH]: "Tipo de Video",
    [Language.PORTUGUESE]: "Tipo de Vídeo",
  },
  "video-style-3d-anatomy": {
    [Language.ENGLISH]: "3D Animated",
    [Language.SPANISH]: "Animado 3D",
    [Language.PORTUGUESE]: "Animado 3D",
  },
  "video-style-3d-anatomy-desc": {
    [Language.ENGLISH]: "A 3D animated character with an anthropomorphic face explains the health problem your product solves. Educational viral style for TikTok/Reels.",
    [Language.SPANISH]: "Un personaje animado 3D con cara antropomórfica explica el problema de salud que tu producto resuelve. Estilo educativo viral para TikTok/Reels.",
    [Language.PORTUGUESE]: "Um personagem animado 3D com rosto antropomórfico explica o problema de saúde que seu produto resolve. Estilo educativo viral para TikTok/Reels.",
  },
  "video-style-ugc-testimonial": {
    [Language.ENGLISH]: "UGC Testimonial",
    [Language.SPANISH]: "Testimonial UGC",
    [Language.PORTUGUESE]: "Depoimento UGC",
  },
  "video-style-ugc-testimonial-desc": {
    [Language.ENGLISH]: "Real user-style video speaking to camera about product benefits.",
    [Language.SPANISH]: "Video estilo usuario real hablando a cámara sobre los beneficios del producto.",
    [Language.PORTUGUESE]: "Vídeo estilo usuário real falando para a câmera sobre os benefícios do produto.",
  },
  "video-style-modeling": {
    [Language.ENGLISH]: "UGC + Voice-over",
    [Language.SPANISH]: "UGC + Voz en off",
    [Language.PORTUGUESE]: "UGC + Voz em off",
  },
  "video-style-modeling-desc": {
    [Language.ENGLISH]: "UGC-style product shots with a clear voice-over.",
    [Language.SPANISH]: "Tomas UGC del producto con voz en off clara.",
    [Language.PORTUGUESE]: "Cenas UGC do produto com voz em off clara.",
  },
  "video-style-modeling-voiceover": {
    [Language.ENGLISH]: "Model + Voice-over",
    [Language.SPANISH]: "Modelo + Voz en off",
    [Language.PORTUGUESE]: "Modelo + Voz em off",
  },
  "video-style-modeling-voiceover-desc": {
    [Language.ENGLISH]: "Person showcases the product while a voice narrates the benefits.",
    [Language.SPANISH]: "La persona muestra el producto mientras una voz narra los beneficios.",
    [Language.PORTUGUESE]: "A pessoa mostra o produto enquanto uma voz narra os benefícios.",
  },
  "video-tab-modeling": {
    [Language.ENGLISH]: "Modeling",
    [Language.SPANISH]: "Modelando",
    [Language.PORTUGUESE]: "Modelando",
  },
  "video-instruction-placeholder-modeling": {
    [Language.ENGLISH]: "E.g.: scratch arm, show headache, rub knee...",
    [Language.SPANISH]: "Ej: que se rasque el brazo, que muestre dolor de cabeza, que se frote la rodilla...",
    [Language.PORTUGUESE]: "Ex: coçar o braço, mostrar dor de cabeça, esfregar o joelho...",
  },
  // Phase 2 V9 REV 2 (Apr 19 2026, REV b) — placeholder rewrote to align
  // with the real pipeline. The prior version mentioned "la voz es una
  // chica de 25 de Medellín" but VOICE is picked later in the preview
  // (Fluxi VoiceLibrary with 8 Gemini voices), and speaker persona/accent
  // comes from the avatar wizard. This field ONLY feeds `user_instruction`
  // to the director LLM, which uses it to shape:
  //   · what specific benefit/ingredient to highlight
  //   · the concrete anchor in beat 2 (dose / days / zone / outcome)
  //   · the emotional arc / narrative tone
  //   · context of use (when / how / frequency)
  // So the placeholder stays inside those levers and avoids anything
  // already handled elsewhere in the flow.
  // Phase 2 V9 REV 2c (Apr 19 2026) — helper + placeholder rewritten to be
  // (a) short, (b) LATAM-neutral tuteo (no voseo "resaltá/mencioná"). The
  // director prompt itself enforces TUTEO ONLY, so the placeholder should
  // match that register.
  "video-instruction-placeholder-modeling-voiceover": {
    [Language.ENGLISH]: "E.g.: focus on 10% niacinamide, quiet discovery tone, used at night, results in three weeks.",
    [Language.SPANISH]: "Ej: enfoque en la niacinamida al 10%, tono calmado de descubrimiento, se usa en la noche, resultados en tres semanas.",
    [Language.PORTUGUESE]: "Ex: foco na niacinamida 10%, tom calmo de descoberta, usa à noite, resultados em três semanas.",
  },
  "video-advanced-options-hint-modeling-voiceover": {
    [Language.ENGLISH]: "Guides the voice-over script (what the narration says). Voice and avatar are picked separately.",
    [Language.SPANISH]: "Guía el guión de la voz en off (qué dice la narración). La voz y el avatar se eligen aparte.",
    [Language.PORTUGUESE]: "Guia o roteiro da voz em off (o que a narração diz). A voz e o avatar se escolhem à parte.",
  },
  "video-style-product-demo": {
    [Language.ENGLISH]: "Product Demo",
    [Language.SPANISH]: "Demo de Producto",
    [Language.PORTUGUESE]: "Demo do Produto",
  },
  "video-style-product-demo-desc": {
    [Language.ENGLISH]: "Visual product demonstration with animations and dynamic text.",
    [Language.SPANISH]: "Demostración visual del producto con animaciones y texto dinámico.",
    [Language.PORTUGUESE]: "Demonstração visual do produto com animações e texto dinâmico.",
  },
  "video-sidebar-title": {
    [Language.ENGLISH]: "Your Video",
    [Language.SPANISH]: "Tu Video",
    [Language.PORTUGUESE]: "Seu Vídeo",
  },
  "video-sidebar-subtitle": {
    [Language.ENGLISH]: "Configure generation parameters",
    [Language.SPANISH]: "Configura los parámetros de generación",
    [Language.PORTUGUESE]: "Configure os parâmetros de geração",
  },
  "video-select-style": {
    [Language.ENGLISH]: "Select a style from the gallery",
    [Language.SPANISH]: "Selecciona un estilo de la galería",
    [Language.PORTUGUESE]: "Selecione um estilo da galeria",
  },
  "video-duration": {
    [Language.ENGLISH]: "Duration",
    [Language.SPANISH]: "Duración",
    [Language.PORTUGUESE]: "Duração",
  },
  "video-advanced-options": {
    [Language.ENGLISH]: "Advanced options",
    [Language.SPANISH]: "Opciones avanzadas",
    [Language.PORTUGUESE]: "Opções avançadas",
  },
  "video-instruction": {
    [Language.ENGLISH]: "Instruction",
    [Language.SPANISH]: "Instrucción",
    [Language.PORTUGUESE]: "Instrução",
  },
  "video-key-ingredient": {
    [Language.ENGLISH]: "Key ingredient",
    [Language.SPANISH]: "Ingrediente clave",
    [Language.PORTUGUESE]: "Ingrediente chave",
  },
  "video-consumer-problem": {
    [Language.ENGLISH]: "Consumer problem",
    [Language.SPANISH]: "Problema del consumidor",
    [Language.PORTUGUESE]: "Problema do consumidor",
  },
  "video-tone": {
    [Language.ENGLISH]: "Tone",
    [Language.SPANISH]: "Tono",
    [Language.PORTUGUESE]: "Tom",
  },
  "video-generate": {
    [Language.ENGLISH]: "Generate Video",
    [Language.SPANISH]: "Generar Video",
    [Language.PORTUGUESE]: "Gerar Vídeo",
  },
  "video-generating": {
    [Language.ENGLISH]: "Generating...",
    [Language.SPANISH]: "Generando...",
    [Language.PORTUGUESE]: "Gerando...",
  },
  "video-studio-next": {
    [Language.ENGLISH]: "Continue",
    [Language.SPANISH]: "Continuar",
    [Language.PORTUGUESE]: "Continuar",
  },
  "video-studio-preparing": {
    [Language.ENGLISH]: "Preparing preview...",
    [Language.SPANISH]: "Preparando vista previa...",
    [Language.PORTUGUESE]: "Preparando pré-visualização...",
  },
  "video-generation-time": {
    [Language.ENGLISH]: "Generation takes 8-10 minutes",
    [Language.SPANISH]: "La generación tarda entre 8-10 minutos",
    [Language.PORTUGUESE]: "A geração leva de 8-10 minutos",
  },
  "video-duration-5s-subtitle": {
    [Language.ENGLISH]: "Quick hook",
    [Language.SPANISH]: "Hook rápido",
    [Language.PORTUGUESE]: "Hook rápido",
  },
  "video-duration-10s-subtitle": {
    [Language.ENGLISH]: "Standard",
    [Language.SPANISH]: "Estándar",
    [Language.PORTUGUESE]: "Padrão",
  },
  "video-duration-15s-subtitle": {
    [Language.ENGLISH]: "Full educational",
    [Language.SPANISH]: "Educativo completo",
    [Language.PORTUGUESE]: "Educativo completo",
  },
  "video-cost": {
    [Language.ENGLISH]: "Cost:",
    [Language.SPANISH]: "Costo:",
    [Language.PORTUGUESE]: "Custo:",
  },
  "video-credits": {
    [Language.ENGLISH]: "credits",
    [Language.SPANISH]: "créditos",
    [Language.PORTUGUESE]: "créditos",
  },
  "video-instruction-placeholder": {
    [Language.ENGLISH]: "E.g.: Focus on knee pain when climbing stairs.",
    [Language.SPANISH]: "Ej: Enfócate en el dolor de rodilla al subir escaleras.",
    [Language.PORTUGUESE]: "Ex: Foque na dor no joelho ao subir escadas.",
  },
  "video-instruction-placeholder-sassy-object": {
    [Language.ENGLISH]: "E.g.: The product is angry because it's been forgotten on the shelf for weeks while the owner keeps complaining about dry skin.",
    [Language.SPANISH]: "Ej: El producto está furioso porque lleva semanas olvidado en el estante mientras el dueño se queja de la piel seca.",
    [Language.PORTUGUESE]: "Ex: O produto está furioso porque ficou esquecido na prateleira por semanas enquanto o dono reclama da pele seca.",
  },
  "video-instruction-placeholder-animated-problem": {
    [Language.ENGLISH]: "E.g.: Show the knee cartilage suffering and cracking every time the person climbs stairs, desperate for relief. Focus on the daily struggle.",
    [Language.SPANISH]: "Ej: Muestra el cartílago de la rodilla sufriendo y agrietándose cada vez que la persona sube escaleras, desesperado por alivio. Enfócate en la lucha diaria.",
    [Language.PORTUGUESE]: "Ex: Mostre a cartilagem do joelho sofrendo e rachando cada vez que a pessoa sobe escadas, desesperada por alívio. Foque na luta diária.",
  },
  "video-instruction-placeholder-ugc": {
    [Language.ENGLISH]: "E.g.: Talk about how the product changed your daily routine, mention that you used to have joint pain.",
    [Language.SPANISH]: "Ej: Habla de cómo el producto cambió tu rutina diaria, menciona que antes tenías dolor articular.",
    [Language.PORTUGUESE]: "Ex: Fale sobre como o produto mudou sua rotina diária, mencione que antes tinha dor articular.",
  },
  "video-count-video": {
    [Language.ENGLISH]: "Video",
    [Language.SPANISH]: "Video",
    [Language.PORTUGUESE]: "Vídeo",
  },
  "video-count-videos": {
    [Language.ENGLISH]: "Videos",
    [Language.SPANISH]: "Videos",
    [Language.PORTUGUESE]: "Vídeos",
  },
  "video-type-ugc-name": {
    [Language.ENGLISH]: "UGC Testimonial",
    [Language.SPANISH]: "UGC Testimonial",
    [Language.PORTUGUESE]: "UGC Testimonial",
  },
  "video-type-ugc-desc": {
    [Language.ENGLISH]: "Real person gives testimonial with your product",
    [Language.SPANISH]: "Persona real da testimonio con tu producto",
    [Language.PORTUGUESE]: "Pessoa real dá testemunho com seu produto",
  },
  "video-avatar-title": {
    [Language.ENGLISH]: "Configure your Avatar",
    [Language.SPANISH]: "Configura tu Avatar",
    [Language.PORTUGUESE]: "Configure seu Avatar",
  },
  "video-avatar-gender": {
    [Language.ENGLISH]: "Gender",
    [Language.SPANISH]: "Género",
    [Language.PORTUGUESE]: "Gênero",
  },
  "video-avatar-age": {
    [Language.ENGLISH]: "Age",
    [Language.SPANISH]: "Edad",
    [Language.PORTUGUESE]: "Idade",
  },
  "video-avatar-skin": {
    [Language.ENGLISH]: "Skin tone",
    [Language.SPANISH]: "Tono de piel",
    [Language.PORTUGUESE]: "Tom de pele",
  },
  "video-avatar-hair": {
    [Language.ENGLISH]: "Hair",
    [Language.SPANISH]: "Cabello",
    [Language.PORTUGUESE]: "Cabelo",
  },
  "video-avatar-hair-color": {
    [Language.ENGLISH]: "Hair color",
    [Language.SPANISH]: "Color de cabello",
    [Language.PORTUGUESE]: "Cor do cabelo",
  },
  "video-avatar-vibe": {
    [Language.ENGLISH]: "Style",
    [Language.SPANISH]: "Estilo",
    [Language.PORTUGUESE]: "Estilo",
  },
  "video-avatar-setting": {
    [Language.ENGLISH]: "Setting",
    [Language.SPANISH]: "Escenario",
    [Language.PORTUGUESE]: "Cenário",
  },
  "gender-female": {
    [Language.ENGLISH]: "Female",
    [Language.SPANISH]: "Mujer",
    [Language.PORTUGUESE]: "Mulher",
  },
  "gender-male": {
    [Language.ENGLISH]: "Male",
    [Language.SPANISH]: "Hombre",
    [Language.PORTUGUESE]: "Homem",
  },
  "age-18-25": {
    [Language.ENGLISH]: "18-25",
    [Language.SPANISH]: "18-25",
    [Language.PORTUGUESE]: "18-25",
  },
  "age-25-35": {
    [Language.ENGLISH]: "25-35",
    [Language.SPANISH]: "25-35",
    [Language.PORTUGUESE]: "25-35",
  },
  "age-35-45": {
    [Language.ENGLISH]: "35-45",
    [Language.SPANISH]: "35-45",
    [Language.PORTUGUESE]: "35-45",
  },
  "age-45+": {
    [Language.ENGLISH]: "45+",
    [Language.SPANISH]: "45+",
    [Language.PORTUGUESE]: "45+",
  },
  "skin-light": {
    [Language.ENGLISH]: "Light",
    [Language.SPANISH]: "Claro",
    [Language.PORTUGUESE]: "Claro",
  },
  "skin-medium": {
    [Language.ENGLISH]: "Medium",
    [Language.SPANISH]: "Medio",
    [Language.PORTUGUESE]: "Médio",
  },
  "skin-tan": {
    [Language.ENGLISH]: "Tan",
    [Language.SPANISH]: "Bronceado",
    [Language.PORTUGUESE]: "Bronzeado",
  },
  "skin-dark": {
    [Language.ENGLISH]: "Dark",
    [Language.SPANISH]: "Oscuro",
    [Language.PORTUGUESE]: "Escuro",
  },
  "hair-short-straight": {
    [Language.ENGLISH]: "Short straight",
    [Language.SPANISH]: "Corto liso",
    [Language.PORTUGUESE]: "Curto liso",
  },
  "hair-short-curly": {
    [Language.ENGLISH]: "Short curly",
    [Language.SPANISH]: "Corto rizado",
    [Language.PORTUGUESE]: "Curto cacheado",
  },
  "hair-long-straight": {
    [Language.ENGLISH]: "Long straight",
    [Language.SPANISH]: "Largo liso",
    [Language.PORTUGUESE]: "Longo liso",
  },
  "hair-long-wavy": {
    [Language.ENGLISH]: "Long wavy",
    [Language.SPANISH]: "Largo ondulado",
    [Language.PORTUGUESE]: "Longo ondulado",
  },
  "hair-long-curly": {
    [Language.ENGLISH]: "Long curly",
    [Language.SPANISH]: "Largo rizado",
    [Language.PORTUGUESE]: "Longo cacheado",
  },
  "hair-bun": {
    [Language.ENGLISH]: "Bun",
    [Language.SPANISH]: "Moño",
    [Language.PORTUGUESE]: "Coque",
  },
  "hair-ponytail": {
    [Language.ENGLISH]: "Ponytail",
    [Language.SPANISH]: "Cola",
    [Language.PORTUGUESE]: "Rabo de cavalo",
  },
  "hair-color-black": {
    [Language.ENGLISH]: "Black",
    [Language.SPANISH]: "Negro",
    [Language.PORTUGUESE]: "Preto",
  },
  "hair-color-brown": {
    [Language.ENGLISH]: "Brown",
    [Language.SPANISH]: "Castaño",
    [Language.PORTUGUESE]: "Castanho",
  },
  "hair-color-blonde": {
    [Language.ENGLISH]: "Blonde",
    [Language.SPANISH]: "Rubio",
    [Language.PORTUGUESE]: "Loiro",
  },
  "hair-color-red": {
    [Language.ENGLISH]: "Red",
    [Language.SPANISH]: "Rojo",
    [Language.PORTUGUESE]: "Ruivo",
  },
  "hair-color-gray": {
    [Language.ENGLISH]: "Gray",
    [Language.SPANISH]: "Canoso",
    [Language.PORTUGUESE]: "Grisalho",
  },
  "vibe-casual-natural": {
    [Language.ENGLISH]: "Natural",
    [Language.SPANISH]: "Natural",
    [Language.PORTUGUESE]: "Natural",
  },
  "vibe-professional": {
    [Language.ENGLISH]: "Professional",
    [Language.SPANISH]: "Profesional",
    [Language.PORTUGUESE]: "Profissional",
  },
  "vibe-sporty": {
    [Language.ENGLISH]: "Sporty",
    [Language.SPANISH]: "Deportivo",
    [Language.PORTUGUESE]: "Esportivo",
  },
  "vibe-glam": {
    [Language.ENGLISH]: "Glam",
    [Language.SPANISH]: "Glam",
    [Language.PORTUGUESE]: "Glam",
  },
  "setting-bedroom": {
    [Language.ENGLISH]: "Bedroom",
    [Language.SPANISH]: "Cuarto",
    [Language.PORTUGUESE]: "Quarto",
  },
  "setting-bathroom": {
    [Language.ENGLISH]: "Bathroom",
    [Language.SPANISH]: "Baño",
    [Language.PORTUGUESE]: "Banheiro",
  },
  "setting-kitchen": {
    [Language.ENGLISH]: "Kitchen",
    [Language.SPANISH]: "Cocina",
    [Language.PORTUGUESE]: "Cozinha",
  },
  "setting-gym": {
    [Language.ENGLISH]: "Gym",
    [Language.SPANISH]: "Gym",
    [Language.PORTUGUESE]: "Academia",
  },
  "setting-outdoor": {
    [Language.ENGLISH]: "Outdoor",
    [Language.SPANISH]: "Exterior",
    [Language.PORTUGUESE]: "Exterior",
  },
  "setting-office": {
    [Language.ENGLISH]: "Office",
    [Language.SPANISH]: "Oficina",
    [Language.PORTUGUESE]: "Escritório",
  },
  "video-style-podcast": {
    [Language.ENGLISH]: "Podcast",
    [Language.SPANISH]: "Podcast",
    [Language.PORTUGUESE]: "Podcast",
  },
  "video-style-podcast-desc": {
    [Language.ENGLISH]: "Podcast-style clip that generates curiosity about a problem without showing the product.",
    [Language.SPANISH]: "Clip estilo podcast que genera curiosidad sobre un problema sin mostrar producto.",
    [Language.PORTUGUESE]: "Clipe estilo podcast que gera curiosidade sobre um problema sem mostrar o produto.",
  },
  "video-tab-podcast": {
    [Language.ENGLISH]: "Podcast",
    [Language.SPANISH]: "Podcast",
    [Language.PORTUGUESE]: "Podcast",
  },
  "video-instruction-placeholder-podcast": {
    [Language.ENGLISH]: "E.g.: Talk about insomnia and how it affects your energy",
    [Language.SPANISH]: "Ej: Habla sobre el insomnio y cómo afecta tu energía",
    [Language.PORTUGUESE]: "Ex: Fale sobre a insônia e como afeta sua energia",
  },
  "video-info-medical-3d": {
    [Language.ENGLISH]: "Generates an animated 3D video showing how the product works inside the body. Ideal for supplements, health and wellness products.",
    [Language.SPANISH]: "Genera un video animado 3D mostrando cómo actúa el producto dentro del cuerpo. Ideal para suplementos, salud y bienestar.",
    [Language.PORTUGUESE]: "Gera um vídeo animado 3D mostrando como o produto atua dentro do corpo. Ideal para suplementos, saúde e bem-estar.",
  },
  "video-info-ugc-testimonial": {
    [Language.ENGLISH]: "A person appears on camera giving a natural testimonial about your product, as if sharing their real experience. Great for building trust.",
    [Language.SPANISH]: "Una persona aparece en cámara dando un testimonio natural sobre tu producto, como si compartiera su experiencia real. Ideal para generar confianza.",
    [Language.PORTUGUESE]: "Uma pessoa aparece na câmera dando um depoimento natural sobre seu produto, como se compartilhasse sua experiência real. Ideal para gerar confiança.",
  },
  "video-info-product-modeling": {
    [Language.ENGLISH]: "A person poses and models with your product on camera — showcasing it naturally in different angles. A silent video without speech.",
    [Language.SPANISH]: "Una persona posa y modela con tu producto en cámara — mostrándolo de forma natural en diferentes ángulos. Un video sin voz.",
    [Language.PORTUGUESE]: "Uma pessoa posa e modela com seu produto na câmera — mostrando-o de forma natural em diferentes ângulos. Um vídeo sem voz.",
  },
  "video-info-product-modeling-voiceover": {
    [Language.ENGLISH]: "A Latino presenter holds your product and voices a 3-beat script aligned to presentation, interaction, and approval. Voice-over + captions.",
    [Language.SPANISH]: "Un presenter latino sostiene tu producto y narra 3 beats alineados con presentación, interacción y aprobación. Voz en off + subtítulos.",
    [Language.PORTUGUESE]: "Um apresentador latino segura seu produto e narra 3 beats alinhados à apresentação, interação e aprovação. Voz em off + legendas.",
  },
  "video-info-sassy-object": {
    [Language.ENGLISH]: "Your product comes alive as a 3D Pixar-style character with its own personality and talks directly to the camera.",
    [Language.SPANISH]: "Tu producto cobra vida como un personaje 3D estilo Pixar con personalidad propia y habla directo a la cámara.",
    [Language.PORTUGUESE]: "Seu produto ganha vida como um personagem 3D estilo Pixar com personalidade própria e fala diretamente para a câmera.",
  },
  "video-info-animated-problem": {
    [Language.ENGLISH]: "The health problem your product solves becomes a 3D Pixar-style character placed in its real-world context.",
    [Language.SPANISH]: "El problema de salud que tu producto resuelve se convierte en un personaje 3D estilo Pixar en su contexto real.",
    [Language.PORTUGUESE]: "O problema de saúde que seu produto resolve se torna um personagem 3D estilo Pixar em seu contexto real.",
  },
  "video-duration-30s-subtitle": {
    [Language.ENGLISH]: "30s",
    [Language.SPANISH]: "30s",
    [Language.PORTUGUESE]: "30s",
  },
  "video-info-podcast-style": {
    [Language.ENGLISH]: "This style generates a podcast-style clip that talks about the problem your product solves, without showing the product. Ideal for generating curiosity and FOMO.",
    [Language.SPANISH]: "Este estilo genera un clip tipo podcast que habla sobre el problema que tu producto resuelve, sin mostrar el producto. Ideal para generar curiosidad y FOMO.",
    [Language.PORTUGUESE]: "Este estilo gera um clipe estilo podcast que fala sobre o problema que seu produto resolve, sem mostrar o produto. Ideal para gerar curiosidade e FOMO.",
  },
  "video-angle": {
    [Language.ENGLISH]: "Sales angle",
    [Language.SPANISH]: "Ángulo de venta",
    [Language.PORTUGUESE]: "Ângulo de venda",
  },
  "video-angle-placeholder": {
    [Language.ENGLISH]: "E.g.: fear of aging, desire for energy, social pressure...",
    [Language.SPANISH]: "Ej: miedo a envejecer, deseo de energía, presión social...",
    [Language.PORTUGUESE]: "Ex: medo de envelhecer, desejo de energia, pressão social...",
  },
  "tone-auto": {
    [Language.ENGLISH]: "Automatic",
    [Language.SPANISH]: "Automático",
    [Language.PORTUGUESE]: "Automático",
  },
  "video-no-results": {
    [Language.ENGLISH]: "No results",
    [Language.SPANISH]: "Sin resultados",
    [Language.PORTUGUESE]: "Sem resultados",
  },
  "video-status-waiting-scenes": {
    [Language.ENGLISH]: "Preparing scenes...",
    [Language.SPANISH]: "Preparando escenas...",
    [Language.PORTUGUESE]: "Preparando cenas...",
  },
  "video-status-processing": {
    [Language.ENGLISH]: "Generating scenes...",
    [Language.SPANISH]: "Generando escenas...",
    [Language.PORTUGUESE]: "Gerando cenas...",
  },
  "video-status-merging": {
    [Language.ENGLISH]: "Merging final video...",
    [Language.SPANISH]: "Uniendo video final...",
    [Language.PORTUGUESE]: "Unindo vídeo final...",
  },
  "video-status-finished": {
    [Language.ENGLISH]: "Video ready!",
    [Language.SPANISH]: "¡Video listo!",
    [Language.PORTUGUESE]: "Vídeo pronto!",
  },
  "video-status-error": {
    [Language.ENGLISH]: "Error generating video",
    [Language.SPANISH]: "Error al generar el video",
    [Language.PORTUGUESE]: "Erro ao gerar vídeo",
  },
  "video-scenes-progress": {
    [Language.ENGLISH]: "Scene {completed} of {total}",
    [Language.SPANISH]: "Escena {completed} de {total}",
    [Language.PORTUGUESE]: "Cena {completed} de {total}",
  },
  "video-upload-avatar": {
    [Language.ENGLISH]: "Upload your photo",
    [Language.SPANISH]: "Sube tu foto",
    [Language.PORTUGUESE]: "Envie sua foto",
  },
  "setting-studio-dark": {
    [Language.ENGLISH]: "Dark Studio",
    [Language.SPANISH]: "Estudio Oscuro",
    [Language.PORTUGUESE]: "Estúdio Escuro",
  },
  "setting-studio-warm": {
    [Language.ENGLISH]: "Warm Studio",
    [Language.SPANISH]: "Estudio Cálido",
    [Language.PORTUGUESE]: "Estúdio Quente",
  },
  "setting-home-office": {
    [Language.ENGLISH]: "Home Office",
    [Language.SPANISH]: "Oficina/Home",
    [Language.PORTUGUESE]: "Home Office",
  },
  "setting-outdoor-night": {
    [Language.ENGLISH]: "Night Terrace",
    [Language.SPANISH]: "Terraza Nocturna",
    [Language.PORTUGUESE]: "Terraço Noturno",
  },
  "setting-minimal": {
    [Language.ENGLISH]: "Minimal",
    [Language.SPANISH]: "Minimalista",
    [Language.PORTUGUESE]: "Minimalista",
  },
  "setting-red-mood": {
    [Language.ENGLISH]: "Red Mood",
    [Language.SPANISH]: "Mood Rojo",
    [Language.PORTUGUESE]: "Mood Vermelho",
  },
  "failed-to-fetch-product-data": {
    [Language.ENGLISH]: "We couldn't get information from the selected page. You can try loading it manually or with a different link.",
    [Language.SPANISH]: "No pudimos obtener información de la página seleccionada. Puedes intentar cargarlo de manera manual o con otro link.",
    [Language.PORTUGUESE]: "Não conseguimos obter informações da página selecionada. Você pode tentar carregá-la manualmente ou com outro link.",
  },
  "failed-to-fetch-product-data-title": {
    [Language.ENGLISH]: "Couldn't load page",
    [Language.SPANISH]: "No pudimos cargar la página",
    [Language.PORTUGUESE]: "Não conseguimos carregar a página",
  },
  "your-funnel-will-be-ready-soon": {
    [Language.ENGLISH]: "Your funnel will be ready in a moment",
    [Language.SPANISH]: "En unos momentos tu embudo estará listo",
    [Language.PORTUGUESE]: "Seu funil estará pronto em instantes",
  },
  "funnel-failed": {
    [Language.ENGLISH]: "Failed",
    [Language.SPANISH]: "Falló",
    [Language.PORTUGUESE]: "Falhou",
  },
  "retry-funnel": {
    [Language.ENGLISH]: "Retry funnel",
    [Language.SPANISH]: "Reintentar embudo",
    [Language.PORTUGUESE]: "Tentar novamente",
  },
  "retrying-funnel": {
    [Language.ENGLISH]: "Retrying...",
    [Language.SPANISH]: "Reintentando...",
    [Language.PORTUGUESE]: "Tentando novamente...",
  },
  "retry-funnel-success": {
    [Language.ENGLISH]: "Retrying failed sections.",
    [Language.SPANISH]: "Reintentando las secciones que fallaron.",
    [Language.PORTUGUESE]: "Tentando novamente as seções com falha.",
  },
  "retry-funnel-error": {
    [Language.ENGLISH]: "Couldn't restart the funnel. Please try again.",
    [Language.SPANISH]: "No pudimos reintentar el embudo. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Não foi possível tentar novamente. Tente de novo.",
  },
  "brand-price-warranty": {
    [Language.ENGLISH]: "Brand, price and warranty",
    [Language.SPANISH]: "Marca, precio y garantía",
    [Language.PORTUGUESE]: "Marca, preço e garantia",
  },
  "advanced-options": {
    [Language.ENGLISH]: "Advanced options",
    [Language.SPANISH]: "Opciones avanzadas",
    [Language.PORTUGUESE]: "Opções avançadas",
  },
  "sales-country": {
    [Language.ENGLISH]: "Sales country",
    [Language.SPANISH]: "País de venta",
    [Language.PORTUGUESE]: "País de venda",
  },
  "sales-currency": {
    [Language.ENGLISH]: "Sales currency",
    [Language.SPANISH]: "Moneda de venta",
    [Language.PORTUGUESE]: "Moeda de venda",
  },
  "according-to-country": {
    [Language.ENGLISH]: "By country",
    [Language.SPANISH]: "Según país",
    [Language.PORTUGUESE]: "Segundo o país",
  },
  "confirm-product-details": {
    [Language.ENGLISH]: "Confirm your product details",
    [Language.SPANISH]: "Confirma los detalles de tu producto",
    [Language.PORTUGUESE]: "Confirme os detalhes do seu produto",
  },
  "select-template-per-funnel": {
    [Language.ENGLISH]: "Select one template for each funnel you want to create",
    [Language.SPANISH]: "Selecciona una plantilla por cada embudo que quieres crear",
    [Language.PORTUGUESE]: "Selecione um modelo para cada funil que deseja criar",
  },
  "ai-templates-label": {
    [Language.ENGLISH]: "Templates with image sections",
    [Language.SPANISH]: "Plantillas con secciones de imagen",
    [Language.PORTUGUESE]: "Modelos com seções de imagem",
  },
  "price-from-product": {
    [Language.ENGLISH]: "Price from product",
    [Language.SPANISH]: "Precio del producto",
    [Language.PORTUGUESE]: "Preço do produto",
  },
  "price-edit-in-products": {
    [Language.ENGLISH]: "To change the price, edit the product in the Products section",
    [Language.SPANISH]: "Para cambiar el precio, edita el producto en la sección de Productos",
    [Language.PORTUGUESE]: "Para alterar o preço, edite o produto na seção de Produtos",
  },
  "classic-templates-label": {
    [Language.ENGLISH]: "Classic templates (HTML)",
    [Language.SPANISH]: "Plantillas clásicas (HTML)",
    [Language.PORTUGUESE]: "Modelos clássicos (HTML)",
  },
  "use-saved-brand": {
    [Language.ENGLISH]: "Use brand",
    [Language.SPANISH]: "Utilizar marca",
    [Language.PORTUGUESE]: "Usar marca",
  },
  "video-reviews-gifs-title": {
    [Language.ENGLISH]: "Do you want to add gifs to your page?",
    [Language.SPANISH]: "¿Quieres agregar gifs a tu página?",
    [Language.PORTUGUESE]: "Quer adicionar gifs à sua página?",
  },
  "video-reviews-gifs-toggle": {
    [Language.ENGLISH]: "Add a carousel section of 4 hyper-realistic gifs to each generated page",
    [Language.SPANISH]: "Agregar sección carrusel de 4 gifs hiper realistas a cada página generada",
    [Language.PORTUGUESE]: "Adicionar uma seção carrossel de 4 gifs hiper-realistas a cada página gerada",
  },
  "short-ugc-gif": {
    [Language.ENGLISH]: "Short UGC",
    [Language.SPANISH]: "UGC corto",
    [Language.PORTUGUESE]: "UGC curto",
  },
  "per-funnel": {
    [Language.ENGLISH]: "per funnel",
    [Language.SPANISH]: "por embudo",
    [Language.PORTUGUESE]: "por funil",
  },
  "ads-page-title": {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  "product-name-example-placeholder": {
    [Language.ENGLISH]: "E.g.: Vitamin C facial serum, Compression garment...",
    [Language.SPANISH]: "Ej: Sérum facial vitamina C, Faja reductora...",
    [Language.PORTUGUESE]: "Ex: Sérum facial vitamina C, Cinta modeladora...",
  },
  "product-description-example-placeholder": {
    [Language.ENGLISH]: "Features, benefits, who it's for, and what makes it different...",
    [Language.SPANISH]: "Características, beneficios, para quién es y qué lo hace diferente...",
    [Language.PORTUGUESE]: "Características, benefícios, para quem é e o que o diferencia...",
  },
  "chat-send-failed-title": {
    [Language.ENGLISH]: "Message not sent",
    [Language.SPANISH]: "Mensaje no enviado",
    [Language.PORTUGUESE]: "Mensagem nao enviada",
  },
  "chat-send-failed-message": {
    [Language.ENGLISH]: "The confirmation message could not be sent to the customer. You can retry sending it.",
    [Language.SPANISH]: "No se pudo enviar el mensaje de confirmacion al cliente. Puedes reintentar el envio.",
    [Language.PORTUGUESE]: "Nao foi possivel enviar a mensagem de confirmacao ao cliente. Voce pode tentar reenviar.",
  },
  "chat-resend-button": {
    [Language.ENGLISH]: "Retry send",
    [Language.SPANISH]: "Reintentar envio",
    [Language.PORTUGUESE]: "Reenviar",
  },
  "chat-resend-sending": {
    [Language.ENGLISH]: "Sending...",
    [Language.SPANISH]: "Enviando...",
    [Language.PORTUGUESE]: "Enviando...",
  },
  "chat-resend-error": {
    [Language.ENGLISH]: "Could not send the message. Please check your WhatsApp account configuration.",
    [Language.SPANISH]: "No se pudo enviar el mensaje. Revisa la configuracion de tu cuenta de WhatsApp.",
    [Language.PORTUGUESE]: "Nao foi possivel enviar a mensagem. Verifique a configuracao da sua conta WhatsApp.",
  },
  "chat-manual-footer": {
    [Language.ENGLISH]: "You are responding manually",
    [Language.SPANISH]: "Estas respondiendo manualmente",
    [Language.PORTUGUESE]: "Voce esta respondendo manualmente",
  },
  "chat-manual-placeholder": {
    [Language.ENGLISH]: "Type a message...",
    [Language.SPANISH]: "Escribe un mensaje...",
    [Language.PORTUGUESE]: "Digite uma mensagem...",
  },
  "chat-window-closed-title": {
    [Language.ENGLISH]: "Cannot reach this customer with free text",
    [Language.SPANISH]: "No se puede comunicar con este cliente por texto libre",
    [Language.PORTUGUESE]: "Não é possível responder a este cliente com texto livre",
  },
  "chat-window-closed-desc": {
    [Language.ENGLISH]: "{h}h passed since the customer's last message. WhatsApp only allows approved templates outside the 24h window.",
    [Language.SPANISH]: "Pasaron {h}h desde el último mensaje del cliente. WhatsApp solo permite plantillas aprobadas fuera de la ventana de 24h.",
    [Language.PORTUGUESE]: "Passaram {h}h desde a última mensagem do cliente. WhatsApp só permite modelos aprovados fora da janela de 24h.",
  },
  "chat-window-closed-banner": {
    [Language.ENGLISH]: "More than 24h have passed without a customer reply. Send a template instead.",
    [Language.SPANISH]: "Pasaron más de 24h sin que el cliente responda. Envía una plantilla.",
    [Language.PORTUGUESE]: "Passaram mais de 24h sem resposta do cliente. Envie um modelo.",
  },
  "chat-window-send-template-cta": {
    [Language.ENGLISH]: "Send template",
    [Language.SPANISH]: "Enviar plantilla",
    [Language.PORTUGUESE]: "Enviar modelo",
  },
  "chat-window-closed-input-placeholder": {
    [Language.ENGLISH]: "Free text blocked — use a template",
    [Language.SPANISH]: "Texto libre bloqueado — usa una plantilla",
    [Language.PORTUGUESE]: "Texto livre bloqueado — use um modelo",
  },
  "chat-template-modal-title": {
    [Language.ENGLISH]: "Send template",
    [Language.SPANISH]: "Enviar plantilla",
    [Language.PORTUGUESE]: "Enviar modelo",
  },
  "chat-template-modal-desc": {
    [Language.ENGLISH]: "Pick an approved template and fill its variables. The template will be sent to this conversation.",
    [Language.SPANISH]: "Selecciona una plantilla aprobada por Meta y completa sus variables. La plantilla se enviará a esta conversación.",
    [Language.PORTUGUESE]: "Selecione um modelo aprovado pela Meta e preencha suas variáveis. O modelo será enviado a esta conversa.",
  },
  "chat-template-modal-empty": {
    [Language.ENGLISH]: "You don't have approved templates. Create one in WhatsApp → Templates.",
    [Language.SPANISH]: "No tienes plantillas aprobadas. Crea una en WhatsApp → Plantillas.",
    [Language.PORTUGUESE]: "Você não tem modelos aprovados. Crie um em WhatsApp → Modelos.",
  },
  "chat-template-modal-pick": {
    [Language.ENGLISH]: "Template",
    [Language.SPANISH]: "Plantilla",
    [Language.PORTUGUESE]: "Modelo",
  },
  "chat-template-modal-pick-placeholder": {
    [Language.ENGLISH]: "— Select a template —",
    [Language.SPANISH]: "— Selecciona una plantilla —",
    [Language.PORTUGUESE]: "— Selecione um modelo —",
  },
  "chat-template-fill-vars": {
    [Language.ENGLISH]: "Fill the variables",
    [Language.SPANISH]: "Completa las variables",
    [Language.PORTUGUESE]: "Preencha as variáveis",
  },
  "chat-template-variable-label": {
    [Language.ENGLISH]: "Variable",
    [Language.SPANISH]: "Variable",
    [Language.PORTUGUESE]: "Variável",
  },
  "chat-template-variable-singular": {
    [Language.ENGLISH]: "variable",
    [Language.SPANISH]: "variable",
    [Language.PORTUGUESE]: "variável",
  },
  "chat-template-variable-plural": {
    [Language.ENGLISH]: "variables",
    [Language.SPANISH]: "variables",
    [Language.PORTUGUESE]: "variáveis",
  },
  "chat-template-var-placeholder": {
    [Language.ENGLISH]: "Value",
    [Language.SPANISH]: "Valor",
    [Language.PORTUGUESE]: "Valor",
  },
  "chat-template-preview": {
    [Language.ENGLISH]: "Preview",
    [Language.SPANISH]: "Vista previa",
    [Language.PORTUGUESE]: "Visualização",
  },
  "chat-template-cancel": {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "chat-template-send": {
    [Language.ENGLISH]: "Send template",
    [Language.SPANISH]: "Enviar plantilla",
    [Language.PORTUGUESE]: "Enviar modelo",
  },
  "chat-template-sending": {
    [Language.ENGLISH]: "Sending...",
    [Language.SPANISH]: "Enviando...",
    [Language.PORTUGUESE]: "Enviando...",
  },
  "chat-template-sent-success": {
    [Language.ENGLISH]: "Template sent",
    [Language.SPANISH]: "Plantilla enviada",
    [Language.PORTUGUESE]: "Modelo enviado",
  },
  "chat-template-sent-error": {
    [Language.ENGLISH]: "Could not send the template",
    [Language.SPANISH]: "No se pudo enviar la plantilla",
    [Language.PORTUGUESE]: "Não foi possível enviar o modelo",
  },
  "chat-ai-input-placeholder": {
    [Language.ENGLISH]: "AI is handling responses...",
    [Language.SPANISH]: "La IA esta gestionando las respuestas...",
    [Language.PORTUGUESE]: "A IA esta gerenciando as respostas...",
  },
  "chat-disable-ai": {
    [Language.ENGLISH]: "Disable AI",
    [Language.SPANISH]: "Desactivar IA",
    [Language.PORTUGUESE]: "Desativar IA",
  },
  "chat-enable-ai": {
    [Language.ENGLISH]: "Enable AI",
    [Language.SPANISH]: "Activar IA",
    [Language.PORTUGUESE]: "Ativar IA",
  },
  "chat-toggle-disabled-reason": {
    [Language.ENGLISH]: "The customer must respond first before you can reply manually",
    [Language.SPANISH]: "El cliente debe responder primero antes de poder escribir manualmente",
    [Language.PORTUGUESE]: "O cliente deve responder primeiro antes de poder escrever manualmente",
  },
  "chat-confirm-button": {
    [Language.ENGLISH]: "Confirm",
    [Language.SPANISH]: "Confirmar",
    [Language.PORTUGUESE]: "Confirmar",
  },
  "chat-cancel-button": {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "chat-confirm-success": {
    [Language.ENGLISH]: "Order confirmed successfully",
    [Language.SPANISH]: "Pedido confirmado exitosamente",
    [Language.PORTUGUESE]: "Pedido confirmado com sucesso",
  },
  "chat-cancel-success": {
    [Language.ENGLISH]: "Order cancelled successfully",
    [Language.SPANISH]: "Pedido cancelado exitosamente",
    [Language.PORTUGUESE]: "Pedido cancelado com sucesso",
  },
  "chat-confirm-error": {
    [Language.ENGLISH]: "Error confirming order",
    [Language.SPANISH]: "Error al confirmar el pedido",
    [Language.PORTUGUESE]: "Erro ao confirmar o pedido",
  },
  "chat-cancel-error": {
    [Language.ENGLISH]: "Error cancelling order",
    [Language.SPANISH]: "Error al cancelar el pedido",
    [Language.PORTUGUESE]: "Erro ao cancelar o pedido",
  },
  "chat-cancel-confirm-dialog": {
    [Language.ENGLISH]: "Are you sure you want to cancel this order?",
    [Language.SPANISH]: "¿Estas seguro de cancelar este pedido?",
    [Language.PORTUGUESE]: "Tem certeza que deseja cancelar este pedido?",
  },
  "whatsapp-confirmation-toggle": {
    [Language.ENGLISH]: "WhatsApp confirmation",
    [Language.SPANISH]: "Confirmacion WhatsApp",
    [Language.PORTUGUESE]: "Confirmacao WhatsApp",
  },
  "whatsapp-integration-description": {
    [Language.ENGLISH]: "Automated order confirmation",
    [Language.SPANISH]: "Confirmador de ordenes automatizado",
    [Language.PORTUGUESE]: "Confirmacao automatica de pedidos",
  },
  "campaigns": {
    [Language.ENGLISH]: "Campaigns",
    [Language.SPANISH]: "Campañas",
    [Language.PORTUGUESE]: "Campanhas",
  },
  "campaigns-empty-title": {
    [Language.ENGLISH]: "No Meta account connected",
    [Language.SPANISH]: "No tienes una cuenta de Meta conectada",
    [Language.PORTUGUESE]: "Nenhuma conta Meta conectada",
  },
  "campaigns-empty-description": {
    [Language.ENGLISH]: "Connect your Meta Ads account to see your active campaigns, metrics, and performance data.",
    [Language.SPANISH]: "Conecta tu cuenta de Meta Ads para ver tus campañas activas, métricas y datos de rendimiento.",
    [Language.PORTUGUESE]: "Conecte sua conta do Meta Ads para ver suas campanhas ativas, métricas e dados de desempenho.",
  },
  "campaigns-connect-meta": {
    [Language.ENGLISH]: "Connect Meta Ads",
    [Language.SPANISH]: "Conectar Meta Ads",
    [Language.PORTUGUESE]: "Conectar Meta Ads",
  },
  "campaigns-active": {
    [Language.ENGLISH]: "Active campaigns",
    [Language.SPANISH]: "Campañas activas",
    [Language.PORTUGUESE]: "Campanhas ativas",
  },
  "campaigns-metric-reach": {
    [Language.ENGLISH]: "Reach",
    [Language.SPANISH]: "Alcance",
    [Language.PORTUGUESE]: "Alcance",
  },
  "campaigns-metric-impressions": {
    [Language.ENGLISH]: "Impressions",
    [Language.SPANISH]: "Impresiones",
    [Language.PORTUGUESE]: "Impressões",
  },
  "campaigns-metric-clicks": {
    [Language.ENGLISH]: "Link clicks",
    [Language.SPANISH]: "Clics en enlace",
    [Language.PORTUGUESE]: "Cliques no link",
  },
  "campaigns-metric-video-3s": {
    [Language.ENGLISH]: "Video views (3s)",
    [Language.SPANISH]: "Vistas de video (3s)",
    [Language.PORTUGUESE]: "Visualizações de vídeo (3s)",
  },
  "campaigns-metric-video-50": {
    [Language.ENGLISH]: "Video views (50%)",
    [Language.SPANISH]: "Vistas de video (50%)",
    [Language.PORTUGUESE]: "Visualizações de vídeo (50%)",
  },
  "campaigns-metric-frequency": {
    [Language.ENGLISH]: "Frequency",
    [Language.SPANISH]: "Frecuencia",
    [Language.PORTUGUESE]: "Frequência",
  },
  "campaigns-load-error": {
    [Language.ENGLISH]: "Error loading campaign data",
    [Language.SPANISH]: "Error al cargar datos de campañas",
    [Language.PORTUGUESE]: "Erro ao carregar dados das campanhas",
  },
  "campaigns-ad-accounts": {
    [Language.ENGLISH]: "Ad accounts",
    [Language.SPANISH]: "Cuentas publicitarias",
    [Language.PORTUGUESE]: "Contas de anúncios",
  },
  "campaigns-select-account-short": {
    [Language.ENGLISH]: "Select account",
    [Language.SPANISH]: "Seleccionar cuenta",
    [Language.PORTUGUESE]: "Selecionar conta",
  },
  "campaigns-select-account-empty": {
    [Language.ENGLISH]: "You must select an ad account to view your campaigns",
    [Language.SPANISH]: "Debes seleccionar una cuenta publicitaria para ver tus campañas",
    [Language.PORTUGUESE]: "Você deve selecionar uma conta de anúncios para ver suas campanhas",
  },
  "campaigns-showing": {
    [Language.ENGLISH]: "Showing",
    [Language.SPANISH]: "Mostrando",
    [Language.PORTUGUESE]: "Mostrando",
  },
  "campaigns-no-active": {
    [Language.ENGLISH]: "No campaigns found",
    [Language.SPANISH]: "No tienes campañas creadas en esta cuenta",
    [Language.PORTUGUESE]: "Não há campanhas criadas nesta conta",
  },
  "campaigns-no-active-description": {
    [Language.ENGLISH]: "This ad account does not have any campaigns created for the selected date range.",
    [Language.SPANISH]: "Esta cuenta publicitaria no tiene campañas creadas para el rango de fechas seleccionado.",
    [Language.PORTUGUESE]: "Esta conta de anúncios não tem campanhas criadas para o período selecionado.",
  },
  "campaigns-portfolio": {
    [Language.ENGLISH]: "Portfolio",
    [Language.SPANISH]: "Portafolio",
    [Language.PORTUGUESE]: "Portfólio",
  },
  "campaigns-col-ad-name": {
    [Language.ENGLISH]: "Ad name",
    [Language.SPANISH]: "Nombre del anuncio",
    [Language.PORTUGUESE]: "Nome do anúncio",
  },
  "campaigns-col-campaign": {
    [Language.ENGLISH]: "Campaign",
    [Language.SPANISH]: "Campaña",
    [Language.PORTUGUESE]: "Campanha",
  },
  "campaigns-col-results": {
    [Language.ENGLISH]: "Results",
    [Language.SPANISH]: "Resultados",
    [Language.PORTUGUESE]: "Resultados",
  },
  "campaigns-col-cost-result": {
    [Language.ENGLISH]: "Cost/Result",
    [Language.SPANISH]: "Costo/Resultado",
    [Language.PORTUGUESE]: "Custo/Resultado",
  },
  "campaigns-col-budget": {
    [Language.ENGLISH]: "Budget",
    [Language.SPANISH]: "Presupuesto",
    [Language.PORTUGUESE]: "Orçamento",
  },
  "campaigns-col-spend": {
    [Language.ENGLISH]: "Amount spent",
    [Language.SPANISH]: "Importe gastado",
    [Language.PORTUGUESE]: "Valor gasto",
  },
  "campaigns-col-impressions": {
    [Language.ENGLISH]: "Impressions",
    [Language.SPANISH]: "Impresiones",
    [Language.PORTUGUESE]: "Impressões",
  },
  "campaigns-col-reach": {
    [Language.ENGLISH]: "Reach",
    [Language.SPANISH]: "Alcance",
    [Language.PORTUGUESE]: "Alcance",
  },
  "campaigns-col-frequency": {
    [Language.ENGLISH]: "Frequency",
    [Language.SPANISH]: "Frecuencia",
    [Language.PORTUGUESE]: "Frequência",
  },
  "campaigns-col-purchases": {
    [Language.ENGLISH]: "Purchases",
    [Language.SPANISH]: "Compras",
    [Language.PORTUGUESE]: "Compras",
  },
  "campaigns-col-status": {
    [Language.ENGLISH]: "Status",
    [Language.SPANISH]: "Estado",
    [Language.PORTUGUESE]: "Status",
  },
  "campaigns-col-cpm": {
    [Language.ENGLISH]: "CPM",
    [Language.SPANISH]: "CPM",
    [Language.PORTUGUESE]: "CPM",
  },
  "campaigns-col-cpc": {
    [Language.ENGLISH]: "CPC",
    [Language.SPANISH]: "CPC",
    [Language.PORTUGUESE]: "CPC",
  },
  "campaigns-col-ctr": {
    [Language.ENGLISH]: "CTR",
    [Language.SPANISH]: "CTR",
    [Language.PORTUGUESE]: "CTR",
  },
  "campaigns-col-roas": {
    [Language.ENGLISH]: "ROAS",
    [Language.SPANISH]: "ROAS",
    [Language.PORTUGUESE]: "ROAS",
  },
  "campaigns-col-hook-rate": {
    [Language.ENGLISH]: "Hook Rate",
    [Language.SPANISH]: "Hook Rate",
    [Language.PORTUGUESE]: "Hook Rate",
  },
  "campaigns-col-thruplay": {
    [Language.ENGLISH]: "ThruPlay",
    [Language.SPANISH]: "ThruPlay",
    [Language.PORTUGUESE]: "ThruPlay",
  },
  "campaigns-col-ad": {
    [Language.ENGLISH]: "Ad",
    [Language.SPANISH]: "Ad",
    [Language.PORTUGUESE]: "Ad",
  },
  "campaigns-col-platform": {
    [Language.ENGLISH]: "Platform",
    [Language.SPANISH]: "Plataforma",
    [Language.PORTUGUESE]: "Plataforma",
  },
  "campaigns-col-funnel": {
    [Language.ENGLISH]: "Funnel",
    [Language.SPANISH]: "Embudo",
    [Language.PORTUGUESE]: "Funil",
  },
  "campaigns-col-cpa": {
    [Language.ENGLISH]: "CPA",
    [Language.SPANISH]: "CPA",
    [Language.PORTUGUESE]: "CPA",
  },
  "campaigns-col-detail": {
    [Language.ENGLISH]: "Detail",
    [Language.SPANISH]: "Detalle",
    [Language.PORTUGUESE]: "Detalhe",
  },
  "common-view": {
    [Language.ENGLISH]: "View",
    [Language.SPANISH]: "Ver",
    [Language.PORTUGUESE]: "Ver",
  },
  "common-back": {
    [Language.ENGLISH]: "Back",
    [Language.SPANISH]: "Volver",
    [Language.PORTUGUESE]: "Voltar",
  },
  "common-close": {
    [Language.ENGLISH]: "Close",
    [Language.SPANISH]: "Cerrar",
    [Language.PORTUGUESE]: "Fechar",
  },
  "common-unknown": {
    [Language.ENGLISH]: "Unknown",
    [Language.SPANISH]: "Desconocido",
    [Language.PORTUGUESE]: "Desconhecido",
  },
  "ad-detail-campaign": {
    [Language.ENGLISH]: "Campaign",
    [Language.SPANISH]: "Campaña",
    [Language.PORTUGUESE]: "Campanha",
  },
  "ad-detail-tab-metrics": {
    [Language.ENGLISH]: "Metrics",
    [Language.SPANISH]: "Métricas",
    [Language.PORTUGUESE]: "Métricas",
  },
  "ad-detail-tab-analyses": {
    [Language.ENGLISH]: "Analyses",
    [Language.SPANISH]: "Análisis",
    [Language.PORTUGUESE]: "Análises",
  },
  "analysis-new": {
    [Language.ENGLISH]: "New analysis",
    [Language.SPANISH]: "Nuevo análisis",
    [Language.PORTUGUESE]: "Nova análise",
  },
  "analysis-cost": {
    [Language.ENGLISH]: "Cost",
    [Language.SPANISH]: "Costo",
    [Language.PORTUGUESE]: "Custo",
  },
  "analysis-created": {
    [Language.ENGLISH]: "Analysis generated",
    [Language.SPANISH]: "Análisis generado",
    [Language.PORTUGUESE]: "Análise gerada",
  },
  "analysis-create-error": {
    [Language.ENGLISH]: "Could not generate the analysis. Try again.",
    [Language.SPANISH]: "No se pudo generar el análisis. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Não foi possível gerar a análise. Tente novamente.",
  },
  "analysis-insufficient-credits": {
    [Language.ENGLISH]: "You don't have enough credits (10 required).",
    [Language.SPANISH]: "No tienes créditos suficientes (se requieren 10).",
    [Language.PORTUGUESE]: "Você não tem créditos suficientes (são necessários 10).",
  },
  "analysis-empty-title": {
    [Language.ENGLISH]: "No analyses yet",
    [Language.SPANISH]: "Aún no hay análisis",
    [Language.PORTUGUESE]: "Ainda não há análises",
  },
  "analysis-empty-description": {
    [Language.ENGLISH]: "Generate the first AI analysis for this ad.",
    [Language.SPANISH]: "Genera el primer análisis con IA para este anuncio.",
    [Language.PORTUGUESE]: "Gere a primeira análise com IA para este anúncio.",
  },
  "analysis-create-first": {
    [Language.ENGLISH]: "Create first analysis",
    [Language.SPANISH]: "Crear primer análisis",
    [Language.PORTUGUESE]: "Criar primeira análise",
  },
  "analysis-loading-title": {
    [Language.ENGLISH]: "Analyzing ad...",
    [Language.SPANISH]: "Analizando anuncio...",
    [Language.PORTUGUESE]: "Analisando anúncio...",
  },
  "analysis-step-1": {
    [Language.ENGLISH]: "Connecting to the platform",
    [Language.SPANISH]: "Conectando con la plataforma",
    [Language.PORTUGUESE]: "Conectando com a plataforma",
  },
  "analysis-step-2": {
    [Language.ENGLISH]: "Extracting metrics",
    [Language.SPANISH]: "Extrayendo métricas",
    [Language.PORTUGUESE]: "Extraindo métricas",
  },
  "analysis-step-3": {
    [Language.ENGLISH]: "Analyzing funnel performance",
    [Language.SPANISH]: "Analizando rendimiento del embudo",
    [Language.PORTUGUESE]: "Analisando desempenho do funil",
  },
  "analysis-step-4": {
    [Language.ENGLISH]: "Evaluating creative and audience",
    [Language.SPANISH]: "Evaluando creativos y audiencia",
    [Language.PORTUGUESE]: "Avaliando criativos e audiência",
  },
  "analysis-step-5": {
    [Language.ENGLISH]: "Generating diagnosis",
    [Language.SPANISH]: "Generando diagnóstico",
    [Language.PORTUGUESE]: "Gerando diagnóstico",
  },
  "analysis-step-6": {
    [Language.ENGLISH]: "Preparing recommendations",
    [Language.SPANISH]: "Preparando recomendaciones",
    [Language.PORTUGUESE]: "Preparando recomendações",
  },
  "analysis-reference": {
    [Language.ENGLISH]: "Reference",
    [Language.SPANISH]: "Referencia",
    [Language.PORTUGUESE]: "Referência",
  },
  "analysis-diagnosis-positive": {
    [Language.ENGLISH]: "Positive diagnosis",
    [Language.SPANISH]: "Diagnóstico positivo",
    [Language.PORTUGUESE]: "Diagnóstico positivo",
  },
  "analysis-diagnosis-attention": {
    [Language.ENGLISH]: "Attention required",
    [Language.SPANISH]: "Atención requerida",
    [Language.PORTUGUESE]: "Atenção necessária",
  },
  "analysis-diagnosis-critical": {
    [Language.ENGLISH]: "Critical diagnosis",
    [Language.SPANISH]: "Diagnóstico crítico",
    [Language.PORTUGUESE]: "Diagnóstico crítico",
  },
  "analysis-action-plan": {
    [Language.ENGLISH]: "Recommended action plan",
    [Language.SPANISH]: "Plan de acción recomendado",
    [Language.PORTUGUESE]: "Plano de ação recomendado",
  },
  "analysis-winning-assets": {
    [Language.ENGLISH]: "What's working (DON'T TOUCH!)",
    [Language.SPANISH]: "Lo que funciona (¡NO TOCAR!)",
    [Language.PORTUGUESE]: "O que funciona (NÃO MEXER!)",
  },
  "analysis-secondary-optimizations": {
    [Language.ENGLISH]: "Secondary optimizations",
    [Language.SPANISH]: "Optimizaciones secundarias",
    [Language.PORTUGUESE]: "Otimizações secundárias",
  },
  "analysis-infra-error": {
    [Language.ENGLISH]: "Couldn't generate the analysis. Try again in a moment.",
    [Language.SPANISH]: "No pudimos generar el análisis. Intenta nuevamente en unos momentos.",
    [Language.PORTUGUESE]: "Não conseguimos gerar a análise. Tente novamente em alguns instantes.",
  },
  "campaigns-col-status-ai": {
    [Language.ENGLISH]: "AI diagnosis",
    [Language.SPANISH]: "Diagnóstico IA",
    [Language.PORTUGUESE]: "Diagnóstico IA",
  },
  "campaigns-show-paused": {
    [Language.ENGLISH]: "Show inactive",
    [Language.SPANISH]: "Mostrar inactivos",
    [Language.PORTUGUESE]: "Mostrar inativos",
  },
  "campaigns-paused-hidden": {
    [Language.ENGLISH]: "inactive hidden",
    [Language.SPANISH]: "inactivos ocultos",
    [Language.PORTUGUESE]: "inativos ocultos",
  },
  "campaigns-inactive-included": {
    [Language.ENGLISH]: "inactive included",
    [Language.SPANISH]: "inactivos incluidos",
    [Language.PORTUGUESE]: "inativos incluídos",
  },
  "campaigns-ads-count": {
    [Language.ENGLISH]: "ads",
    [Language.SPANISH]: "anuncios",
    [Language.PORTUGUESE]: "anúncios",
  },
  "campaigns-subtab-overview": {
    [Language.ENGLISH]: "Overview",
    [Language.SPANISH]: "Vista general",
    [Language.PORTUGUESE]: "Visão geral",
  },
  "campaigns-subtab-performance": {
    [Language.ENGLISH]: "Creative performance",
    [Language.SPANISH]: "Performance de creativos",
    [Language.PORTUGUESE]: "Performance de criativos",
  },
  "performance-dashboard-title": {
    [Language.ENGLISH]: "Performance by product",
    [Language.SPANISH]: "Performance por producto",
    [Language.PORTUGUESE]: "Performance por produto",
  },
  "performance-dashboard-subtitle": {
    [Language.ENGLISH]: "Pick a product to see how its ads are performing and which creatives are winning in its niche.",
    [Language.SPANISH]: "Elegí un producto para ver cómo performan sus anuncios y qué creativos están ganando en su nicho.",
    [Language.PORTUGUESE]: "Escolha um produto para ver como seus anúncios performam e quais criativos estão ganhando no nicho.",
  },
  "performance-search-placeholder": {
    [Language.ENGLISH]: "Search products…",
    [Language.SPANISH]: "Buscar productos…",
    [Language.PORTUGUESE]: "Buscar produtos…",
  },
  "performance-with-ads": {
    [Language.ENGLISH]: "With ads",
    [Language.SPANISH]: "Con anuncios",
    [Language.PORTUGUESE]: "Com anúncios",
  },
  "performance-without-ads": {
    [Language.ENGLISH]: "No ads yet",
    [Language.SPANISH]: "Sin anuncios todavía",
    [Language.PORTUGUESE]: "Sem anúncios ainda",
  },
  "performance-unassigned-title": {
    [Language.ENGLISH]: "Unassigned",
    [Language.SPANISH]: "Sin asignar",
    [Language.PORTUGUESE]: "Sem atribuir",
  },
  "performance-unassigned-subtext": {
    [Language.ENGLISH]: "Ads without a matching product",
    [Language.SPANISH]: "Anuncios sin producto que coincida",
    [Language.PORTUGUESE]: "Anúncios sem produto correspondente",
  },
  "performance-banner-title": {
    [Language.ENGLISH]: "{N} ads without a product assigned",
    [Language.SPANISH]: "{N} anuncios sin producto asignado",
    [Language.PORTUGUESE]: "{N} anúncios sem produto atribuído",
  },
  "performance-banner-subtext": {
    [Language.ENGLISH]: "Assign them so we can group their performance and surface competitors of their niche.",
    [Language.SPANISH]: "Asignalos para poder agrupar su performance y mostrarte competidores de su nicho.",
    [Language.PORTUGUESE]: "Atribua-os para podermos agrupar a performance e mostrar concorrentes do nicho.",
  },
  "performance-banner-cta": {
    [Language.ENGLISH]: "Assign {N} ads",
    [Language.SPANISH]: "Asignar {N} anuncios",
    [Language.PORTUGUESE]: "Atribuir {N} anúncios",
  },
  "performance-ads-count": {
    [Language.ENGLISH]: "ads",
    [Language.SPANISH]: "ads",
    [Language.PORTUGUESE]: "ads",
  },
  "performance-your-creatives": {
    [Language.ENGLISH]: "Your creatives",
    [Language.SPANISH]: "Tus creativos",
    [Language.PORTUGUESE]: "Seus criativos",
  },
  "performance-sort-by": {
    [Language.ENGLISH]: "Sort by",
    [Language.SPANISH]: "Ordenar por",
    [Language.PORTUGUESE]: "Ordenar por",
  },
  "performance-metric-hook-rate": {
    [Language.ENGLISH]: "Hook rate",
    [Language.SPANISH]: "Hook rate",
    [Language.PORTUGUESE]: "Hook rate",
  },
  "performance-metric-ctr": {
    [Language.ENGLISH]: "CTR",
    [Language.SPANISH]: "CTR",
    [Language.PORTUGUESE]: "CTR",
  },
  "performance-metric-cpa": {
    [Language.ENGLISH]: "CPA",
    [Language.SPANISH]: "CPA",
    [Language.PORTUGUESE]: "CPA",
  },
  "performance-metric-spend": {
    [Language.ENGLISH]: "Spend",
    [Language.SPANISH]: "Gasto",
    [Language.PORTUGUESE]: "Gasto",
  },
  "performance-metric-roas": {
    [Language.ENGLISH]: "ROAS",
    [Language.SPANISH]: "ROAS",
    [Language.PORTUGUESE]: "ROAS",
  },
  "performance-format-video": {
    [Language.ENGLISH]: "Video",
    [Language.SPANISH]: "Video",
    [Language.PORTUGUESE]: "Vídeo",
  },
  "performance-format-image": {
    [Language.ENGLISH]: "Image",
    [Language.SPANISH]: "Imagen",
    [Language.PORTUGUESE]: "Imagem",
  },
  "performance-competitors-title": {
    [Language.ENGLISH]: "Niche winners",
    [Language.SPANISH]: "Ganadores de tu nicho",
    [Language.PORTUGUESE]: "Ganhadores do nicho",
  },
  "performance-competitors-pill": {
    [Language.ENGLISH]: "Spy · 48h",
    [Language.SPANISH]: "Espionaje · 48h",
    [Language.PORTUGUESE]: "Espionagem · 48h",
  },
  "performance-competitors-empty": {
    [Language.ENGLISH]: "Save brands in Ad spy to see competitors here.",
    [Language.SPANISH]: "Guardá brands en el espía de anuncios para ver competidores acá.",
    [Language.PORTUGUESE]: "Salve marcas no espião para ver concorrentes aqui.",
  },
  "performance-cta-create": {
    [Language.ENGLISH]: "Create with my product",
    [Language.SPANISH]: "Crear con mi producto",
    [Language.PORTUGUESE]: "Criar com meu produto",
  },
  "performance-back-to-products": {
    [Language.ENGLISH]: "Products",
    [Language.SPANISH]: "Productos",
    [Language.PORTUGUESE]: "Produtos",
  },
  "performance-empty-no-products-title": {
    [Language.ENGLISH]: "You don't have any products yet",
    [Language.SPANISH]: "Todavía no tenés productos",
    [Language.PORTUGUESE]: "Você ainda não tem produtos",
  },
  "performance-empty-no-products-subtext": {
    [Language.ENGLISH]: "Create a product from the Products section to start tracking your ads' performance.",
    [Language.SPANISH]: "Creá un producto desde la sección Productos para empezar a ver la performance de tus anuncios.",
    [Language.PORTUGUESE]: "Crie um produto na seção Produtos para começar a acompanhar a performance dos anúncios.",
  },
  "performance-empty-no-ads-title": {
    [Language.ENGLISH]: "This product has no ads yet",
    [Language.SPANISH]: "Este producto todavía no tiene anuncios",
    [Language.PORTUGUESE]: "Este produto ainda não tem anúncios",
  },
  "assign-modal-title": {
    [Language.ENGLISH]: "Assign ads to a product",
    [Language.SPANISH]: "Asignar anuncios a un producto",
    [Language.PORTUGUESE]: "Atribuir anúncios a um produto",
  },
  "assign-modal-subtitle": {
    [Language.ENGLISH]: "Review each unassigned ad and pick the product it belongs to.",
    [Language.SPANISH]: "Revisá cada anuncio sin asignar y elegí el producto al que pertenece.",
    [Language.PORTUGUESE]: "Revise cada anúncio sem atribuir e escolha o produto ao qual pertence.",
  },
  "assign-modal-question": {
    [Language.ENGLISH]: "Which product does this ad belong to?",
    [Language.SPANISH]: "¿A qué producto pertenece este anuncio?",
    [Language.PORTUGUESE]: "A qual produto este anúncio pertence?",
  },
  "assign-modal-skip": {
    [Language.ENGLISH]: "Skip",
    [Language.SPANISH]: "Saltar",
    [Language.PORTUGUESE]: "Pular",
  },
  "assign-modal-finish": {
    [Language.ENGLISH]: "Finish",
    [Language.SPANISH]: "Terminar",
    [Language.PORTUGUESE]: "Terminar",
  },
  "assign-modal-save-error": {
    [Language.ENGLISH]: "Could not save the assignment. Try again.",
    [Language.SPANISH]: "No pudimos guardar la asignación. Intentá de nuevo.",
    [Language.PORTUGUESE]: "Não foi possível salvar a atribuição. Tente novamente.",
  },
  "assign-modal-empty-picker": {
    [Language.ENGLISH]: "No products match your search.",
    [Language.SPANISH]: "Ningún producto coincide con tu búsqueda.",
    [Language.PORTUGUESE]: "Nenhum produto corresponde à busca.",
  },
  "assign-modal-all-done": {
    [Language.ENGLISH]: "All ads assigned",
    [Language.SPANISH]: "Todos los anuncios asignados",
    [Language.PORTUGUESE]: "Todos os anúncios atribuídos",
  },
  "semaforo-optimal": {
    [Language.ENGLISH]: "Optimal",
    [Language.SPANISH]: "Óptimo",
    [Language.PORTUGUESE]: "Ótimo",
  },
  "semaforo-risk": {
    [Language.ENGLISH]: "At risk",
    [Language.SPANISH]: "En riesgo",
    [Language.PORTUGUESE]: "Em risco",
  },
  "semaforo-critical": {
    [Language.ENGLISH]: "Critical",
    [Language.SPANISH]: "Crítico",
    [Language.PORTUGUESE]: "Crítico",
  },
  "meta-connect-title": {
    [Language.ENGLISH]: "Connect Meta Ads",
    [Language.SPANISH]: "Conectar Meta Ads",
    [Language.PORTUGUESE]: "Conectar Meta Ads",
  },
  "meta-connect-description": {
    [Language.ENGLISH]: "Connect your Meta Ads account to view your campaign metrics and performance directly in Fluxi.",
    [Language.SPANISH]: "Conecta tu cuenta de Meta Ads para ver las métricas y el rendimiento de tus campañas directamente en Fluxi.",
    [Language.PORTUGUESE]: "Conecte sua conta do Meta Ads para visualizar as métricas e o desempenho das suas campanhas diretamente no Fluxi.",
  },
  "meta-connect-button": {
    [Language.ENGLISH]: "Connect with Meta",
    [Language.SPANISH]: "Conectar con Meta",
    [Language.PORTUGUESE]: "Conectar com Meta",
  },
  "meta-connect-error": {
    [Language.ENGLISH]: "Error connecting Meta Ads account",
    [Language.SPANISH]: "Error al conectar la cuenta de Meta Ads",
    [Language.PORTUGUESE]: "Erro ao conectar a conta do Meta Ads",
  },
  // ── Phase 2: Video draft preview-then-commit flow ──
  "video-preview-loading-title": {
    [Language.ENGLISH]: "Planning the details of your video",
    [Language.SPANISH]: "Planeando los detalles de tu video",
    [Language.PORTUGUESE]: "Planejando os detalhes do seu vídeo",
  },
  "video-preview-loading-subtitle": {
    [Language.ENGLISH]: "The creative director is choosing the best concept for your product. This usually takes 20 to 60 seconds.",
    [Language.SPANISH]: "El director creativo está eligiendo el mejor concepto para tu producto. Esto suele tardar entre 20 y 60 segundos.",
    [Language.PORTUGUESE]: "O diretor criativo está escolhendo o melhor conceito para seu produto. Isso normalmente leva de 20 a 60 segundos.",
  },
  "video-preview-error-title": {
    [Language.ENGLISH]: "We couldn't create the preview",
    [Language.SPANISH]: "No pudimos crear el preview",
    [Language.PORTUGUESE]: "Não foi possível criar o preview",
  },
  "video-preview-error-subtitle": {
    [Language.ENGLISH]: "Something failed while creating the preview. You were not charged.",
    [Language.SPANISH]: "Algo falló creando el preview. No te cobramos nada.",
    [Language.PORTUGUESE]: "Algo falhou ao criar o preview. Nada foi cobrado.",
  },
  "video-preview-back-to-studio": {
    [Language.ENGLISH]: "Back to studio",
    [Language.SPANISH]: "Volver al estudio",
    [Language.PORTUGUESE]: "Voltar ao estúdio",
  },
  "video-preview-approved-title": {
    [Language.ENGLISH]: "Approved!",
    [Language.SPANISH]: "¡Aprobado!",
    [Language.PORTUGUESE]: "Aprovado!",
  },
  "video-preview-approved-subtitle": {
    [Language.ENGLISH]: "Your video is being rendered. We'll let you know when it's ready.",
    [Language.SPANISH]: "Tu video se está renderizando. Te avisamos cuando esté listo.",
    [Language.PORTUGUESE]: "Seu vídeo está sendo renderizado. Vamos te avisar quando estiver pronto.",
  },
  "video-preview-rejected-title": {
    [Language.ENGLISH]: "Cancelled",
    [Language.SPANISH]: "Cancelado",
    [Language.PORTUGUESE]: "Cancelado",
  },
  "video-preview-rejected-subtitle": {
    [Language.ENGLISH]: "The preview was discarded. No video was created.",
    [Language.SPANISH]: "El preview fue descartado. No se creó ningún video.",
    [Language.PORTUGUESE]: "O preview foi descartado. Nenhum vídeo foi criado.",
  },
  "video-preview-back": {
    [Language.ENGLISH]: "Back",
    [Language.SPANISH]: "Volver",
    [Language.PORTUGUESE]: "Voltar",
  },
  "video-preview-title": {
    [Language.ENGLISH]: "Your preview is ready",
    [Language.SPANISH]: "Tu preview está listo",
    [Language.PORTUGUESE]: "Seu preview está pronto",
  },
  "video-preview-style-label": {
    [Language.ENGLISH]: "Creative style",
    [Language.SPANISH]: "Estilo creativo",
    [Language.PORTUGUESE]: "Estilo criativo",
  },
  "video-preview-opening-label": {
    [Language.ENGLISH]: "How your video starts",
    [Language.SPANISH]: "Cómo empieza tu video",
    [Language.PORTUGUESE]: "Como começa seu vídeo",
  },
  "video-preview-script-label": {
    [Language.ENGLISH]: "Full script",
    [Language.SPANISH]: "Guion completo",
    [Language.PORTUGUESE]: "Roteiro completo",
  },
  "video-preview-product-mentioned": {
    [Language.ENGLISH]: "Includes the product name",
    [Language.SPANISH]: "Incluye el nombre del producto",
    [Language.PORTUGUESE]: "Inclui o nome do produto",
  },
  "video-preview-approve": {
    [Language.ENGLISH]: "Create my video",
    [Language.SPANISH]: "Crear mi video",
    [Language.PORTUGUESE]: "Criar meu vídeo",
  },
  "video-preview-approving": {
    [Language.ENGLISH]: "Creating...",
    [Language.SPANISH]: "Creando...",
    [Language.PORTUGUESE]: "Criando...",
  },
  "video-preview-reject": {
    [Language.ENGLISH]: "Discard",
    [Language.SPANISH]: "Descartar",
    [Language.PORTUGUESE]: "Descartar",
  },
  "video-preview-rejecting": {
    [Language.ENGLISH]: "Cancelling...",
    [Language.SPANISH]: "Cancelando...",
    [Language.PORTUGUESE]: "Cancelando...",
  },
  "video-render-title": {
    [Language.ENGLISH]: "We're creating your video",
    [Language.SPANISH]: "Estamos creando tu video",
    [Language.PORTUGUESE]: "Estamos criando seu vídeo",
  },
  "video-render-warming": {
    [Language.ENGLISH]: "Setting up your scene",
    [Language.SPANISH]: "Preparando tu escena",
    [Language.PORTUGUESE]: "Preparando sua cena",
  },
  "video-render-progress": {
    [Language.ENGLISH]: "Almost there",
    [Language.SPANISH]: "Casi listo",
    [Language.PORTUGUESE]: "Quase lá",
  },
  "video-render-done-title": {
    [Language.ENGLISH]: "Your video is ready",
    [Language.SPANISH]: "Tu video está listo",
    [Language.PORTUGUESE]: "Seu vídeo está pronto",
  },
  "video-render-done-action": {
    [Language.ENGLISH]: "Done",
    [Language.SPANISH]: "Listo",
    [Language.PORTUGUESE]: "Pronto",
  },
  "video-preview-edit-script": {
    [Language.ENGLISH]: "Edit",
    [Language.SPANISH]: "Editar",
    [Language.PORTUGUESE]: "Editar",
  },
  "video-preview-edit-cancel": {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "video-preview-edit-save": {
    [Language.ENGLISH]: "Save",
    [Language.SPANISH]: "Guardar",
    [Language.PORTUGUESE]: "Salvar",
  },
  "video-preview-edit-saving": {
    [Language.ENGLISH]: "Saving...",
    [Language.SPANISH]: "Guardando...",
    [Language.PORTUGUESE]: "Salvando...",
  },
  "video-preview-words": {
    [Language.ENGLISH]: "words",
    [Language.SPANISH]: "palabras",
    [Language.PORTUGUESE]: "palavras",
  },
  "video-preview-script-placeholder": {
    [Language.ENGLISH]: "Write the full script of the video...",
    [Language.SPANISH]: "Escribe el guión completo del video...",
    [Language.PORTUGUESE]: "Escreva o roteiro completo do vídeo...",
  },
  // ── Phase 5.4 polish: neutral LATAM Spanish, all centralized ──
  "video-preview-style-section": {
    [Language.ENGLISH]: "Personality",
    [Language.SPANISH]: "Personalidad",
    [Language.PORTUGUESE]: "Personalidade",
  },
  "video-preview-script-section": {
    [Language.ENGLISH]: "Video script",
    [Language.SPANISH]: "Guión del video",
    [Language.PORTUGUESE]: "Roteiro do vídeo",
  },
  "video-preview-silent-label": {
    [Language.ENGLISH]: "Silent video",
    [Language.SPANISH]: "Video silencioso",
    [Language.PORTUGUESE]: "Vídeo silencioso",
  },
  "video-preview-silent-copy": {
    [Language.ENGLISH]: "The person shows the product with natural expressions — no voice.",
    [Language.SPANISH]: "La persona muestra el producto con expresiones naturales — sin voz.",
    [Language.PORTUGUESE]: "A pessoa mostra o produto com expressões naturais — sem voz.",
  },
  "video-preview-voice-ready-label": {
    [Language.ENGLISH]: "Voice-over",
    [Language.SPANISH]: "Voz en off",
    [Language.PORTUGUESE]: "Locução",
  },
  "video-preview-voice-pick-label": {
    [Language.ENGLISH]: "Pick a voice",
    [Language.SPANISH]: "Elige la voz",
    [Language.PORTUGUESE]: "Escolha a voz",
  },
  "video-preview-voice-generating": {
    [Language.ENGLISH]: "Generating voice...",
    [Language.SPANISH]: "Generando voz...",
    [Language.PORTUGUESE]: "Gerando voz...",
  },
  "video-preview-voice-generate": {
    [Language.ENGLISH]: "Generate voice",
    [Language.SPANISH]: "Generar voz",
    [Language.PORTUGUESE]: "Gerar voz",
  },
  "video-preview-voice-regen": {
    [Language.ENGLISH]: "Generate with this voice",
    [Language.SPANISH]: "Generar con esta voz",
    [Language.PORTUGUESE]: "Gerar com esta voz",
  },
  "video-preview-voice-hint": {
    [Language.ENGLISH]: "Try voices before approving. Switching voices is free — credits are only charged when you create the final video.",
    [Language.SPANISH]: "Prueba las voces antes de aprobar. Cambiar de voz es gratis — solo se cobran los créditos al crear el video final.",
    [Language.PORTUGUESE]: "Experimente vozes antes de aprovar. Trocar de voz é grátis — os créditos são cobrados apenas ao criar o vídeo final.",
  },
  "video-voice-library-aria": {
    [Language.ENGLISH]: "Pick the video voice",
    [Language.SPANISH]: "Elige la voz del video",
    [Language.PORTUGUESE]: "Escolha a voz do vídeo",
  },
  "video-voice-library-error": {
    [Language.ENGLISH]: "Could not load voices. Please retry.",
    [Language.SPANISH]: "No pudimos cargar las voces. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Não foi possível carregar as vozes. Tente novamente.",
  },
  "video-voice-library-retry": {
    [Language.ENGLISH]: "Retry",
    [Language.SPANISH]: "Reintentar",
    [Language.PORTUGUESE]: "Tentar de novo",
  },
  "video-voice-preview-aria": {
    [Language.ENGLISH]: "Play voice sample",
    [Language.SPANISH]: "Escuchar muestra de voz",
    [Language.PORTUGUESE]: "Ouvir amostra de voz",
  },
  "video-voice-upload-own": {
    [Language.ENGLISH]: "Upload my own voice",
    [Language.SPANISH]: "Subir mi propia voz",
    [Language.PORTUGUESE]: "Enviar minha própria voz",
  },
  "video-voice-upload-hint": {
    [Language.ENGLISH]: "We clone your voice with ElevenLabs · coming soon",
    [Language.SPANISH]: "Clonamos tu voz con ElevenLabs · próximamente",
    [Language.PORTUGUESE]: "Clonamos sua voz com ElevenLabs · em breve",
  },
  "video-voice-upload-coming-soon": {
    [Language.ENGLISH]: "Coming soon",
    [Language.SPANISH]: "Próximamente",
    [Language.PORTUGUESE]: "Em breve",
  },
  "video-audio-hero-title": {
    [Language.ENGLISH]: "How does your video sound?",
    [Language.SPANISH]: "¿Cómo suena tu video?",
    [Language.PORTUGUESE]: "Como soa o seu vídeo?",
  },
  "video-audio-hero-subtitle": {
    [Language.ENGLISH]: "Pick the voice in the next step",
    [Language.SPANISH]: "Elige voz en el próximo paso",
    [Language.PORTUGUESE]: "Escolha a voz no próximo passo",
  },
  "video-audio-mode-tts": {
    [Language.ENGLISH]: "AI voice",
    [Language.SPANISH]: "Voz con IA",
    [Language.PORTUGUESE]: "Voz com IA",
  },
  "video-audio-mode-upload": {
    [Language.ENGLISH]: "My audio",
    [Language.SPANISH]: "Mi audio",
    [Language.PORTUGUESE]: "Meu áudio",
  },
  "video-audio-mode-none": {
    [Language.ENGLISH]: "No voice",
    [Language.SPANISH]: "Sin voz",
    [Language.PORTUGUESE]: "Sem voz",
  },
  // Phase 2 V3 — three-mode audio switch (replaces tts / upload / none
  // binary toggle). Professional is the recommended default (ElevenLabs
  // colombian voices); own = user-uploaded; fast = Kling inline audio.
  "video-audio-mode-professional": {
    [Language.ENGLISH]: "Pro voice",
    [Language.SPANISH]: "Voz profesional",
    [Language.PORTUGUESE]: "Voz profissional",
  },
  "video-audio-mode-professional-hint": {
    [Language.ENGLISH]: "8 Colombian voices + sliders",
    [Language.SPANISH]: "8 voces colombianas + ajustes",
    [Language.PORTUGUESE]: "8 vozes colombianas + ajustes",
  },
  "video-audio-mode-professional-desc": {
    [Language.ENGLISH]: "Pick a Colombian voice in the preview and tweak speed and emotion. Recommended.",
    [Language.SPANISH]: "Elige una voz colombiana en el preview y ajusta velocidad y emoción. Recomendado.",
    [Language.PORTUGUESE]: "Escolha uma voz colombiana no preview e ajuste velocidade e emoção. Recomendado.",
  },
  "video-audio-mode-own": {
    [Language.ENGLISH]: "My voice",
    [Language.SPANISH]: "Mi voz",
    [Language.PORTUGUESE]: "Minha voz",
  },
  "video-audio-mode-own-hint": {
    [Language.ENGLISH]: "Upload your own recording",
    [Language.SPANISH]: "Sube tu propia grabación",
    [Language.PORTUGUESE]: "Envie sua própria gravação",
  },
  "video-audio-mode-own-desc": {
    [Language.ENGLISH]: "Upload an MP3 with your voice (max 15s). We'll sync it with the video.",
    [Language.SPANISH]: "Sube un MP3 con tu voz (máx 15s). Nosotros lo sincronizamos con el video.",
    [Language.PORTUGUESE]: "Envie um MP3 com sua voz (máx 15s). Nós sincronizamos com o vídeo.",
  },
  "video-audio-mode-fast": {
    [Language.ENGLISH]: "Fast voice",
    [Language.SPANISH]: "Voz rápida",
    [Language.PORTUGUESE]: "Voz rápida",
  },
  "video-audio-mode-fast-hint": {
    [Language.ENGLISH]: "Generated alongside the video",
    [Language.SPANISH]: "Generada al vuelo con el video",
    [Language.PORTUGUESE]: "Gerada junto com o vídeo",
  },
  "video-audio-mode-fast-desc": {
    [Language.ENGLISH]: "Faster: the video and voice are generated in one pass. Less control over the voice.",
    [Language.SPANISH]: "Más rápido: el video y la voz se generan en una sola pasada. Menos control sobre la voz.",
    [Language.PORTUGUESE]: "Mais rápido: o vídeo e a voz são gerados em uma só passada. Menos controle sobre a voz.",
  },
  "video-preview-fast-audio-label": {
    [Language.ENGLISH]: "Fast voice (generated with the video)",
    [Language.SPANISH]: "Voz rápida (generada con el video)",
    [Language.PORTUGUESE]: "Voz rápida (gerada com o vídeo)",
  },
  "video-preview-fast-audio-desc": {
    [Language.ENGLISH]: "No voice to pick: the video and voice are generated together in one pass. Faster, but the voice may vary between videos.",
    [Language.SPANISH]: "No hay voces que elegir: el video y la voz se generan juntos en una sola pasada. Más rápido, pero la voz puede variar entre videos.",
    [Language.PORTUGUESE]: "Não há vozes para escolher: o vídeo e a voz são gerados juntos em uma só passada. Mais rápido, mas a voz pode variar entre vídeos.",
  },
  "video-preview-own-voice-label": {
    [Language.ENGLISH]: "Your voice",
    [Language.SPANISH]: "Tu voz",
    [Language.PORTUGUESE]: "Sua voz",
  },
  "video-preview-own-voice-ready": {
    [Language.ENGLISH]: "We'll sync your audio with the video automatically when you approve.",
    [Language.SPANISH]: "Vamos a sincronizar tu audio con el video automáticamente cuando apruebes.",
    [Language.PORTUGUESE]: "Vamos sincronizar seu áudio com o vídeo automaticamente quando você aprovar.",
  },
  "video-preview-own-voice-missing": {
    [Language.ENGLISH]: "We couldn't find your audio. Go back to the studio and upload it before creating the video.",
    [Language.SPANISH]: "No encontramos tu audio. Vuelve al estudio y súbelo antes de crear el video.",
    [Language.PORTUGUESE]: "Não encontramos seu áudio. Volte ao estúdio e envie antes de criar o vídeo.",
  },
  "video-audio-upload-hint": {
    [Language.ENGLISH]: "You'll upload your audio (MP3 / WAV) in the preview",
    [Language.SPANISH]: "Podrás subir tu audio (MP3 / WAV) en el preview",
    [Language.PORTUGUESE]: "Você poderá enviar seu áudio (MP3 / WAV) no preview",
  },
  "video-style-modeling-silent": {
    [Language.ENGLISH]: "Modeling (silent)",
    [Language.SPANISH]: "Modelando (silencioso)",
    [Language.PORTUGUESE]: "Modelando (silencioso)",
  },
  "avatar-wizard-title": {
    [Language.ENGLISH]: "Who's in your video?",
    [Language.SPANISH]: "¿Quién protagoniza tu video?",
    [Language.PORTUGUESE]: "Quem protagoniza seu vídeo?",
  },
  "avatar-wizard-subtitle": {
    [Language.ENGLISH]: "Pick the person who'll present your product",
    [Language.SPANISH]: "Elige a la persona que va a mostrar tu producto",
    [Language.PORTUGUESE]: "Escolha a pessoa que vai apresentar seu produto",
  },
  "avatar-wizard-preset-title": {
    [Language.ENGLISH]: "Pick a Fluxi avatar",
    [Language.SPANISH]: "Elige un avatar de Fluxi",
    [Language.PORTUGUESE]: "Escolha um avatar Fluxi",
  },
  "avatar-wizard-preset-subtitle-v3": {
    [Language.ENGLISH]: "Pick one ready-made, create with AI, or upload your avatar",
    [Language.SPANISH]: "Elige uno listo, crea con IA o sube tu avatar",
    [Language.PORTUGUESE]: "Escolha um pronto, crie com IA ou envie seu avatar",
  },
  "avatar-wizard-custom-title": {
    [Language.ENGLISH]: "Build your avatar",
    [Language.SPANISH]: "Construye tu avatar",
    [Language.PORTUGUESE]: "Construa seu avatar",
  },
  "avatar-wizard-custom-subtitle": {
    [Language.ENGLISH]: "Tweak the details — preview refreshes live",
    [Language.SPANISH]: "Ajusta los detalles — el preview se regenera en vivo",
    [Language.PORTUGUESE]: "Ajuste os detalhes — o preview atualiza ao vivo",
  },
  "avatar-wizard-custom-subtitle-v2": {
    [Language.ENGLISH]: "With detailed parameters or a free prompt",
    [Language.SPANISH]: "Por parámetros detallados o con un prompt libre",
    [Language.PORTUGUESE]: "Por parâmetros detalhados ou com um prompt livre",
  },
  "avatar-wizard-builder-tab-params": {
    [Language.ENGLISH]: "By parameters",
    [Language.SPANISH]: "Por parámetros",
    [Language.PORTUGUESE]: "Por parâmetros",
  },
  "avatar-wizard-builder-tab-prompt": {
    [Language.ENGLISH]: "With AI prompt",
    [Language.SPANISH]: "Con prompt IA",
    [Language.PORTUGUESE]: "Com prompt IA",
  },
  "avatar-wizard-upload-title": {
    [Language.ENGLISH]: "Own photo",
    [Language.SPANISH]: "Foto propia",
    [Language.PORTUGUESE]: "Foto própria",
  },
  "avatar-wizard-choice-preset-title": {
    [Language.ENGLISH]: "Pick from Fluxi",
    [Language.SPANISH]: "Elegir de Fluxi",
    [Language.PORTUGUESE]: "Escolher do Fluxi",
  },
  "avatar-wizard-choice-preset-desc": {
    [Language.ENGLISH]: "8 ready presenters, one click",
    [Language.SPANISH]: "8 presenters listos, un click y listo",
    [Language.PORTUGUESE]: "8 apresentadores prontos, um clique",
  },
  "avatar-wizard-choice-custom-title": {
    [Language.ENGLISH]: "Build your own",
    [Language.SPANISH]: "Construye el tuyo",
    [Language.PORTUGUESE]: "Construa o seu",
  },
  "avatar-wizard-choice-custom-desc": {
    [Language.ENGLISH]: "Tweak and see the live preview",
    [Language.SPANISH]: "Ajusta y ve el preview en vivo",
    [Language.PORTUGUESE]: "Ajuste e veja o preview ao vivo",
  },
  "avatar-wizard-choice-upload-title": {
    [Language.ENGLISH]: "Upload your photo",
    [Language.SPANISH]: "Sube tu foto",
    [Language.PORTUGUESE]: "Envie sua foto",
  },
  "avatar-wizard-choice-upload-desc": {
    [Language.ENGLISH]: "Clone your face with ElevenLabs AI",
    [Language.SPANISH]: "Clona tu cara con ElevenLabs AI",
    [Language.PORTUGUESE]: "Clone seu rosto com ElevenLabs AI",
  },
  "avatar-wizard-choice-fastest": {
    [Language.ENGLISH]: "Fastest",
    [Language.SPANISH]: "Más rápido",
    [Language.PORTUGUESE]: "Mais rápido",
  },
  "avatar-wizard-use-avatar": {
    [Language.ENGLISH]: "Use this avatar",
    [Language.SPANISH]: "Usar este avatar",
    [Language.PORTUGUESE]: "Usar este avatar",
  },
  "avatar-wizard-custom-generating": {
    [Language.ENGLISH]: "Generating preview...",
    [Language.SPANISH]: "Generando preview...",
    [Language.PORTUGUESE]: "Gerando preview...",
  },
  "avatar-wizard-custom-empty-title": {
    [Language.ENGLISH]: "Fill in every field",
    [Language.SPANISH]: "Completa los campos",
    [Language.PORTUGUESE]: "Preencha os campos",
  },
  "avatar-wizard-custom-filled-of": {
    [Language.ENGLISH]: "fields completed",
    [Language.SPANISH]: "campos completos",
    [Language.PORTUGUESE]: "campos completos",
  },
  "avatar-wizard-custom-ready": {
    [Language.ENGLISH]: "Ready to generate",
    [Language.SPANISH]: "Listo para generar",
    [Language.PORTUGUESE]: "Pronto para gerar",
  },
  "avatar-wizard-custom-ready-desc": {
    [Language.ENGLISH]: "Click 'Generate preview' to see your avatar.",
    [Language.SPANISH]: "Presiona 'Generar preview' para ver tu avatar.",
    [Language.PORTUGUESE]: "Clique em 'Gerar preview' para ver seu avatar.",
  },
  "avatar-wizard-custom-generate": {
    [Language.ENGLISH]: "Generate preview",
    [Language.SPANISH]: "Generar preview",
    [Language.PORTUGUESE]: "Gerar preview",
  },
  "avatar-wizard-custom-regenerate": {
    [Language.ENGLISH]: "Regenerate",
    [Language.SPANISH]: "Regenerar",
    [Language.PORTUGUESE]: "Regerar",
  },
  "avatar-auto": {
    [Language.ENGLISH]: "Auto",
    [Language.SPANISH]: "Auto",
    [Language.PORTUGUESE]: "Auto",
  },
  "avatar-photographic-style": {
    [Language.ENGLISH]: "Photographic style",
    [Language.SPANISH]: "Estilo fotográfico",
    [Language.PORTUGUESE]: "Estilo fotográfico",
  },
  "avatar-photo-style-natural": {
    [Language.ENGLISH]: "Natural",
    [Language.SPANISH]: "Natural",
    [Language.PORTUGUESE]: "Natural",
  },
  "avatar-photo-style-golden-hour": {
    [Language.ENGLISH]: "Golden hour",
    [Language.SPANISH]: "Hora dorada",
    [Language.PORTUGUESE]: "Hora dourada",
  },
  "avatar-photo-style-studio": {
    [Language.ENGLISH]: "Studio",
    [Language.SPANISH]: "Estudio",
    [Language.PORTUGUESE]: "Estúdio",
  },
  "avatar-photo-style-flash": {
    [Language.ENGLISH]: "Flash",
    [Language.SPANISH]: "Flash",
    [Language.PORTUGUESE]: "Flash",
  },
  "avatar-photo-style-selfie": {
    [Language.ENGLISH]: "Selfie",
    [Language.SPANISH]: "Selfie",
    [Language.PORTUGUESE]: "Selfie",
  },
  "avatar-skin-finish": {
    [Language.ENGLISH]: "Skin finish",
    [Language.SPANISH]: "Acabado de piel",
    [Language.PORTUGUESE]: "Acabamento de pele",
  },
  "avatar-skin-finish-natural": {
    [Language.ENGLISH]: "Natural",
    [Language.SPANISH]: "Natural",
    [Language.PORTUGUESE]: "Natural",
  },
  "avatar-skin-finish-dewy": {
    [Language.ENGLISH]: "Dewy",
    [Language.SPANISH]: "Radiante",
    [Language.PORTUGUESE]: "Radiante",
  },
  "avatar-skin-finish-matte": {
    [Language.ENGLISH]: "Matte",
    [Language.SPANISH]: "Mate",
    [Language.PORTUGUESE]: "Matte",
  },
  "avatar-wizard-choice-prompt-title": {
    [Language.ENGLISH]: "Describe it",
    [Language.SPANISH]: "Descríbelo",
    [Language.PORTUGUESE]: "Descreva",
  },
  "avatar-wizard-choice-prompt-desc": {
    [Language.ENGLISH]: "Write your own description and let AI generate it",
    [Language.SPANISH]: "Descríbelo con tus palabras y deja que la IA lo genere",
    [Language.PORTUGUESE]: "Descreva com suas palavras e deixe a IA gerar",
  },
  "avatar-wizard-choice-power": {
    [Language.ENGLISH]: "Advanced",
    [Language.SPANISH]: "Avanzado",
    [Language.PORTUGUESE]: "Avançado",
  },
  "avatar-wizard-prompt-title": {
    [Language.ENGLISH]: "Describe your avatar",
    [Language.SPANISH]: "Describe tu avatar",
    [Language.PORTUGUESE]: "Descreva seu avatar",
  },
  "avatar-wizard-prompt-subtitle": {
    [Language.ENGLISH]: "Paste a detailed description or write what you picture",
    [Language.SPANISH]: "Pega una descripción detallada o escribe lo que imaginas",
    [Language.PORTUGUESE]: "Cole uma descrição detalhada ou escreva o que imagina",
  },
  // Phase 2 V9 REV 2 (Apr 19 2026) — user feedback: revert the super-prompt
  // Prompt path; merge presets + structured custom axes into ONE entry
  // card called "Elegir o personalizar", enable the "Subir tu foto" card,
  // and add in-flow bridges between preset mode ↔ custom axes mode.
  "avatar-wizard-choice-unified-title": {
    [Language.ENGLISH]: "Choose or customize",
    [Language.SPANISH]: "Elegir o personalizar",
    [Language.PORTUGUESE]: "Escolher ou personalizar",
  },
  "avatar-wizard-choice-unified-desc": {
    [Language.ENGLISH]: "8 ready Fluxi presenters, or tune the details (skin, hair, age, vibe, setting)",
    [Language.SPANISH]: "8 presenters listos de Fluxi, o ajusta los detalles (piel, cabello, edad, vibe, setting)",
    [Language.PORTUGUESE]: "8 apresentadores prontos da Fluxi, ou ajuste os detalhes (pele, cabelo, idade, vibe, cenário)",
  },
  "avatar-wizard-choice-unified-badge": {
    [Language.ENGLISH]: "Recommended",
    [Language.SPANISH]: "Recomendado",
    [Language.PORTUGUESE]: "Recomendado",
  },
  "avatar-wizard-best-match-badge": {
    [Language.ENGLISH]: "Best match",
    [Language.SPANISH]: "Mejor match",
    [Language.PORTUGUESE]: "Melhor opção",
  },
  "avatar-wizard-choice-upload-desc-v2": {
    [Language.ENGLISH]: "Clone your face and star in the video yourself",
    [Language.SPANISH]: "Clona tu cara y protagoniza el video",
    [Language.PORTUGUESE]: "Clone seu rosto e seja você quem protagoniza o vídeo",
  },
  "avatar-wizard-preset-to-custom": {
    [Language.ENGLISH]: "Prefer to tune details (skin, hair, age…)?",
    [Language.SPANISH]: "¿Prefieres ajustar detalles (piel, cabello, edad…)?",
    [Language.PORTUGUESE]: "Prefere ajustar detalhes (pele, cabelo, idade…)?",
  },
  "avatar-wizard-custom-to-preset": {
    [Language.ENGLISH]: "See the 8 ready presets",
    [Language.SPANISH]: "Ver los 8 presets listos",
    [Language.PORTUGUESE]: "Ver os 8 presets prontos",
  },
  "avatar-wizard-mine-empty-desc-v2": {
    [Language.ENGLISH]: "Pick a Fluxi preset or tune the details — it saves to your cast so you reuse it in every video.",
    [Language.SPANISH]: "Elige un preset de Fluxi o personaliza los detalles — se guarda en tu elenco y lo reutilizas en todos tus videos.",
    [Language.PORTUGUESE]: "Escolha um preset da Fluxi ou ajuste os detalhes — salva no seu elenco e você reutiliza em todos os vídeos.",
  },
  // Phase 2 V9 REV 2 — helper text next to the script word counter so the
  // user knows the limit is calibrated to fit the audio inside the video.
  "video-preview-script-duration-hint": {
    [Language.ENGLISH]: "Word limit calibrated so the audio fits in {duration}s without clipping.",
    [Language.SPANISH]: "Límite calibrado para que el audio entre en {duration}s sin cortarse.",
    [Language.PORTUGUESE]: "Limite calibrado para que o áudio entre em {duration}s sem cortar.",
  },
  "video-preview-progress-audio": {
    [Language.ENGLISH]: "Generating the voice-over…",
    [Language.SPANISH]: "Generando la voz en off…",
    [Language.PORTUGUESE]: "Gerando a voz em off…",
  },
  "video-preview-progress-dispatch": {
    [Language.ENGLISH]: "Sending to render. Almost ready.",
    [Language.SPANISH]: "Mandando a render. Ya casi está listo.",
    [Language.PORTUGUESE]: "Enviando ao render. Já quase pronto.",
  },
  // (kept — old V9 super-prompt keys may still be referenced elsewhere)
  "avatar-wizard-prompt-title-v2": {
    [Language.ENGLISH]: "Build your own",
    [Language.SPANISH]: "Construye el tuyo",
    [Language.PORTUGUESE]: "Construa o seu",
  },
  "avatar-wizard-prompt-subtitle-v2": {
    [Language.ENGLISH]: "Describe it however you want — we use it as-is, no changes",
    [Language.SPANISH]: "Descríbelo como quieras — lo usamos tal cual, sin cambiarle nada",
    [Language.PORTUGUESE]: "Descreva como quiser — usamos exatamente assim, sem mudar nada",
  },
  "avatar-wizard-library-create-prompt-title": {
    [Language.ENGLISH]: "Create with AI",
    [Language.SPANISH]: "Crear con IA",
    [Language.PORTUGUESE]: "Criar com IA",
  },
  "avatar-wizard-upload-tab-title": {
    [Language.ENGLISH]: "Upload avatar",
    [Language.SPANISH]: "Subir avatar",
    [Language.PORTUGUESE]: "Enviar avatar",
  },
  "avatar-wizard-library-subtitle-v2": {
    [Language.ENGLISH]: "Pick a ready face or create a new one for your ad",
    [Language.SPANISH]: "Elige un rostro listo o crea uno nuevo para tu anuncio",
    [Language.PORTUGUESE]: "Escolha um rosto pronto ou crie um novo para seu anúncio",
  },
  "avatar-wizard-library-create-prompt-desc": {
    [Language.ENGLISH]: "Describe the avatar you imagine",
    [Language.SPANISH]: "Describe el avatar que imaginas",
    [Language.PORTUGUESE]: "Descreva o avatar que imagina",
  },
  "avatar-wizard-library-create-params-title": {
    [Language.ENGLISH]: "Tune details",
    [Language.SPANISH]: "Ajustar detalles",
    [Language.PORTUGUESE]: "Ajustar detalhes",
  },
  "avatar-wizard-library-create-params-desc": {
    [Language.ENGLISH]: "Gender, age, skin, hair and setting",
    [Language.SPANISH]: "Género, edad, piel, cabello y ambiente",
    [Language.PORTUGUESE]: "Gênero, idade, pele, cabelo e ambiente",
  },
  "avatar-wizard-library-create-cta": {
    [Language.ENGLISH]: "Create",
    [Language.SPANISH]: "Crear",
    [Language.PORTUGUESE]: "Criar",
  },
  "avatar-wizard-back-to-library": {
    [Language.ENGLISH]: "Back to library",
    [Language.SPANISH]: "Volver a la biblioteca",
    [Language.PORTUGUESE]: "Voltar à biblioteca",
  },
  "avatar-wizard-choice-custom-desc-v2": {
    [Language.ENGLISH]: "Describe it in your own words — we use it as-is, no tweaks",
    [Language.SPANISH]: "Descríbelo con tus palabras — lo tomamos tal cual, sin cambiarle nada",
    [Language.PORTUGUESE]: "Descreva com suas palavras — usamos exatamente assim, sem mudar nada",
  },
  "avatar-wizard-choice-custom-badge": {
    [Language.ENGLISH]: "Your idea, exact",
    [Language.SPANISH]: "Tu idea, exacta",
    [Language.PORTUGUESE]: "Sua ideia, exata",
  },
  "avatar-wizard-prompt-label": {
    [Language.ENGLISH]: "Avatar description",
    [Language.SPANISH]: "Descripción del avatar",
    [Language.PORTUGUESE]: "Descrição do avatar",
  },
  "avatar-wizard-prompt-placeholder": {
    [Language.ENGLISH]: "e.g. Latina woman, 30, medium warm golden-undertone skin, glass-skin dewy texture with peach fuzz, subtle freckles, long wavy black hair with flyaways backlit, white tank top, gold hoop earrings, golden-hour harsh sunlight creating angular shadows, iPhone 15 Pro selfie at a slight high angle, confident relaxed attitude…",
    [Language.SPANISH]: "Ej: Mujer latina de 30, piel medium con subtono cálido dorado, textura glass-skin dewy con peach fuzz, pecas sutiles, cabello largo ondulado negro con flyaways a contraluz, top blanco de tirantes, aros dorados finos, luz solar de hora dorada creando sombras duras, cámara iPhone 15 Pro selfie, ligero ángulo picado, actitud confiada y relajada…",
    [Language.PORTUGUESE]: "Ex: Mulher latina de 30, pele média com subtom quente dourado, textura glass-skin dewy com peach fuzz, sardas sutis, cabelo longo ondulado preto com flyaways contra luz, top branco de alças, argolas douradas finas, luz solar de hora dourada com sombras angulares, câmera iPhone 15 Pro selfie, leve ângulo alto, atitude confiante e relaxada…",
  },
  "avatar-wizard-prompt-empty-title": {
    [Language.ENGLISH]: "Write your description",
    [Language.SPANISH]: "Escribe tu descripción",
    [Language.PORTUGUESE]: "Escreva sua descrição",
  },
  "avatar-wizard-prompt-hint": {
    [Language.ENGLISH]: "Minimum 30 characters. You can paste a detailed description (skin, light, camera, outfit…).",
    [Language.SPANISH]: "Mínimo 30 caracteres. Puedes pegar una descripción detallada (piel, luz, cámara, ropa…).",
    [Language.PORTUGUESE]: "Mínimo 30 caracteres. Você pode colar uma descrição detalhada (pele, luz, câmera, roupa…).",
  },
  "avatar-wizard-prompt-ready": {
    [Language.ENGLISH]: "Ready to generate",
    [Language.SPANISH]: "Listo para generar",
    [Language.PORTUGUESE]: "Pronto para gerar",
  },
  "avatar-wizard-prompt-ready-desc": {
    [Language.ENGLISH]: "Press 'Generate preview' to see the avatar.",
    [Language.SPANISH]: "Presiona 'Generar preview' para ver el avatar.",
    [Language.PORTUGUESE]: "Clique em 'Gerar preview' para ver o avatar.",
  },
  "avatar-wizard-prompt-min-hint": {
    [Language.ENGLISH]: "Minimum 30 characters",
    [Language.SPANISH]: "Mínimo 30 caracteres",
    [Language.PORTUGUESE]: "Mínimo 30 caracteres",
  },
  "avatar-wizard-prompt-chars-missing": {
    [Language.ENGLISH]: "more characters needed",
    [Language.SPANISH]: "caracteres más para continuar",
    [Language.PORTUGUESE]: "caracteres a mais para continuar",
  },
  "avatar-wizard-prompt-ready-hint": {
    [Language.ENGLISH]: "Ready when you are",
    [Language.SPANISH]: "Listo cuando quieras",
    [Language.PORTUGUESE]: "Pronto quando quiser",
  },
  "avatar-wizard-prompt-name": {
    [Language.ENGLISH]: "Avatar from description",
    [Language.SPANISH]: "Avatar desde descripción",
    [Language.PORTUGUESE]: "Avatar pela descrição",
  },
  "category-auto-ai": {
    [Language.ENGLISH]: "Auto (AI classifies)",
    [Language.SPANISH]: "Auto (IA clasifica)",
    [Language.PORTUGUESE]: "Auto (IA classifica)",
  },
  "category-joints": {
    [Language.ENGLISH]: "Joints",
    [Language.SPANISH]: "Articulaciones",
    [Language.PORTUGUESE]: "Articulações",
  },
  "category-digestive": {
    [Language.ENGLISH]: "Digestive",
    [Language.SPANISH]: "Digestivo",
    [Language.PORTUGUESE]: "Digestivo",
  },
  "category-cardiovascular": {
    [Language.ENGLISH]: "Cardiovascular",
    [Language.SPANISH]: "Cardiovascular",
    [Language.PORTUGUESE]: "Cardiovascular",
  },
  "category-skincare": {
    [Language.ENGLISH]: "Skin / skincare",
    [Language.SPANISH]: "Piel / skincare",
    [Language.PORTUGUESE]: "Pele / skincare",
  },
  "category-hair": {
    [Language.ENGLISH]: "Hair",
    [Language.SPANISH]: "Cabello",
    [Language.PORTUGUESE]: "Cabelo",
  },
  "category-energy": {
    [Language.ENGLISH]: "Energy",
    [Language.SPANISH]: "Energía",
    [Language.PORTUGUESE]: "Energia",
  },
  "category-sleep-stress": {
    [Language.ENGLISH]: "Sleep / stress",
    [Language.SPANISH]: "Sueño / estrés",
    [Language.PORTUGUESE]: "Sono / estresse",
  },
  "category-weight": {
    [Language.ENGLISH]: "Weight",
    [Language.SPANISH]: "Peso",
    [Language.PORTUGUESE]: "Peso",
  },
  "category-pain-inflammation": {
    [Language.ENGLISH]: "Pain / inflammation",
    [Language.SPANISH]: "Dolor / inflamación",
    [Language.PORTUGUESE]: "Dor / inflamação",
  },
  "category-vision": {
    [Language.ENGLISH]: "Vision",
    [Language.SPANISH]: "Visión",
    [Language.PORTUGUESE]: "Visão",
  },
  "category-immunity": {
    [Language.ENGLISH]: "Immunity",
    [Language.SPANISH]: "Inmunidad",
    [Language.PORTUGUESE]: "Imunidade",
  },
  "category-muscle-fitness": {
    [Language.ENGLISH]: "Muscle / fitness",
    [Language.SPANISH]: "Músculo / fitness",
    [Language.PORTUGUESE]: "Músculo / fitness",
  },
  "category-dental": {
    [Language.ENGLISH]: "Dental",
    [Language.SPANISH]: "Dental",
    [Language.PORTUGUESE]: "Dental",
  },
  "category-liver-detox": {
    [Language.ENGLISH]: "Liver / detox",
    [Language.SPANISH]: "Hígado / detox",
    [Language.PORTUGUESE]: "Fígado / detox",
  },
  "category-bones": {
    [Language.ENGLISH]: "Bones",
    [Language.SPANISH]: "Huesos",
    [Language.PORTUGUESE]: "Ossos",
  },
  "category-brain-cognitive": {
    [Language.ENGLISH]: "Brain / cognitive",
    [Language.SPANISH]: "Cerebro / cognitivo",
    [Language.PORTUGUESE]: "Cérebro / cognitivo",
  },
  "video-voice-settings-title": {
    [Language.ENGLISH]: "Voice settings",
    [Language.SPANISH]: "Ajustes de voz",
    [Language.PORTUGUESE]: "Ajustes de voz",
  },
  "video-voice-settings-reset": {
    [Language.ENGLISH]: "Defaults",
    [Language.SPANISH]: "Valores por defecto",
    [Language.PORTUGUESE]: "Padrões",
  },
  "video-voice-settings-stability": {
    [Language.ENGLISH]: "Stability",
    [Language.SPANISH]: "Estabilidad",
    [Language.PORTUGUESE]: "Estabilidade",
  },
  "video-voice-settings-stability-min": {
    [Language.ENGLISH]: "More expressive",
    [Language.SPANISH]: "Más expresiva",
    [Language.PORTUGUESE]: "Mais expressiva",
  },
  "video-voice-settings-stability-max": {
    [Language.ENGLISH]: "More stable",
    [Language.SPANISH]: "Más estable",
    [Language.PORTUGUESE]: "Mais estável",
  },
  "video-voice-settings-speed": {
    [Language.ENGLISH]: "Speed",
    [Language.SPANISH]: "Velocidad",
    [Language.PORTUGUESE]: "Velocidade",
  },
  "video-voice-settings-speed-min": {
    [Language.ENGLISH]: "Slower",
    [Language.SPANISH]: "Más lenta",
    [Language.PORTUGUESE]: "Mais lenta",
  },
  "video-voice-settings-speed-max": {
    [Language.ENGLISH]: "Faster",
    [Language.SPANISH]: "Más rápida",
    [Language.PORTUGUESE]: "Mais rápida",
  },
  "video-preview-voice-cached": {
    [Language.ENGLISH]: "Already generated with these settings",
    [Language.SPANISH]: "Ya generado con estos ajustes",
    [Language.PORTUGUESE]: "Já gerado com esses ajustes",
  },
  "video-voice-settings-similarity": {
    [Language.ENGLISH]: "Similarity",
    [Language.SPANISH]: "Similitud",
    [Language.PORTUGUESE]: "Similaridade",
  },
  "video-voice-settings-similarity-min": {
    [Language.ENGLISH]: "Low",
    [Language.SPANISH]: "Baja",
    [Language.PORTUGUESE]: "Baixa",
  },
  "video-voice-settings-similarity-max": {
    [Language.ENGLISH]: "High",
    [Language.SPANISH]: "Alta",
    [Language.PORTUGUESE]: "Alta",
  },
  "video-voice-settings-style": {
    [Language.ENGLISH]: "Style",
    [Language.SPANISH]: "Estilo",
    [Language.PORTUGUESE]: "Estilo",
  },
  "video-voice-settings-style-min": {
    [Language.ENGLISH]: "Neutral",
    [Language.SPANISH]: "Neutro",
    [Language.PORTUGUESE]: "Neutro",
  },
  "video-voice-settings-style-max": {
    [Language.ENGLISH]: "Exaggerated",
    [Language.SPANISH]: "Exagerado",
    [Language.PORTUGUESE]: "Exagerado",
  },
  "video-preview-voice-hint-simple": {
    [Language.ENGLISH]: "Tap play on any voice to hear a sample. Settings apply when you create the final video.",
    [Language.SPANISH]: "Toca play en cada voz para escucharla. Los ajustes se aplican al crear el video final.",
    [Language.PORTUGUESE]: "Toque play em cada voz para ouvi-la. Os ajustes se aplicam ao criar o vídeo final.",
  },
  "video-preview-audio-stale-pill": {
    [Language.ENGLISH]: "You edited the script. Pick a voice again so the audio matches the new text.",
    [Language.SPANISH]: "Editaste el guion. Vuelve a elegir una voz para que el audio coincida con el nuevo texto.",
    [Language.PORTUGUESE]: "Editaste o roteiro. Escolhe uma voz de novo para que o áudio combine com o texto.",
  },
  "video-voice-advanced-title": {
    [Language.ENGLISH]: "Advanced options",
    [Language.SPANISH]: "Opciones avanzadas",
    [Language.PORTUGUESE]: "Opções avançadas",
  },
  "video-voice-advanced-hint": {
    [Language.ENGLISH]: "We pre-tune the rest (style, stability) per voice.",
    [Language.SPANISH]: "El resto de parámetros (estilo, estabilidad) los optimizamos nosotros por cada voz.",
    [Language.PORTUGUESE]: "O resto (estilo, estabilidade) nós otimizamos por cada voz.",
  },
  "custom-voice-title": {
    [Language.ENGLISH]: "Create your voice",
    [Language.SPANISH]: "Crea tu voz",
    [Language.PORTUGUESE]: "Cria a tua voz",
  },
  "custom-voice-close": {
    [Language.ENGLISH]: "Close",
    [Language.SPANISH]: "Cerrar",
    [Language.PORTUGUESE]: "Fechar",
  },
  "custom-voice-desc-label": {
    [Language.ENGLISH]: "Describe how you want the voice to sound",
    [Language.SPANISH]: "Describe cómo quieres que suene la voz",
    [Language.PORTUGUESE]: "Descreve como queres que soe a voz",
  },
  "custom-voice-desc-placeholder": {
    [Language.ENGLISH]: "e.g.: Female voice from Medellín, 25 years old, cheerful and close like a makeup influencer.",
    [Language.SPANISH]: "Ej: Voz femenina paisa de 25 años, alegre y cercana tipo influencer de maquillaje.",
    [Language.PORTUGUESE]: "Ex: Voz feminina jovem, alegre e próxima, tipo influencer de maquiagem.",
  },
  "custom-voice-desc-hint": {
    [Language.ENGLISH]: "1-2 lines. Accent + personality + age help.",
    [Language.SPANISH]: "1 o 2 líneas. Acento + personalidad + edad ayudan.",
    [Language.PORTUGUESE]: "1 ou 2 linhas. Sotaque + personalidade + idade ajudam.",
  },
  "custom-voice-cancel": {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "custom-voice-generate": {
    [Language.ENGLISH]: "Generate preview",
    [Language.SPANISH]: "Generar preview",
    [Language.PORTUGUESE]: "Gerar preview",
  },
  "custom-voice-generating": {
    [Language.ENGLISH]: "Creating your voice…",
    [Language.SPANISH]: "Creando tu voz…",
    [Language.PORTUGUESE]: "Criando a tua voz…",
  },
  "custom-voice-generating-hint": {
    [Language.ENGLISH]: "We analyze your description and render a preview. Takes about 10 seconds.",
    [Language.SPANISH]: "Analizamos tu descripción y rendereamos un preview. Toma unos 10 segundos.",
    [Language.PORTUGUESE]: "Analisamos a descrição e geramos o preview. Demora uns 10 segundos.",
  },
  "custom-voice-preview-label": {
    [Language.ENGLISH]: "Preview generated",
    [Language.SPANISH]: "Preview generado",
    [Language.PORTUGUESE]: "Preview gerado",
  },
  "custom-voice-play": {
    [Language.ENGLISH]: "Play",
    [Language.SPANISH]: "Reproducir",
    [Language.PORTUGUESE]: "Reproduzir",
  },
  "custom-voice-pause": {
    [Language.ENGLISH]: "Pause",
    [Language.SPANISH]: "Pausar",
    [Language.PORTUGUESE]: "Pausar",
  },
  "custom-voice-name-label": {
    [Language.ENGLISH]: "Name your voice",
    [Language.SPANISH]: "Ponle un nombre",
    [Language.PORTUGUESE]: "Coloca um nome",
  },
  "custom-voice-name-placeholder": {
    [Language.ENGLISH]: "e.g.: Paisa Influencer",
    [Language.SPANISH]: "Ej: Influencer Paisa",
    [Language.PORTUGUESE]: "Ex: Influencer Paisa",
  },
  "custom-voice-restart": {
    [Language.ENGLISH]: "Start over",
    [Language.SPANISH]: "Empezar de nuevo",
    [Language.PORTUGUESE]: "Começar de novo",
  },
  "custom-voice-save": {
    [Language.ENGLISH]: "Save and use",
    [Language.SPANISH]: "Guardar y usar",
    [Language.PORTUGUESE]: "Guardar e usar",
  },
  "custom-voice-saving": {
    [Language.ENGLISH]: "Saving…",
    [Language.SPANISH]: "Guardando…",
    [Language.PORTUGUESE]: "Guardando…",
  },
  "custom-voice-error-empty": {
    [Language.ENGLISH]: "Please describe how you want the voice to sound.",
    [Language.SPANISH]: "Escribe cómo quieres que suene.",
    [Language.PORTUGUESE]: "Descreve como queres que soe.",
  },
  "custom-voice-error-safety": {
    [Language.ENGLISH]: "This description was blocked by the safety filter. Try more neutral words (e.g. warm, friendly, confident).",
    [Language.SPANISH]: "Esta descripción fue bloqueada por el filtro. Prueba con palabras más neutras (ej: cálida, alegre, confiada).",
    [Language.PORTUGUESE]: "Essa descrição foi bloqueada pelo filtro. Tenta palavras mais neutras (ex: cálida, alegre, confiante).",
  },
  "custom-voice-error-generic": {
    [Language.ENGLISH]: "Couldn't generate the preview. Try again.",
    [Language.SPANISH]: "No pudimos generar el preview. Inténtalo de nuevo.",
    [Language.PORTUGUESE]: "Não conseguimos gerar o preview. Tenta de novo.",
  },
  "custom-voice-error-name": {
    [Language.ENGLISH]: "Give your voice a name.",
    [Language.SPANISH]: "Ponle un nombre a tu voz.",
    [Language.PORTUGUESE]: "Coloca um nome na tua voz.",
  },
  "custom-voice-error-save": {
    [Language.ENGLISH]: "Couldn't save the voice.",
    [Language.SPANISH]: "No pudimos guardar la voz.",
    [Language.PORTUGUESE]: "Não conseguimos guardar a voz.",
  },
  "custom-voice-grid-cta-title": {
    [Language.ENGLISH]: "Create voice",
    [Language.SPANISH]: "Crea tu voz",
    [Language.PORTUGUESE]: "Cria tua voz",
  },
  "custom-voice-grid-cta-sub": {
    [Language.ENGLISH]: "Describe it and we generate it",
    [Language.SPANISH]: "Descríbela y te la generamos",
    [Language.PORTUGUESE]: "Descreve e nós geramos",
  },
  "custom-voice-delete-aria": {
    [Language.ENGLISH]: "Delete custom voice",
    [Language.SPANISH]: "Borrar voz custom",
    [Language.PORTUGUESE]: "Apagar voz personalizada",
  },
  "custom-voice-confirm-delete": {
    [Language.ENGLISH]: "Delete this voice? Videos that already used it stay intact.",
    [Language.SPANISH]: "¿Borrar esta voz? Los videos que ya la usan se mantienen intactos.",
    [Language.PORTUGUESE]: "Apagar esta voz? Os vídeos que já a usaram ficam intactos.",
  },
  "custom-voice-step-1": {
    [Language.ENGLISH]: "Describe",
    [Language.SPANISH]: "Describe",
    [Language.PORTUGUESE]: "Descreve",
  },
  "custom-voice-step-2": {
    [Language.ENGLISH]: "Listen",
    [Language.SPANISH]: "Escucha",
    [Language.PORTUGUESE]: "Escuta",
  },
  "custom-voice-step-3": {
    [Language.ENGLISH]: "Save",
    [Language.SPANISH]: "Guarda",
    [Language.PORTUGUESE]: "Guarda",
  },
  "custom-voice-saved-toast": {
    [Language.ENGLISH]: "Voice added to your library",
    [Language.SPANISH]: "Voz agregada a tu biblioteca",
    [Language.PORTUGUESE]: "Voz adicionada à tua biblioteca",
  },
  "avatar-wizard-custom-refresh": {
    [Language.ENGLISH]: "Refreshing",
    [Language.SPANISH]: "Actualizando",
    [Language.PORTUGUESE]: "Atualizando",
  },
  "avatar-wizard-custom-error": {
    [Language.ENGLISH]: "Could not generate the preview",
    [Language.SPANISH]: "No pudimos generar el preview",
    [Language.PORTUGUESE]: "Não foi possível gerar o preview",
  },
  "avatar-wizard-custom-preview-alt": {
    [Language.ENGLISH]: "Avatar preview",
    [Language.SPANISH]: "Vista previa del avatar",
    [Language.PORTUGUESE]: "Prévia do avatar",
  },
  "avatar-wizard-custom-name": {
    [Language.ENGLISH]: "Custom avatar",
    [Language.SPANISH]: "Avatar personalizado",
    [Language.PORTUGUESE]: "Avatar personalizado",
  },
  "avatar-wizard-upload-coming-soon-title": {
    [Language.ENGLISH]: "Coming soon",
    [Language.SPANISH]: "Disponible pronto",
    [Language.PORTUGUESE]: "Disponível em breve",
  },
  "avatar-wizard-upload-coming-soon-desc": {
    [Language.ENGLISH]: "This option is still in progress. For now, choose a ready-made avatar or create one with AI.",
    [Language.SPANISH]: "Esta opción todavía está en preparación. Por ahora puedes elegir un avatar listo o crear uno con IA.",
    [Language.PORTUGUESE]: "Esta opção ainda está em preparação. Por enquanto, escolha um avatar pronto ou crie um com IA.",
  },
  "avatar-wizard-mine-title": {
    [Language.ENGLISH]: "My saved avatars",
    [Language.SPANISH]: "Mis avatares guardados",
    [Language.PORTUGUESE]: "Meus avatares salvos",
  },
  "avatar-wizard-mine-subtitle": {
    [Language.ENGLISH]: "Your reusable cast — perfect for keeping consistency across videos",
    [Language.SPANISH]: "Tu elenco reutilizable — ideal para mantener consistencia entre videos",
    [Language.PORTUGUESE]: "Seu elenco reutilizável — ideal para manter consistência entre vídeos",
  },
  "avatar-wizard-choice-mine-title": {
    [Language.ENGLISH]: "My avatars",
    [Language.SPANISH]: "Mis avatares",
    [Language.PORTUGUESE]: "Meus avatares",
  },
  "avatar-wizard-choice-mine-desc": {
    [Language.ENGLISH]: "Reuse the ones you've already saved to your cast",
    [Language.SPANISH]: "Reutiliza los que ya guardaste en tu elenco",
    [Language.PORTUGUESE]: "Reutilize os que você já salvou no seu elenco",
  },
  "avatar-wizard-mine-empty-title": {
    [Language.ENGLISH]: "You haven't saved any avatars yet",
    [Language.SPANISH]: "Todavía no guardaste avatares",
    [Language.PORTUGUESE]: "Você ainda não salvou nenhum avatar",
  },
  "avatar-wizard-mine-empty-desc": {
    [Language.ENGLISH]: "Build one in 'Build your own' and save it to your cast so you can reuse it across videos.",
    [Language.SPANISH]: "Crea uno en 'Construye el tuyo' y guárdalo en tu elenco para reutilizarlo en todos tus videos.",
    [Language.PORTUGUESE]: "Monte um em 'Construa o seu' e salve no seu elenco para reutilizá-lo em todos os seus vídeos.",
  },
  "avatar-wizard-mine-delete": {
    [Language.ENGLISH]: "Remove from cast",
    [Language.SPANISH]: "Eliminar del elenco",
    [Language.PORTUGUESE]: "Remover do elenco",
  },
  "avatar-wizard-source-preset": {
    [Language.ENGLISH]: "Preset",
    [Language.SPANISH]: "Preset",
    [Language.PORTUGUESE]: "Preset",
  },
  "avatar-wizard-source-custom": {
    [Language.ENGLISH]: "Custom",
    [Language.SPANISH]: "Custom",
    [Language.PORTUGUESE]: "Custom",
  },
  "avatar-wizard-source-upload": {
    [Language.ENGLISH]: "Photo",
    [Language.SPANISH]: "Foto",
    [Language.PORTUGUESE]: "Foto",
  },
  "avatar-wizard-save-to-cast": {
    [Language.ENGLISH]: "Save to my cast",
    [Language.SPANISH]: "Guardar en mi elenco",
    [Language.PORTUGUESE]: "Salvar no meu elenco",
  },
  "avatar-wizard-saving": {
    [Language.ENGLISH]: "Saving…",
    [Language.SPANISH]: "Guardando…",
    [Language.PORTUGUESE]: "Salvando…",
  },
  "avatar-wizard-saved": {
    [Language.ENGLISH]: "Saved",
    [Language.SPANISH]: "Guardado",
    [Language.PORTUGUESE]: "Salvo",
  },
  "video-preview-change-style": {
    [Language.ENGLISH]: "Change style",
    [Language.SPANISH]: "Cambiar estilo",
    [Language.PORTUGUESE]: "Mudar estilo",
  },
  "video-preview-empty-title": {
    [Language.ENGLISH]: "Pick your presenter",
    [Language.SPANISH]: "Elige tu presenter",
    [Language.PORTUGUESE]: "Escolha seu apresentador",
  },
  "video-preview-empty-subtitle": {
    [Language.ENGLISH]: "Preset, build it, or reuse one from your cast",
    [Language.SPANISH]: "Preset, construilo o reutilizá uno de tu elenco",
    [Language.PORTUGUESE]: "Preset, construa ou reutilize um do seu elenco",
  },
  "video-preview-product-label": {
    [Language.ENGLISH]: "Product",
    [Language.SPANISH]: "Producto",
    [Language.PORTUGUESE]: "Produto",
  },
  "video-audio-label": {
    [Language.ENGLISH]: "Audio",
    [Language.SPANISH]: "Audio",
    [Language.PORTUGUESE]: "Áudio",
  },
  "video-audio-upload-pick": {
    [Language.ENGLISH]: "Upload your audio (MP3 / WAV)",
    [Language.SPANISH]: "Sube tu audio (MP3 / WAV)",
    [Language.PORTUGUESE]: "Envie seu áudio (MP3 / WAV)",
  },
  "video-audio-upload-remove": {
    [Language.ENGLISH]: "Remove audio",
    [Language.SPANISH]: "Quitar audio",
    [Language.PORTUGUESE]: "Remover áudio",
  },
  "video-audio-upload-error": {
    [Language.ENGLISH]: "We couldn't upload your audio. Try again.",
    [Language.SPANISH]: "No pudimos subir el audio. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Não conseguimos enviar o áudio. Tente de novo.",
  },
  "video-avatar-label": {
    [Language.ENGLISH]: "Avatar",
    [Language.SPANISH]: "Avatar",
    [Language.PORTUGUESE]: "Avatar",
  },
  "video-duration-fixed": {
    [Language.ENGLISH]: "Standard duration",
    [Language.SPANISH]: "Duración estándar",
    [Language.PORTUGUESE]: "Duração padrão",
  },
  "video-avatar-chip-label": {
    [Language.ENGLISH]: "Presenter",
    [Language.SPANISH]: "Presenter",
    [Language.PORTUGUESE]: "Apresentador",
  },
  "video-avatar-chip-change": {
    [Language.ENGLISH]: "Change",
    [Language.SPANISH]: "Cambiar",
    [Language.PORTUGUESE]: "Mudar",
  },
  "video-avatar-cta-title": {
    [Language.ENGLISH]: "Configure avatar",
    [Language.SPANISH]: "Configurar avatar",
    [Language.PORTUGUESE]: "Configurar avatar",
  },
  "video-avatar-cta-subtitle": {
    [Language.ENGLISH]: "Preset, custom, or from your cast",
    [Language.SPANISH]: "Preset, personalizado o de tu elenco",
    [Language.PORTUGUESE]: "Preset, personalizado ou do seu elenco",
  },
  "video-preview-edit-style-aria": {
    [Language.ENGLISH]: "Change personality",
    [Language.SPANISH]: "Cambiar personalidad",
    [Language.PORTUGUESE]: "Mudar personalidade",
  },
  "video-preview-edit-script-aria": {
    [Language.ENGLISH]: "Edit script",
    [Language.SPANISH]: "Editar guión",
    [Language.PORTUGUESE]: "Editar roteiro",
  },
  "video-preview-style-prompt": {
    [Language.ENGLISH]: "Describe how you want it",
    [Language.SPANISH]: "Describe cómo lo quieres",
    [Language.PORTUGUESE]: "Descreve como tu queres",
  },
  "video-preview-style-quickvibes-label": {
    [Language.ENGLISH]: "Quick options",
    [Language.SPANISH]: "Opciones rápidas",
    [Language.PORTUGUESE]: "Opções rápidas",
  },
  "video-preview-style-input-placeholder": {
    [Language.ENGLISH]: "or type it: e.g. more threatening, less serious...",
    [Language.SPANISH]: "o escríbelo tú: ej. más amenazante, menos serio...",
    [Language.PORTUGUESE]: "ou escreve: ex. mais ameaçador, menos sério...",
  },
  "video-preview-vibe-angry": {
    [Language.ENGLISH]: "more angry",
    [Language.SPANISH]: "más enojado",
    [Language.PORTUGUESE]: "mais bravo",
  },
  "video-preview-vibe-sarcastic": {
    [Language.ENGLISH]: "more sarcastic",
    [Language.SPANISH]: "más sarcástico",
    [Language.PORTUGUESE]: "mais sarcástico",
  },
  "video-preview-vibe-less-dramatic": {
    [Language.ENGLISH]: "less dramatic",
    [Language.SPANISH]: "menos dramático",
    [Language.PORTUGUESE]: "menos dramático",
  },
  "video-preview-vibe-funny": {
    [Language.ENGLISH]: "more funny",
    [Language.SPANISH]: "más divertido",
    [Language.PORTUGUESE]: "mais engraçado",
  },
  "video-preview-vibe-maternal": {
    [Language.ENGLISH]: "more motherly",
    [Language.SPANISH]: "más maternal",
    [Language.PORTUGUESE]: "mais maternal",
  },
  "video-preview-regen-action": {
    [Language.ENGLISH]: "Apply and regenerate",
    [Language.SPANISH]: "Aplicar y regenerar",
    [Language.PORTUGUESE]: "Aplicar e regenerar",
  },
  "video-preview-style-edit-warning": {
    [Language.ENGLISH]: "Cambiar la personalidad regenera el guión y la imagen, y usa 1 de tus 3 cambios.",
    [Language.SPANISH]: "Cambiar la personalidad regenera el guión y la imagen, y usa 1 de tus 3 cambios.",
    [Language.PORTUGUESE]: "Mudar a personalidade regenera o roteiro e a imagem, e usa 1 das 3 mudanças.",
  },
  "video-preview-other-version": {
    [Language.ENGLISH]: "Other version",
    [Language.SPANISH]: "Otra versión",
    [Language.PORTUGUESE]: "Outra versão",
  },
  "video-preview-other-version-hint": {
    [Language.ENGLISH]: "Don't love it? Generate a totally new version (script + image).",
    [Language.SPANISH]: "¿No te convence? Genera una versión totalmente nueva (guión + imagen).",
    [Language.PORTUGUESE]: "Não gostou? Gere uma versão totalmente nova (roteiro + imagem).",
  },
  "video-preview-cancel": {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "video-preview-credits-cost": {
    [Language.ENGLISH]: "{credits} credits",
    [Language.SPANISH]: "{credits} créditos",
    [Language.PORTUGUESE]: "{credits} créditos",
  },
  "video-preview-regen-uses": {
    [Language.ENGLISH]: "Uses 1 of {max} changes",
    [Language.SPANISH]: "Usa 1 de {max} cambios",
    [Language.PORTUGUESE]: "Usa 1 de {max} mudanças",
  },
  "video-preview-image-edit-title": {
    [Language.ENGLISH]: "What do you want to change in the image?",
    [Language.SPANISH]: "¿Qué quieres cambiar de la imagen?",
    [Language.PORTUGUESE]: "O que tu queres mudar da imagem?",
  },
  "video-preview-image-edit-placeholder": {
    [Language.ENGLISH]: "Describe what you want to change (optional)...",
    [Language.SPANISH]: "Describe qué quieres cambiar (opcional)...",
    [Language.PORTUGUESE]: "Descreve o que tu queres mudar (opcional)...",
  },
  "video-preview-image-edit-toggle": {
    [Language.ENGLISH]: "with instruction",
    [Language.SPANISH]: "con instrucción",
    [Language.PORTUGUESE]: "com instrução",
  },
  "video-preview-image-edit-apply": {
    [Language.ENGLISH]: "Apply",
    [Language.SPANISH]: "Aplicar",
    [Language.PORTUGUESE]: "Aplicar",
  },
  "video-preview-image-suggestion-brighter": {
    [Language.ENGLISH]: "brighter background",
    [Language.SPANISH]: "fondo más brillante",
    [Language.PORTUGUESE]: "fundo mais brilhante",
  },
  "video-preview-image-suggestion-darker": {
    [Language.ENGLISH]: "darker background",
    [Language.SPANISH]: "fondo más oscuro",
    [Language.PORTUGUESE]: "fundo mais escuro",
  },
  "video-preview-image-suggestion-closeup": {
    [Language.ENGLISH]: "more close-up",
    [Language.SPANISH]: "más close-up",
    [Language.PORTUGUESE]: "mais close-up",
  },
  "video-preview-image-suggestion-colorful": {
    [Language.ENGLISH]: "more colorful",
    [Language.SPANISH]: "más colorido",
    [Language.PORTUGUESE]: "mais colorido",
  },
  "video-preview-image-other": {
    [Language.ENGLISH]: "Other image",
    [Language.SPANISH]: "Otra imagen",
    [Language.PORTUGUESE]: "Outra imagem",
  },
  "video-preview-ugc-actor-label": {
    [Language.ENGLISH]: "Your actor",
    [Language.SPANISH]: "Tu actriz",
    [Language.PORTUGUESE]: "Seu ator",
  },
  "video-preview-ugc-product-label": {
    [Language.ENGLISH]: "Your product",
    [Language.SPANISH]: "Tu producto",
    [Language.PORTUGUESE]: "Seu produto",
  },
  "video-preview-ugc-helper": {
    [Language.ENGLISH]: "These are the base images for your video. Hover any of them to regenerate it.",
    [Language.SPANISH]: "Estas son las imágenes base del video. Pasá el cursor sobre cada una para regenerarla.",
    [Language.PORTUGUESE]: "Estas são as imagens base do vídeo. Passe o cursor sobre cada uma para regerá-la.",
  },
  "video-preview-ugc-scene-a-label": {
    [Language.ENGLISH]: "Scene 1",
    [Language.SPANISH]: "Escena 1",
    [Language.PORTUGUESE]: "Cena 1",
  },
  "video-preview-ugc-scene-b-label": {
    [Language.ENGLISH]: "Scene 2",
    [Language.SPANISH]: "Escena 2",
    [Language.PORTUGUESE]: "Cena 2",
  },
  "video-preview-ugc-regen-this": {
    [Language.ENGLISH]: "Regenerate",
    [Language.SPANISH]: "Regenerar",
    [Language.PORTUGUESE]: "Regerar",
  },
  "video-preview-ugc-regen-portrait-title": {
    [Language.ENGLISH]: "Regenerate the actor (also refreshes both scenes)",
    [Language.SPANISH]: "Regenerar la actriz (también renueva ambas escenas)",
    [Language.PORTUGUESE]: "Regerar a atriz (também renova ambas as cenas)",
  },
  "video-preview-ugc-regen-scene-a-title": {
    [Language.ENGLISH]: "Regenerate Scene 1",
    [Language.SPANISH]: "Regenerar Escena 1",
    [Language.PORTUGUESE]: "Regerar Cena 1",
  },
  "video-preview-ugc-regen-scene-b-title": {
    [Language.ENGLISH]: "Regenerate Scene 2",
    [Language.SPANISH]: "Regenerar Escena 2",
    [Language.PORTUGUESE]: "Regerar Cena 2",
  },
  "video-preview-image-generating": {
    [Language.ENGLISH]: "Generating...",
    [Language.SPANISH]: "Generando...",
    [Language.PORTUGUESE]: "Gerando...",
  },
  "video-preview-image-generating-overlay": {
    [Language.ENGLISH]: "Generating new version...",
    [Language.SPANISH]: "Generando nueva versión...",
    [Language.PORTUGUESE]: "Gerando nova versão...",
  },
  "video-preview-image-updated": {
    [Language.ENGLISH]: "Image updated",
    [Language.SPANISH]: "Imagen actualizada",
    [Language.PORTUGUESE]: "Imagem atualizada",
  },
  "video-preview-changes-counter": {
    [Language.ENGLISH]: "{used}/{max} changes used",
    [Language.SPANISH]: "{used}/{max} cambios usados",
    [Language.PORTUGUESE]: "{used}/{max} mudanças usadas",
  },
  "video-preview-changes-exhausted": {
    [Language.ENGLISH]: "No more changes available",
    [Language.SPANISH]: "Ya no hay cambios disponibles",
    [Language.PORTUGUESE]: "Não há mais mudanças disponíveis",
  },
  "video-preview-save-changes": {
    [Language.ENGLISH]: "Save changes",
    [Language.SPANISH]: "Guardar cambios",
    [Language.PORTUGUESE]: "Salvar mudanças",
  },
  "video-preview-loading-msg-1": {
    [Language.ENGLISH]: "Researching successful similar ads",
    [Language.SPANISH]: "Investigando anuncios similares exitosos",
    [Language.PORTUGUESE]: "Pesquisando anúncios similares bem-sucedidos",
  },
  "video-preview-loading-msg-2": {
    [Language.ENGLISH]: "Writing a persuasive script",
    [Language.SPANISH]: "Escribiendo un guión persuasivo",
    [Language.PORTUGUESE]: "Escrevendo um roteiro persuasivo",
  },
  "video-preview-loading-msg-3": {
    [Language.ENGLISH]: "Creating hyper-realistic scenes",
    [Language.SPANISH]: "Creando escenas hiper-realistas",
    [Language.PORTUGUESE]: "Criando cenas hiper-realistas",
  },
  "video-preview-loading-msg-4": {
    [Language.ENGLISH]: "Defining the rhythm of the voice-over",
    [Language.SPANISH]: "Definiendo el ritmo de la voz en off",
    [Language.PORTUGUESE]: "Definindo o ritmo da voz em off",
  },
  "video-preview-loading-msg-5": {
    [Language.ENGLISH]: "Planning natural camera movement",
    [Language.SPANISH]: "Planeando movimientos naturales de cámara",
    [Language.PORTUGUESE]: "Planejando movimentos naturais de câmera",
  },
  "video-preview-loading-msg-6": {
    [Language.ENGLISH]: "Preparing consistent visual references",
    [Language.SPANISH]: "Preparando referencias visuales consistentes",
    [Language.PORTUGUESE]: "Preparando referências visuais consistentes",
  },
  "video-preview-loading-msg-7": {
    [Language.ENGLISH]: "Adjusting the tone for your audience",
    [Language.SPANISH]: "Ajustando el tono para tu audiencia",
    [Language.PORTUGUESE]: "Ajustando o tom para seu público",
  },
  "video-preview-loading-msg-8": {
    [Language.ENGLISH]: "Organizing the video resources",
    [Language.SPANISH]: "Organizando los recursos del video",
    [Language.PORTUGUESE]: "Organizando os recursos do video",
  },
  "video-preview-regen-image": {
    [Language.ENGLISH]: "Regenerate image",
    [Language.SPANISH]: "Regenerar imagen",
    [Language.PORTUGUESE]: "Regenerar imagem",
  },
  "video-preview-regen-image-loading": {
    [Language.ENGLISH]: "Regenerating...",
    [Language.SPANISH]: "Regenerando...",
    [Language.PORTUGUESE]: "Regenerando...",
  },
  "video-preview-regen-style-title": {
    [Language.ENGLISH]: "Changing the creative style",
    [Language.SPANISH]: "Cambiando el estilo creativo",
    [Language.PORTUGUESE]: "Mudando o estilo criativo",
  },
  "video-preview-regen-style-subtitle": {
    [Language.ENGLISH]: "We're redesigning your video with the new style. Takes about a minute.",
    [Language.SPANISH]: "Estamos rediseñando tu video con el nuevo estilo. Tarda alrededor de un minuto.",
    [Language.PORTUGUESE]: "Estamos redesenhando seu vídeo com o novo estilo. Demora cerca de um minuto.",
  },

  // USER PROFILE
  "profile-my-profile": {
    [Language.ENGLISH]: "My Profile",
    [Language.SPANISH]: "Mi Perfil",
    [Language.PORTUGUESE]: "Meu Perfil",
  },
  "profile-logout": {
    [Language.ENGLISH]: "Log Out",
    [Language.SPANISH]: "Cerrar Sesión",
    [Language.PORTUGUESE]: "Sair",
  },
  "profile-subtitle": {
    [Language.ENGLISH]: "Manage your personal information",
    [Language.SPANISH]: "Gestiona tu información personal",
    [Language.PORTUGUESE]: "Gerencie suas informações pessoais",
  },
  "profile-tab-personal": {
    [Language.ENGLISH]: "Personal Information",
    [Language.SPANISH]: "Información Personal",
    [Language.PORTUGUESE]: "Informações Pessoais",
  },
  "profile-tab-payment": {
    [Language.ENGLISH]: "Payment Method",
    [Language.SPANISH]: "Método de Pago",
    [Language.PORTUGUESE]: "Método de Pagamento",
  },
  "profile-fluxi-user": {
    [Language.ENGLISH]: "Fluxi User",
    [Language.SPANISH]: "Usuario Fluxi",
    [Language.PORTUGUESE]: "Usuário Fluxi",
  },
  "profile-account-info": {
    [Language.ENGLISH]: "Account Information",
    [Language.SPANISH]: "Información de Cuenta",
    [Language.PORTUGUESE]: "Informações da Conta",
  },
  "profile-account-info-desc": {
    [Language.ENGLISH]: "These details are read-only and synced with your account",
    [Language.SPANISH]: "Estos datos son de solo lectura y se sincronizan con tu cuenta",
    [Language.PORTUGUESE]: "Estes dados são somente leitura e sincronizados com sua conta",
  },
  "profile-country": {
    [Language.ENGLISH]: "Country",
    [Language.SPANISH]: "País",
    [Language.PORTUGUESE]: "País",
  },
  "profile-currency": {
    [Language.ENGLISH]: "Currency",
    [Language.SPANISH]: "Moneda",
    [Language.PORTUGUESE]: "Moeda",
  },
  "profile-language": {
    [Language.ENGLISH]: "Language",
    [Language.SPANISH]: "Idioma",
    [Language.PORTUGUESE]: "Idioma",
  },
  "profile-email": {
    [Language.ENGLISH]: "Email",
    [Language.SPANISH]: "Correo Electrónico",
    [Language.PORTUGUESE]: "E-mail",
  },
  "profile-timezone": {
    [Language.ENGLISH]: "Time Zone",
    [Language.SPANISH]: "Zona Horaria",
    [Language.PORTUGUESE]: "Fuso Horário",
  },
  "profile-payment-title": {
    [Language.ENGLISH]: "Payment Methods",
    [Language.SPANISH]: "Métodos de Pago",
    [Language.PORTUGUESE]: "Métodos de Pagamento",
  },
  "profile-payment-desc": {
    [Language.ENGLISH]: "Manage your credit and debit cards",
    [Language.SPANISH]: "Administra tus tarjetas de crédito y débito",
    [Language.PORTUGUESE]: "Gerencie seus cartões de crédito e débito",
  },
  "profile-add-card": {
    [Language.ENGLISH]: "Add Card",
    [Language.SPANISH]: "Agregar Tarjeta",
    [Language.PORTUGUESE]: "Adicionar Cartão",
  },
  "profile-active-card": {
    [Language.ENGLISH]: "Active Card",
    [Language.SPANISH]: "Tarjeta Activa",
    [Language.PORTUGUESE]: "Cartão Ativo",
  },
  "profile-active": {
    [Language.ENGLISH]: "ACTIVE",
    [Language.SPANISH]: "ACTIVA",
    [Language.PORTUGUESE]: "ATIVO",
  },
  "profile-credit-card": {
    [Language.ENGLISH]: "Credit Card",
    [Language.SPANISH]: "Tarjeta de Crédito",
    [Language.PORTUGUESE]: "Cartão de Crédito",
  },
  "profile-card-number": {
    [Language.ENGLISH]: "Card Number",
    [Language.SPANISH]: "Número de Tarjeta",
    [Language.PORTUGUESE]: "Número do Cartão",
  },
  "profile-card-name": {
    [Language.ENGLISH]: "Cardholder Name",
    [Language.SPANISH]: "Nombre en la Tarjeta",
    [Language.PORTUGUESE]: "Nome no Cartão",
  },
  "profile-card-expiry": {
    [Language.ENGLISH]: "Expiry Date",
    [Language.SPANISH]: "Fecha de Vencimiento",
    [Language.PORTUGUESE]: "Data de Validade",
  },
  "profile-card-holder": {
    [Language.ENGLISH]: "HOLDER",
    [Language.SPANISH]: "TITULAR",
    [Language.PORTUGUESE]: "TITULAR",
  },
  "profile-card-expires": {
    [Language.ENGLISH]: "EXPIRES",
    [Language.SPANISH]: "VENCE",
    [Language.PORTUGUESE]: "VENCE",
  },
  "profile-edit-card": {
    [Language.ENGLISH]: "Edit Card",
    [Language.SPANISH]: "Editar Tarjeta",
    [Language.PORTUGUESE]: "Editar Cartão",
  },
  "profile-other-cards": {
    [Language.ENGLISH]: "Other Cards",
    [Language.SPANISH]: "Otras Tarjetas",
    [Language.PORTUGUESE]: "Outros Cartões",
  },
  "profile-saved-cards": {
    [Language.ENGLISH]: "saved card(s)",
    [Language.SPANISH]: "tarjeta(s) guardada(s)",
    [Language.PORTUGUESE]: "cartão(ões) salvo(s)",
  },
  "profile-activate": {
    [Language.ENGLISH]: "Activate",
    [Language.SPANISH]: "Activar",
    [Language.PORTUGUESE]: "Ativar",
  },
  "profile-secure-data-title": {
    [Language.ENGLISH]: "Your data is safe",
    [Language.SPANISH]: "Tus datos están seguros",
    [Language.PORTUGUESE]: "Seus dados estão seguros",
  },
  "profile-secure-data-desc": {
    [Language.ENGLISH]: "All payment information is encrypted and protected with the highest security standards.",
    [Language.SPANISH]: "Toda la información de pago está cifrada y protegida con los más altos estándares de seguridad.",
    [Language.PORTUGUESE]: "Todas as informações de pagamento são criptografadas e protegidas com os mais altos padrões de segurança.",
  },
  "profile-no-cards-title": {
    [Language.ENGLISH]: "You have no saved cards",
    [Language.SPANISH]: "No tienes tarjetas guardadas",
    [Language.PORTUGUESE]: "Você não tem cartões salvos",
  },
  "profile-no-cards-desc": {
    [Language.ENGLISH]: "Add your first card to get started",
    [Language.SPANISH]: "Agrega tu primera tarjeta para comenzar",
    [Language.PORTUGUESE]: "Adicione seu primeiro cartão para começar",
  },
  "profile-add-first-card": {
    [Language.ENGLISH]: "Add First Card",
    [Language.SPANISH]: "Agregar Primera Tarjeta",
    [Language.PORTUGUESE]: "Adicionar Primeiro Cartão",
  },
  "profile-cancel": {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "profile-save": {
    [Language.ENGLISH]: "Save",
    [Language.SPANISH]: "Guardar",
    [Language.PORTUGUESE]: "Salvar",
  },
  "profile-delete-confirm": {
    [Language.ENGLISH]: "Are you sure you want to delete this card?",
    [Language.SPANISH]: "¿Estás seguro de que quieres eliminar esta tarjeta?",
    [Language.PORTUGUESE]: "Tem certeza de que deseja excluir este cartão?",
  },
  "profile-saved-success": {
    [Language.ENGLISH]: "Information saved successfully",
    [Language.SPANISH]: "Información guardada correctamente",
    [Language.PORTUGUESE]: "Informação salva com sucesso",
  },
  "profile-card-saved-success": {
    [Language.ENGLISH]: "Payment method saved successfully",
    [Language.SPANISH]: "Método de pago guardado correctamente",
    [Language.PORTUGUESE]: "Método de pagamento salvo com sucesso",
  },
  "profile-error-card-16": {
    [Language.ENGLISH]: "Card number must be 16 digits",
    [Language.SPANISH]: "El número de tarjeta debe tener 16 dígitos",
    [Language.PORTUGUESE]: "O número do cartão deve ter 16 dígitos",
  },
  "profile-error-card-test": {
    [Language.ENGLISH]: "Only test cards accepted (16 zeros)",
    [Language.SPANISH]: "Solo se aceptan tarjetas de prueba (16 ceros)",
    [Language.PORTUGUESE]: "Apenas cartões de teste são aceitos (16 zeros)",
  },
  "profile-error-expiry": {
    [Language.ENGLISH]: "Invalid format (MM/YY)",
    [Language.SPANISH]: "Formato inválido (MM/AA)",
    [Language.PORTUGUESE]: "Formato inválido (MM/AA)",
  },
  "profile-error-cvv": {
    [Language.ENGLISH]: "CVV must be 3 digits",
    [Language.SPANISH]: "El CVV debe tener 3 dígitos",
    [Language.PORTUGUESE]: "O CVV deve ter 3 dígitos",
  },
  "profile-error-name-required": {
    [Language.ENGLISH]: "Name is required",
    [Language.SPANISH]: "El nombre es requerido",
    [Language.PORTUGUESE]: "O nome é obrigatório",
  },
  "chat-tab-chat": {
    [Language.ENGLISH]: "Chat",
    [Language.SPANISH]: "Chat",
    [Language.PORTUGUESE]: "Chat",
  },
  "chat-tab-confirmaciones": {
    [Language.ENGLISH]: "Confirmations",
    [Language.SPANISH]: "Confirmaciones",
    [Language.PORTUGUESE]: "Confirmações",
  },
  "chat-tab-config-ws": {
    [Language.ENGLISH]: "Settings",
    [Language.SPANISH]: "Configuración",
    [Language.PORTUGUESE]: "Configuração",
  },
  // ---- WS Config Tab ----
  "ws-config-title": {
    [Language.ENGLISH]: "WhatsApp Assistant Settings",
    [Language.SPANISH]: "Configuración del Asistente WhatsApp",
    [Language.PORTUGUESE]: "Configuração do Assistente WhatsApp",
  },
  "ws-config-subtitle": {
    [Language.ENGLISH]: "Customize how the AI behaves when confirming orders",
    [Language.SPANISH]: "Personaliza cómo se comporta la IA al confirmar pedidos",
    [Language.PORTUGUESE]: "Personalize como a IA se comporta ao confirmar pedidos",
  },
  "ws-config-tone-title": {
    [Language.ENGLISH]: "AI Tone",
    [Language.SPANISH]: "Tono de la IA",
    [Language.PORTUGUESE]: "Tom da IA",
  },
  "ws-config-tone-professional": {
    [Language.ENGLISH]: "Professional",
    [Language.SPANISH]: "Profesional",
    [Language.PORTUGUESE]: "Profissional",
  },
  "ws-config-tone-professional-desc": {
    [Language.ENGLISH]: "Formal and polite. Uses \"usted\" instead of \"tú\".",
    [Language.SPANISH]: "Formal y cortés. Usa \"usted\" en vez de \"tú\".",
    [Language.PORTUGUESE]: "Formal e educado. Usa tratamento respeitoso.",
  },
  "ws-config-tone-friendly": {
    [Language.ENGLISH]: "Friendly",
    [Language.SPANISH]: "Amigable",
    [Language.PORTUGUESE]: "Amigável",
  },
  "ws-config-tone-friendly-desc": {
    [Language.ENGLISH]: "Warm and casual. Natural WhatsApp style.",
    [Language.SPANISH]: "Cercano y casual. Estilo natural de WhatsApp.",
    [Language.PORTUGUESE]: "Próximo e casual. Estilo natural de WhatsApp.",
  },
  "ws-config-tone-casual": {
    [Language.ENGLISH]: "Ultra-casual",
    [Language.SPANISH]: "Ultra-casual",
    [Language.PORTUGUESE]: "Ultra-casual",
  },
  "ws-config-tone-casual-desc": {
    [Language.ENGLISH]: "Very relaxed, like chatting with a friend.",
    [Language.SPANISH]: "Super relajado, como hablar con un amigo.",
    [Language.PORTUGUESE]: "Super relaxado, como falar com um amigo.",
  },
  "ws-config-tone-custom": {
    [Language.ENGLISH]: "Custom",
    [Language.SPANISH]: "Personalizado",
    [Language.PORTUGUESE]: "Personalizado",
  },
  "ws-config-tone-custom-desc": {
    [Language.ENGLISH]: "Define your own tone with custom instructions.",
    [Language.SPANISH]: "Define tu propio tono con instrucciones personalizadas.",
    [Language.PORTUGUESE]: "Defina seu próprio tom com instruções personalizadas.",
  },
  "ws-config-instructions-title": {
    [Language.ENGLISH]: "Custom Instructions",
    [Language.SPANISH]: "Instrucciones personalizadas",
    [Language.PORTUGUESE]: "Instruções personalizadas",
  },
  "ws-config-instructions-desc": {
    [Language.ENGLISH]: "Add specific instructions for your business. E.g.: \"Always mention our return policy\"",
    [Language.SPANISH]: "Agrega instrucciones específicas para tu negocio. Ej: \"Siempre menciona nuestra política de devoluciones\"",
    [Language.PORTUGUESE]: "Adicione instruções específicas para seu negócio. Ex: \"Sempre mencione nossa política de devoluções\"",
  },
  "ws-config-instructions-placeholder": {
    [Language.ENGLISH]: "Write additional instructions for the AI...",
    [Language.SPANISH]: "Escribe instrucciones adicionales para la IA...",
    [Language.PORTUGUESE]: "Escreva instruções adicionais para a IA...",
  },
  "ws-config-temperature-title": {
    [Language.ENGLISH]: "Response Creativity",
    [Language.SPANISH]: "Creatividad de respuesta",
    [Language.PORTUGUESE]: "Criatividade de resposta",
  },
  "ws-config-temperature-precise": {
    [Language.ENGLISH]: "Precise",
    [Language.SPANISH]: "Preciso",
    [Language.PORTUGUESE]: "Preciso",
  },
  "ws-config-temperature-creative": {
    [Language.ENGLISH]: "Creative",
    [Language.SPANISH]: "Creativo",
    [Language.PORTUGUESE]: "Criativo",
  },
  "ws-config-length-title": {
    [Language.ENGLISH]: "Response Length",
    [Language.SPANISH]: "Largo de respuesta",
    [Language.PORTUGUESE]: "Tamanho da resposta",
  },
  "ws-config-length-short": {
    [Language.ENGLISH]: "Short",
    [Language.SPANISH]: "Corto",
    [Language.PORTUGUESE]: "Curto",
  },
  "ws-config-length-medium": {
    [Language.ENGLISH]: "Medium",
    [Language.SPANISH]: "Medio",
    [Language.PORTUGUESE]: "Médio",
  },
  "ws-config-length-long": {
    [Language.ENGLISH]: "Long",
    [Language.SPANISH]: "Largo",
    [Language.PORTUGUESE]: "Longo",
  },
  "ws-config-ai-default-title": {
    [Language.ENGLISH]: "AI enabled by default",
    [Language.SPANISH]: "IA activa por defecto",
    [Language.PORTUGUESE]: "IA ativa por padrão",
  },
  "ws-config-ai-default-desc": {
    [Language.ENGLISH]: "New conversations will start with AI enabled",
    [Language.SPANISH]: "Las nuevas conversaciones iniciarán con la IA habilitada",
    [Language.PORTUGUESE]: "Novas conversas iniciarão com a IA ativada",
  },
  "ws-config-save": {
    [Language.ENGLISH]: "Save settings",
    [Language.SPANISH]: "Guardar configuración",
    [Language.PORTUGUESE]: "Salvar configuração",
  },
  "ws-config-saving": {
    [Language.ENGLISH]: "Saving...",
    [Language.SPANISH]: "Guardando...",
    [Language.PORTUGUESE]: "Salvando...",
  },
  "ws-config-saved": {
    [Language.ENGLISH]: "Settings saved",
    [Language.SPANISH]: "Configuración guardada",
    [Language.PORTUGUESE]: "Configuração salva",
  },
  "ws-config-save-error": {
    [Language.ENGLISH]: "Error saving settings",
    [Language.SPANISH]: "Error al guardar",
    [Language.PORTUGUESE]: "Erro ao salvar",
  },
  "ws-config-ai-delinquent-title": {
    [Language.ENGLISH]: "Assistant on hold for pending coins",
    [Language.SPANISH]: "Asistente en mora",
    [Language.PORTUGUESE]: "Assistente em atraso",
  },
  "ws-config-ai-delinquent-desc": {
    [Language.ENGLISH]: "You have {pending} pending Fluxi Coins from sent messages. Once the balance reaches {limit} coins, AI replies are paused until you top up or the pending balance is charged.",
    [Language.SPANISH]: "Tienes {pending} Fluxi Coins pendientes por mensajes enviados. Al llegar a {limit} coins, la IA deja de responder automáticamente hasta que recargues o se descuente el saldo pendiente.",
    [Language.PORTUGUESE]: "Você tem {pending} Fluxi Coins pendentes por mensagens enviadas. Ao chegar a {limit} coins, a IA para de responder automaticamente até você recarregar ou o saldo pendente ser cobrado.",
  },
  "ws-config-ai-settle-button": {
    [Language.ENGLISH]: "Pay balance",
    [Language.SPANISH]: "Pagar saldo",
    [Language.PORTUGUESE]: "Pagar saldo",
  },
  "ws-config-ai-settle-loading": {
    [Language.ENGLISH]: "Charging...",
    [Language.SPANISH]: "Descontando...",
    [Language.PORTUGUESE]: "Descontando...",
  },
  "ws-config-ai-settle-success": {
    [Language.ENGLISH]: "Pending balance charged successfully",
    [Language.SPANISH]: "Saldo pendiente descontado correctamente",
    [Language.PORTUGUESE]: "Saldo pendente descontado corretamente",
  },
  "ws-config-ai-settle-error": {
    [Language.ENGLISH]: "Could not charge the pending balance",
    [Language.SPANISH]: "No se pudo descontar el saldo pendiente",
    [Language.PORTUGUESE]: "Não foi possível descontar o saldo pendente",
  },
  "ws-config-ai-settle-still-delinquent": {
    [Language.ENGLISH]: "Could not clear the overdue balance. Check that you have Fluxi Coins available.",
    [Language.SPANISH]: "No se pudo saldar la mora. Revisa que tengas Fluxi Coins disponibles.",
    [Language.PORTUGUESE]: "Não foi possível quitar a pendência. Verifique se você tem Fluxi Coins disponíveis.",
  },
  // ---- WS Config Tabs (AI vs Templates) ----
  "ws-config-tab-ai": {
    [Language.ENGLISH]: "AI Assistant",
    [Language.SPANISH]: "Asistente IA",
    [Language.PORTUGUESE]: "Assistente IA",
  },
  "ws-config-tab-templates": {
    [Language.ENGLISH]: "Templates",
    [Language.SPANISH]: "Plantillas",
    [Language.PORTUGUESE]: "Modelos",
  },
  "ws-config-tab-funnels": {
    [Language.ENGLISH]: "Funnels",
    [Language.SPANISH]: "Embudos",
    [Language.PORTUGUESE]: "Funis",
  },
  "ws-config-funnels-add": {
    [Language.ENGLISH]: "Add",
    [Language.SPANISH]: "Afiliar",
    [Language.PORTUGUESE]: "Afiliar",
  },
  "ws-config-funnels-remove": {
    [Language.ENGLISH]: "Remove",
    [Language.SPANISH]: "Quitar",
    [Language.PORTUGUESE]: "Remover",
  },
  "ws-config-funnels-open": {
    [Language.ENGLISH]: "Open funnel",
    [Language.SPANISH]: "Abrir embudo",
    [Language.PORTUGUESE]: "Abrir funil",
  },
  "ws-config-funnels-search-label": {
    [Language.ENGLISH]: "Add funnel",
    [Language.SPANISH]: "Agregar embudo",
    [Language.PORTUGUESE]: "Adicionar funil",
  },
  "ws-config-funnels-search-empty": {
    [Language.ENGLISH]: "All funnels are already affiliated",
    [Language.SPANISH]: "Todos los embudos ya están afiliados",
    [Language.PORTUGUESE]: "Todos os funis já estão afiliados",
  },
  "ws-config-funnels-none-connected": {
    [Language.ENGLISH]: "You haven't affiliated any funnel yet. Search above to get started.",
    [Language.SPANISH]: "Aún no has afiliado ningún embudo. Búscalo arriba para empezar.",
    [Language.PORTUGUESE]: "Você ainda não afiliou nenhum funil. Busque acima para começar.",
  },
  "ws-config-funnels-active": {
    [Language.ENGLISH]: "Active",
    [Language.SPANISH]: "Activo",
    [Language.PORTUGUESE]: "Ativo",
  },
  "ws-config-funnels-remove-from-confirmation": {
    [Language.ENGLISH]: "Remove from confirmation",
    [Language.SPANISH]: "Quitar de confirmación",
    [Language.PORTUGUESE]: "Remover da confirmação",
  },
  "ws-config-model-title": {
    [Language.ENGLISH]: "AI Model",
    [Language.SPANISH]: "Modelo de IA",
    [Language.PORTUGUESE]: "Modelo de IA",
  },
  "ws-config-model-estimate": {
    [Language.ENGLISH]: "Estimated",
    [Language.SPANISH]: "Estimado",
    [Language.PORTUGUESE]: "Estimado",
  },
  "ws-config-model-credits-per-message": {
    [Language.ENGLISH]: "credits per message",
    [Language.SPANISH]: "créditos por mensaje",
    [Language.PORTUGUESE]: "créditos por mensagem",
  },
  "ws-config-funnels-title": {
    [Language.ENGLISH]: "Funnels affiliated to confirmation",
    [Language.SPANISH]: "Embudos afiliados a confirmación",
    [Language.PORTUGUESE]: "Funis afiliados à confirmação",
  },
  "ws-config-funnels-desc": {
    [Language.ENGLISH]: "Add the funnels whose orders should be confirmed via WhatsApp. You can also enable confirmation directly from each funnel's settings — both options stay in sync.",
    [Language.SPANISH]: "Agrega los embudos cuyos pedidos quieres confirmar por WhatsApp. También puedes activar la confirmación desde la configuración de cada embudo — ambas opciones se mantienen sincronizadas.",
    [Language.PORTUGUESE]: "Adicione os funis cujos pedidos quer confirmar por WhatsApp. Também é possível ativar a confirmação diretamente nas configurações de cada funil — ambas as opções ficam sincronizadas.",
  },
  "ws-config-funnels-placeholder": {
    [Language.ENGLISH]: "Search funnel by name...",
    [Language.SPANISH]: "Buscar embudo por nombre...",
    [Language.PORTUGUESE]: "Buscar funil pelo nome...",
  },
  "ws-config-funnels-empty": {
    [Language.ENGLISH]: "No funnels available",
    [Language.SPANISH]: "Sin embudos disponibles",
    [Language.PORTUGUESE]: "Sem funis disponíveis",
  },
  "ws-config-funnels-loading": {
    [Language.ENGLISH]: "Loading funnels...",
    [Language.SPANISH]: "Cargando embudos...",
    [Language.PORTUGUESE]: "Carregando funis...",
  },
  "ws-config-funnels-save-error": {
    [Language.ENGLISH]: "Some funnels could not be saved",
    [Language.SPANISH]: "No se pudo guardar algún embudo",
    [Language.PORTUGUESE]: "Não foi possível salvar algum funil",
  },
  "ws-config-meta-api-title": {
    [Language.ENGLISH]: "Meta API status",
    [Language.SPANISH]: "Estado de la API de Meta",
    [Language.PORTUGUESE]: "Status da API de Meta",
  },
  "ws-config-meta-api-tooltip": {
    [Language.ENGLISH]: "All this information comes directly from the Meta API and updates automatically.",
    [Language.SPANISH]: "Toda esta información se obtiene directamente de la API de Meta y se actualiza automáticamente.",
    [Language.PORTUGUESE]: "Todas estas informações vêm diretamente da API de Meta e são atualizadas automaticamente.",
  },
  "ws-config-api-connected": {
    [Language.ENGLISH]: "API connected",
    [Language.SPANISH]: "API conectada",
    [Language.PORTUGUESE]: "API conectada",
  },
  "ws-config-api-disconnected": {
    [Language.ENGLISH]: "API disconnected",
    [Language.SPANISH]: "API desconectada",
    [Language.PORTUGUESE]: "API desconectada",
  },
  "ws-config-manage-api": {
    [Language.ENGLISH]: "Manage API",
    [Language.SPANISH]: "Gestionar API",
    [Language.PORTUGUESE]: "Gerenciar API",
  },
  "ws-config-tab-contacts": {
    [Language.ENGLISH]: "Contacts",
    [Language.SPANISH]: "Contactos",
    [Language.PORTUGUESE]: "Contatos",
  },
  "ws-contacts-title": {
    [Language.ENGLISH]: "Contact list",
    [Language.SPANISH]: "Lista de contactos",
    [Language.PORTUGUESE]: "Lista de contatos",
  },
  "ws-contacts-desc": {
    [Language.ENGLISH]: "All WhatsApp contacts that have ever interacted with your funnels.",
    [Language.SPANISH]: "Todos los contactos de WhatsApp que han interactuado con tus embudos.",
    [Language.PORTUGUESE]: "Todos os contatos de WhatsApp que já interagiram com seus funis.",
  },
  "ws-contacts-search-placeholder": {
    [Language.ENGLISH]: "Search by name, phone or email...",
    [Language.SPANISH]: "Buscar por nombre, teléfono o email...",
    [Language.PORTUGUESE]: "Buscar por nome, telefone ou email...",
  },
  "ws-contacts-empty": {
    [Language.ENGLISH]: "No contacts yet.",
    [Language.SPANISH]: "Aún no hay contactos.",
    [Language.PORTUGUESE]: "Ainda não há contatos.",
  },
  "ws-contacts-empty-search": {
    [Language.ENGLISH]: "No contacts match your search.",
    [Language.SPANISH]: "No hay contactos que coincidan con tu búsqueda.",
    [Language.PORTUGUESE]: "Nenhum contato corresponde à sua busca.",
  },
  "ws-contacts-col-name": {
    [Language.ENGLISH]: "Name",
    [Language.SPANISH]: "Nombre",
    [Language.PORTUGUESE]: "Nome",
  },
  "ws-contacts-col-phone": {
    [Language.ENGLISH]: "Phone",
    [Language.SPANISH]: "Teléfono",
    [Language.PORTUGUESE]: "Telefone",
  },
  "ws-contacts-col-email": {
    [Language.ENGLISH]: "Email",
    [Language.SPANISH]: "Email",
    [Language.PORTUGUESE]: "Email",
  },
  "ws-contacts-col-alias": {
    [Language.ENGLISH]: "Alias",
    [Language.SPANISH]: "Alias",
    [Language.PORTUGUESE]: "Apelido",
  },
  "ws-contacts-col-tags": {
    [Language.ENGLISH]: "Tags",
    [Language.SPANISH]: "Etiquetas",
    [Language.PORTUGUESE]: "Etiquetas",
  },
  "ws-contacts-col-notes": {
    [Language.ENGLISH]: "Notes",
    [Language.SPANISH]: "Notas",
    [Language.PORTUGUESE]: "Notas",
  },
  "ws-contacts-col-created": {
    [Language.ENGLISH]: "First seen",
    [Language.SPANISH]: "Primer contacto",
    [Language.PORTUGUESE]: "Primeiro contato",
  },
  "ws-contacts-col-updated": {
    [Language.ENGLISH]: "Last update",
    [Language.SPANISH]: "Última actualización",
    [Language.PORTUGUESE]: "Última atualização",
  },
  "ws-contacts-col-actions": {
    [Language.ENGLISH]: "Actions",
    [Language.SPANISH]: "Acciones",
    [Language.PORTUGUESE]: "Ações",
  },
  "ws-contacts-load-error": {
    [Language.ENGLISH]: "Could not load contacts",
    [Language.SPANISH]: "No se pudieron cargar los contactos",
    [Language.PORTUGUESE]: "Não foi possível carregar os contatos",
  },
  "ws-contacts-view": {
    [Language.ENGLISH]: "View in chat",
    [Language.SPANISH]: "Ver en chat",
    [Language.PORTUGUESE]: "Ver no chat",
  },
  "ws-templates-delete-modal-warning": {
    [Language.ENGLISH]: "Heads up: once you delete \"{name}\", Meta blocks creating a new template with that exact name in the future. This action cannot be undone.",
    [Language.SPANISH]: "Aviso: al eliminar \"{name}\", Meta no permitirá volver a crear otra plantilla con ese mismo nombre. Esta acción no se puede deshacer.",
    [Language.PORTUGUESE]: "Aviso: ao excluir \"{name}\", Meta não permitirá criar outro modelo com o mesmo nome. Esta ação não pode ser desfeita.",
  },
  "ws-config-quality-green": {
    [Language.ENGLISH]: "Good quality",
    [Language.SPANISH]: "Buena calidad",
    [Language.PORTUGUESE]: "Boa qualidade",
  },
  "ws-config-quality-yellow": {
    [Language.ENGLISH]: "Medium quality",
    [Language.SPANISH]: "Calidad media",
    [Language.PORTUGUESE]: "Qualidade média",
  },
  "ws-config-quality-red": {
    [Language.ENGLISH]: "Low quality — at risk",
    [Language.SPANISH]: "Calidad baja — riesgo",
    [Language.PORTUGUESE]: "Qualidade baixa — risco",
  },
  "ws-config-quality-unknown": {
    [Language.ENGLISH]: "No data yet",
    [Language.SPANISH]: "Sin información aún",
    [Language.PORTUGUESE]: "Sem informações ainda",
  },
  "ws-config-quality-green-tooltip": {
    [Language.ENGLISH]: "Your account has a good reputation with Meta. Few customers have blocked or reported your messages, so you can keep sending normally.",
    [Language.SPANISH]: "Tu cuenta tiene buena reputación con Meta. Pocos clientes han bloqueado o reportado tus mensajes, así que puedes seguir enviando con normalidad.",
    [Language.PORTUGUESE]: "Sua conta tem boa reputação com a Meta. Poucos clientes bloquearam ou denunciaram suas mensagens, então pode continuar enviando normalmente.",
  },
  "ws-config-quality-yellow-tooltip": {
    [Language.ENGLISH]: "Some customers are blocking or reporting your messages. If quality drops further, Meta may throttle your sending. Review your template content.",
    [Language.SPANISH]: "Algunos clientes están bloqueando o reportando tus mensajes. Si baja más, Meta puede limitar tu envío. Revisa el contenido de tus templates.",
    [Language.PORTUGUESE]: "Alguns clientes estão bloqueando ou denunciando suas mensagens. Se cair mais, a Meta pode limitar seu envio. Revise o conteúdo dos seus modelos.",
  },
  "ws-config-quality-red-tooltip": {
    [Language.ENGLISH]: "Many customers are reporting your messages. Meta may suspend your account. Urgently review what you're sending and to whom.",
    [Language.SPANISH]: "Muchos clientes están reportando tus mensajes. Meta podría suspender tu cuenta. Revisa urgentemente qué estás enviando y a quién.",
    [Language.PORTUGUESE]: "Muitos clientes estão denunciando suas mensagens. A Meta pode suspender sua conta. Revise urgentemente o que está enviando e para quem.",
  },
  "ws-config-quality-unknown-tooltip": {
    [Language.ENGLISH]: "Not enough messages have been sent yet for Meta to evaluate your account quality.",
    [Language.SPANISH]: "Aún no hay suficientes mensajes enviados para que Meta evalúe la calidad de tu cuenta.",
    [Language.PORTUGUESE]: "Ainda não há mensagens suficientes enviadas para que a Meta avalie a qualidade da sua conta.",
  },
  "ws-config-token-expires-in": {
    [Language.ENGLISH]: "Token expires in",
    [Language.SPANISH]: "Token expira en",
    [Language.PORTUGUESE]: "Token expira em",
  },
  "ws-config-token-days": {
    [Language.ENGLISH]: "days",
    [Language.SPANISH]: "días",
    [Language.PORTUGUESE]: "dias",
  },
  "ws-config-token-expired": {
    [Language.ENGLISH]: "Token expired",
    [Language.SPANISH]: "Token expirado",
    [Language.PORTUGUESE]: "Token expirado",
  },
  "ws-config-reconnect": {
    [Language.ENGLISH]: "Reconnect",
    [Language.SPANISH]: "Reconectar",
    [Language.PORTUGUESE]: "Reconectar",
  },
  "contact-panel-title": {
    [Language.ENGLISH]: "Contact detail",
    [Language.SPANISH]: "Detalle del contacto",
    [Language.PORTUGUESE]: "Detalhe do contato",
  },
  "contact-panel-open": {
    [Language.ENGLISH]: "View contact",
    [Language.SPANISH]: "Ver contacto",
    [Language.PORTUGUESE]: "Ver contato",
  },
  "contact-not-found": {
    [Language.ENGLISH]: "Could not load the contact",
    [Language.SPANISH]: "No se pudo cargar el contacto",
    [Language.PORTUGUESE]: "Não foi possível carregar o contato",
  },
  "contact-section-info": {
    [Language.ENGLISH]: "General info",
    [Language.SPANISH]: "Información general",
    [Language.PORTUGUESE]: "Informação geral",
  },
  "contact-name-placeholder": {
    [Language.ENGLISH]: "Contact name",
    [Language.SPANISH]: "Nombre del contacto",
    [Language.PORTUGUESE]: "Nome do contato",
  },
  "contact-email-placeholder": {
    [Language.ENGLISH]: "Email address",
    [Language.SPANISH]: "Correo electrónico",
    [Language.PORTUGUESE]: "Email",
  },
  "contact-phone-label": {
    [Language.ENGLISH]: "Phone",
    [Language.SPANISH]: "Teléfono",
    [Language.PORTUGUESE]: "Telefone",
  },
  "contact-save": {
    [Language.ENGLISH]: "Save",
    [Language.SPANISH]: "Guardar",
    [Language.PORTUGUESE]: "Salvar",
  },
  "contact-info-saved": {
    [Language.ENGLISH]: "Information saved",
    [Language.SPANISH]: "Información guardada",
    [Language.PORTUGUESE]: "Informação salva",
  },
  "contact-info-error": {
    [Language.ENGLISH]: "Error saving",
    [Language.SPANISH]: "Error al guardar",
    [Language.PORTUGUESE]: "Erro ao salvar",
  },
  "contact-section-tags": {
    [Language.ENGLISH]: "Tags",
    [Language.SPANISH]: "Etiquetas",
    [Language.PORTUGUESE]: "Etiquetas",
  },
  "contact-tags-placeholder": {
    [Language.ENGLISH]: "Add tag...",
    [Language.SPANISH]: "Agregar etiqueta...",
    [Language.PORTUGUESE]: "Adicionar etiqueta...",
  },
  "contact-tags-empty": {
    [Language.ENGLISH]: "No saved tags",
    [Language.SPANISH]: "Sin etiquetas guardadas",
    [Language.PORTUGUESE]: "Sem etiquetas salvas",
  },
  "contact-section-history": {
    [Language.ENGLISH]: "Order history",
    [Language.SPANISH]: "Historial de pedidos",
    [Language.PORTUGUESE]: "Histórico de pedidos",
  },
  "contact-history-empty": {
    [Language.ENGLISH]: "No orders yet",
    [Language.SPANISH]: "Aún no hay pedidos",
    [Language.PORTUGUESE]: "Ainda sem pedidos",
  },
  "contact-section-notes": {
    [Language.ENGLISH]: "Notes",
    [Language.SPANISH]: "Notas",
    [Language.PORTUGUESE]: "Notas",
  },
  "contact-note-placeholder": {
    [Language.ENGLISH]: "Add a note...",
    [Language.SPANISH]: "Agregar una nota...",
    [Language.PORTUGUESE]: "Adicionar uma nota...",
  },
  "contact-note-add": {
    [Language.ENGLISH]: "Add note",
    [Language.SPANISH]: "Agregar nota",
    [Language.PORTUGUESE]: "Adicionar nota",
  },
  "contact-note-error": {
    [Language.ENGLISH]: "Could not save note",
    [Language.SPANISH]: "No se pudo guardar la nota",
    [Language.PORTUGUESE]: "Não foi possível salvar a nota",
  },
  "contact-note-author-human": {
    [Language.ENGLISH]: "You",
    [Language.SPANISH]: "Tú",
    [Language.PORTUGUESE]: "Você",
  },
  "contact-note-author-ai": {
    [Language.ENGLISH]: "AI",
    [Language.SPANISH]: "IA",
    [Language.PORTUGUESE]: "IA",
  },
  "contact-delete": {
    [Language.ENGLISH]: "Delete contact",
    [Language.SPANISH]: "Eliminar contacto",
    [Language.PORTUGUESE]: "Excluir contato",
  },
  "contact-delete-title": {
    [Language.ENGLISH]: "Delete contact",
    [Language.SPANISH]: "Eliminar contacto",
    [Language.PORTUGUESE]: "Excluir contato",
  },
  "contact-delete-description": {
    [Language.ENGLISH]: "This will free the contact slot in your plan. Continue?",
    [Language.SPANISH]: "Esta acción liberará el cupo de contacto en tu plan. ¿Quieres continuar?",
    [Language.PORTUGUESE]: "Esta ação liberará a vaga de contato no seu plano. Continuar?",
  },
  "contact-delete-confirm": {
    [Language.ENGLISH]: "Delete",
    [Language.SPANISH]: "Eliminar",
    [Language.PORTUGUESE]: "Excluir",
  },
  "contact-delete-cancel": {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "contact-deleted": {
    [Language.ENGLISH]: "Contact deleted",
    [Language.SPANISH]: "Contacto eliminado",
    [Language.PORTUGUESE]: "Contato excluído",
  },
  "contact-delete-error": {
    [Language.ENGLISH]: "Could not delete",
    [Language.SPANISH]: "No se pudo eliminar",
    [Language.PORTUGUESE]: "Não foi possível excluir",
  },
  "chat-contact-counter-label": {
    [Language.ENGLISH]: "contacts",
    [Language.SPANISH]: "contactos",
    [Language.PORTUGUESE]: "contatos",
  },
  "plans-contacts-feature": {
    [Language.ENGLISH]: "WhatsApp contacts",
    [Language.SPANISH]: "contactos de WhatsApp",
    [Language.PORTUGUESE]: "contatos do WhatsApp",
  },
  "chat-filter-no-tags": {
    [Language.ENGLISH]: "Create tags from the contact panel",
    [Language.SPANISH]: "Crea etiquetas desde el panel de contacto",
    [Language.PORTUGUESE]: "Crie etiquetas no painel do contato",
  },
  "contact-alias-label": {
    [Language.ENGLISH]: "Alias (shown in chats)",
    [Language.SPANISH]: "Alias (visible en chats)",
    [Language.PORTUGUESE]: "Apelido (visível nos chats)",
  },
  "contact-alias-hint": {
    [Language.ENGLISH]: "If filled, this name will be used instead of the order name.",
    [Language.SPANISH]: "Si lo llenas, se usará este nombre en vez del nombre del pedido.",
    [Language.PORTUGUESE]: "Se preenchido, este nome será usado em vez do nome do pedido.",
  },
  "contact-alias-placeholder": {
    [Language.ENGLISH]: "e.g. good customer",
    [Language.SPANISH]: "Ej: buena gente",
    [Language.PORTUGUESE]: "Ex: boa gente",
  },
  "contact-alias-saved": {
    [Language.ENGLISH]: "Alias saved",
    [Language.SPANISH]: "Alias guardado",
    [Language.PORTUGUESE]: "Apelido salvo",
  },
  "contact-name-label": {
    [Language.ENGLISH]: "Name (latest order)",
    [Language.SPANISH]: "Nombre (último pedido)",
    [Language.PORTUGUESE]: "Nome (último pedido)",
  },
  "contact-email-label": {
    [Language.ENGLISH]: "Email (latest order with email)",
    [Language.SPANISH]: "Email (último pedido con email)",
    [Language.PORTUGUESE]: "Email (último pedido com email)",
  },
  "contact-none": {
    [Language.ENGLISH]: "No data",
    [Language.SPANISH]: "Sin datos",
    [Language.PORTUGUESE]: "Sem dados",
  },
  // ---- WhatsApp Templates Panel ----
  "ws-templates-title": {
    [Language.ENGLISH]: "WhatsApp templates",
    [Language.SPANISH]: "Plantillas de WhatsApp",
    [Language.PORTUGUESE]: "Modelos do WhatsApp",
  },
  "ws-templates-subtitle": {
    [Language.ENGLISH]: "Create and manage the templates approved by Meta to send initial messages.",
    [Language.SPANISH]: "Crea y gestiona las plantillas aprobadas por Meta para enviar mensajes iniciales.",
    [Language.PORTUGUESE]: "Crie e gerencie os modelos aprovados pela Meta para enviar mensagens iniciais.",
  },
  "ws-templates-sync": {
    [Language.ENGLISH]: "Sync with Meta",
    [Language.SPANISH]: "Sincronizar con Meta",
    [Language.PORTUGUESE]: "Sincronizar com Meta",
  },
  "ws-templates-syncing": {
    [Language.ENGLISH]: "Syncing...",
    [Language.SPANISH]: "Sincronizando...",
    [Language.PORTUGUESE]: "Sincronizando...",
  },
  "ws-templates-synced": {
    [Language.ENGLISH]: "Synced",
    [Language.SPANISH]: "Sincronizado",
    [Language.PORTUGUESE]: "Sincronizado",
  },
  "ws-templates-sync-error": {
    [Language.ENGLISH]: "Could not sync with Meta",
    [Language.SPANISH]: "No se pudo sincronizar con Meta",
    [Language.PORTUGUESE]: "Não foi possível sincronizar com a Meta",
  },
  "ws-templates-create": {
    [Language.ENGLISH]: "New template",
    [Language.SPANISH]: "Nueva plantilla",
    [Language.PORTUGUESE]: "Novo modelo",
  },
  "ws-templates-created": {
    [Language.ENGLISH]: "Template sent to Meta (PENDING)",
    [Language.SPANISH]: "Plantilla enviada a Meta (PENDING)",
    [Language.PORTUGUESE]: "Modelo enviado à Meta (PENDING)",
  },
  "ws-templates-create-error": {
    [Language.ENGLISH]: "Could not create the template",
    [Language.SPANISH]: "No se pudo crear la plantilla",
    [Language.PORTUGUESE]: "Não foi possível criar o modelo",
  },
  "ws-templates-delete": {
    [Language.ENGLISH]: "Delete",
    [Language.SPANISH]: "Eliminar",
    [Language.PORTUGUESE]: "Excluir",
  },
  "ws-templates-delete-confirm": {
    [Language.ENGLISH]: "Delete the \"{name}\" template? This also removes it from Meta.",
    [Language.SPANISH]: "¿Eliminar el template \"{name}\"? Esta acción también lo borra en Meta.",
    [Language.PORTUGUESE]: "Excluir o modelo \"{name}\"? Isso também o remove da Meta.",
  },
  "ws-templates-deleted": {
    [Language.ENGLISH]: "Template deleted",
    [Language.SPANISH]: "Plantilla eliminada",
    [Language.PORTUGUESE]: "Modelo excluído",
  },
  "ws-templates-delete-error": {
    [Language.ENGLISH]: "Could not delete the template",
    [Language.SPANISH]: "No se pudo eliminar la plantilla",
    [Language.PORTUGUESE]: "Não foi possível excluir o modelo",
  },
  "ws-templates-defaults-title": {
    [Language.ENGLISH]: "Default templates",
    [Language.SPANISH]: "Plantillas por defecto",
    [Language.PORTUGUESE]: "Modelos padrão",
  },
  "ws-templates-defaults-desc": {
    [Language.ENGLISH]: "Pick which approved template is used for each case. Only APPROVED templates can be set as defaults.",
    [Language.SPANISH]: "Selecciona qué plantilla aprobada se usa en cada caso. Solo puedes asignar plantillas con estado APPROVED.",
    [Language.PORTUGUESE]: "Escolha qual modelo aprovado é usado em cada caso. Apenas modelos APPROVED podem ser definidos como padrão.",
  },
  "ws-templates-default-confirmation": {
    [Language.ENGLISH]: "Order confirmation",
    [Language.SPANISH]: "Confirmación de pedido",
    [Language.PORTUGUESE]: "Confirmação de pedido",
  },
  "ws-templates-default-order-confirmed": {
    [Language.ENGLISH]: "Order confirmed message (optional)",
    [Language.SPANISH]: "Pedido confirmado (opcional)",
    [Language.PORTUGUESE]: "Pedido confirmado (opcional)",
  },
  "ws-templates-default-reminder": {
    [Language.ENGLISH]: "Reminder",
    [Language.SPANISH]: "Recordatorio",
    [Language.PORTUGUESE]: "Lembrete",
  },
  "ws-templates-default-fallback": {
    [Language.ENGLISH]: "Fallback (missing address)",
    [Language.SPANISH]: "Fallback (dirección incompleta)",
    [Language.PORTUGUESE]: "Fallback (endereço incompleto)",
  },
  "ws-templates-default-saved": {
    [Language.ENGLISH]: "Default saved",
    [Language.SPANISH]: "Default guardado",
    [Language.PORTUGUESE]: "Padrão salvo",
  },
  "ws-templates-default-error": {
    [Language.ENGLISH]: "Could not save the default",
    [Language.SPANISH]: "No se pudo guardar el default",
    [Language.PORTUGUESE]: "Não foi possível salvar o padrão",
  },
  "ws-templates-choose-template": {
    [Language.ENGLISH]: "— Choose a template —",
    [Language.SPANISH]: "— Selecciona una plantilla —",
    [Language.PORTUGUESE]: "— Selecione um modelo —",
  },
  "ws-templates-use-ai-response": {
    [Language.ENGLISH]: "No template, use AI response",
    [Language.SPANISH]: "Sin plantilla, usar respuesta de IA",
    [Language.PORTUGUESE]: "Sem modelo, usar resposta da IA",
  },
  "ws-templates-optional": {
    [Language.ENGLISH]: "Optional",
    [Language.SPANISH]: "Opcional",
    [Language.PORTUGUESE]: "Opcional",
  },
  "ws-templates-order-confirmed-optional-hint": {
    [Language.ENGLISH]: "Optional. If empty, after confirming the order the AI replies as usual.",
    [Language.SPANISH]: "Opcional. Si queda vacío, después de confirmar responde la IA como de costumbre.",
    [Language.PORTUGUESE]: "Opcional. Se ficar vazio, depois de confirmar o pedido a IA responde normalmente.",
  },
  "ws-templates-required": {
    [Language.ENGLISH]: "You must assign a template. Use \"Crear recomendadas\" if you don't have one yet.",
    [Language.SPANISH]: "Debes asignar una plantilla. Usa \"Crear recomendadas\" si aún no tienes.",
    [Language.PORTUGUESE]: "Você precisa atribuir um modelo. Use \"Crear recomendadas\" se ainda não tem.",
  },
  "ws-templates-variables-picker-hint": {
    [Language.ENGLISH]: "Click a variable to insert it in the body:",
    [Language.SPANISH]: "Haz click en una variable para insertarla en el cuerpo:",
    [Language.PORTUGUESE]: "Clique em uma variável para inseri-la no corpo:",
  },
  "ws-templates-body-placeholder": {
    [Language.ENGLISH]: "Write the message. Click the buttons above to insert variables, or type {{1}}, {{2}}, etc. manually.",
    [Language.SPANISH]: "Escribe el mensaje. Usa los botones de arriba para insertar variables, o escribe {{1}}, {{2}}, etc. manualmente.",
    [Language.PORTUGUESE]: "Escreva a mensagem. Use os botões acima para inserir variáveis, ou digite {{1}}, {{2}}, etc. manualmente.",
  },
  "ws-templates-list-title": {
    [Language.ENGLISH]: "All templates",
    [Language.SPANISH]: "Todas las plantillas",
    [Language.PORTUGUESE]: "Todos os modelos",
  },
  "ws-templates-empty": {
    [Language.ENGLISH]: "No templates yet. Sync with Meta or create a new one.",
    [Language.SPANISH]: "Aún no tienes plantillas. Sincroniza con Meta o crea una nueva.",
    [Language.PORTUGUESE]: "Ainda não há modelos. Sincronize com a Meta ou crie um novo.",
  },
  "ws-templates-no-account": {
    [Language.ENGLISH]: "Connect your WhatsApp Business account first to manage templates.",
    [Language.SPANISH]: "Primero conecta tu cuenta de WhatsApp Business para gestionar templates.",
    [Language.PORTUGUESE]: "Conecte sua conta do WhatsApp Business para gerenciar modelos.",
  },
  "ws-templates-variables": {
    [Language.ENGLISH]: "variables",
    [Language.SPANISH]: "variables",
    [Language.PORTUGUESE]: "variáveis",
  },
  "ws-templates-rejection-reason": {
    [Language.ENGLISH]: "Rejection reason",
    [Language.SPANISH]: "Razón de rechazo",
    [Language.PORTUGUESE]: "Motivo da rejeição",
  },
  "ws-templates-modal-title": {
    [Language.ENGLISH]: "Create template",
    [Language.SPANISH]: "Crear plantilla",
    [Language.PORTUGUESE]: "Criar modelo",
  },
  "ws-templates-close": {
    [Language.ENGLISH]: "Close",
    [Language.SPANISH]: "Cerrar",
    [Language.PORTUGUESE]: "Fechar",
  },
  "ws-templates-preset": {
    [Language.ENGLISH]: "Use as",
    [Language.SPANISH]: "Usar como",
    [Language.PORTUGUESE]: "Usar como",
  },
  "ws-templates-preset-confirmation": {
    [Language.ENGLISH]: "Confirmation",
    [Language.SPANISH]: "Confirmación",
    [Language.PORTUGUESE]: "Confirmação",
  },
  "ws-templates-preset-reminder": {
    [Language.ENGLISH]: "Reminder",
    [Language.SPANISH]: "Recordatorio",
    [Language.PORTUGUESE]: "Lembrete",
  },
  "ws-templates-preset-fallback": {
    [Language.ENGLISH]: "Fallback",
    [Language.SPANISH]: "Fallback",
    [Language.PORTUGUESE]: "Fallback",
  },
  "ws-templates-preset-cart_recovery": {
    [Language.ENGLISH]: "Cart recovery",
    [Language.SPANISH]: "Recuperación carrito",
    [Language.PORTUGUESE]: "Recup. carrinho",
  },
  "ws-templates-preset-order_confirmed": {
    [Language.ENGLISH]: "Order confirmed",
    [Language.SPANISH]: "Pedido confirmado",
    [Language.PORTUGUESE]: "Pedido confirmado",
  },
  "ws-templates-preset-custom": {
    [Language.ENGLISH]: "Custom",
    [Language.SPANISH]: "Personalizado",
    [Language.PORTUGUESE]: "Personalizado",
  },
  "ws-templates-preset-hint": {
    [Language.ENGLISH]: "This preset creates a template with the structure the order flow expects. If you edit the body, keep the same number of {{1}}..{{n}} variables.",
    [Language.SPANISH]: "Este preset crea una plantilla con la estructura que el flujo de pedidos espera. Si modificas el cuerpo, mantén el mismo número de variables {{1}}..{{n}}.",
    [Language.PORTUGUESE]: "Este preset cria um modelo com a estrutura que o fluxo de pedidos espera. Se editar o corpo, mantenha o mesmo número de variáveis {{1}}..{{n}}.",
  },
  "ws-templates-field-name": {
    [Language.ENGLISH]: "Name",
    [Language.SPANISH]: "Nombre",
    [Language.PORTUGUESE]: "Nome",
  },
  "ws-templates-field-language": {
    [Language.ENGLISH]: "Language",
    [Language.SPANISH]: "Idioma",
    [Language.PORTUGUESE]: "Idioma",
  },
  "ws-templates-field-category": {
    [Language.ENGLISH]: "Category",
    [Language.SPANISH]: "Categoría",
    [Language.PORTUGUESE]: "Categoria",
  },
  "ws-templates-field-body": {
    [Language.ENGLISH]: "Message body",
    [Language.SPANISH]: "Cuerpo del mensaje",
    [Language.PORTUGUESE]: "Corpo da mensagem",
  },
  "ws-templates-body-hint": {
    [Language.ENGLISH]: "Use {{1}}, {{2}}, etc. for variables. Meta will validate syntax when approving.",
    [Language.SPANISH]: "Usa {{1}}, {{2}}, etc. para las variables. Meta validará la sintaxis al aprobar.",
    [Language.PORTUGUESE]: "Use {{1}}, {{2}}, etc. para as variáveis. A Meta validará a sintaxe ao aprovar.",
  },
  "ws-templates-with-buttons": {
    [Language.ENGLISH]: "Include Confirm / Modify order buttons (quick_reply)",
    [Language.SPANISH]: "Incluir botones Confirmar / Modificar orden (quick_reply)",
    [Language.PORTUGUESE]: "Incluir botões Confirmar / Modificar pedido (quick_reply)",
  },
  "ws-templates-name-error": {
    [Language.ENGLISH]: "Name must be alphanumeric with underscores only",
    [Language.SPANISH]: "El nombre debe ser alfanumérico con underscores",
    [Language.PORTUGUESE]: "O nome deve ser alfanumérico com underscores",
  },
  "ws-templates-body-error": {
    [Language.ENGLISH]: "Body cannot be empty",
    [Language.SPANISH]: "El cuerpo no puede estar vacío",
    [Language.PORTUGUESE]: "O corpo não pode estar vazio",
  },
  "ws-templates-variable-at-start-error": {
    [Language.ENGLISH]: "Body can't start with a variable ({{1}}, {{2}}…). Add text before it.",
    [Language.SPANISH]: "El cuerpo no puede empezar con una variable ({{1}}, {{2}}…). Agrega texto antes.",
    [Language.PORTUGUESE]: "O corpo não pode começar com uma variável ({{1}}, {{2}}…). Adicione texto antes.",
  },
  "ws-templates-variable-at-end-error": {
    [Language.ENGLISH]: "Body can't end with a variable ({{1}}, {{2}}…). Add text after it.",
    [Language.SPANISH]: "El cuerpo no puede terminar con una variable ({{1}}, {{2}}…). Agrega texto después.",
    [Language.PORTUGUESE]: "O corpo não pode terminar com uma variável ({{1}}, {{2}}…). Adicione texto depois.",
  },
  "ws-templates-cancel": {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "ws-templates-submit": {
    [Language.ENGLISH]: "Create and send to Meta",
    [Language.SPANISH]: "Crear y enviar a Meta",
    [Language.PORTUGUESE]: "Criar e enviar à Meta",
  },
  "ws-templates-submitting": {
    [Language.ENGLISH]: "Sending to Meta...",
    [Language.SPANISH]: "Enviando a Meta...",
    [Language.PORTUGUESE]: "Enviando à Meta...",
  },
  // ---- Recommended templates banner ----
  "ws-templates-recommended-title": {
    [Language.ENGLISH]: "Templates recommended by Fluxi",
    [Language.SPANISH]: "Plantillas recomendadas por Fluxi",
    [Language.PORTUGUESE]: "Modelos recomendados por Fluxi",
  },
  "ws-templates-recommended-desc": {
    [Language.ENGLISH]: "Create in one click the templates the order flow needs. They stay PENDING until Meta approves them (a few minutes).",
    [Language.SPANISH]: "Crea en un click las plantillas que el flujo de pedidos necesita. Quedan en PENDING hasta que Meta las apruebe (unos minutos).",
    [Language.PORTUGUESE]: "Crie em um clique os modelos que o fluxo de pedidos precisa. Ficam em PENDING até a Meta aprovar (alguns minutos).",
  },
  "ws-templates-recommended-missing": {
    [Language.ENGLISH]: "Missing",
    [Language.SPANISH]: "Faltan",
    [Language.PORTUGUESE]: "Faltam",
  },
  "ws-templates-recommended-cta": {
    [Language.ENGLISH]: "Create recommended",
    [Language.SPANISH]: "Crear recomendadas",
    [Language.PORTUGUESE]: "Criar recomendados",
  },
  "ws-templates-recommended-creating": {
    [Language.ENGLISH]: "Creating...",
    [Language.SPANISH]: "Creando...",
    [Language.PORTUGUESE]: "Criando...",
  },
  "ws-templates-recommended-created": {
    [Language.ENGLISH]: "Sent {n} template(s) to Meta (PENDING)",
    [Language.SPANISH]: "Enviadas {n} plantilla(s) a Meta (PENDING)",
    [Language.PORTUGUESE]: "Enviados {n} modelo(s) à Meta (PENDING)",
  },
  "ws-templates-recommended-error": {
    [Language.ENGLISH]: "{n} template(s) could not be created",
    [Language.SPANISH]: "{n} plantilla(s) no se pudieron crear",
    [Language.PORTUGUESE]: "{n} modelo(s) não puderam ser criados",
  },
  // ---- Create modal: variable legend ----
  "ws-templates-variables-legend-title": {
    [Language.ENGLISH]: "What each variable means",
    [Language.SPANISH]: "Qué significa cada variable",
    [Language.PORTUGUESE]: "O que significa cada variável",
  },
  "ws-templates-variables-legend-hint": {
    [Language.ENGLISH]: "The order flow fills these variables automatically from the customer and order data. Keep the same number and order.",
    [Language.SPANISH]: "El flujo de pedidos rellena estas variables automáticamente desde los datos del cliente y la orden. Mantén el mismo número y orden.",
    [Language.PORTUGUESE]: "O fluxo de pedidos preenche essas variáveis automaticamente com os dados do cliente e do pedido. Mantenha o mesmo número e ordem.",
  },
  "ws-templates-body-var-count": {
    [Language.ENGLISH]: "Variables detected",
    [Language.SPANISH]: "Variables detectadas",
    [Language.PORTUGUESE]: "Variáveis detectadas",
  },
  "ws-templates-body-var-mismatch": {
    [Language.ENGLISH]: "The \"{preset}\" flow expects exactly {expected} variables. Your body has {actual}. If you create it like this, you won't be able to assign it as default — you'd need to adjust the backend code to map the new fields.",
    [Language.SPANISH]: "El flujo de \"{preset}\" espera exactamente {expected} variables. Tu cuerpo tiene {actual}. Si creas así, no podrás asignar esta plantilla como default — tendrás que ajustar el código del backend para mapear los nuevos campos.",
    [Language.PORTUGUESE]: "O fluxo de \"{preset}\" espera exatamente {expected} variáveis. Seu corpo tem {actual}. Se criar assim, não poderá atribuir como padrão — terá que ajustar o código do backend.",
  },
  "ws-templates-rejection-no-reason": {
    [Language.ENGLISH]: "Meta rejected without a specific reason",
    [Language.SPANISH]: "Meta rechazó sin razón específica",
    [Language.PORTUGUESE]: "Meta rejeitou sem motivo específico",
  },
  "ws-templates-rejection-hint": {
    [Language.ENGLISH]: "Usually a per-day template rate-limit or a low WABA quality rating. Check business.facebook.com/wa/manage/message-templates. If it keeps failing, try creating the template directly from Meta Business Manager and then sync here.",
    [Language.SPANISH]: "Suele ser un rate-limit de templates por día o un quality rating bajo del WABA. Revisa business.facebook.com/wa/manage/message-templates. Si sigue fallando, intenta crear el template directamente desde Meta Business Manager y después sincroniza aquí.",
    [Language.PORTUGUESE]: "Normalmente é um rate-limit diário ou quality rating baixo do WABA. Verifique business.facebook.com/wa/manage/message-templates. Se continuar falhando, crie o modelo direto do Meta Business Manager e sincronize aqui.",
  },
  "ws-templates-delete-title": {
    [Language.ENGLISH]: "Delete template",
    [Language.SPANISH]: "Eliminar plantilla",
    [Language.PORTUGUESE]: "Excluir modelo",
  },
  "ws-templates-delete-modal-desc": {
    [Language.ENGLISH]: "You're about to delete \"{name}\". Meta blocks reusing this exact name for 4 weeks — after that you can create another template with the name \"{name}\". This also removes it on Meta and cannot be undone.",
    [Language.SPANISH]: "Vas a eliminar \"{name}\". Meta bloquea reutilizar ese mismo nombre durante 4 semanas — después de ese tiempo podrás volver a crear otra plantilla con el nombre \"{name}\". Esta acción también la borra en Meta y no se puede deshacer.",
    [Language.PORTUGUESE]: "Você vai excluir \"{name}\". A Meta bloqueia reutilizar esse nome por 4 semanas — após esse período você poderá criar outro modelo com o nome \"{name}\". Esta ação também o remove na Meta e não pode ser desfeita.",
  },
  "confio-connect-title": {
    [Language.ENGLISH]: "Connect your Confío account",
    [Language.SPANISH]: "Conecta tu cuenta Confío",
    [Language.PORTUGUESE]: "Conecte sua conta Confío",
  },
  "confio-connect-description": {
    [Language.ENGLISH]: "Offer payment links, PSE, cards, Bancolombia and Nequi to your customers. Generate a token and paste it in your Confío account to finish linking.",
    [Language.SPANISH]: "Ofrece links de pago, PSE, tarjetas, Bancolombia y Nequi a tus clientes. Genera un token y pégalo en tu cuenta de Confío para terminar la vinculación.",
    [Language.PORTUGUESE]: "Ofereça links de pagamento, PSE, cartões, Bancolombia e Nequi aos seus clientes. Gere um token e cole em sua conta Confío para terminar a vinculação.",
  },
  "confio-feature-methods": {
    [Language.ENGLISH]: "Multiple payment methods (PSE, card, Bancolombia, Nequi)",
    [Language.SPANISH]: "Múltiples métodos de pago (PSE, tarjeta, Bancolombia, Nequi)",
    [Language.PORTUGUESE]: "Múltiplos métodos de pagamento (PSE, cartão, Bancolombia, Nequi)",
  },
  "confio-feature-secure": {
    [Language.ENGLISH]: "Secure linking via mutual authentication",
    [Language.SPANISH]: "Vinculación segura con autenticación mutua",
    [Language.PORTUGUESE]: "Vinculação segura com autenticação mútua",
  },
  "confio-feature-webhooks": {
    [Language.ENGLISH]: "Automatic payment status updates via webhooks",
    [Language.SPANISH]: "Actualizaciones automáticas de pago vía webhooks",
    [Language.PORTUGUESE]: "Atualizações automáticas de pagamento via webhooks",
  },
  "confio-register-link": {
    [Language.ENGLISH]: "Register with Confío",
    [Language.SPANISH]: "Regístrate en Confío",
    [Language.PORTUGUESE]: "Cadastre-se na Confío",
  },
  "confio-token-label": {
    [Language.ENGLISH]: "Connection token",
    [Language.SPANISH]: "Token de conexión",
    [Language.PORTUGUESE]: "Token de conexão",
  },
  "confio-generate-token": {
    [Language.ENGLISH]: "Generate token",
    [Language.SPANISH]: "Generar token",
    [Language.PORTUGUESE]: "Gerar token",
  },
  "confio-regenerate-token": {
    [Language.ENGLISH]: "Generate a new token",
    [Language.SPANISH]: "Generar un nuevo token",
    [Language.PORTUGUESE]: "Gerar um novo token",
  },
  "confio-copy-token": {
    [Language.ENGLISH]: "Copy token",
    [Language.SPANISH]: "Copiar token",
    [Language.PORTUGUESE]: "Copiar token",
  },
  "confio-token-copied": {
    [Language.ENGLISH]: "Token copied to clipboard",
    [Language.SPANISH]: "Token copiado al portapapeles",
    [Language.PORTUGUESE]: "Token copiado para a área de transferência",
  },
  "confio-paste-instructions": {
    [Language.ENGLISH]: "Copy this token and paste it in your Confío account to finish linking. The token expires in 15 minutes.",
    [Language.SPANISH]: "Copia este token y pégalo en tu cuenta de Confío para terminar la vinculación. El token expira en 15 minutos.",
    [Language.PORTUGUESE]: "Copie este token e cole em sua conta Confío para terminar a vinculação. O token expira em 15 minutos.",
  },
  "confio-waiting-connection": {
    [Language.ENGLISH]: "Waiting for linking from Confío…",
    [Language.SPANISH]: "Esperando la vinculación desde Confío…",
    [Language.PORTUGUESE]: "Aguardando a vinculação do Confío…",
  },
};
